/* eslint-disable */
import {
  useMutation,
  useQuery,
  useInfiniteQuery,
  UseMutationOptions,
  UseQueryOptions,
  UseInfiniteQueryOptions
} from '@tanstack/react-query';
import { useFetchData } from 'data/graphqlClient';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  JSON: Record<string, unknown>;
};

/** The type of Allesseh collection. */
export enum AllessehCollectionType {
  CurationBanner = 'Curation_Banner',
  CurationCollection = 'Curation_Collection',
  CurationIssue = 'Curation_Issue',
  CurationIssuePage = 'Curation_Issue_Page',
  CurationIssueSection = 'Curation_Issue_Section',
  CurationModule = 'Curation_Module',
  CurationNewsletter = 'Curation_Newsletter',
  CurationOffPlatform = 'Curation_OffPlatform',
  CurationPage = 'Curation_Page',
  CurationSection = 'Curation_Section'
}

/** The types of Allesseh content that Curation works with. */
export enum AllessehContentType {
  Banner = 'Banner',
  Collection = 'Collection',
  ItpIssue = 'ITPIssue',
  Newsletter = 'Newsletter',
  OffPlatform = 'OffPlatform',
  Page = 'Page'
}

/** User data added to Allesseh and DynamoDB page and collections. */
export type AllessehUser = {
  __typename?: 'AllessehUser';
  /** Unique user id specific to DJ employees. */
  djUserId: Scalars['String'];
};

/** Article model attributes */
export type ArticleAttributes = {
  __typename?: 'ArticleAttributes';
  /** Same as origin id.† */
  base_doc_id: Scalars['String'];
  /** Where the article is hosted, obtained from metadata for article (canonical_url in metadata).† */
  hosted_url: Scalars['String'];
  /** ID to represent the content item as represented in Allesseh. (ex: "D7906099-0B15-4EBF-8815-964581E11CD4", "MW-BT-CO-20220906-706724")† */
  id: Scalars['String'];
  /** Link to access this article from the Allesseh API.† */
  link: Scalars['String'];
  /** Type of the content as represented by originating source. (ex: article, video, audio) */
  originContentType?: Maybe<Scalars['String']>;
  /** ID to represent the content item as represented by originating source. (ex: "D7906099-0B15-4EBF-8815-964581E11CD4", "MW-BT-CO-20220906-706724")† */
  originId?: Maybe<Scalars['String']>;
  /** Product the article originates from, obtained from metadata for article.† */
  product: Scalars['String'];
  /** Seo ID, obtained from metadata for article.† */
  seo_id: Scalars['String'];
  /** The status of the article, obtained from metadata for article (content_status in metadata).† */
  status: Scalars['String'];
};

/** Article model attributes for inputs */
export type ArticleAttributesInput = {
  /** Same as origin id. */
  base_doc_id: Scalars['String'];
  /** Where the article is hosted, obtained from metadata for article. */
  hosted_url: Scalars['String'];
  /** ID to represent the content item as represented in Allesseh. */
  id: Scalars['String'];
  /** Link to access this article from the Allesseh API. */
  link: Scalars['String'];
  /** Type of the content as represented by originating source. (ex: article, video, audio) */
  originContentType?: InputMaybe<Scalars['String']>;
  /** ID to represent the content item as represented by originating source. */
  originId?: InputMaybe<Scalars['String']>;
  /** Product the article originates from, obtained from metadata for article. */
  product: Scalars['String'];
  /** Seo ID, obtained from metadata for article. */
  seo_id: Scalars['String'];
  /** The status of the article, obtained from metadata for article. */
  status: Scalars['String'];
};

/** Article model */
export type ArticleItem = {
  __typename?: 'ArticleItem';
  /** Article attributes */
  attributes: ArticleAttributes;
  content?: Maybe<Scalars['String']>;
  /** Raw attributes of the Node */
  rawAttributes?: Maybe<Scalars['JSON']>;
  /** Subtype */
  subtype?: Maybe<Scalars['String']>;
  /** Content Type */
  type: Scalars['String'];
};

/** Article model for inputs */
export type ArticleItemInput = {
  /** Article attributes */
  attributes: ArticleAttributesInput;
  /** Type always is Article */
  type?: Scalars['String'];
};

/** The artifacts supported by Curation Tool. */
export enum Artifact {
  Banner = 'Banner',
  Collection = 'Collection',
  ItpIssue = 'ITPIssue',
  Newsletter = 'Newsletter',
  OffPlatform = 'OffPlatform',
  Page = 'Page'
}

/** Defines an available page module for a page with restriction rules. */
export type AvailableLayoutModule = {
  __typename?: 'AvailableLayoutModule';
  /** Allowed treatment types for the module */
  allowedTreatmentTypes?: Maybe<Array<UiTitleTreatmentType>>;
  /** The default module for this UI module type */
  defaultModule: PageModule;
  /** Maximum number of modules of this type allowed */
  maximumAllowed: Scalars['Float'];
  /** Minimum number of modules of this type allowed */
  minimumAllowed: Scalars['Float'];
  /** Type of UI module (corresponds to PageModule's UiModuleType) */
  uiModuleType: UiModuleType;
};

/** Defines an available page module for a page with restriction rules. */
export type AvailableRequiredLayoutModule = {
  __typename?: 'AvailableRequiredLayoutModule';
  /** Allowed treatment types for the module */
  allowedTreatmentTypes?: Maybe<Array<UiBasicOptionalTreatmentType>>;
  /** The default module for this UI module type */
  defaultModule: PageModule;
  /** Maximum number of modules of this type allowed */
  maximumAllowed: Scalars['Float'];
  /** Minimum number of modules of this type allowed */
  minimumAllowed: Scalars['Float'];
  /** Name for the module */
  moduleName: Scalars['String'];
  /** Type of UI module (corresponds to PageModule's UiModuleType) */
  uiModuleType: UiModuleType;
};

/** A Banner artifact represents a banner at the top of a page. */
export type BannerDto = {
  __typename?: 'BannerDTO';
  /** Metadata properties. */
  metadata: BaseMetadata;
  /** Banner root container. */
  root: BannerModuleContainer;
  /** Unique string denoting the type of this DTO. */
  type: Scalars['String'];
};

export type BannerDtoConnection = {
  __typename?: 'BannerDTOConnection';
  /** Pagination results. */
  edges: Array<BannerDtoEdge>;
  /** Page info for results. */
  pageInfo: PageInfo;
};

export type BannerDtoCreateInput = {
  /** Banner DTO artifact. */
  bannerDTO: Scalars['JSON'];
  /** Key to denote the publication. (ex: 'wsj', 'barrons') */
  publicationKey: Scalars['String'];
};

export type BannerDtoEdge = {
  __typename?: 'BannerDTOEdge';
  /** Current cursor of edge. */
  cursor: Scalars['String'];
  /** Banner data within paginated results. */
  node: BannerDto;
};

export type BannerDtoPreviewLinkInput = {
  /** Banner DTO artifact. */
  bannerDTO: Scalars['JSON'];
  /** Key to denote the publication. (ex: 'wsj', 'barrons') */
  publicationKey: Scalars['String'];
};

export type BannerDtoUpdateInput = {
  /** Banner DTO artifact. */
  bannerDTO: Scalars['JSON'];
  /** Key to denote the publication. (ex: 'wsj', 'barrons') */
  publicationKey: Scalars['String'];
};

/** Banner module model attributes */
export type BannerModuleAttributes = {
  __typename?: 'BannerModuleAttributes';
  /** External container info. `null` if not an external container */
  externalContainer?: Maybe<ExternalContainerAttributes>;
  /** Module ID */
  moduleId?: Maybe<Scalars['String']>;
  /** Page Module */
  pageModule?: Maybe<PageModule>;
};

/** Banner module model */
export type BannerModuleContainer = {
  __typename?: 'BannerModuleContainer';
  /** Banner module Model attributes */
  attributes: BannerModuleAttributes;
  /** Ordered array of Content in this Module. */
  collection: Array<ContentUnion>;
  /** Raw attributes of the Node */
  rawAttributes?: Maybe<Scalars['JSON']>;
  /** Container subtype */
  subtype?: Maybe<Scalars['String']>;
  /** Container Type */
  type: Scalars['String'];
};

export type BaseMetadata = {
  __typename?: 'BaseMetadata';
  /** Allesseh ID of this Curation artifact. */
  allessehId: Scalars['String'];
  /** Unix timestamp of when this Curation artifact was created. */
  createdUtc: Scalars['Float'];
  creatorUser: AllessehUser;
  name: Scalars['String'];
  publicationKey: Scalars['String'];
  publishUtc?: Maybe<Scalars['Float']>;
  revisorUser?: Maybe<AllessehUser>;
  updatedUtc?: Maybe<Scalars['Float']>;
};

/** Group of content curated manually or powered by a query. */
export type Collection = {
  __typename?: 'Collection';
  /** ID that is sent to Allesseh as the collection ID. */
  allessehCollectionId: Scalars['String'];
  /** The `collection_type` stored in the `meta` property of Allesseh. */
  allessehCollectionType?: Maybe<AllessehCollectionType>;
  /** Allesseh JSON stringified query for content. */
  allessehJsonQuery?: Maybe<Scalars['String']>;
  /** Specifies which publication can include this collection in their page (ex: if 'wsj', this collection can only be included by WSJ). Currently only used for Off-Platform collections. */
  consumer?: Maybe<Scalars['String']>;
  /** Ordered array of manually curated content. */
  contentItems: Array<CollectionContentItem>;
  /** MS since epoch of the datetime when this collection was created. */
  createdUtc: Scalars['Float'];
  /** Data of user who created this collection. */
  creatorUser: AllessehUser;
  /** Unique ID for this collection. */
  id: Scalars['String'];
  /** Composite key for a collection. */
  idCreatedUtc: Scalars['String'];
  /** "true" if this collection was published to Allesseh, otherwise "false". Only used for off-platform collections. */
  isAllessehPublished?: Maybe<Scalars['String']>;
  /** True if this collection is archived. */
  isArchived: Scalars['Boolean'];
  /** Name for this collection for use within this tool. */
  name: Scalars['String'];
  /** Freeform notes field for editors to write anything into. */
  notes?: Maybe<Scalars['String']>;
  /** Field that allows storing arbitrary data related to the collection */
  parameters: CollectionParameters;
  /** Key to denote the publication. (ex: 'wsj', 'barrons') */
  publicationKey: Scalars['String'];
  /** MS since epoch of the datetime when this scheduled collection is to be published. */
  publishUtc?: Maybe<Scalars['Float']>;
  /** Data of user who last updated this collection. */
  revisorUser: AllessehUser;
  /** MS since epoch of the datetime when this collection was updated. */
  updatedUtc?: Maybe<Scalars['Float']>;
};

export type CollectionArchiveInput = {
  /** ID that is sent to Allesseh as the collection ID. */
  allessehCollectionId: Scalars['String'];
  /** MS since epoch of the datetime when this collection was created. */
  createdUtc: Scalars['Float'];
  /** ID that is the same across revisions for this collection. */
  id: Scalars['String'];
  /** True if this collection is archived. */
  isArchived: Scalars['Boolean'];
  /** Key to denote the publication. (ex: 'wsj', 'barrons') */
  publicationKey: Scalars['String'];
};

export type CollectionConnection = {
  __typename?: 'CollectionConnection';
  /** Pagination results. */
  edges: Array<CollectionEdge>;
  /** Page info for results. */
  pageInfo: PageInfo;
};

export type CollectionContentItem = {
  __typename?: 'CollectionContentItem';
  /** Same as origin id. */
  base_doc_id: Scalars['String'];
  content?: Maybe<Scalars['String']>;
  /** Where the article is hosted, obtained from metadata for article (canonical_url in metadata). */
  hosted_url: Scalars['String'];
  /** ID to represent the content item as represented by originating source. (ex: 'D7906099-0B15-4EBF-8815-964581E11CD4', 'MW-BT-CO-20220906-706724') */
  id: Scalars['String'];
  /** Link to access this article from the Allesseh API. */
  link: Scalars['String'];
  /** Type of the content as represented by originating source. (ex: article, video, audio) */
  originContentType: Scalars['String'];
  /** ID to represent the content item as represented by originating source. (ex: 'D7906099-0B15-4EBF-8815-964581E11CD4', 'MW-BT-CO-20220906-706724') */
  originId: Scalars['String'];
  /** Product the article originates from, obtained from metadata for article. */
  product: Scalars['String'];
  /** Seo ID, obtained from metadata for article. */
  seo_id: Scalars['String'];
  /** The status of the article, obtained from metadata for article (content_status in metadata). */
  status: Scalars['String'];
};

export type CollectionContentItemInput = {
  /** Same as origin id. */
  base_doc_id: Scalars['String'];
  /** Where the article is hosted, obtained from metadata for article (canonical_url in metadata). */
  hosted_url: Scalars['String'];
  /** ID to represent the content item as represented by originating source. (ex: 'D7906099-0B15-4EBF-8815-964581E11CD4', 'MW-BT-CO-20220906-706724') */
  id: Scalars['String'];
  /** Link to access this article from the Allesseh API. */
  link: Scalars['String'];
  /** Type of the content as represented by originating source. (ex: article, video, audio) */
  originContentType: Scalars['String'];
  /** ID to represent the content item as represented by originating source. (ex: 'D7906099-0B15-4EBF-8815-964581E11CD4', 'MW-BT-CO-20220906-706724') */
  originId: Scalars['String'];
  /** Product the article originates from, obtained from metadata for article. */
  product: Scalars['String'];
  /** Seo ID, obtained from metadata for article. */
  seo_id: Scalars['String'];
  /** The status of the article, obtained from metadata for article (content_status in metadata). */
  status: Scalars['String'];
};

export type CollectionCopyInput = {
  /** ID that is sent to Allesseh as the collection ID. */
  allessehCollectionId: Scalars['String'];
  /** MS since epoch of the datetime when this collection was created. */
  createdUtc: Scalars['Float'];
  /** ID for this collection. */
  id: Scalars['String'];
  /** Key to denote the publication. (ex: 'wsj', 'barrons') */
  publicationKey: Scalars['String'];
};

export type CollectionCreateInput = {
  /** Name for the collection for use within this tool. */
  name: Scalars['String'];
  /** Key to denote the publication. (ex: 'wsj', 'barrons') */
  publicationKey: Scalars['String'];
};

/** Group of content curated manually or powered by a query. */
export type CollectionDto = {
  __typename?: 'CollectionDTO';
  /** Composite key for a collection. */
  idCreatedUtc: Scalars['String'];
  /** Metadata properties. */
  metadata: CollectionDtoMetadata;
  /** Collection list root container. */
  root: ListContainer;
  /** Unique string denoting the type of this DTO. */
  type: Scalars['String'];
};

export type CollectionDtoArchiveInput = {
  /** Collection DTO artifact. */
  collectionDTO: Scalars['JSON'];
  /** True if this collection is archived. */
  isArchived: Scalars['Boolean'];
  /** Key to denote the publication. (ex: 'wsj', 'barrons') */
  publicationKey: Scalars['String'];
};

export type CollectionDtoConnection = {
  __typename?: 'CollectionDTOConnection';
  /** Pagination results. */
  edges: Array<CollectionDtoEdge>;
  /** Page info for results. */
  pageInfo: PageInfo;
};

export type CollectionDtoCreateInput = {
  /** Name for the collection for use within this tool. */
  name: Scalars['String'];
  /** Key to denote the publication. (ex: 'wsj', 'barrons') */
  publicationKey: Scalars['String'];
};

export type CollectionDtoEdge = {
  __typename?: 'CollectionDTOEdge';
  /** Current cursor of edge. */
  cursor: Scalars['String'];
  /** Collection data within paginated results. */
  node: CollectionDto;
};

/** Collection metadata. */
export type CollectionDtoMetadata = {
  __typename?: 'CollectionDTOMetadata';
  /** Allesseh ID of this Curation artifact. */
  allessehId: Scalars['String'];
  /** Unix timestamp of when this Curation artifact was created. */
  createdUtc: Scalars['Float'];
  creatorUser: AllessehUser;
  /** Indicates whether this collection is archived. */
  isArchived: Scalars['Boolean'];
  name: Scalars['String'];
  /** Freeform notes field for editors to write in. */
  notes?: Maybe<Scalars['String']>;
  publicationKey: Scalars['String'];
  publishUtc?: Maybe<Scalars['Float']>;
  revisorUser?: Maybe<AllessehUser>;
  updatedUtc?: Maybe<Scalars['Float']>;
};

export type CollectionDtoMutationInput = {
  /** Collection DTO artifact. */
  collectionDTO: Scalars['JSON'];
  /** Key to denote the publication. (ex: 'wsj', 'barrons') */
  publicationKey: Scalars['String'];
};

/** The types of sorting for a collection query. */
export enum CollectionDtoSortType {
  CreateDate = 'CREATE_DATE',
  Name = 'NAME'
}

/** The types of state for a collection. */
export enum CollectionDtoStatusType {
  Archived = 'ARCHIVED',
  Live = 'LIVE'
}

export type CollectionDeleteResult = {
  __typename?: 'CollectionDeleteResult';
  /** Error message. */
  error?: Maybe<Scalars['String']>;
  /** Message. */
  message: Scalars['String'];
  /** Code. */
  statusCode: Scalars['Float'];
};

export type CollectionDeleteScheduledInput = {
  /** ID that is sent to Allesseh as the collection ID. */
  allessehCollectionId: Scalars['String'];
  /** Key to denote the publication. (ex: 'wsj', 'barrons') */
  publicationKey: Scalars['String'];
  /** MS since epoch of the datetime when this scheduled collection is to be published. */
  publishUtc: Scalars['Float'];
};

export type CollectionEdge = {
  __typename?: 'CollectionEdge';
  /** Current cursor of edge. */
  cursor: Scalars['String'];
  /** Collection data within paginated results. */
  node: Collection;
};

export type CollectionOffPlatformInput = {
  /** ID that is sent to Allesseh as the collection ID. */
  allessehCollectionId: Scalars['String'];
  /** Specifies which publication can include this collection in their page (ex: if 'wsj', this collection can only be included by WSJ) */
  consumer: Scalars['String'];
  /** Default alt-summ variant to use in this collection (e.g. "U.S. Home") */
  defaultAltSummVariant: Scalars['String'];
  /** URL of the page that hosts this off-platform module (e.g. https://wsj.com) */
  hostingPageURL: Scalars['String'];
  /** Maximum number of items the off-platform collection must contain */
  maxItems?: InputMaybe<Scalars['Float']>;
  /** Minimum number of items the off-platform collection must contain */
  minItems?: InputMaybe<Scalars['Float']>;
  /** Text to display as the module name (e.g. "BuySide Promotional Module") */
  moduleDisplayName: Scalars['String'];
  /** Key to denote the publication. (ex: 'wsj', 'barrons') */
  publicationKey: Scalars['String'];
};

export type CollectionParameters = {
  __typename?: 'CollectionParameters';
  /** Parameters for off-platform collections */
  offPlatform?: Maybe<OffPlatformParams>;
};

export type CollectionScheduleInput = {
  /** ID that is sent to Allesseh as the collection ID. */
  allessehCollectionId: Scalars['String'];
  /** Allesseh JSON stringified query for content. */
  allessehJsonQuery?: InputMaybe<Scalars['String']>;
  /** Specifies which publication can include this collection in their page (ex: if 'wsj', this collection can only be included by WSJ). Currently only used for Off-Platform collections. */
  consumer?: InputMaybe<Scalars['String']>;
  /** Ordered array of manually curated content. */
  contentItems: Array<CollectionContentItemInput>;
  /** MS since epoch of the datetime when this collection was created. */
  createdUtc: Scalars['Float'];
  /** ID for this collection. */
  id: Scalars['String'];
  /** Name for this collection for use within this tool. */
  name: Scalars['String'];
  /** Freeform notes field for editors to write anything into. */
  notes?: InputMaybe<Scalars['String']>;
  /** Key to denote the publication. (ex: 'wsj', 'barrons') */
  publicationKey: Scalars['String'];
  /** MS since epoch of the datetime when this scheduled collection is to be published. */
  publishUtc: Scalars['Float'];
};

/** The types of sorting for a collection query. */
export enum CollectionSortType {
  CreateDate = 'CREATE_DATE',
  Name = 'NAME'
}

/** The types of state for a collection. */
export enum CollectionStatusType {
  Archived = 'ARCHIVED',
  Live = 'LIVE'
}

export type CollectionUpdateInput = {
  /** ID that is sent to Allesseh as the collection ID. */
  allessehCollectionId: Scalars['String'];
  /** Allesseh JSON stringified query for content. */
  allessehJsonQuery?: InputMaybe<Scalars['String']>;
  /** Specifies which publication can include this collection in their page (ex: if 'wsj', this collection can only be included by WSJ). Currently only used for Off-Platform collections. */
  consumer?: InputMaybe<Scalars['String']>;
  /** Ordered array of manually curated content. */
  contentItems: Array<CollectionContentItemInput>;
  /** MS since epoch of the datetime when this collection was created. */
  createdUtc: Scalars['Float'];
  /** ID for this collection. */
  id: Scalars['String'];
  /** Name for this collection for use within this tool. */
  name: Scalars['String'];
  /** Freeform notes field for editors to write anything into. */
  notes?: InputMaybe<Scalars['String']>;
  /** Key to denote the publication. (ex: 'wsj', 'barrons') */
  publicationKey: Scalars['String'];
};

export type CollectionsDtoInput = {
  /** Array of Collection composite keys to exclude. */
  excludedCollectionIdCreatedUtcs?: InputMaybe<Array<Scalars['String']>>;
  /** Key to denote the publication. (ex: 'wsj', 'barrons') */
  publicationKey: Scalars['String'];
  /** Search input text for a collection. */
  searchText?: InputMaybe<Scalars['String']>;
  /** Sort type for the collection in descending order. */
  sortType?: InputMaybe<CollectionDtoSortType>;
  /** Status to filter by. */
  status?: InputMaybe<CollectionDtoStatusType>;
};

export type CollectionsInput = {
  /** Array of Collection composite keys to exclude. */
  excludedCollectionIdCreatedUtcs?: InputMaybe<Array<Scalars['String']>>;
  /** Key to denote the publication. (ex: 'wsj', 'barrons') */
  publicationKey: Scalars['String'];
  /** Search input text for a collection. */
  searchText?: InputMaybe<Scalars['String']>;
  /** Sort type for the collection in descending order. */
  sortType?: InputMaybe<CollectionSortType>;
  /** Status to filter by. */
  status?: InputMaybe<CollectionStatusType>;
  /** Type of collections to query. */
  type: Scalars['String'];
};

export type ContentUnion = ArticleItem | ExternalCollectionItem | LinkedItem | MobileArticleItem | QueryItem;

export type ConvertToOffPlatformInput = {
  /** Id that is sent to Allesseh as the collection Id. */
  allessehCollectionId: Scalars['String'];
  /** Specifies which publication can include this collection in their page (ex: if 'wsj', this collection can only be included by WSJ) */
  consumer: Scalars['String'];
  /** Default alt-summ variant to use in this collection (e.g. "U.S. Home") */
  defaultAltSummVariant: Scalars['String'];
  /** URL of the page that hosts this off platform module (e.g. https://wsj.com) */
  hostingPageURL: Scalars['String'];
  /** Maximum number of items the off platform collection must contain */
  maxItems?: InputMaybe<Scalars['Float']>;
  /** Minimum number of items the off platform collection must contain */
  minItems?: InputMaybe<Scalars['Float']>;
  /** Text to display as the module name (e.g. "BuySide Promotional Module") */
  moduleDisplayName: Scalars['String'];
  /** Key to denote the publication. (ex: 'wsj', 'barrons') */
  publicationKey: Scalars['String'];
};

/** Scheduled content for a cron notification, including publication key, ID, and publish timestamp. */
export type CronNotificationScheduledContent = {
  __typename?: 'CronNotificationScheduledContent';
  /** Allesseh ID for the scheduled content. */
  allessehId: Scalars['String'];
  /** Key representing the publication. */
  publicationKey: Scalars['String'];
  /** UTC timestamp in milliseconds representing the scheduled publish time. */
  publishUtc: Scalars['Int'];
};

export type DeleteAllessehCollectionInput = {
  /** ID that is sent to Allesseh as the collection ID. */
  allessehCollectionId: Scalars['String'];
  /** Key to denote the publication. (ex: 'wsj', 'barrons') */
  publicationKey: Scalars['String'];
};

/** External Collection model attributes */
export type ExternalCollectionAttributes = {
  __typename?: 'ExternalCollectionAttributes';
  /** The base_doc_id of the external collection */
  base_doc_id?: Maybe<Scalars['String']>;
  /** The id of the external collection */
  id: Scalars['String'];
  /** The id of the external collection */
  repo: Scalars['String'];
};

/** External Collection model */
export type ExternalCollectionItem = {
  __typename?: 'ExternalCollectionItem';
  /** External Collection attributes */
  attributes: ExternalCollectionAttributes;
  contentItems: Array<ContentUnion>;
  metadata: ExternalCollectionMetadata;
  /** Raw attributes of the Node */
  rawAttributes?: Maybe<Scalars['JSON']>;
  /** Subtype */
  subtype?: Maybe<Scalars['String']>;
  /** Content Type */
  type: Scalars['String'];
};

/** External Collection metadata */
export type ExternalCollectionMetadata = {
  __typename?: 'ExternalCollectionMetadata';
  createdUtc: Scalars['Float'];
  creatorUser: AllessehUser;
  id: Scalars['String'];
  isArchived: Scalars['Boolean'];
  name: Scalars['String'];
  notes: Scalars['String'];
  publicationKey: Scalars['String'];
  revisorUser: AllessehUser;
  updatedUtc: Scalars['Float'];
};

/** External Container Attributes */
export type ExternalContainerAttributes = {
  __typename?: 'ExternalContainerAttributes';
  /** The id of the external container */
  externalDocId?: Maybe<Scalars['String']>;
  /** The repo of the container */
  externalRepo?: Maybe<Scalars['String']>;
  /** The repo of the container */
  publishStatus?: Maybe<Scalars['String']>;
};

export type GeneralPurposeFeatureFlag = {
  __typename?: 'GeneralPurposeFeatureFlag';
  /** What the feature flag is used for. */
  description: Scalars['String'];
  /** Whether the feature flag is enabled. */
  enabled: Scalars['Boolean'];
};

export type GetBannersDtoInput = {
  /** Key to denote the publication. (ex: 'wsj', 'barrons') */
  publicationKey: Scalars['String'];
};

export type ItpCreateInput = {
  /** Date of the ITP issue in YYYYMMDD format. For example, 20230825 is the date of the issue released on the 25th of August, 2023. */
  issueDate: Scalars['String'];
};

export type ItpImportContentInput = {
  /** Ordered array of modules programmed for this page. */
  currentPages: Array<ItpImportContentPageInput>;
  /** Denotes if this import action is the first import made in the issue. */
  isFirstImport: Scalars['Boolean'];
};

export type ItpImportContentPageInput = {
  /** Array of all content IDs in a page. */
  contentIds: Array<Scalars['String']>;
  /** The label displayed by the frontend for this page. */
  label: Scalars['String'];
  /** Denotes the type of page. A page type enforces certain rules for the page. */
  pageType: Scalars['String'];
};

/** Represents a single issue for the ITP (In Today's Paper) edition of WSJ */
export type ItpIssue = {
  __typename?: 'ITPIssue';
  /** MS since epoch of the datetime when this issue was created. */
  createdUtc: Scalars['Float'];
  /** Data of user who created this Issue. */
  creatorUser: AllessehUser;
  /** Date of the ITP issue in YYYYMMDD format. For example, 20230825 is the date of the issue released on the 25th of August, 2023. */
  issueDate: Scalars['String'];
  /** ID of this ITP issue. */
  issueId: Scalars['String'];
  /** Date of the week that corresponds to this issue. */
  label: Scalars['String'];
  /** MS since epoch of the datetime when this issue was first published to Allesseh. */
  publishUtc?: Maybe<Scalars['Float']>;
  /** MS since epoch of the datetime when this issue data was last refreshed from ITP feeds. */
  refreshedUtc?: Maybe<Scalars['Float']>;
  /** Data of user who last updated this Issue. */
  revisorUser?: Maybe<AllessehUser>;
  /** The status in which the issue is currently in. */
  status: ItpIssueStatus;
  /** Alt-Sum variant to be used in this issue. Default value is 'ITP' */
  summaryPriority: Scalars['String'];
  /** MS since epoch of the datetime when this issue was last updated. */
  updatedUtc?: Maybe<Scalars['Float']>;
};

/** A page type enforces certain rules for the page. (ex: Page One, World, etc.) */
export enum ItpIssuePageType {
  BusinessAndFinance = 'BUSINESS_AND_FINANCE',
  FrontSection = 'FRONT_SECTION',
  JournalReport = 'JOURNAL_REPORT',
  LifeAndArts = 'LIFE_AND_ARTS',
  Mansion = 'MANSION',
  OffDuty = 'OFF_DUTY',
  Opinion = 'OPINION',
  Review = 'REVIEW',
  SpecialSection = 'SPECIAL_SECTION',
  Us = 'US',
  World = 'WORLD',
  WsjMagazine = 'WSJ_MAGAZINE'
}

/** The status in which the issue is currently in */
export enum ItpIssueStatus {
  Changed = 'CHANGED',
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

/** ITP issue with corresponding pages */
export type ItpIssueWithPages = {
  __typename?: 'ITPIssueWithPages';
  /** MS since epoch of the datetime when this issue was created. */
  createdUtc: Scalars['Float'];
  /** Data of user who created this Issue. */
  creatorUser: AllessehUser;
  /** Date of the ITP issue in YYYYMMDD format. For example, 20230825 is the date of the issue released on the 25th of August, 2023. */
  issueDate: Scalars['String'];
  /** ID of this ITP issue. */
  issueId: Scalars['String'];
  /** Date of the week that corresponds to this issue. */
  label: Scalars['String'];
  /** The corresponding pages for a given ITP issue */
  pages: Array<ItpPage>;
  /** MS since epoch of the datetime when this issue was first published to Allesseh. */
  publishUtc?: Maybe<Scalars['Float']>;
  /** MS since epoch of the datetime when this issue data was last refreshed from ITP feeds. */
  refreshedUtc?: Maybe<Scalars['Float']>;
  /** Data of user who last updated this Issue. */
  revisorUser?: Maybe<AllessehUser>;
  /** The status in which the issue is currently in. */
  status: ItpIssueStatus;
  /** Alt-Sum variant to be used in this issue. Default value is 'ITP' */
  summaryPriority: Scalars['String'];
  /** MS since epoch of the datetime when this issue was last updated. */
  updatedUtc?: Maybe<Scalars['Float']>;
};

/** Represents a page of an ITP issue that contains multiple modules, each with collection and UI metadata. */
export type ItpPage = {
  __typename?: 'ITPPage';
  /** Denotes the ad type for this page. */
  adType: Scalars['String'];
  /** Denotes the ad zones for this page. */
  adZones: Scalars['String'];
  /** ID of Allesseh collection used to fill the content slots for this page. */
  allessehCollectionId?: Maybe<Scalars['String']>;
  /** Denotes whether this page will appear in its corresponding ITP issue. */
  isHidden: Scalars['Boolean'];
  /** ID of this ITP issue. */
  issueId: Scalars['String'];
  /** The label displayed by the frontend for this page. */
  label: Scalars['String'];
  /** Ordered array of modules programmed for this page. */
  pageModules: Array<PageModule>;
  /** Denotes the type of page. A page type enforces certain rules for the page. */
  pageType: Scalars['String'];
};

export type ItpPageSaveInput = {
  /** Denotes the ad type for this page. */
  adType: Scalars['String'];
  /** Denotes the ad zones for this page. */
  adZones: Scalars['String'];
  /** Denotes whether this page will appear in its corresponding ITP issue. */
  isHidden: Scalars['Boolean'];
  /** ID of this ITP issue. */
  issueId: Scalars['String'];
  /** The label displayed by the frontend for this page. */
  label?: InputMaybe<Scalars['String']>;
  /** Ordered array of modules programmed for this page. */
  pageModules: Array<PageModuleInput>;
  /** Denotes the type of page. A page type enforces certain rules for the page. */
  pageType: Scalars['String'];
};

export type ItpSaveInput = {
  /** issueDate argument of ITPCreateInput must be a string in YYYYMMDD format */
  issueDate: Scalars['String'];
  /** ID of this ITP issue. */
  issueId: Scalars['String'];
  /** Date of the week that corresponds to this issue. */
  label?: InputMaybe<Scalars['String']>;
  /** Ordered array of the pages associated with this issue. */
  pages: Array<ItpPageSaveInput>;
  /** MS since epoch of the datetime when this issue data was last refreshed from ITP feeds. */
  refreshedUtc?: InputMaybe<Scalars['Float']>;
};

/** Image Attributes */
export type ImageAttributes = {
  __typename?: 'ImageAttributes';
  /** Alt Images */
  alt_images: Array<Scalars['String']>;
  /** Alternate Text */
  alternate_text: Scalars['String'];
  /** Credit */
  credit: Scalars['String'];
  /** Height */
  height: Scalars['Float'];
  /** ID */
  id: Scalars['String'];
  /** Media Type */
  media_type: Scalars['String'];
  /** Name */
  name: Scalars['String'];
  /** Properties */
  properties: Properties;
  /** Reuse Type */
  reuse_type: Scalars['String'];
  /** Source */
  src: ImageSourceAttributes;
  /** Image Type */
  type: Scalars['String'];
  /** Width */
  width: Scalars['Float'];
};

/** Image Parameters */
export type ImageParams = {
  __typename?: 'ImageParams';
  /** Size */
  size: Scalars['Float'];
};

/** Image Source Attributes */
export type ImageSourceAttributes = {
  __typename?: 'ImageSourceAttributes';
  /** Base URL */
  base_url: Scalars['String'];
  /** Image ID */
  image_id: Scalars['String'];
  /** Image Parameters */
  params: ImageParams;
  /** Path */
  path: Scalars['String'];
};

/** Issue model attributes */
export type IssueAttributes = {
  __typename?: 'IssueAttributes';
  /** External container info. `null` if not an external container */
  externalContainer?: Maybe<ExternalContainerAttributes>;
  /** Issue Date in ISO 8601 format */
  issueDate: Scalars['String'];
  /** Issue Key - UCSD_{PUB}}_ITP_ITP{YYYYMMDD}_ */
  issueKey: Scalars['String'];
  /** Publishing Status of the Issue */
  status: Scalars['String'];
};

/** Issue model */
export type IssueContainer = {
  __typename?: 'IssueContainer';
  /** Issue Model attributes */
  attributes: IssueAttributes;
  /** Ordered array of Pages for this Issue. */
  collection: Array<IssueSectionContainer>;
  /** Raw attributes of the Node */
  rawAttributes?: Maybe<Scalars['JSON']>;
  /** Container subtype */
  subtype?: Maybe<Scalars['String']>;
  /** Container Type */
  type: Scalars['String'];
};

/** Issue Section model attributes */
export type IssueSectionAttributes = {
  __typename?: 'IssueSectionAttributes';
  /** Ad. type for section */
  adPlacementType?: Maybe<Scalars['String']>;
  /** Ad. Zone */
  adZone?: Maybe<Scalars['String']>;
  /** External container info. `null` if not an external container */
  externalContainer?: Maybe<ExternalContainerAttributes>;
  /** Hide Section? */
  isHidden: Scalars['Boolean'];
  /** Issue date for Issue sections */
  issueDate?: Maybe<Scalars['String']>;
  /** Section page type */
  pageType: Scalars['String'];
  /** Url path structured key to denote where this page will be used. (ex: ‘/’, ‘/news/world’, etc.). This is combined with the baseRoute from publication setting. */
  routeKey: Scalars['String'];
  /** Section Key. e.g. "BUSINESS_AND_FINANCE" */
  sectionKey: Scalars['String'];
  /** Section Label. e.g. "Business & Finance" */
  sectionLabel: Scalars['String'];
  /** alt_summ variant for this section */
  summaryPriority: Scalars['String'];
  /** Source of content */
  upstreamAllessehCollectionId?: Maybe<Scalars['String']>;
};

/** Issue Section model */
export type IssueSectionContainer = {
  __typename?: 'IssueSectionContainer';
  /** Issue Section Model attributes */
  attributes: IssueSectionAttributes;
  /** Ordered array of Pages for this Section. */
  collection: Array<PageContainer>;
  /** Raw attributes of the Node */
  rawAttributes?: Maybe<Scalars['JSON']>;
  /** Container subtype */
  subtype?: Maybe<Scalars['String']>;
  /** Container Type */
  type: Scalars['String'];
};

/** Represents an ITP issue that may contain multiple pages, each with multiple modules. */
export type ItpDto = {
  __typename?: 'ItpDTO';
  /** Metadata properties. */
  metadata: ItpMetadata;
  /** Represents a single issue for the ITP (In Today's Paper) edition of WSJ */
  root: IssueContainer;
  /** Unique string denoting the type of this DTO. */
  type: Scalars['String'];
};

export type ItpDtoCreateInput = {
  /** Date of the ITP issue in YYYYMMDD format. For example, 20230825 is the date of the issue released on the 25th of August, 2023. */
  issueDate: Scalars['String'];
};

export type ItpDtoImportContentInput = {
  /** The ITP Issue that is currently being edited, as is. */
  itpDto: Scalars['JSON'];
};

export type ItpDtoPageModuleSaveInput = {
  /** Ordered array of modules programmed for this page. */
  pageModules: Array<PageModuleInput>;
};

export type ItpDtoSaveInput = {
  /** ID of this ITP issue. */
  allessehId: Scalars['String'];
  /** issueDate argument of ITPCreateInput must be a string in YYYYMMDD format */
  issueDate: Scalars['String'];
  /** MS since epoch of the datetime when this issue data was last refreshed from ITP feeds. */
  refreshedUtc?: InputMaybe<Scalars['Float']>;
  /** Ordered array of the pages associated with this issue. */
  sections: Array<ItpDtoSectionSaveInput>;
};

export type ItpDtoSectionSaveInput = {
  /** Denotes the ad type for this page. */
  adPlacementType?: InputMaybe<Scalars['String']>;
  /** Denotes the ad zone for this page. */
  adZone?: InputMaybe<Scalars['String']>;
  /** Denotes whether this page will appear in its corresponding ITP issue. */
  isHidden: Scalars['Boolean'];
  /** issueDate argument of ITPCreateInput must be a string in YYYYMMDD format */
  issueDate: Scalars['String'];
  /** Denotes the type of page. A page type enforces certain rules for the page. */
  pageType: Scalars['String'];
  pages: Array<ItpDtoPageModuleSaveInput>;
  /** The URL path segment associated with the given section (e.g. `/electronics`). */
  routeKey: Scalars['String'];
  /** The key associated with the given section (e.g. `BUSINESS_AND_FINANCE`). */
  sectionKey: Scalars['String'];
  /** The label associated with the given section (e.g. `Business & Finance`). */
  sectionLabel: Scalars['String'];
  /** Alt summ variant (e.g. `U.S. Home`). */
  summaryPriority: Scalars['String'];
  /** Id for corresponding allesseh content (e.g. `ITPWSJPageOneOnlineOverride`). */
  upstreamAllessehCollectionId: Scalars['String'];
};

export type ItpImportResponse = {
  __typename?: 'ItpImportResponse';
  issue: ItpDto;
  newIds: Array<Scalars['String']>;
  staleIds: Array<Scalars['String']>;
};

/** ITP metadata. */
export type ItpMetadata = {
  __typename?: 'ItpMetadata';
  /** Allesseh ID of this Curation artifact. */
  allessehId: Scalars['String'];
  /** Unix timestamp of when this Curation artifact was created. */
  createdUtc: Scalars['Float'];
  creatorUser: AllessehUser;
  name: Scalars['String'];
  publicationKey: Scalars['String'];
  publishUtc?: Maybe<Scalars['Float']>;
  /** MS since epoch of the datetime when this issue data was last refreshed from ITP feeds. */
  refreshedUtc?: Maybe<Scalars['Float']>;
  revisorUser?: Maybe<AllessehUser>;
  updatedUtc?: Maybe<Scalars['Float']>;
};

/** Defines the required and/or available page modules allowed for a page. */
export type Layout = {
  __typename?: 'Layout';
  /** Unordered array of available modules to use */
  availableLayoutModules: Array<AvailableLayoutModule>;
  /** Unordered array of available fixed modules to use */
  availableRequiredLayoutModules: Array<AvailableRequiredLayoutModule>;
  /** Allowed treatment types for the page */
  availableTreatmentTypes?: Maybe<Array<Scalars['String']>>;
  /** Whether layout is deprecated */
  deprecated?: Maybe<Scalars['Boolean']>;
  /** ID to identify the layout which is connected to a page. */
  id: Scalars['String'];
  /** Name for the layout for internal use within the tool. */
  name: Scalars['String'];
  /** Ordered array of required modules */
  requiredLayoutModules: Array<PageModule>;
};

/** Linked item model */
export type LinkedItem = {
  __typename?: 'LinkedItem';
  /** Linked attributes */
  attributes: LinkedItemAttributes;
  /** Raw attributes of the Node */
  rawAttributes?: Maybe<Scalars['JSON']>;
  /** Subtype */
  subtype?: Maybe<Scalars['String']>;
  /** Content Type */
  type: Scalars['String'];
};

/** Linked item model attributes */
export type LinkedItemAttributes = {
  __typename?: 'LinkedItemAttributes';
  /** The description of the linked item.† */
  description?: Maybe<Scalars['String']>;
  /** Where the linked item content is hosted.† */
  hosted_url: Scalars['String'];
  /** Unique ID to represent the linked item. This is equal to the `hosted_url` of the item.† */
  id: Scalars['String'];
  /** Image data associated with external content */
  image?: Maybe<ImageAttributes>;
  /** Product where the linked item originates from. */
  product: Scalars['String'];
  /** The title of the linked item.† */
  title: Scalars['String'];
};

/** List model attributes */
export type ListAttributes = {
  __typename?: 'ListAttributes';
  /** External container info. `null` if not an external container */
  externalContainer?: Maybe<ExternalContainerAttributes>;
};

/** List model */
export type ListContainer = {
  __typename?: 'ListContainer';
  /** List attributes */
  attributes: ListAttributes;
  /** Ordered array of Content in this List. */
  collection: Array<ContentUnion>;
  /** Raw attributes of the Node */
  rawAttributes?: Maybe<Scalars['JSON']>;
  /** Container subtype */
  subtype?: Maybe<Scalars['String']>;
  /** Container Type */
  type: Scalars['String'];
};

/** The type of metadata allowed for the module. */
export enum Metadata {
  Subtitle = 'Subtitle',
  SubtitleUrl = 'SubtitleUrl',
  Title = 'Title',
  TitleUrl = 'TitleUrl'
}

/** Mobile Article attributes */
export type MobileArticleAttributes = {
  __typename?: 'MobileArticleAttributes';
  /** Same as origin id.† */
  base_doc_id: Scalars['String'];
  /** Where the article is hosted, obtained from metadata for article (canonical_url in metadata).† */
  hosted_url: Scalars['String'];
  /** ID to represent the content item as represented in Allesseh. (ex: "D7906099-0B15-4EBF-8815-964581E11CD4", "MW-BT-CO-20220906-706724")† */
  id: Scalars['String'];
  /** Link to access this article from the Allesseh API.† */
  link: Scalars['String'];
  /** Type of the content as represented by originating source. (ex: article, video, audio) */
  originContentType?: Maybe<Scalars['String']>;
  /** ID to represent the content item as represented by originating source. (ex: "D7906099-0B15-4EBF-8815-964581E11CD4", "MW-BT-CO-20220906-706724")† */
  originId?: Maybe<Scalars['String']>;
  /** Product the article originates from, obtained from metadata for article.† */
  product: Scalars['String'];
  /** Seo ID, obtained from metadata for article.† */
  seo_id: Scalars['String'];
  /** show flashline toggle */
  showFlashline: Scalars['Boolean'];
  /** show image toggle */
  showImage: Scalars['Boolean'];
  /** show image below toggle */
  showImageBelow: Scalars['Boolean'];
  /** The status of the article, obtained from metadata for article (content_status in metadata).† */
  status: Scalars['String'];
};

/** Mobile Article Model */
export type MobileArticleItem = {
  __typename?: 'MobileArticleItem';
  /** Article attributes */
  attributes: MobileArticleAttributes;
  content?: Maybe<Scalars['String']>;
  /** Raw attributes of the Node */
  rawAttributes?: Maybe<Scalars['JSON']>;
  /** Subtype */
  subtype?: Maybe<Scalars['String']>;
  /** Content Type */
  type: Scalars['String'];
};

/** Module model attributes */
export type ModuleAttributes = {
  __typename?: 'ModuleAttributes';
  /** External container info. `null` if not an external container */
  externalContainer?: Maybe<ExternalContainerAttributes>;
  /** Module ID */
  moduleId?: Maybe<Scalars['String']>;
  /** Page Module */
  pageModule?: Maybe<PageModule>;
};

/** Module model */
export type ModuleContainer = {
  __typename?: 'ModuleContainer';
  /** Module attributes */
  attributes: ModuleAttributes;
  /** Ordered array of Content in this Module. */
  collection: Array<ContentUnion>;
  /** Raw attributes of the Node */
  rawAttributes?: Maybe<Scalars['JSON']>;
  /** Container subtype */
  subtype?: Maybe<Scalars['String']>;
  /** Container Type */
  type: Scalars['String'];
};

/** Module model attributes */
export type ModuleInputAttributes = {
  /** Module ID */
  moduleId?: InputMaybe<Scalars['String']>;
  /** Page Module */
  pageModule?: InputMaybe<PageModuleInput>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Cancel scheduling of an already scheduled content. */
  cancelScheduledContent: ScheduledContent;
  /** Archive a collection. Prevent it from showing up in search. */
  collectionArchive: Collection;
  /** Copy a collection. */
  collectionCopy: Collection;
  /** Create a new collection. */
  collectionCreate: Collection;
  /** Archive a collection. Prevent it from showing up in search. */
  collectionDTOArchive: CollectionDto;
  /** Copy a collection. */
  collectionDTOCopy: CollectionDto;
  /** Create a new collection. */
  collectionDTOCreate: CollectionDto;
  /** Update a collection. May create a new revision. */
  collectionDTOUpdate: CollectionDto;
  /** Delete scheduled collection. */
  collectionDeleteScheduled: Collection;
  /** Converts a Collection to Off-Platform Module */
  collectionOffPlatformConvert: Collection;
  /** Schedule a collection */
  collectionSchedule: Collection;
  /** Update a collection. May create a new revision. */
  collectionUpdate: Collection;
  /** Converts a collection to an off platform module. */
  convertToOffPlatform: OffPlatformDto;
  /** Creates a new banner and publishes it to Allesseh. */
  createBanner: BannerDto;
  /** Create a new issue. */
  createITP: ItpIssue;
  /** Create a new issue. */
  createItpDTO: ItpDto;
  /** Create a new newsletter in Allesseh. */
  createNewsletter: NewsletterDto;
  /** Create a new newsletter in Allesseh Preview. */
  createPreviewNewsletter: NewsletterDto;
  /** Create a section front (e.g. World, Business, U.S., Politics) page for WSJ brand. */
  createWSJSectionFrontPage: PageDto;
  /** Delete Allesseh collection. */
  deleteAllessehCollection: CollectionDeleteResult;
  /** Delete an issue. */
  deleteITP: ItpIssue;
  /** Delete an issue. */
  deleteItpDTO: Scalars['Boolean'];
  /** Get preview link for banner. */
  getBannerPreviewLink: Scalars['String'];
  /** Create a new page. */
  pageCreate: Page;
  /** Get preview link for a page. */
  pageDTOPreviewLink?: Maybe<Scalars['String']>;
  /** Update a page. May create a new revision. */
  pageDTOUpdate: PageDto;
  /** Delete scheduled page. */
  pageDelete: Page;
  /** Get preview link for a page. */
  pagePreviewLink?: Maybe<Scalars['String']>;
  /** Update a page. May create a new revision. */
  pageUpdate: Page;
  /** Get a list of itp allesseh collections links for preview */
  previewItpDTOLink?: Maybe<Array<Scalars['String']>>;
  /** Get a list of itp allesseh collections links for preview */
  previewItpLink?: Maybe<Array<Scalars['String']>>;
  /** Update a publication setting. */
  publicationSettingUpdate: PublicationSetting;
  /** Save & Publish issue and pages. */
  publishITP: ItpIssueWithPages;
  /** Save & Publish issue and pages. */
  publishItpDTO: ItpDto;
  /** Reschedule a previously scheduled content for a later date. */
  rescheduleContent: ScheduledContent;
  /** Save content as a draft. */
  saveDraftContent: ScheduledContent;
  /** Save issue & pages. */
  saveITP: ItpIssueWithPages;
  /** Save issue & pages. */
  saveItpDTO: ItpDto;
  /** Schedule some Allesseh content to be published at a future date. */
  scheduleContent: ScheduledContent;
  /** Updates an existing banner and publishes the changes to Allesseh. */
  updateBanner: BannerDto;
  /** Update an off platform module. May create a new revision. */
  updateOffPlatform: OffPlatformDto;
  /** Update an already scheduled content. */
  updateScheduledContent: ScheduledContent;
};

export type MutationCancelScheduledContentArgs = {
  publicationKey: Scalars['String'];
  scheduledContentCancelInput: ScheduledContentCancelInput;
};

export type MutationCollectionArchiveArgs = {
  collectionArchiveInput: CollectionArchiveInput;
};

export type MutationCollectionCopyArgs = {
  collectionCopyInput: CollectionCopyInput;
};

export type MutationCollectionCreateArgs = {
  collectionCreateInput: CollectionCreateInput;
};

export type MutationCollectionDtoArchiveArgs = {
  collectionDTOArchiveInput: CollectionDtoArchiveInput;
};

export type MutationCollectionDtoCopyArgs = {
  collectionDTOCopyInput: CollectionDtoMutationInput;
};

export type MutationCollectionDtoCreateArgs = {
  collectionDTOCreateInput: CollectionDtoCreateInput;
};

export type MutationCollectionDtoUpdateArgs = {
  collectionDTOUpdateInput: CollectionDtoMutationInput;
};

export type MutationCollectionDeleteScheduledArgs = {
  collectionDeleteScheduledInput: CollectionDeleteScheduledInput;
};

export type MutationCollectionOffPlatformConvertArgs = {
  collectionOffPlatformInput: CollectionOffPlatformInput;
};

export type MutationCollectionScheduleArgs = {
  collectionScheduleInput: CollectionScheduleInput;
  previousPublishUtc?: InputMaybe<Scalars['Float']>;
};

export type MutationCollectionUpdateArgs = {
  collectionUpdateInput: CollectionUpdateInput;
};

export type MutationConvertToOffPlatformArgs = {
  convertToOffPlatformInput: ConvertToOffPlatformInput;
};

export type MutationCreateBannerArgs = {
  bannerDTOCreateInput: BannerDtoCreateInput;
};

export type MutationCreateItpArgs = {
  itpCreateInput: ItpCreateInput;
  publicationKey: Scalars['String'];
};

export type MutationCreateItpDtoArgs = {
  itpDTOCreateInput: ItpDtoCreateInput;
  publicationKey: Scalars['String'];
};

export type MutationCreateNewsletterArgs = {
  newsletterInput: NewsletterInput;
};

export type MutationCreatePreviewNewsletterArgs = {
  newsletterInput: NewsletterInput;
};

export type MutationCreateWsjSectionFrontPageArgs = {
  wsjSectionFrontCreateInput: WsjSectionFrontCreateInput;
};

export type MutationDeleteAllessehCollectionArgs = {
  deleteAllessehCollectionInput: DeleteAllessehCollectionInput;
};

export type MutationDeleteItpArgs = {
  issueId: Scalars['String'];
  publicationKey: Scalars['String'];
};

export type MutationDeleteItpDtoArgs = {
  allessehId: Scalars['String'];
  publicationKey: Scalars['String'];
};

export type MutationGetBannerPreviewLinkArgs = {
  bannerPreviewLinkInput: BannerDtoPreviewLinkInput;
};

export type MutationPageCreateArgs = {
  pageCreateInput: PageCreateInput;
};

export type MutationPageDtoPreviewLinkArgs = {
  pagePreviewLinkInput: PageDtoPreviewLinkInput;
};

export type MutationPageDtoUpdateArgs = {
  pageUpdateInput: PageDtoUpdateInput;
};

export type MutationPageDeleteArgs = {
  pageDeleteInput: PageDeleteInput;
};

export type MutationPagePreviewLinkArgs = {
  pagePreviewLinkInput: PagePreviewLinkInput;
};

export type MutationPageUpdateArgs = {
  pageUpdateInput: PageUpdateInput;
};

export type MutationPreviewItpDtoLinkArgs = {
  itpDTOPreviewInput: ItpDtoSaveInput;
  publicationKey: Scalars['String'];
};

export type MutationPreviewItpLinkArgs = {
  itpPreviewInput: ItpSaveInput;
  publicationKey: Scalars['String'];
};

export type MutationPublicationSettingUpdateArgs = {
  publicationSettingUpdateInput: PublicationSettingUpdateInput;
};

export type MutationPublishItpArgs = {
  itpSaveInput: ItpSaveInput;
  publicationKey: Scalars['String'];
};

export type MutationPublishItpDtoArgs = {
  itpDTOSaveInput: ItpDtoSaveInput;
  publicationKey: Scalars['String'];
};

export type MutationRescheduleContentArgs = {
  publicationKey: Scalars['String'];
  scheduledContentRescheduleInput: ScheduledContentRescheduleInput;
};

export type MutationSaveDraftContentArgs = {
  publicationKey: Scalars['String'];
  scheduledContentSaveDraftInput: ScheduledContentSaveDraftInput;
};

export type MutationSaveItpArgs = {
  itpSaveInput: ItpSaveInput;
  publicationKey: Scalars['String'];
};

export type MutationSaveItpDtoArgs = {
  itpDTOSaveInput: ItpDtoSaveInput;
  publicationKey: Scalars['String'];
};

export type MutationScheduleContentArgs = {
  publicationKey: Scalars['String'];
  scheduledContentCreateInput: ScheduledContentCreateInput;
};

export type MutationUpdateBannerArgs = {
  bannerDTOUpdateInput: BannerDtoUpdateInput;
};

export type MutationUpdateOffPlatformArgs = {
  offPlatformUpdateInput: OffPlatformUpdateInput;
};

export type MutationUpdateScheduledContentArgs = {
  publicationKey: Scalars['String'];
  scheduledContentUpdateInput: ScheduledContentUpdateInput;
};

/** Newsletter Page model attributes */
export type NewsletterAttributesInput = {
  /** Campaign id */
  campaignId: Scalars['String'];
  /** Page Layout Id */
  layoutId?: InputMaybe<Scalars['String']>;
  /** Newsletter id */
  newsletterId: Scalars['Float'];
  /** Pre-Header text */
  preHeaderText: Scalars['String'];
  /** email recipients */
  recipients?: InputMaybe<Scalars['String']>;
  /** email for reply to */
  replyToEmail: Scalars['String'];
  /** Newsletter Sender */
  senderName: Scalars['String'];
  /** email subject line */
  subject: Scalars['String'];
};

export type NewsletterDto = {
  __typename?: 'NewsletterDTO';
  /** Base metadata properties for all Curation artifacts. */
  metadata: BaseMetadata;
  /** Root container. */
  root: NewsletterPageContainer;
  type: Scalars['String'];
};

export type NewsletterDtoConnection = {
  __typename?: 'NewsletterDTOConnection';
  /** Pagination results. */
  edges: Array<NewsletterDtoEdge>;
  /** Page info for results. */
  pageInfo: PageInfo;
};

export type NewsletterDtoEdge = {
  __typename?: 'NewsletterDTOEdge';
  /** Current cursor of edge. */
  cursor: Scalars['String'];
  /** Newsletter data within paginated results. */
  node: NewsletterDto;
};

export type NewsletterInput = {
  /** Allesseh ID of this Curation artifact. */
  allessehId: Scalars['String'];
  attributes: NewsletterAttributesInput;
  /** Ordered array of manually curated content. */
  collection: Array<ArticleItemInput>;
  moduleAttributes: ModuleInputAttributes;
  /** Newsletter name */
  name: Scalars['String'];
  publicationKey: Scalars['String'];
};

/** Default Campaign Details. */
export type NewsletterItemDefaultCampaignDetails = {
  __typename?: 'NewsletterItemDefaultCampaignDetails';
  /** Subject line */
  Subject: Scalars['String'];
  /** Text before header */
  pre_header_text: Scalars['String'];
  /** Reply-to email */
  reply_to_email: Scalars['String'];
  /** Sender name */
  sender_name: Scalars['String'];
};

/** Campaign schedule time. */
export type NewsletterItemSchedule = {
  __typename?: 'NewsletterItemSchedule';
  /** Cron string */
  cron: Scalars['String'];
  /** Timezone */
  timezone: Scalars['String'];
};

/** Items returned from the Panda API source of truth for newsletters. */
export type NewsletterListItem = {
  __typename?: 'NewsletterListItem';
  /** Default campaign details */
  defaultCampaignDetails?: Maybe<NewsletterItemDefaultCampaignDetails>;
  /** Description of newsletter */
  description: Scalars['String'];
  /** ID in Panda API */
  id: Scalars['String'];
  /** Newsletter name */
  name: Scalars['String'];
  /** Publication newsletter belongs too */
  product: Scalars['String'];
  /** Time when newsletter should be scheduled for sending */
  schedule?: Maybe<NewsletterItemSchedule>;
  /** Newsletter subject */
  subject: Scalars['String'];
};

/** Newsletter Page model attributes */
export type NewsletterPageAttributes = {
  __typename?: 'NewsletterPageAttributes';
  /** Campaign id */
  campaignId: Scalars['String'];
  /** External container info. `null` if not an external container */
  externalContainer?: Maybe<ExternalContainerAttributes>;
  /** Page Layout Id */
  layoutId?: Maybe<Scalars['String']>;
  /** Newsletter id */
  newsletterId: Scalars['Float'];
  /** Pre-Header text */
  preHeaderText: Scalars['String'];
  /** email recipients */
  recipients?: Maybe<Scalars['String']>;
  /** email for reply to */
  replyToEmail: Scalars['String'];
  /** Newsletter Sender */
  senderName: Scalars['String'];
  /** email subject line */
  subject: Scalars['String'];
};

/** Newsletter Page model */
export type NewsletterPageContainer = {
  __typename?: 'NewsletterPageContainer';
  /** Newsletter Page Model attributes */
  attributes: NewsletterPageAttributes;
  /** Ordered array of Modules for this Page. */
  collection: Array<ModuleContainer>;
  /** Raw attributes of the Node */
  rawAttributes?: Maybe<Scalars['JSON']>;
  /** Container subtype */
  subtype?: Maybe<Scalars['String']>;
  /** Container Type */
  type: Scalars['String'];
};

export type NewslettersSearchInput = {
  /** Array of Newsletter composite keys to exclude. */
  excludedNewsletterIdCreatedUtcs?: InputMaybe<Array<Scalars['String']>>;
  /** Key to denote the publication. (ex: 'wsj', 'barrons') */
  publicationKey: Scalars['String'];
  /** Search input text for a newsletter. */
  searchText?: InputMaybe<Scalars['String']>;
};

/** Represents an off platform that contains a collection of Articles and metadata. */
export type OffPlatformDto = {
  __typename?: 'OffPlatformDTO';
  /** Composite key for a collection. */
  idCreatedUtc: Scalars['String'];
  /** Metadata properties. */
  metadata: OffPlatformMetadata;
  /** Off platform root container. */
  root: OffPlatformListContainer;
  type: Scalars['String'];
};

export type OffPlatformDtoConnection = {
  __typename?: 'OffPlatformDTOConnection';
  /** Pagination results. */
  edges: Array<OffPlatformDtoEdge>;
  /** Page info for results. */
  pageInfo: PageInfo;
};

export type OffPlatformDtoEdge = {
  __typename?: 'OffPlatformDTOEdge';
  /** Current cursor of edge. */
  cursor: Scalars['String'];
  /** Collection data within paginated results. */
  node: OffPlatformDto;
};

export type OffPlatformInput = {
  /** Key to denote the publication. (ex: 'wsj', 'barrons') */
  publicationKey: Scalars['String'];
};

/** OffPlatform List model attributes */
export type OffPlatformListAttributes = {
  __typename?: 'OffPlatformListAttributes';
  /** OffPlatform date for OffPlatform Lists */
  defaultAltSummVariant: Scalars['String'];
  /** External container info. `null` if not an external container */
  externalContainer?: Maybe<ExternalContainerAttributes>;
  /** Host Page URL */
  hostingPageURL: Scalars['String'];
  /** Maximum number of items this List can hold */
  maxItems: Scalars['Float'];
  /** Minimum number of items this list can hold */
  minItems: Scalars['Float'];
  /** Module name displayed on the host page */
  moduleDisplayName: Scalars['String'];
};

/** OffPlatform List model */
export type OffPlatformListContainer = {
  __typename?: 'OffPlatformListContainer';
  /** OffPlatform List Model attributes */
  attributes: OffPlatformListAttributes;
  /** Ordered array of Content in this List. */
  collection: Array<ContentUnion>;
  /** Raw attributes of the Node */
  rawAttributes?: Maybe<Scalars['JSON']>;
  /** Container subtype */
  subtype?: Maybe<Scalars['String']>;
  /** Container Type */
  type: Scalars['String'];
};

/** Off platform metadata. */
export type OffPlatformMetadata = {
  __typename?: 'OffPlatformMetadata';
  /** Allesseh ID of this Curation artifact. */
  allessehId: Scalars['String'];
  /** Specifies which publication can include this off platform. */
  consumer: Scalars['String'];
  /** Unix timestamp of when this Curation artifact was created. */
  createdUtc: Scalars['Float'];
  creatorUser: AllessehUser;
  /** Indicates whether this off platform is archived. */
  isArchived: Scalars['Boolean'];
  name: Scalars['String'];
  /** Freeform notes field for editors to write in. */
  notes?: Maybe<Scalars['String']>;
  publicationKey: Scalars['String'];
  publishUtc?: Maybe<Scalars['Float']>;
  revisorUser?: Maybe<AllessehUser>;
  updatedUtc?: Maybe<Scalars['Float']>;
};

export type OffPlatformParams = {
  __typename?: 'OffPlatformParams';
  /** Default alt-summ variant to use in this collection (e.g. "U.S. Home") */
  defaultAltSummVariant: Scalars['String'];
  /** URL of the page that hosts this off-platform module (e.g. https://wsj.com) */
  hostingPageURL: Scalars['String'];
  /** Maximum number of items the off-platform collection must contain */
  maxItems?: Maybe<Scalars['Float']>;
  /** Minimum number of items the off-platform collection must contain */
  minItems?: Maybe<Scalars['Float']>;
  /** Text to display as the module name (e.g. "BuySide Promotional Module") */
  moduleDisplayName: Scalars['String'];
};

export type OffPlatformUpdateInput = {
  /** Collection DTO artifact. */
  offPlatform: Scalars['JSON'];
  publicationKey: Scalars['String'];
};

/** Represents a page on a website or screen on a mobile app that contains multiple modules, each with collection and UI metadata. */
export type Page = {
  __typename?: 'Page';
  /** page route specific configuration. */
  config?: Maybe<PageRouteConfig>;
  /** MS since epoch of the datetime when this page revision was created. This is set once per page revision. */
  createdUtc: Scalars['Float'];
  /** Data of user who last updated this page. */
  creatorUser: AllessehUser;
  /** "true" if this page was published to Allesseh, otherwise "false" */
  isAllessehPublished: Scalars['String'];
  /** True if this page is for a mobile app screen instead of a web page. */
  isMobileAppScreen: Scalars['Boolean'];
  /** Layout ID that is connected to this page. */
  layoutId: Scalars['String'];
  /** Name for this page for use within this tool. */
  name: Scalars['String'];
  /** Freeform notes field for editors to write anything into. */
  notes?: Maybe<Scalars['String']>;
  /** Ordered array of modules programmed for this page. */
  pageModules: Array<PageModule>;
  /** Denotes the type of page. A page type enforces certain rules for the page. */
  pageType: PageType;
  /** Key to denote the publication. (ex: 'wsj', 'barrons') */
  publicationKey: Scalars['String'];
  /** Set to the publication key if this page revision is the latest in its revision group. */
  publicationKeyLatestQueryKey?: Maybe<Scalars['String']>;
  /** MS since epoch of the datetime when this page was or will be published. */
  publishUtc?: Maybe<Scalars['Float']>;
  /** ID that is the same across revisions for this page. */
  revisionGroupKey: Scalars['String'];
  /** Data of user who last updated this page revision. */
  revisorUser: AllessehUser;
  /** Url path structured key to denote where this page will be used. (ex: ‘/’, ‘/news/world’, etc.). This is combined with the baseRoute from publication setting. */
  routeKey: Scalars['String'];
};

/** Page model attributes */
export type PageAttributes = {
  __typename?: 'PageAttributes';
  /** External container info. `null` if not an external container */
  externalContainer?: Maybe<ExternalContainerAttributes>;
  /** Page Layout Id */
  layoutId?: Maybe<Scalars['String']>;
};

export type PageConnection = {
  __typename?: 'PageConnection';
  /** Pagination results. */
  edges: Array<PageEdge>;
  /** Page info for results. */
  pageInfo: PageInfo;
};

/** Page model */
export type PageContainer = {
  __typename?: 'PageContainer';
  /** Page attributes */
  attributes: PageAttributes;
  /** Ordered array of Modules for this Page. */
  collection: Array<ModuleContainer>;
  /** Raw attributes of the Node */
  rawAttributes?: Maybe<Scalars['JSON']>;
  /** Container subtype */
  subtype?: Maybe<Scalars['String']>;
  /** Container Type */
  type: Scalars['String'];
};

export type PageCreateInput = {
  /** ID that is the same across revisions for this page. */
  isMobileAppScreen?: InputMaybe<Scalars['Boolean']>;
  /** Layout ID that is connected to this page. */
  layoutId: Scalars['String'];
  /** Name for this page for use within this tool. */
  name: Scalars['String'];
  /** Denotes the type of page. A page type enforces certain rules for the page. */
  pageType: PageType;
  /** Key to denote the publication. (ex: 'wsj', 'barrons') */
  publicationKey: Scalars['String'];
  /** ID that is the same across revisions for this page. */
  revisionGroupKey?: InputMaybe<Scalars['String']>;
  /** Url path structured key to denote where this page will be used. (ex: ‘/’, ‘/news/world’, etc.). This is combined with the baseRoute from publication setting. Must be unique. */
  routeKey: Scalars['String'];
};

/** Represents a page on a website or screen on a mobile app that contains multiple modules, each with collection and UI metadata. */
export type PageDto = {
  __typename?: 'PageDTO';
  /** Base metadata properties for all Curation artifacts. */
  metadata: BaseMetadata;
  /** Section page root container. */
  root: SectionContainer;
  /** Unique string denoting the type of this DTO. */
  type: Scalars['String'];
};

export type PageDtoConnection = {
  __typename?: 'PageDTOConnection';
  /** Pagination results. */
  edges: Array<PageDtoEdge>;
  /** Page info for results. */
  pageInfo: PageInfo;
};

export type PageDtoEdge = {
  __typename?: 'PageDTOEdge';
  /** Current cursor of edge. */
  cursor: Scalars['String'];
  /** Page data within paginated results. */
  node: PageDto;
};

export type PageDtoPreviewLinkInput = {
  /** Section page DTO artifact. */
  pageDTO: Scalars['JSON'];
  /** Key to denote the publication. (ex: 'wsj', 'barrons') */
  publicationKey: Scalars['String'];
};

export type PageDtoUpdateInput = {
  /** Section page DTO artifact. */
  pageDTO: Scalars['JSON'];
  /** Key to denote the publication. (ex: 'wsj', 'barrons') */
  publicationKey: Scalars['String'];
};

export type PageDeleteInput = {
  /** MS since epoch of the datetime when this page revision was created. This is set once per page revision. */
  createdUtc: Scalars['Float'];
  /** Key to denote the publication. (ex: 'wsj', 'barrons') */
  publicationKey: Scalars['String'];
  /** ID that is the same across revisions for this page. */
  revisionGroupKey: Scalars['String'];
};

export type PageEdge = {
  __typename?: 'PageEdge';
  /** Current cursor of edge. */
  cursor: Scalars['String'];
  /** Page data within paginated results. */
  node: Page;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  /** End cursor used for retrieving a next page. */
  endCursor?: Maybe<Scalars['String']>;
  /** True if there is a next page. */
  hasNextPage: Scalars['Boolean'];
  /** True if there is a previous page. */
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  /** Start cursor used for retrieving a previous page. */
  startCursor?: Maybe<Scalars['String']>;
};

/** A section of a page that contains 1 collection and some fields for UI display use. */
export type PageModule = {
  __typename?: 'PageModule';
  /** Generic error message that can be attached to a page module. */
  error?: Maybe<Scalars['String']>;
  /** Denotes if the module has a validation error. */
  hasValidationError?: Maybe<Scalars['Boolean']>;
  /** The list of content or queries available for a page module. */
  moduleItems: Array<PageModuleItem>;
  /** Fields for the UI Module specific to the UI module type. */
  uiModuleFields: UiModule;
  /** Denotes the type of UI module, which defines what the uiModuleFields schema is. There is one type of UI module per UI data schema. */
  uiModuleType: UiModuleType;
};

/** A section of a page that contains 1 collection and some fields for UI display use. */
export type PageModuleInput = {
  /** The list of content or queries available for a page module. */
  moduleItems: Array<PageModuleItemInput>;
  /** Fields for the UI Module specific to the UI module type. */
  uiModuleFields: UiModuleInput;
  /** Denotes the type of UI module, which defines what the uiModuleFields schema is. There is one type of UI module per UI data schema. */
  uiModuleType: Scalars['String'];
};

/** A page module item that contains a piece of content or a query. */
export type PageModuleItem = {
  __typename?: 'PageModuleItem';
  /** Fields for the module content specific to the type. */
  itemFields: PageModuleItemFields;
  /** Denotes the type of module item type, which defines what the fields schema is. */
  itemType: PageModuleItemType;
};

/** Fields to signify a direct Allesseh collection. */
export type PageModuleItemAllessehCollection = {
  __typename?: 'PageModuleItemAllessehCollection';
  /** Allesseh Collection ID */
  allessehCollectionId: Scalars['String'];
};

/** Fields to signify a direct Allesseh collection. */
export type PageModuleItemAllessehCollectionInput = {
  /** Allesseh Collection ID */
  allessehCollectionId: Scalars['String'];
};

/** Fields to signify a collection. */
export type PageModuleItemCollection = {
  __typename?: 'PageModuleItemCollection';
  collection?: Maybe<Collection>;
  collectionQueryCount?: Maybe<PageModuleItemCollectionQueryCount>;
  /** Composite key for a collection. */
  idCreatedUtc: Scalars['String'];
};

/** Fields to signify a collection. */
export type PageModuleItemCollectionInput = {
  collectionQueryCount?: InputMaybe<PageModuleItemCollectionQueryCountInput>;
  /** Composite key for a collection. */
  idCreatedUtc: Scalars['String'];
};

/** Fields to signify collection query count. */
export type PageModuleItemCollectionQueryCount = {
  __typename?: 'PageModuleItemCollectionQueryCount';
  /** For queried or curated + queried collections number of query items. */
  count: Scalars['Float'];
};

/** Fields to signify collection query count. */
export type PageModuleItemCollectionQueryCountInput = {
  /** For queried or curated + queried collections number of query items. */
  count: Scalars['Float'];
};

/** Fields to signify a piece of content. */
export type PageModuleItemContent = {
  __typename?: 'PageModuleItemContent';
  /** Same as origin id. */
  base_doc_id: Scalars['String'];
  content?: Maybe<Scalars['String']>;
  /** Where the article is hosted, obtained from metadata for article (canonical_url in metadata). */
  hosted_url: Scalars['String'];
  /** ID to represent the content item as represented by originating source. (ex: 'D7906099-0B15-4EBF-8815-964581E11CD4', 'MW-BT-CO-20220906-706724') */
  id: Scalars['String'];
  /** Link to access this article from the Allesseh API. */
  link: Scalars['String'];
  /** Type of the content as represented by originating source. (ex: article, video, audio) */
  originContentType: Scalars['String'];
  /** ID to represent the content item as represented by originating source. (ex: 'D7906099-0B15-4EBF-8815-964581E11CD4', 'MW-BT-CO-20220906-706724') */
  originId: Scalars['String'];
  parameters?: Maybe<Array<ParametersType>>;
  /** Product the article originates from, obtained from metadata for article. */
  product: Scalars['String'];
  /** Seo ID, obtained from metadata for article. */
  seo_id: Scalars['String'];
  /** The status of the article, obtained from metadata for article (content_status in metadata). */
  status: Scalars['String'];
};

/** Fields to signify a piece of content. */
export type PageModuleItemContentInput = {
  /** Same as origin id. */
  base_doc_id: Scalars['String'];
  /** Where the article is hosted, obtained from metadata for article (canonical_url in metadata). */
  hosted_url: Scalars['String'];
  /** ID to represent the content item as represented by originating source. (ex: 'D7906099-0B15-4EBF-8815-964581E11CD4', 'MW-BT-CO-20220906-706724') */
  id: Scalars['String'];
  /** Link to access this article from the Allesseh API. */
  link: Scalars['String'];
  /** Type of the content as represented by originating source. (ex: article, video, audio) */
  originContentType: Scalars['String'];
  /** ID to represent the content item as represented by originating source. (ex: 'D7906099-0B15-4EBF-8815-964581E11CD4', 'MW-BT-CO-20220906-706724') */
  originId: Scalars['String'];
  parameters?: InputMaybe<Array<ParametersInput>>;
  /** Product the article originates from, obtained from metadata for article. */
  product: Scalars['String'];
  /** Seo ID, obtained from metadata for article. */
  seo_id: Scalars['String'];
  /** The status of the article, obtained from metadata for article (content_status in metadata). */
  status: Scalars['String'];
};

/** Fields for the specific module item. Only one field should be set. */
export type PageModuleItemFields = {
  __typename?: 'PageModuleItemFields';
  allessehCollectionItem?: Maybe<PageModuleItemAllessehCollection>;
  collectionItem?: Maybe<PageModuleItemCollection>;
  contentItem?: Maybe<PageModuleItemContent>;
  linkedItem?: Maybe<PageModuleItemLinkedItem>;
  queryItem?: Maybe<PageModuleItemQuery>;
};

/** Fields for the specific module item. Only one field should be set. */
export type PageModuleItemFieldsInput = {
  allessehCollectionItem?: InputMaybe<PageModuleItemAllessehCollectionInput>;
  collectionItem?: InputMaybe<PageModuleItemCollectionInput>;
  contentItem?: InputMaybe<PageModuleItemContentInput>;
  linkedItem?: InputMaybe<PageModuleItemLinkedItemInput>;
  queryItem?: InputMaybe<PageModuleItemQueryInput>;
};

/** A page module item that contains a piece of content or a query. */
export type PageModuleItemInput = {
  /** Fields for the module content specific to the type. */
  itemFields: PageModuleItemFieldsInput;
  /** Denotes the type of module item type, which defines what the fields schema is. */
  itemType: PageModuleItemType;
};

/** Fields to signify a link to an item outside of Allesseh. */
export type PageModuleItemLinkedItem = {
  __typename?: 'PageModuleItemLinkedItem';
  /** Headline of externally content (AKA: `Title`) */
  headline: Scalars['String'];
  /** Media associated with external content (AKA: `Image`) */
  media?: Maybe<Scalars['String']>;
  /** Summary of external content (AKA: `Description`) */
  summary?: Maybe<Scalars['String']>;
  /** Url to the external content (AKA: `HostedUrl`) */
  url: Scalars['String'];
  /** Allows admin users to publish with internal urls */
  validationBypassed?: Maybe<Scalars['Boolean']>;
};

/** Fields to signify a link to an item outside of Allesseh. */
export type PageModuleItemLinkedItemInput = {
  /** Headline of externally content (AKA: `Title`) */
  headline: Scalars['String'];
  /** Media associated with external content (AKA: `Image`) */
  media?: InputMaybe<Scalars['String']>;
  /** Summary of external content (AKA: `Description`) */
  summary?: InputMaybe<Scalars['String']>;
  /** Url to the external content (AKA: `HostedUrl`) */
  url: Scalars['String'];
  /** Allows admin users to publish with internal urls */
  validationBypassed?: InputMaybe<Scalars['Boolean']>;
};

/** Fields to signify an Allesseh query. */
export type PageModuleItemQuery = {
  __typename?: 'PageModuleItemQuery';
  /** Whether the query is a feed. */
  isFeed?: Maybe<Scalars['Boolean']>;
  /** JSON formatted string representing the query to search content on Allesseh. */
  jsonQuery: Scalars['String'];
  /** Title for the feed queries. */
  title?: Maybe<Scalars['String']>;
  /** URL for the feed queries. */
  url?: Maybe<Scalars['String']>;
};

/** Fields to signify an Allesseh query. */
export type PageModuleItemQueryInput = {
  /** JSON formatted string representing the query to search content on Allesseh. */
  jsonQuery: Scalars['String'];
};

/** Denotes the type of module content item. */
export enum PageModuleItemType {
  AllessehCollection = 'AllessehCollection',
  Collection = 'Collection',
  Content = 'Content',
  LinkedItem = 'LinkedItem',
  Query = 'Query'
}

export type PagePreviewLinkInput = {
  /** MS since epoch of the datetime when this page revision was created. This is set once per page revision. */
  createdUtc: Scalars['Float'];
  /** Layout ID that is connected to this page. */
  layoutId: Scalars['String'];
  /** Name for this page for use within this tool. */
  name: Scalars['String'];
  /** Freeform notes field for editors to write anything into. */
  notes?: InputMaybe<Scalars['String']>;
  /** Ordered array of modules programmed for this page. */
  pageModules: Array<PageModuleInput>;
  /** Key to denote the publication. (ex: 'wsj', 'barrons') */
  publicationKey: Scalars['String'];
  /** ID that is the same across revisions for this page. */
  revisionGroupKey: Scalars['String'];
};

export type PageRouteConfig = {
  __typename?: 'PageRouteConfig';
  /** Alt-Sum variant to be used in this page (e.g. ‘U.S. Home’, ‘Markets Main’, etc.). */
  summaryPriority: Scalars['String'];
};

/** A page type enforces certain rules for the page. (ex: Home, Section) */
export enum PageType {
  Banner = 'BANNER',
  Home = 'HOME',
  HomeAdvisor = 'HOME_ADVISOR',
  Itp = 'ITP',
  Mobile = 'MOBILE',
  Newsletter = 'NEWSLETTER',
  ParentSection = 'PARENT_SECTION',
  Section = 'SECTION'
}

/** Defines the settings and restrictions for a particular page type for a publication. */
export type PageTypeSetting = {
  __typename?: 'PageTypeSetting';
  /** Content types allowed for the page */
  contentTypes: Array<PublicationSettingSearchableContentType>;
  /** Unordered array of available layout variations for the page type. */
  layouts: Array<Layout>;
  /** Denotes the type of page. A page type enforces certain rules for the page. */
  pageType: PageType;
  /** Key to denote the publication. (ex: 'wsj', 'barrons') */
  publicationKey: Scalars['String'];
  /** Settings for specific treatment types. One of each treatment type should exist in this array. */
  treatmentTypeSettings: Array<TreatmentTypeSetting>;
};

export type PageUpdateInput = {
  /** MS since epoch of the datetime when this page revision was created. This is set once per page revision. */
  createdUtc: Scalars['Float'];
  /** Layout ID that is connected to this page. */
  layoutId: Scalars['String'];
  /** Name for this page for use within this tool. */
  name: Scalars['String'];
  /** Freeform notes field for editors to write anything into. */
  notes?: InputMaybe<Scalars['String']>;
  /** Ordered array of modules programmed for this page. */
  pageModules: Array<PageModuleInput>;
  /** Key to denote the publication. (ex: 'wsj', 'barrons') */
  publicationKey: Scalars['String'];
  /** MS since epoch of the datetime when this page was or will be published. */
  publishUtc?: InputMaybe<Scalars['Float']>;
  /** ID that is the same across revisions for this page. */
  revisionGroupKey: Scalars['String'];
};

export type PagesDtoForCollection = {
  __typename?: 'PagesDTOForCollection';
  /** Page data within paginated results. */
  latestPage: PageDto;
  /** Number of revisions that use the collection */
  numRevisions: Scalars['Float'];
};

export type PagesDtoInput = {
  /** Key to denote the publication. (ex: 'wsj', 'barrons') */
  publicationKey: Scalars['String'];
  /** Search input text for a collection. */
  searchText?: InputMaybe<Scalars['String']>;
};

export type PagesForCollection = {
  __typename?: 'PagesForCollection';
  /** Page data within paginated results. */
  latestPage: Page;
  /** Number of revisions that use the collection */
  numRevisions: Scalars['Float'];
};

export type PagesInput = {
  /** Key to denote the publication. (ex: 'wsj', 'barrons') */
  publicationKey: Scalars['String'];
  /** Search input text for a collection. */
  searchText?: InputMaybe<Scalars['String']>;
};

export type PaginationParams = {
  /** Starting cursor for items coming after the last item in the current page */
  after?: InputMaybe<Scalars['String']>;
  /** Starting cursor for items coming before the first item in the current page */
  before?: InputMaybe<Scalars['String']>;
  /** Number of items after cursor. */
  first: Scalars['Float'];
};

export type ParametersInput = {
  /** Name of the parameter, can be anything. */
  name: Scalars['String'];
  /** Type of parameter, generally 'parameter'. */
  type: Scalars['String'];
  /** Value of the parameter, should be any type but cannot figure out how to make it so. */
  value: Scalars['String'];
};

export type ParametersType = {
  __typename?: 'ParametersType';
  /** Name of the parameter, can be anything. */
  name: Scalars['String'];
  /** Type of parameter, generally 'parameter'. */
  type: Scalars['String'];
  /** Value of the parameter, should be any type but cannot figure out how to make it so. */
  value: Scalars['String'];
};

export type PreferredTimezone = {
  __typename?: 'PreferredTimezone';
  /** IANA timezone identifier (https://en.wikipedia.org/wiki/List_of_tz_database_time_zones) */
  timezone: Scalars['String'];
  /** The abbreviation used to display the timezone. (ex: ET for America/New_York) */
  timezoneAbbreviation: Scalars['String'];
};

export type PreferredTimezoneInput = {
  /** IANA timezone identifier (https://en.wikipedia.org/wiki/List_of_tz_database_time_zones) */
  timezone: Scalars['String'];
  /** The abbreviation used to display the timezone. (ex: ET for America/New_York) */
  timezoneAbbreviation: Scalars['String'];
};

/** Properties object type */
export type Properties = {
  __typename?: 'Properties';
  /** IM Photo ID */
  imphotoid: Scalars['String'];
  /** Location of the property */
  location: Scalars['String'];
};

/** Publication settings, e.g. content types allowed for publications */
export type PublicationSetting = {
  __typename?: 'PublicationSetting';
  /** String representation of JSON for the base Allesseh query for AFP to be used always for this publication. */
  baseAfpAllessehQuery?: Maybe<Scalars['String']>;
  /** String representation of JSON for the base Allesseh query to be used always for this publication. */
  baseAllessehQuery: Scalars['String'];
  /** String representation of JSON for the base Allesseh query for Audio to be used always for this publication. */
  baseAudioAllessehQuery?: Maybe<Scalars['String']>;
  /** String representation of JSON for the base Allesseh query for Barrons to be used always for this publication. */
  baseBarronsAllessehQuery?: Maybe<Scalars['String']>;
  /** String representation of JSON for the base Allesseh query for DowJonesRiskJournal to be used always for this publication. */
  baseDowJonesRiskJournalAllessehQuery?: Maybe<Scalars['String']>;
  /** String representation of JSON for the base Allesseh query for DowJonesRiskJournalCCOEvents to be used always for this publication. */
  baseDowJonesRiskJournalCCOEventsAllessehQuery?: Maybe<Scalars['String']>;
  /** String representation of JSON for the base Allesseh query for DowJonesRiskJournalContributor to be used always for this publication. */
  baseDowJonesRiskJournalContributorAllessehQuery?: Maybe<Scalars['String']>;
  /** String representation of JSON for the base Allesseh query for DowJonesRiskJournalDJEvents to be used always for this publication. */
  baseDowJonesRiskJournalDJEventsAllessehQuery?: Maybe<Scalars['String']>;
  /** String representation of JSON for the base Allesseh query for ExportComplianceManager to be used always for this publication. */
  baseExportComplianceManagerAllessehQuery?: Maybe<Scalars['String']>;
  /** String representation of JSON for the base Allesseh query for LC to be used always for this publication. */
  baseLiveCoverageAllessehQuery?: Maybe<Scalars['String']>;
  /** String representation of JSON for the base Allesseh query for Mansion Global to be used always for this publication. */
  baseMansionGlobalAllessehQuery?: Maybe<Scalars['String']>;
  /** String representation of JSON for the base Allesseh query for Marketwatch to be used always for this publication. */
  baseMarketwatchAllessehQuery?: Maybe<Scalars['String']>;
  /** String representation of JSON for the base Allesseh query for Opinion to be used always for this publication. */
  baseOpinionAllessehQuery?: Maybe<Scalars['String']>;
  /** String representation of JSON for the base Allesseh query for Penta to be used always for this publication. */
  basePentaAllessehQuery?: Maybe<Scalars['String']>;
  /** String representation of JSON for the base Allesseh query for Podcast to be used always for this publication. */
  basePodcastAllessehQuery?: Maybe<Scalars['String']>;
  /** String representation of JSON for the base Allesseh query for Product cards to be used always for this publication. */
  baseProductCardAllessehQuery?: Maybe<Scalars['String']>;
  /** String representation of JSON for the base Allesseh query for Recipe to be used always for this publication. */
  baseRecipeAllessehQuery?: Maybe<Scalars['String']>;
  /** Base URL for all pages in publication without trailing slash. (ex: 'https://wsj.com/buyside') */
  baseRoute: Scalars['String'];
  /** String representation of JSON for the base Tappable Allesseh query to be used always for this publication. */
  baseTappableAllessehQuery?: Maybe<Scalars['String']>;
  /** String representation of JSON for the base Allesseh query for Video to be used always for this publication. */
  baseVideoAllessehQuery?: Maybe<Scalars['String']>;
  /** String representation of JSON for the base Allesseh query for Web Story to be used always for this publication. */
  baseWebStoryAllessehQuery?: Maybe<Scalars['String']>;
  /** String representation of JSON for the base Allesseh query for WorldECR to be used always for this publication. */
  baseWorldECRAllessehQuery?: Maybe<Scalars['String']>;
  /** String representation of JSON for the base Allesseh query for WSJ to be used always for this publication. */
  baseWsjAllessehQuery?: Maybe<Scalars['String']>;
  /** String representation of JSON for the required validations. */
  beforePublishValidation?: Maybe<Scalars['JSON']>;
  /** Default alt summ variant for publication. This is used when the publication does not have alt summ edit disabled. */
  defaultAltSumm?: Maybe<Scalars['String']>;
  /** Default publication content types set in the search filters (ex: 'article', 'tappable') */
  defaultContentTypes: Array<PublicationSettingSearchableContentType>;
  /** Boolean to denote if the publication has alt summary edit disabled. */
  disableAltSummEdit?: Maybe<Scalars['Boolean']>;
  /** Boolean to denote if the publication has embargo disabled (when true data comes from live allesseh endpoint). */
  disableEmbargo?: Maybe<Scalars['Boolean']>;
  /** List of external publications where alt summary edit is allowed. */
  editableExternalPublications?: Maybe<Array<Scalars['String']>>;
  /** Array of artifacts names (e.g. page, collection, offPlatform, newsletter, etc) enabled for this publication. */
  enabledArtifacts: Array<Artifact>;
  /** Boolean multi-purpose feature flag. Its use is determined by the publication. */
  generalPurposeFeatureFlag?: Maybe<GeneralPurposeFeatureFlag>;
  /** List of page types that are required for ITP and cannot be disabled. This is WSJ-only property. */
  itpRequiredPageTypes?: Maybe<Array<ItpIssuePageType>>;
  /** Object that specifies the preferred timezone of the publication used to display dates and times. */
  preferredTimezone: PreferredTimezone;
  /** Base URL for all pages in publication without trailing slash for preview mode. (ex: 'https://next.wsj.com/buyside') */
  previewBaseRoute: Scalars['String'];
  /** Key to denote the publication. (ex: 'wsj', 'barrons') */
  publicationKey: Scalars['String'];
  /** Publication content type (ex: 'video', 'audio') */
  searchableContentTypes: Array<PublicationSettingSearchableContentType>;
  /** Mapping of page slugs to page revision group keys. (ex: "homepage" -> "fd2b9eb3-3f01-4d17-99d0-21f335b7e31d") */
  slugMappings?: Maybe<Scalars['JSON']>;
  /** The Chartlos domain that is used by the Snippety Service to retrieve the data of a chart */
  snippetyChartDomain?: Maybe<Scalars['String']>;
  /** The Image Manager domain that is used by the Snippety Service to retrieve the data of an image */
  snippetyIMDomain?: Maybe<Scalars['String']>;
  /** The start domain of the video api that is used by the Snippety Service to retrieve the data for a video */
  snippetyVideoDomain?: Maybe<Scalars['String']>;
  /** Topic tool URL used to power feed queries for each publication (currently exists for barrons). */
  topicTool?: Maybe<Scalars['String']>;
};

/** The types of searchable content types for publications. */
export enum PublicationSettingSearchableContentType {
  Afp = 'Afp',
  Article = 'Article',
  Audio = 'Audio',
  Barrons = 'Barrons',
  CommerceProduct = 'CommerceProduct',
  DowJonesRiskJournal = 'DowJonesRiskJournal',
  DowJonesRiskJournalCcoEvents = 'DowJonesRiskJournalCCOEvents',
  DowJonesRiskJournalContributor = 'DowJonesRiskJournalContributor',
  DowJonesRiskJournalDjEvents = 'DowJonesRiskJournalDJEvents',
  ExportComplianceManager = 'ExportComplianceManager',
  LiveCoverage = 'LiveCoverage',
  LiveCoverageCard = 'LiveCoverageCard',
  LiveCoverageStack = 'LiveCoverageStack',
  MansionGlobal = 'MansionGlobal',
  Marketwatch = 'Marketwatch',
  Opinion = 'Opinion',
  Penta = 'Penta',
  Podcast = 'Podcast',
  Recipe = 'Recipe',
  Tappable = 'Tappable',
  Video = 'Video',
  Webstory = 'Webstory',
  WorldEcr = 'WorldECR',
  Wsj = 'Wsj'
}

export type PublicationSettingUpdateInput = {
  /** String representation of JSON for the base Allesseh query for AFP to be used always for this publication. */
  baseAfpAllessehQuery?: InputMaybe<Scalars['String']>;
  /** String representation of JSON for the base Allesseh query to be used always for this publication. */
  baseAllessehQuery: Scalars['String'];
  /** String representation of JSON for the base Allesseh query for Audio to be used always for this publication. */
  baseAudioAllessehQuery?: InputMaybe<Scalars['String']>;
  /** String representation of JSON for the base Allesseh query for Barrons to be used always for this publication. */
  baseBarronsAllessehQuery?: InputMaybe<Scalars['String']>;
  /** String representation of JSON for the base Allesseh query for DowJonesRiskJournalCCOEvents to be used always for this publication. */
  baseDowJonesRiskJournalCCOEventsAllessehQuery?: InputMaybe<Scalars['String']>;
  /** String representation of JSON for the base Allesseh query for DowJonesRiskJournalContributor to be used always for this publication. */
  baseDowJonesRiskJournalContributorAllessehQuery?: InputMaybe<Scalars['String']>;
  /** String representation of JSON for the base Allesseh query for DowJonesRiskJournalDJEvents to be used always for this publication. */
  baseDowJonesRiskJournalDJEventsAllessehQuery?: InputMaybe<Scalars['String']>;
  /** String representation of JSON for the base Allesseh query for ExportComplianceManager to be used always for this publication. */
  baseExportComplianceManagerAllessehQuery?: InputMaybe<Scalars['String']>;
  /** String representation of JSON for the base Allesseh query for LC to be used always for this publication. */
  baseLiveCoverageAllessehQuery?: InputMaybe<Scalars['String']>;
  /** String representation of JSON for the base Allesseh query for MansionGlobal to be used always for this publication. */
  baseMansionGlobalAllessehQuery?: InputMaybe<Scalars['String']>;
  /** String representation of JSON for the base Allesseh query for Marketwatch to be used always for this publication. */
  baseMarketwatchAllessehQuery?: InputMaybe<Scalars['String']>;
  /** String representation of JSON for the base Allesseh query for Opinion to be used always for this publication. */
  baseOpinionAllessehQuery?: InputMaybe<Scalars['String']>;
  /** String representation of JSON for the base Allesseh query for Penta to be used always for this publication. */
  basePentaAllessehQuery?: InputMaybe<Scalars['String']>;
  /** String representation of JSON for the base Allesseh query for Podcast to be used always for this publication. */
  basePodcastAllessehQuery?: InputMaybe<Scalars['String']>;
  /** String representation of JSON for the base Allesseh query for Product cards to be used always for this publication. */
  baseProductCardAllessehQuery?: InputMaybe<Scalars['String']>;
  /** String representation of JSON for the base Allesseh query for Recipe to be used always for this publication. */
  baseRecipeAllessehQuery?: InputMaybe<Scalars['String']>;
  /** Base URL for all pages in publication without trailing slash. (ex: 'https://wsj.com/buyside' */
  baseRoute: Scalars['String'];
  /** String representation of JSON for the base Tappable Allesseh query to be used always for this publication. */
  baseTappableAllessehQuery?: InputMaybe<Scalars['String']>;
  /** String representation of JSON for the base Allesseh query for Video to be used always for this publication. */
  baseVideoAllessehQuery?: InputMaybe<Scalars['String']>;
  /** String representation of JSON for the base Allesseh query for Web Story to be used always for this publication. */
  baseWebStoryAllessehQuery?: InputMaybe<Scalars['String']>;
  /** String representation of JSON for the base Allesseh query for WorldECR to be used always for this publication. */
  baseWorldECRAllessehQuery?: InputMaybe<Scalars['String']>;
  /** String representation of JSON for the base Allesseh query for WSJ to be used always for this publication. */
  baseWsjAllessehQuery?: InputMaybe<Scalars['String']>;
  /** An object that specifies which validations should be applied for each allessehId. Example: {"UCSD_BARRONS_ADVISOR":{"max":true,"min":false}} */
  beforePublishValidation?: InputMaybe<Scalars['JSON']>;
  /** Default alt summ variant for publication. This is used when the publication does not have alt summ edit disabled. */
  defaultAltSumm?: InputMaybe<Scalars['String']>;
  /** Default publication content types set in the search filters (ex: 'article', 'tappable') */
  defaultContentTypes: Array<PublicationSettingSearchableContentType>;
  /** Boolean to denote if the publication has alt summary edit disabled. */
  disableAltSummEdit?: InputMaybe<Scalars['Boolean']>;
  /** Boolean to denote if the publication has embargo disabled (when true data comes from live allesseh endpoint). */
  disableEmbargo?: InputMaybe<Scalars['Boolean']>;
  /** List of external publications where alt summary edit is allowed. */
  editableExternalPublications?: InputMaybe<Array<Scalars['String']>>;
  /** Array of artifacts names (e.g. page, collection, offPlatform, newsletter, etc) enabled for this publication. */
  enabledArtifacts: Array<Artifact>;
  /** List of page types that are required for ITP and cannot be disabled. This is WSJ-only property. */
  itpRequiredPageTypes?: InputMaybe<Array<ItpIssuePageType>>;
  /** Object that specifies the preferred timezone of the publication used to display dates and times. */
  preferredTimezone: PreferredTimezoneInput;
  /** Base URL for all pages in publication without trailing slash for preview mode. (ex: 'https://buyside.dev.next.wsj.com/buyside' */
  previewBaseRoute: Scalars['String'];
  /** Key to denote the publication. (ex: 'wsj', 'barrons') */
  publicationKey: Scalars['String'];
  /** Publication content type (ex: 'video', 'audio') */
  searchableContentTypes: Array<PublicationSettingSearchableContentType>;
  /** Mapping of page slugs to page revision group keys. (ex: "homepage" -> "fd2b9eb3-3f01-4d17-99d0-21f335b7e31d") */
  slugMappings?: InputMaybe<Scalars['JSON']>;
  /** The Chartlos domain that is used by the Snippety Service to retrieve the data of a chart */
  snippetyChartDomain?: InputMaybe<Scalars['String']>;
  /** The Image Manager domain that is used by the Snippety Service to retrieve the data of an image */
  snippetyIMDomain?: InputMaybe<Scalars['String']>;
  /** The start domain of the video api that is used by the Snippety Service to retrieve the data for a video */
  snippetyVideoDomain?: InputMaybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  /** Get the current revision for a collection. */
  collectionById: Collection;
  /** Get the current revision for a collection. */
  collectionDTOById: CollectionDto;
  collections: CollectionConnection;
  collectionsDTO: CollectionDtoConnection;
  /** Get all collections for an allesseh ID published on a specific date */
  collectionsPublishedOnDate: CollectionConnection;
  /** A placeholder query to expose the CronNotificationScheduledContent type in the schema */
  cronNotificationPlaceholder: Array<CronNotificationScheduledContent>;
  /** Get all the off platform. */
  getAllOffPlatform: OffPlatformDtoConnection;
  /** Get the current revision for a banner by its Allesseh ID. */
  getBannerById: BannerDto;
  /** Get a paginated response of all banners for a publication. */
  getBanners: BannerDtoConnection;
  /** Get default issue pages. */
  getDefaultITPIssueState: ItpDto;
  /** Get default issue pages. */
  getDefaultITPPages: Array<ItpPage>;
  /** Get newsletter list items. */
  getNewsletterList: Array<NewsletterListItem>;
  getNewsletters: NewsletterDtoConnection;
  /** Get the default content for an ITP issue from the Allesseh ITP collections (e.g. ITPWSJPageOneOnlineOverride, ITPWSJUSOnlineOverride, etc.) as a list of page modules. */
  importITPContent: Array<Array<PageModule>>;
  /** Get the default content for an ITP issue from the Allesseh ITP collections (e.g. ITPWSJPageOneOnlineOverride, ITPWSJUSOnlineOverride, etc.) as a list of page modules. */
  importItpDTOContent: ItpImportResponse;
  /** Check if current preview is a draft page. */
  isPreviewDraftPage: Scalars['Boolean'];
  /** Get the ITP issue & pages for a given date. */
  itpByDate: ItpIssueWithPages;
  /** Get the ITP issue & pages for a given date. */
  itpDTOByDate: ItpDto;
  /** Retrieve last N published scheduled contents. */
  lastNPublishedScheduledContent: Array<ScheduledContent>;
  /** Get the list of latest ITP issues. */
  lastSevenITPIssues: Array<ItpIssue>;
  /** Get the list of latest ITP issues. */
  lastSevenItpDTOs: Array<ItpDto>;
  /** Retrieve scheduled contents by Allesseh ID. */
  liveContentByAllessehId: Array<ScheduledContent>;
  /** Get the current revision for a newsletter. */
  newsletterById: NewsletterDto;
  /** Get an off platform module by id. */
  offPlatformById: OffPlatformDto;
  /** Get the current revision for a page. */
  pageByRevisionGroupKey: Page;
  /** Get the current revision for a page by its Allesseh ID. */
  pageDTOByAllessehId: PageDto;
  /** Get the publication's settings for a particular page type. */
  pageTypeSettingByPublicationKeyPageType: PageTypeSetting;
  /** Get all latest page revisions for a publication. */
  pages: PageConnection;
  /** Get a list of pages that contains the page that has the publish timestamp param and the adjacent newer and older pages */
  pagesByPublishUtcTimestamp: PageConnection;
  /** Get all latest page revisions for a publication. */
  pagesDTO: PageDtoConnection;
  /** Get all page revision groups that use the collection */
  pagesDTOForCollectionId: Array<PagesDtoForCollection>;
  /** Get all page revision groups that use the collection */
  pagesForCollectionIdCreatedUtc: Array<PagesForCollection>;
  /** Get all published pages for a revision group. */
  pagesPublishedByRevisionGroupKey: PageConnection;
  /** Get all published pages for a revision group on a specific date. */
  pagesPublishedOnDate: PageConnection;
  /** Get publication setting. */
  publicationSetting: PublicationSetting;
  /** Get the currently published collection and its scheduled revisions. */
  scheduledCollections: CollectionConnection;
  /** Retrieve scheduled contents by Allesseh ID. */
  scheduledContentByAllessehId: Array<ScheduledContent>;
  /** Retrieve scheduled contents by publication key, content type, and optionally, status. */
  scheduledContentByPublicationKey: ScheduledContentConnection;
  /** Get content scheduled to publish within a specific time. */
  scheduledContentByTimeWithAllessehId: Array<ScheduledContent>;
};

export type QueryCollectionByIdArgs = {
  collectionType: Scalars['String'];
  id: Scalars['String'];
  publicationKey: Scalars['String'];
};

export type QueryCollectionDtoByIdArgs = {
  id: Scalars['String'];
  publicationKey: Scalars['String'];
};

export type QueryCollectionsArgs = {
  collectionsInput: CollectionsInput;
  paginationParams: PaginationParams;
};

export type QueryCollectionsDtoArgs = {
  collectionsDTOInput: CollectionsDtoInput;
  paginationParams: PaginationParams;
};

export type QueryCollectionsPublishedOnDateArgs = {
  allessehCollectionId: Scalars['String'];
  paginationParams: PaginationParams;
  publicationKey: Scalars['String'];
  publishUtc: Scalars['Float'];
};

export type QueryGetAllOffPlatformArgs = {
  offPlatformInput: OffPlatformInput;
  paginationParams: PaginationParams;
};

export type QueryGetBannerByIdArgs = {
  id: Scalars['String'];
  publicationKey: Scalars['String'];
};

export type QueryGetBannersArgs = {
  bannersDTOInput: GetBannersDtoInput;
  paginationParams: PaginationParams;
};

export type QueryGetDefaultItpIssueStateArgs = {
  issueDate: Scalars['String'];
  publicationKey: Scalars['String'];
};

export type QueryGetDefaultItpPagesArgs = {
  issueDate: Scalars['String'];
  publicationKey: Scalars['String'];
};

export type QueryGetNewsletterListArgs = {
  publicationKey: Scalars['String'];
};

export type QueryGetNewslettersArgs = {
  newslettersSearchInput: NewslettersSearchInput;
  paginationParams: PaginationParams;
};

export type QueryImportItpContentArgs = {
  itpImportContentInput: ItpImportContentInput;
  publicationKey: Scalars['String'];
};

export type QueryImportItpDtoContentArgs = {
  itpDTOImportContentInput: ItpDtoImportContentInput;
  publicationKey: Scalars['String'];
};

export type QueryIsPreviewDraftPageArgs = {
  allessehId: Scalars['String'];
};

export type QueryItpByDateArgs = {
  issueDate: Scalars['String'];
  publicationKey: Scalars['String'];
};

export type QueryItpDtoByDateArgs = {
  issueDate: Scalars['String'];
  publicationKey: Scalars['String'];
};

export type QueryLastNPublishedScheduledContentArgs = {
  allessehId: Scalars['String'];
  n: Scalars['Float'];
  publishUtc?: InputMaybe<Scalars['Float']>;
  status: ScheduledContentStatus;
};

export type QueryLastSevenItpIssuesArgs = {
  publicationKey: Scalars['String'];
};

export type QueryLastSevenItpDtOsArgs = {
  publicationKey: Scalars['String'];
};

export type QueryLiveContentByAllessehIdArgs = {
  allessehId: Scalars['String'];
  publicationKey: Scalars['String'];
};

export type QueryNewsletterByIdArgs = {
  id: Scalars['String'];
  publicationKey: Scalars['String'];
};

export type QueryOffPlatformByIdArgs = {
  id: Scalars['String'];
  publicationKey: Scalars['String'];
};

export type QueryPageByRevisionGroupKeyArgs = {
  publicationKey: Scalars['String'];
  revisionGroupKey: Scalars['String'];
};

export type QueryPageDtoByAllessehIdArgs = {
  allessehId: Scalars['String'];
  publicationKey: Scalars['String'];
};

export type QueryPageTypeSettingByPublicationKeyPageTypeArgs = {
  pageType: PageType;
  publicationKey: Scalars['String'];
};

export type QueryPagesArgs = {
  pagesInput: PagesInput;
  paginationParams: PaginationParams;
};

export type QueryPagesByPublishUtcTimestampArgs = {
  paginationParams: PaginationParams;
  publicationKey: Scalars['String'];
  publishUtc: Scalars['Float'];
  revisionGroupKey: Scalars['String'];
};

export type QueryPagesDtoArgs = {
  pagesInput: PagesDtoInput;
  paginationParams: PaginationParams;
};

export type QueryPagesDtoForCollectionIdArgs = {
  collectionId: Scalars['String'];
  publicationKey: Scalars['String'];
};

export type QueryPagesForCollectionIdCreatedUtcArgs = {
  collectionIdCreatedUtc: Scalars['String'];
  publicationKey: Scalars['String'];
};

export type QueryPagesPublishedByRevisionGroupKeyArgs = {
  paginationParams: PaginationParams;
  publicationKey: Scalars['String'];
  revisionGroupKey: Scalars['String'];
};

export type QueryPagesPublishedOnDateArgs = {
  paginationParams: PaginationParams;
  publicationKey: Scalars['String'];
  publishUtc: Scalars['Float'];
  revisionGroupKey: Scalars['String'];
};

export type QueryPublicationSettingArgs = {
  publicationKey: Scalars['String'];
};

export type QueryScheduledCollectionsArgs = {
  allessehCollectionId: Scalars['String'];
  paginationParams: PaginationParams;
  publicationKey: Scalars['String'];
};

export type QueryScheduledContentByAllessehIdArgs = {
  allessehId: Scalars['String'];
  publicationKey: Scalars['String'];
  publishUtc?: InputMaybe<Scalars['Float']>;
};

export type QueryScheduledContentByPublicationKeyArgs = {
  contentType: AllessehContentType;
  paginationParams: PaginationParams;
  publicationKey: Scalars['String'];
  status?: InputMaybe<ScheduledContentStatus>;
};

export type QueryScheduledContentByTimeWithAllessehIdArgs = {
  allessehId: Scalars['String'];
  maxTimestamp: Scalars['Float'];
};

/** Query model attributes */
export type QueryAttributes = {
  __typename?: 'QueryAttributes';
  /** Title for the feed queries. */
  feedTitle?: Maybe<Scalars['String']>;
  /** URL for the feed queries. */
  feedUrl?: Maybe<Scalars['String']>;
  /** Whether the query is a feed. */
  isFeed?: Maybe<Scalars['Boolean']>;
  /** The query as a JSON object. */
  query: Scalars['JSON'];
};

/** Query model */
export type QueryItem = {
  __typename?: 'QueryItem';
  /** Query attributes */
  attributes: QueryAttributes;
  /** Raw attributes of the Node */
  rawAttributes?: Maybe<Scalars['JSON']>;
  /** Subtype */
  subtype?: Maybe<Scalars['String']>;
  /** Content Type */
  type: Scalars['String'];
};

/** Primary key of content that replaced this content when it was rescheduled. */
export type ReplacedBy = {
  __typename?: 'ReplacedBy';
  /** Alleseh origin ID of content that replaced this rescheduled content. */
  allessehId: Scalars['String'];
  /** Timestamp of content that replaced this rescheduled content.. */
  publishUtc: Scalars['Float'];
};

/** Properties that *may be* required for a page module, dependent upon what is set in treatment types. */
export enum RequiredUiModuleFields {
  MainText = 'mainText',
  SecondaryText = 'secondaryText',
  Subtitle = 'subtitle',
  SubtitleUrl = 'subtitleUrl',
  Title = 'title',
  TitleUrl = 'titleUrl'
}

/** Allesseh content scheduled to be published at a future date. */
export type ScheduledContent = {
  __typename?: 'ScheduledContent';
  /** Origin ID of this Allesseh content. */
  allessehId: Scalars['String'];
  /** The body of the scheduled content that is published to Allesseh once the timestamp specified in `publishUtc` is reached. */
  body: ScheduledContentDataUnion;
  /** The content type of this Allesseh content. */
  contentType: AllessehContentType;
  /** MS since epoch of the datetime when this scheduled content was created. */
  createdUtc: Scalars['Float'];
  /** Data of user who first scheduled this content. */
  creatorUser: AllessehUser;
  /** MS since epoch of the datetime when this content is no longer relevant and can be deleted by DynamoDB TTL. */
  expireUtc: Scalars['Float'];
  /** The publication that this scheduled content belongs to. */
  publicationKey: Scalars['String'];
  /** MS since epoch of the datetime when this scheduled content is to be published. */
  publishUtc: Scalars['Float'];
  /** Primary key of content that replaced this content when it was rescheduled. */
  replacedBy?: Maybe<ReplacedBy>;
  /** Data of user who last updated this scheduled content. */
  revisorUser?: Maybe<AllessehUser>;
  /** The publish status of this content. */
  status: ScheduledContentStatus;
  /** MS since epoch of the datetime when this scheduled content was last updated. */
  updatedUtc?: Maybe<Scalars['Float']>;
};

export type ScheduledContentCancelInput = {
  /** Allesseh origin ID of this content. */
  allessehId: Scalars['String'];
  /** MS since epoch of the datetime when this scheduled content is to be published. */
  publishUtc: Scalars['Float'];
};

export type ScheduledContentConnection = {
  __typename?: 'ScheduledContentConnection';
  /** Pagination results. */
  edges: Array<ScheduledContentEdge>;
  /** Page info for results. */
  pageInfo: PageInfo;
};

export type ScheduledContentCreateInput = {
  /** Allesseh origin ID of this content. */
  allessehId: Scalars['String'];
  /** The body of the scheduled content that is published to Allesseh once the timestamp specified in `publishUtc` is reached. */
  body: Scalars['JSON'];
  /** The content type of this content. */
  contentType: AllessehContentType;
  /** MS since epoch of the datetime when this scheduled content is to be published. */
  publishUtc: Scalars['Float'];
};

export type ScheduledContentDataUnion =
  | BannerDto
  | Collection
  | CollectionDto
  | ItpIssueWithPages
  | NewsletterDto
  | OffPlatformDto
  | Page
  | PageDto;

export type ScheduledContentEdge = {
  __typename?: 'ScheduledContentEdge';
  /** Current cursor of edge. */
  cursor: Scalars['String'];
  /** Scheduled content item within paginated results. */
  node: ScheduledContent;
};

export type ScheduledContentRescheduleInput = {
  /** Allesseh origin ID of this content. */
  allessehId: Scalars['String'];
  /** The body of the scheduled content that is published to Allesseh once the timestamp specified in `publishUtc` is reached. */
  body: Scalars['JSON'];
  /** The content type of this content. */
  contentType: AllessehContentType;
  /** New timestamp of when this scheduled content is meant to be published. */
  newPublishUtc: Scalars['Float'];
  /** Previous timestamp of when this scheduled content was to be published. */
  previousPublishUtc: Scalars['Float'];
};

export type ScheduledContentSaveDraftInput = {
  /** Allesseh origin ID of this content. */
  allessehId: Scalars['String'];
  /** The body of the content that will be saved as draft. */
  body: Scalars['JSON'];
  /** The content type of this content. */
  contentType: AllessehContentType;
};

/** Describes whether the scheduled content has been published to Allesseh, or if it's still awaiting publication, or has been canceled. */
export enum ScheduledContentStatus {
  Canceled = 'Canceled',
  Draft = 'Draft',
  Live = 'Live',
  Published = 'Published',
  Rescheduled = 'Rescheduled',
  Scheduled = 'Scheduled'
}

export type ScheduledContentUpdateInput = {
  /** Origin ID of the content to be updated. */
  allessehId: Scalars['String'];
  /** The body of the scheduled content that is to be updated. */
  body: Scalars['JSON'];
  /** The content type of this content. */
  contentType: AllessehContentType;
  /** MS since epoch of the datetime when this scheduled content is to be published. */
  publishUtc: Scalars['Float'];
};

/** Section model attributes */
export type SectionAttributes = {
  __typename?: 'SectionAttributes';
  /** Ad. type for section */
  adPlacementType?: Maybe<Scalars['String']>;
  /** Ad. Zone */
  adZone?: Maybe<Scalars['String']>;
  /** External container info. `null` if not an external container */
  externalContainer?: Maybe<ExternalContainerAttributes>;
  /** Hide Section? */
  isHidden: Scalars['Boolean'];
  /** Section page type */
  pageType: Scalars['String'];
  /** Url path structured key to denote where this page will be used. (ex: ‘/’, ‘/news/world’, etc.). This is combined with the baseRoute from publication setting. */
  routeKey: Scalars['String'];
  /** Section Key. e.g. "BUSINESS_AND_FINANCE" */
  sectionKey?: Maybe<Scalars['String']>;
  /** Section Label. e.g. "Business & Finance" */
  sectionLabel?: Maybe<Scalars['String']>;
  /** alt_summ variant for this section */
  summaryPriority: Scalars['String'];
};

/** Section model */
export type SectionContainer = {
  __typename?: 'SectionContainer';
  /** Section Model attributes */
  attributes: SectionAttributes;
  /** Ordered array of Pages for this Section. */
  collection: Array<PageContainer>;
  /** Raw attributes of the Node */
  rawAttributes?: Maybe<Scalars['JSON']>;
  /** Container subtype */
  subtype?: Maybe<Scalars['String']>;
  /** Container Type */
  type: Scalars['String'];
};

/** Defines settings tied to a specific treatment type. */
export type TreatmentTypeSetting = {
  __typename?: 'TreatmentTypeSetting';
  /** Content types allowed for this type */
  contentTypes: Array<PublicationSettingSearchableContentType>;
  /** Friendly label to describe the treatment type */
  label: Scalars['String'];
  /** The maximum number of pieces of content that will display on this module. */
  maxRequiredContentItems: Scalars['Float'];
  /** The minimum number of pieces of content needed for display on this module. */
  minRequiredContentItems: Scalars['Float'];
  /** The default module for this treatment type */
  module?: Maybe<PageModule>;
  /** Properties required to be filled out for this module. */
  requiredProperties: Array<RequiredUiModuleFields>;
  /** UI treatment type enum */
  treatmentType: Scalars['String'];
  /** UI treatment type enum key when different in FE vs BE */
  treatmentTypeKey?: Maybe<Scalars['String']>;
};

/** Module for a collection with no additional metadata. */
export type UiBasicModule = {
  __typename?: 'UiBasicModule';
  /** Allowed UI treatment types for this module. */
  allowedTreatmentTypes?: Maybe<Array<UiBasicTreatmentType>>;
  /** Denotes the type of content for this module. */
  contentTypes: Array<PublicationSettingSearchableContentType>;
  /** Denotes the type of UI treatment for this module. */
  treatmentType: UiBasicTreatmentType;
};

/** Module for a collection with no additional metadata. */
export type UiBasicModuleInput = {
  /** Allowed UI treatment type for this module. */
  allowedTreatmentTypes?: InputMaybe<Array<UiBasicTreatmentType>>;
  /** Denotes the type of content for this module. */
  contentTypes: Array<PublicationSettingSearchableContentType>;
  /** Denotes the type of UI treatment for this module. */
  treatmentType: UiBasicTreatmentType;
};

/** Optional module for a collection with no additional metadata. */
export type UiBasicOptionalModule = {
  __typename?: 'UiBasicOptionalModule';
  /** Allowed UI treatment type for this module. */
  allowedTreatmentTypes?: Maybe<Array<UiBasicOptionalTreatmentType>>;
  /** Denotes the type of content for this module. */
  contentTypes: Array<PublicationSettingSearchableContentType>;
  /** Name for the module */
  moduleName?: Maybe<Scalars['String']>;
  /** Denotes the type of UI treatment for this module. */
  treatmentType: UiBasicOptionalTreatmentType;
};

/** Module for a collection with no additional metadata. */
export type UiBasicOptionalModuleInput = {
  /** Allowed UI treatment type for this module. */
  allowedTreatmentTypes?: InputMaybe<Array<UiBasicOptionalTreatmentType>>;
  /** Denotes the type of content for this module. */
  contentTypes: Array<PublicationSettingSearchableContentType>;
  /** Denotes the type of UI treatment for this module. */
  treatmentType: UiBasicOptionalTreatmentType;
};

/** The type to denote the visual look of the Basic module (the treatment). */
export enum UiBasicOptionalTreatmentType {
  AboveSuperHero = 'ABOVE_SUPER_HERO',
  LongReaderBigTop = 'LONG_READER_BIG_TOP',
  LongReaderDefault = 'LONG_READER_DEFAULT',
  SuperHero = 'SUPER_HERO'
}

/** The type to denote the visual look of the Basic module (the treatment). */
export enum UiBasicTreatmentType {
  Antihero = 'ANTIHERO',
  AntiheroPulse = 'ANTIHERO_PULSE',
  Asymmetric_2SmallLeft_1LargeRight = 'ASYMMETRIC_2_SMALL_LEFT_1_LARGE_RIGHT',
  AsymmetricTwoColumnList = 'ASYMMETRIC_TWO_COLUMN_LIST',
  Audience = 'AUDIENCE',
  BelowMostRead = 'BELOW_MOST_READ',
  BelowSuperHero = 'BELOW_SUPER_HERO',
  BreakingNews = 'BREAKING_NEWS',
  Grid_2X2 = 'GRID_2X2',
  Hero_1LargeImage = 'HERO_1_LARGE_IMAGE',
  HomepageBattenberg = 'HOMEPAGE_BATTENBERG',
  Horizontal_4Image = 'HORIZONTAL_4_IMAGE',
  Itp_2Stories = 'ITP_2_STORIES',
  Itp_2StoriesWithFeatureSpot = 'ITP_2_STORIES_WITH_FEATURE_SPOT',
  Itp_3StoriesWithFeatureSpot = 'ITP_3_STORIES_WITH_FEATURE_SPOT',
  Itp_5Stories = 'ITP_5_STORIES',
  Itp_5StoriesNoAhed = 'ITP_5_STORIES_NO_AHED',
  Itp_5StoriesWithFeatureSpot = 'ITP_5_STORIES_WITH_FEATURE_SPOT',
  Itp_6NoWhatsNews = 'ITP_6_NO_WHATS_NEWS',
  Itp_6Stories = 'ITP_6_STORIES',
  Itp_6StoriesNoAhed = 'ITP_6_STORIES_NO_AHED',
  Itp_6StoriesVerticalImageDeco = 'ITP_6_STORIES_VERTICAL_IMAGE_DECO',
  Itp_6StoriesWithDeco = 'ITP_6_STORIES_WITH_DECO',
  Itp_6StoriesWithFeatureSpot = 'ITP_6_STORIES_WITH_FEATURE_SPOT',
  Itp_6StoriesWithLowerDeco = 'ITP_6_STORIES_WITH_LOWER_DECO',
  Itp_12Stories = 'ITP_12_STORIES',
  Leader = 'LEADER',
  MoreTopStories = 'MORE_TOP_STORIES',
  Sampler = 'SAMPLER',
  SamplerWithTimeline = 'SAMPLER_WITH_TIMELINE',
  SectionTop = 'SECTION_TOP',
  StandardNewsletter = 'STANDARD_NEWSLETTER',
  SuperHero = 'SUPER_HERO',
  SuperHeroPulse = 'SUPER_HERO_PULSE',
  Takeover = 'TAKEOVER',
  TopAdvisorNews = 'TOP_ADVISOR_NEWS',
  TopStory = 'TOP_STORY',
  Vertical_3ImageLeft = 'VERTICAL_3_IMAGE_LEFT'
}

/** Module for a collection containing a list of feeds. */
export type UiFeedsModule = {
  __typename?: 'UiFeedsModule';
  /** Allowed UI treatment types for this module. */
  allowedTreatmentTypes?: Maybe<Array<UiFeedsTreatmentType>>;
  /** Denotes the type of content for this module. */
  contentTypes: Array<PublicationSettingSearchableContentType>;
  /** Denotes the type of UI treatment for this module. */
  treatmentType: UiFeedsTreatmentType;
};

/** Module for a collection containing a list of feeds. */
export type UiFeedsModuleInput = {
  /** Allowed UI treatment type for this module. */
  allowedTreatmentTypes?: InputMaybe<Array<UiFeedsTreatmentType>>;
  /** Denotes the type of content for this module. */
  contentTypes: Array<PublicationSettingSearchableContentType>;
  /** Denotes the type of UI treatment for this module. */
  treatmentType: UiFeedsTreatmentType;
};

/** The type to denote the visual look of the Feeds module (the treatment). */
export enum UiFeedsTreatmentType {
  Feeds = 'FEEDS',
  Feeds_3Stories = 'FEEDS_3_STORIES'
}

/** Fields for the specific uiModuleType. Only one field should be set. */
export type UiModule = {
  __typename?: 'UiModule';
  basicModule?: Maybe<UiBasicModule>;
  basicOptionalModule?: Maybe<UiBasicOptionalModule>;
  feedsModule?: Maybe<UiFeedsModule>;
  rankedModule?: Maybe<UiRankedModule>;
  textModule?: Maybe<UiTextModule>;
  titleModule?: Maybe<UiTitleModule>;
  twoColumnModule?: Maybe<UiTwoColumnModule>;
};

/** Fields for the specific uiModuleType. Only one field should be set. */
export type UiModuleInput = {
  basicModule?: InputMaybe<UiBasicModuleInput>;
  basicOptionalModule?: InputMaybe<UiBasicOptionalModuleInput>;
  feedsModule?: InputMaybe<UiFeedsModuleInput>;
  rankedModule?: InputMaybe<UiRankedModuleInput>;
  textModule?: InputMaybe<UiTextModuleInput>;
  titleModule?: InputMaybe<UiTitleModuleInput>;
  twoColumnModule?: InputMaybe<UiTwoColumnModuleInput>;
};

/** Denotes the type of UI module, which defines what the uiModuleFields schema is. */
export enum UiModuleType {
  UiBasicModuleType = 'UiBasicModuleType',
  UiBasicOptionalModuleType = 'UiBasicOptionalModuleType',
  UiFeedsModuleType = 'UiFeedsModuleType',
  UiRankedModuleType = 'UiRankedModuleType',
  UiTextModuleType = 'UiTextModuleType',
  UiTitleModuleType = 'UiTitleModuleType',
  UiTwoColumnModuleType = 'UiTwoColumnModuleType'
}

/** Module for a collection of ranked items with a title. */
export type UiRankedModule = {
  __typename?: 'UiRankedModule';
  /** Allowed UI treatment type for this module. */
  allowedTreatmentTypes?: Maybe<Array<UiRankedTreatmentType>>;
  /** Denotes the type of content for this module. */
  contentTypes: Array<PublicationSettingSearchableContentType>;
  /** Displayed title for the module. */
  title: Scalars['String'];
  /** Denotes the type of UI treatment for this module. */
  treatmentType: UiRankedTreatmentType;
};

/** Module for a collection with a title. */
export type UiRankedModuleInput = {
  /** Allowed UI treatment type for this module. */
  allowedTreatmentTypes?: InputMaybe<Array<UiRankedTreatmentType>>;
  /** Denotes the type of content for this module. */
  contentTypes: Array<PublicationSettingSearchableContentType>;
  /** Displayed title for the module. */
  title: Scalars['String'];
  /** Denotes the type of UI treatment for this module. */
  treatmentType: UiRankedTreatmentType;
};

/** The type to denote the visual look of the Ranked module (the treatment). */
export enum UiRankedTreatmentType {
  Latest = 'LATEST',
  OnTheMove = 'ON_THE_MOVE',
  Vertical_4WithImage = 'VERTICAL_4_WITH_IMAGE',
  Vertical_5WithImage = 'VERTICAL_5_WITH_IMAGE',
  Vertical_5WithProductCards = 'VERTICAL_5_WITH_PRODUCT_CARDS',
  Vertical_7WithoutImage = 'VERTICAL_7_WITHOUT_IMAGE',
  VerticalWithoutImage = 'VERTICAL_WITHOUT_IMAGE'
}

/** Module for a collection with a header, subtitle, and link. */
export type UiTextModule = {
  __typename?: 'UiTextModule';
  /** Allowed UI treatment type for this module. */
  allowedTreatmentTypes?: Maybe<Array<UiTextTreatmentType>>;
  /** Main text for the module (ex: header). */
  mainText: Scalars['String'];
  /** Secondary text for the module (ex: description or subtitle). Can be a longer piece of text. */
  secondaryText: Scalars['String'];
  /** Denotes the type of UI treatment for this module. */
  treatmentType: UiTextTreatmentType;
};

/** Module for a collection with a section header, subtitle, and link. */
export type UiTextModuleInput = {
  /** Allowed UI treatment type for this module. */
  allowedTreatmentTypes?: InputMaybe<Array<UiTextTreatmentType>>;
  /** Main text for the section (ex: header). */
  mainText: Scalars['String'];
  /** Secondary text for the section (ex: description or subtitle). */
  secondaryText: Scalars['String'];
  /** Denotes the type of UI treatment for this module. */
  treatmentType: UiTextTreatmentType;
};

/** The type to denote the visual look of the Text module (the treatment). */
export enum UiTextTreatmentType {
  HeaderDescriptionLeftBar = 'HEADER_DESCRIPTION_LEFT_BAR'
}

/** Module for a collection with a header, subtitle, and link. */
export type UiTitleModule = {
  __typename?: 'UiTitleModule';
  /** Allowed Meta for the module. */
  allowedMeta?: Maybe<Array<Metadata>>;
  /** Allowed UI treatment types for this module. */
  allowedTreatmentTypes?: Maybe<Array<UiTitleTreatmentType>>;
  /** Denotes the type of content for this module. */
  contentTypes: Array<PublicationSettingSearchableContentType>;
  /** Subtitle or subheader for the module. */
  subtitle?: Maybe<Scalars['String']>;
  /** Url for the subtitle or subheader for the module. */
  subtitleUrl?: Maybe<Scalars['String']>;
  /** Title or header for the module. */
  title?: Maybe<Scalars['String']>;
  /** Url for the title for the module. */
  titleUrl?: Maybe<Scalars['String']>;
  /** Denotes the type of UI treatment for this module. */
  treatmentType: UiTitleTreatmentType;
};

/** Module for a collection with a section header, subtitle, and link. */
export type UiTitleModuleInput = {
  /** Allowed Meta for the module. */
  allowedMeta?: InputMaybe<Array<Metadata>>;
  /** Allowed UI treatment type for this module. */
  allowedTreatmentTypes?: InputMaybe<Array<UiTitleTreatmentType>>;
  /** Denotes the type of content for this module. */
  contentTypes: Array<PublicationSettingSearchableContentType>;
  /** Subtitle or subheader for the section. */
  subtitle?: InputMaybe<Scalars['String']>;
  /** Url path for the subtitle or subheader for the section. */
  subtitleUrl?: InputMaybe<Scalars['String']>;
  /** Title or header for the section. */
  title?: InputMaybe<Scalars['String']>;
  /** Url for the title for the module. */
  titleUrl?: InputMaybe<Scalars['String']>;
  /** Denotes the type of UI treatment for this module. */
  treatmentType: UiTitleTreatmentType;
};

/** The type to denote the visual look of the Title module (the treatment). */
export enum UiTitleTreatmentType {
  AllLarge = 'ALL_LARGE',
  AllSmall = 'ALL_SMALL',
  Asymmetric_1LargeLeft_2SmallRight = 'ASYMMETRIC_1_LARGE_LEFT_2_SMALL_RIGHT',
  Asymmetric_2MediumTop_2SmallBottom = 'ASYMMETRIC_2_MEDIUM_TOP_2_SMALL_BOTTOM',
  Asymmetric_2Top_4Bottom = 'ASYMMETRIC_2_TOP_4_BOTTOM',
  BreakingNews = 'BREAKING_NEWS',
  BreakingNewsMedium = 'BREAKING_NEWS_MEDIUM',
  ExclusiveHorizontal_4SmallImage = 'EXCLUSIVE_HORIZONTAL_4_SMALL_IMAGE',
  Grid_2x4 = 'GRID_2x4',
  Horizontal_4SmallImage = 'HORIZONTAL_4_SMALL_IMAGE',
  LargeMediumSupport = 'LARGE_MEDIUM_SUPPORT',
  LargeSupport = 'LARGE_SUPPORT',
  List = 'LIST',
  RoundFranchise = 'ROUND_FRANCHISE',
  RoundGrid_2x2 = 'ROUND_GRID_2x2',
  Thumbnails = 'THUMBNAILS',
  WindowsA = 'WINDOWS_A',
  WindowsB = 'WINDOWS_B',
  WindowsC = 'WINDOWS_C'
}

export type UiTwoColumnModule = {
  __typename?: 'UiTwoColumnModule';
  /** Allowed UI treatment type for this module. */
  allowedTreatmentTypes?: Maybe<Array<UiTwoColumnTreatmentType>>;
  /** Ordered array of modules in the left column. */
  leftModules: Array<PageModule>;
  /** Ordered array of modules in the right column. */
  rightModules: Array<PageModule>;
  /** Denotes the type of UI treatment for this module. */
  treatmentType: UiTwoColumnTreatmentType;
};

export type UiTwoColumnModuleInput = {
  /** Allowed UI treatment type for this module. */
  allowedTreatmentTypes?: InputMaybe<Array<UiTwoColumnTreatmentType>>;
  /** Ordered array of modules in the left column. */
  leftModules: Array<PageModuleInput>;
  /** Ordered array of modules in the right column. */
  rightModules: Array<PageModuleInput>;
  /** Denotes the type of UI treatment for this module. */
  treatmentType: UiTwoColumnTreatmentType;
};

/** The type to denote the visual look of the Two Column module (the treatment). */
export enum UiTwoColumnTreatmentType {
  Grid_9x3 = 'GRID_9x3',
  Grid_9x3BottomDivider = 'GRID_9x3_BOTTOM_DIVIDER'
}

export type WsjSectionFrontCreateInput = {
  /** Name for this page for use within this tool. */
  name: Scalars['String'];
  /** Key to denote the publication. (ex: 'wsj', 'barrons') */
  publicationKey: Scalars['String'];
  /** Url path structured key to denote where this page will be used. (ex: ‘/’, ‘/news/world’, etc.). This is combined with the baseRoute from publication setting. Must be unique. */
  routeKey: Scalars['String'];
};

export type BannerDtoArtifactFragment = {
  __typename?: 'BannerDTO';
  metadata: {
    __typename?: 'BaseMetadata';
    allessehId: string;
    createdUtc: number;
    name: string;
    publicationKey: string;
    publishUtc?: number | null;
    updatedUtc?: number | null;
    creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
    revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
  };
  root: {
    __typename?: 'BannerModuleContainer';
    type: string;
    subtype?: string | null;
    attributes: {
      __typename?: 'BannerModuleAttributes';
      moduleId?: string | null;
      pageModule?: {
        __typename?: 'PageModule';
        uiModuleType: UiModuleType;
        uiModuleFields: {
          __typename?: 'UiModule';
          basicModule?: { __typename?: 'UiBasicModule'; treatmentType: UiBasicTreatmentType } | null;
        };
      } | null;
    };
    collection: Array<
      | {
          __typename?: 'ArticleItem';
          type: string;
          content?: string | null;
          attributes: {
            __typename?: 'ArticleAttributes';
            base_doc_id: string;
            hosted_url: string;
            id: string;
            link: string;
            originContentType?: string | null;
            originId?: string | null;
            product: string;
            seo_id: string;
            status: string;
          };
        }
      | { __typename?: 'ExternalCollectionItem' }
      | { __typename?: 'LinkedItem' }
      | { __typename?: 'MobileArticleItem' }
      | { __typename?: 'QueryItem' }
    >;
  };
};

export type BannerDtoUpdateMutationVariables = Exact<{
  bannerDTOUpdateInput: BannerDtoUpdateInput;
}>;

export type BannerDtoUpdateMutation = {
  __typename?: 'Mutation';
  updateBanner: {
    __typename?: 'BannerDTO';
    metadata: {
      __typename?: 'BaseMetadata';
      allessehId: string;
      createdUtc: number;
      name: string;
      publicationKey: string;
      publishUtc?: number | null;
      updatedUtc?: number | null;
      creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
      revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
    };
    root: {
      __typename?: 'BannerModuleContainer';
      type: string;
      subtype?: string | null;
      attributes: {
        __typename?: 'BannerModuleAttributes';
        moduleId?: string | null;
        pageModule?: {
          __typename?: 'PageModule';
          uiModuleType: UiModuleType;
          uiModuleFields: {
            __typename?: 'UiModule';
            basicModule?: { __typename?: 'UiBasicModule'; treatmentType: UiBasicTreatmentType } | null;
          };
        } | null;
      };
      collection: Array<
        | {
            __typename?: 'ArticleItem';
            type: string;
            content?: string | null;
            attributes: {
              __typename?: 'ArticleAttributes';
              base_doc_id: string;
              hosted_url: string;
              id: string;
              link: string;
              originContentType?: string | null;
              originId?: string | null;
              product: string;
              seo_id: string;
              status: string;
            };
          }
        | { __typename?: 'ExternalCollectionItem' }
        | { __typename?: 'LinkedItem' }
        | { __typename?: 'MobileArticleItem' }
        | { __typename?: 'QueryItem' }
      >;
    };
  };
};

export type BannerDtoPreviewMutationVariables = Exact<{
  bannerDTOPreviewLinkInput: BannerDtoPreviewLinkInput;
}>;

export type BannerDtoPreviewMutation = { __typename?: 'Mutation'; getBannerPreviewLink: string };

export type GetAllBannersQueryVariables = Exact<{
  bannersDTOInput: GetBannersDtoInput;
  paginationParams: PaginationParams;
}>;

export type GetAllBannersQuery = {
  __typename?: 'Query';
  getBanners: {
    __typename?: 'BannerDTOConnection';
    edges: Array<{
      __typename?: 'BannerDTOEdge';
      node: {
        __typename?: 'BannerDTO';
        metadata: {
          __typename?: 'BaseMetadata';
          allessehId: string;
          createdUtc: number;
          name: string;
          publicationKey: string;
          publishUtc?: number | null;
          updatedUtc?: number | null;
          creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
          revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
        };
        root: {
          __typename?: 'BannerModuleContainer';
          type: string;
          subtype?: string | null;
          attributes: {
            __typename?: 'BannerModuleAttributes';
            moduleId?: string | null;
            pageModule?: {
              __typename?: 'PageModule';
              uiModuleType: UiModuleType;
              uiModuleFields: {
                __typename?: 'UiModule';
                basicModule?: { __typename?: 'UiBasicModule'; treatmentType: UiBasicTreatmentType } | null;
              };
            } | null;
          };
          collection: Array<
            | {
                __typename?: 'ArticleItem';
                type: string;
                content?: string | null;
                attributes: {
                  __typename?: 'ArticleAttributes';
                  base_doc_id: string;
                  hosted_url: string;
                  id: string;
                  link: string;
                  originContentType?: string | null;
                  originId?: string | null;
                  product: string;
                  seo_id: string;
                  status: string;
                };
              }
            | { __typename?: 'ExternalCollectionItem' }
            | { __typename?: 'LinkedItem' }
            | { __typename?: 'MobileArticleItem' }
            | { __typename?: 'QueryItem' }
          >;
        };
      };
    }>;
    pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type BannerByIdQueryVariables = Exact<{
  id: Scalars['String'];
  publicationKey: Scalars['String'];
}>;

export type BannerByIdQuery = {
  __typename?: 'Query';
  getBannerById: {
    __typename?: 'BannerDTO';
    metadata: {
      __typename?: 'BaseMetadata';
      allessehId: string;
      createdUtc: number;
      name: string;
      publicationKey: string;
      publishUtc?: number | null;
      updatedUtc?: number | null;
      creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
      revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
    };
    root: {
      __typename?: 'BannerModuleContainer';
      type: string;
      subtype?: string | null;
      attributes: {
        __typename?: 'BannerModuleAttributes';
        moduleId?: string | null;
        pageModule?: {
          __typename?: 'PageModule';
          uiModuleType: UiModuleType;
          uiModuleFields: {
            __typename?: 'UiModule';
            basicModule?: { __typename?: 'UiBasicModule'; treatmentType: UiBasicTreatmentType } | null;
          };
        } | null;
      };
      collection: Array<
        | {
            __typename?: 'ArticleItem';
            type: string;
            content?: string | null;
            attributes: {
              __typename?: 'ArticleAttributes';
              base_doc_id: string;
              hosted_url: string;
              id: string;
              link: string;
              originContentType?: string | null;
              originId?: string | null;
              product: string;
              seo_id: string;
              status: string;
            };
          }
        | { __typename?: 'ExternalCollectionItem' }
        | { __typename?: 'LinkedItem' }
        | { __typename?: 'MobileArticleItem' }
        | { __typename?: 'QueryItem' }
      >;
    };
  };
};

export type CollectionEditCollectionFragment = {
  __typename?: 'Collection';
  idCreatedUtc: string;
  id: string;
  createdUtc: number;
  updatedUtc?: number | null;
  allessehCollectionId: string;
  name: string;
  notes?: string | null;
  consumer?: string | null;
  allessehJsonQuery?: string | null;
  isArchived: boolean;
  contentItems: Array<{
    __typename?: 'CollectionContentItem';
    originId: string;
    originContentType: string;
    content?: string | null;
  }>;
  creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
  revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
  parameters: {
    __typename?: 'CollectionParameters';
    offPlatform?: {
      __typename?: 'OffPlatformParams';
      minItems?: number | null;
      maxItems?: number | null;
      moduleDisplayName: string;
      defaultAltSummVariant: string;
      hostingPageURL: string;
    } | null;
  };
};

export type CollectionScheduleCollectionFragment = {
  __typename?: 'Collection';
  publishUtc?: number | null;
  idCreatedUtc: string;
  id: string;
  createdUtc: number;
  updatedUtc?: number | null;
  allessehCollectionId: string;
  name: string;
  notes?: string | null;
  consumer?: string | null;
  allessehJsonQuery?: string | null;
  isArchived: boolean;
  contentItems: Array<{
    __typename?: 'CollectionContentItem';
    originId: string;
    originContentType: string;
    content?: string | null;
  }>;
  creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
  revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
  parameters: {
    __typename?: 'CollectionParameters';
    offPlatform?: {
      __typename?: 'OffPlatformParams';
      minItems?: number | null;
      maxItems?: number | null;
      moduleDisplayName: string;
      defaultAltSummVariant: string;
      hostingPageURL: string;
    } | null;
  };
};

export type CollectionPageCollectionFragment = {
  __typename?: 'Collection';
  allessehCollectionId: string;
  idCreatedUtc: string;
  id: string;
  createdUtc: number;
  updatedUtc?: number | null;
  name: string;
  isArchived: boolean;
  allessehJsonQuery?: string | null;
  contentItems: Array<{
    __typename?: 'CollectionContentItem';
    originId: string;
    originContentType: string;
    content?: string | null;
  }>;
};

export type CollectionUpdateMutationVariables = Exact<{
  collectionUpdateInput: CollectionUpdateInput;
}>;

export type CollectionUpdateMutation = {
  __typename?: 'Mutation';
  collectionUpdate: {
    __typename?: 'Collection';
    idCreatedUtc: string;
    id: string;
    createdUtc: number;
    updatedUtc?: number | null;
    allessehCollectionId: string;
    name: string;
    notes?: string | null;
    consumer?: string | null;
    allessehJsonQuery?: string | null;
    isArchived: boolean;
    contentItems: Array<{
      __typename?: 'CollectionContentItem';
      originId: string;
      originContentType: string;
      content?: string | null;
    }>;
    creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
    revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
    parameters: {
      __typename?: 'CollectionParameters';
      offPlatform?: {
        __typename?: 'OffPlatformParams';
        minItems?: number | null;
        maxItems?: number | null;
        moduleDisplayName: string;
        defaultAltSummVariant: string;
        hostingPageURL: string;
      } | null;
    };
  };
};

export type CollectionScheduleMutationVariables = Exact<{
  collectionScheduleInput: CollectionScheduleInput;
  previousPublishUtc?: InputMaybe<Scalars['Float']>;
}>;

export type CollectionScheduleMutation = {
  __typename?: 'Mutation';
  collectionSchedule: {
    __typename?: 'Collection';
    publishUtc?: number | null;
    idCreatedUtc: string;
    id: string;
    createdUtc: number;
    updatedUtc?: number | null;
    allessehCollectionId: string;
    name: string;
    notes?: string | null;
    consumer?: string | null;
    allessehJsonQuery?: string | null;
    isArchived: boolean;
    contentItems: Array<{
      __typename?: 'CollectionContentItem';
      originId: string;
      originContentType: string;
      content?: string | null;
    }>;
    creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
    revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
    parameters: {
      __typename?: 'CollectionParameters';
      offPlatform?: {
        __typename?: 'OffPlatformParams';
        minItems?: number | null;
        maxItems?: number | null;
        moduleDisplayName: string;
        defaultAltSummVariant: string;
        hostingPageURL: string;
      } | null;
    };
  };
};

export type CollectionDeleteScheduledMutationVariables = Exact<{
  collectionDeleteScheduledInput: CollectionDeleteScheduledInput;
}>;

export type CollectionDeleteScheduledMutation = {
  __typename?: 'Mutation';
  collectionDeleteScheduled: {
    __typename?: 'Collection';
    idCreatedUtc: string;
    id: string;
    createdUtc: number;
    updatedUtc?: number | null;
    allessehCollectionId: string;
    name: string;
    notes?: string | null;
    consumer?: string | null;
    allessehJsonQuery?: string | null;
    isArchived: boolean;
    contentItems: Array<{
      __typename?: 'CollectionContentItem';
      originId: string;
      originContentType: string;
      content?: string | null;
    }>;
    creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
    revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
    parameters: {
      __typename?: 'CollectionParameters';
      offPlatform?: {
        __typename?: 'OffPlatformParams';
        minItems?: number | null;
        maxItems?: number | null;
        moduleDisplayName: string;
        defaultAltSummVariant: string;
        hostingPageURL: string;
      } | null;
    };
  };
};

export type CollectionCreateMutationVariables = Exact<{
  collectionCreateInput: CollectionCreateInput;
}>;

export type CollectionCreateMutation = {
  __typename?: 'Mutation';
  collectionCreate: { __typename?: 'Collection'; idCreatedUtc: string };
};

export type CollectionCopyMutationVariables = Exact<{
  collectionCopyInput: CollectionCopyInput;
}>;

export type CollectionCopyMutation = {
  __typename?: 'Mutation';
  collectionCopy: { __typename?: 'Collection'; idCreatedUtc: string };
};

export type CollectionArchiveMutationVariables = Exact<{
  collectionArchiveInput: CollectionArchiveInput;
}>;

export type CollectionArchiveMutation = {
  __typename?: 'Mutation';
  collectionArchive: { __typename?: 'Collection'; idCreatedUtc: string };
};

export type CollectionOffPlatformConvertMutationVariables = Exact<{
  collectionOffPlatformInput: CollectionOffPlatformInput;
}>;

export type CollectionOffPlatformConvertMutation = {
  __typename?: 'Mutation';
  collectionOffPlatformConvert: {
    __typename?: 'Collection';
    idCreatedUtc: string;
    id: string;
    createdUtc: number;
    updatedUtc?: number | null;
    allessehCollectionId: string;
    name: string;
    notes?: string | null;
    consumer?: string | null;
    allessehJsonQuery?: string | null;
    isArchived: boolean;
    contentItems: Array<{
      __typename?: 'CollectionContentItem';
      originId: string;
      originContentType: string;
      content?: string | null;
    }>;
    creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
    revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
    parameters: {
      __typename?: 'CollectionParameters';
      offPlatform?: {
        __typename?: 'OffPlatformParams';
        minItems?: number | null;
        maxItems?: number | null;
        moduleDisplayName: string;
        defaultAltSummVariant: string;
        hostingPageURL: string;
      } | null;
    };
  };
};

export type CollectionAllessehDeleteMutationVariables = Exact<{
  deleteAllessehCollectionInput: DeleteAllessehCollectionInput;
}>;

export type CollectionAllessehDeleteMutation = {
  __typename?: 'Mutation';
  deleteAllessehCollection: {
    __typename?: 'CollectionDeleteResult';
    message: string;
    statusCode: number;
    error?: string | null;
  };
};

export type CollectionsQueryVariables = Exact<{
  collectionsInput: CollectionsInput;
  paginationParams: PaginationParams;
}>;

export type CollectionsQuery = {
  __typename?: 'Query';
  collections: {
    __typename?: 'CollectionConnection';
    edges: Array<{
      __typename?: 'CollectionEdge';
      node: {
        __typename?: 'Collection';
        allessehCollectionId: string;
        idCreatedUtc: string;
        id: string;
        createdUtc: number;
        updatedUtc?: number | null;
        name: string;
        isArchived: boolean;
        allessehJsonQuery?: string | null;
        contentItems: Array<{
          __typename?: 'CollectionContentItem';
          originId: string;
          originContentType: string;
          content?: string | null;
        }>;
      };
    }>;
    pageInfo: { __typename?: 'PageInfo'; endCursor?: string | null; hasNextPage: boolean };
  };
};

export type ScheduledCollectionsQueryVariables = Exact<{
  allessehCollectionId: Scalars['String'];
  paginationParams: PaginationParams;
  publicationKey: Scalars['String'];
}>;

export type ScheduledCollectionsQuery = {
  __typename?: 'Query';
  scheduledCollections: {
    __typename?: 'CollectionConnection';
    edges: Array<{
      __typename?: 'CollectionEdge';
      node: {
        __typename?: 'Collection';
        publishUtc?: number | null;
        publicationKey: string;
        idCreatedUtc: string;
        id: string;
        createdUtc: number;
        updatedUtc?: number | null;
        allessehCollectionId: string;
        name: string;
        notes?: string | null;
        consumer?: string | null;
        allessehJsonQuery?: string | null;
        isArchived: boolean;
        contentItems: Array<{
          __typename?: 'CollectionContentItem';
          originId: string;
          originContentType: string;
          content?: string | null;
        }>;
        creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
        revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
        parameters: {
          __typename?: 'CollectionParameters';
          offPlatform?: {
            __typename?: 'OffPlatformParams';
            minItems?: number | null;
            maxItems?: number | null;
            moduleDisplayName: string;
            defaultAltSummVariant: string;
            hostingPageURL: string;
          } | null;
        };
      };
    }>;
    pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type CollectionsPublishedOnDateQueryVariables = Exact<{
  allessehCollectionId: Scalars['String'];
  publishUtc: Scalars['Float'];
  paginationParams: PaginationParams;
  publicationKey: Scalars['String'];
}>;

export type CollectionsPublishedOnDateQuery = {
  __typename?: 'Query';
  collectionsPublishedOnDate: {
    __typename?: 'CollectionConnection';
    edges: Array<{
      __typename?: 'CollectionEdge';
      node: {
        __typename?: 'Collection';
        publishUtc?: number | null;
        idCreatedUtc: string;
        id: string;
        createdUtc: number;
        updatedUtc?: number | null;
        allessehCollectionId: string;
        name: string;
        notes?: string | null;
        consumer?: string | null;
        allessehJsonQuery?: string | null;
        isArchived: boolean;
        contentItems: Array<{
          __typename?: 'CollectionContentItem';
          originId: string;
          originContentType: string;
          content?: string | null;
        }>;
        creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
        revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
        parameters: {
          __typename?: 'CollectionParameters';
          offPlatform?: {
            __typename?: 'OffPlatformParams';
            minItems?: number | null;
            maxItems?: number | null;
            moduleDisplayName: string;
            defaultAltSummVariant: string;
            hostingPageURL: string;
          } | null;
        };
      };
    }>;
    pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type CollectionDtoFragment = {
  __typename?: 'CollectionDTO';
  idCreatedUtc: string;
  metadata: {
    __typename?: 'CollectionDTOMetadata';
    allessehId: string;
    createdUtc: number;
    isArchived: boolean;
    name: string;
    notes?: string | null;
    publicationKey: string;
    publishUtc?: number | null;
    updatedUtc?: number | null;
    creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
    revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
  };
  root: {
    __typename?: 'ListContainer';
    type: string;
    collection: Array<
      | {
          __typename?: 'ArticleItem';
          type: string;
          content?: string | null;
          attributes: {
            __typename?: 'ArticleAttributes';
            base_doc_id: string;
            hosted_url: string;
            id: string;
            link: string;
            originContentType?: string | null;
            originId?: string | null;
            product: string;
            seo_id: string;
            status: string;
          };
        }
      | { __typename?: 'ExternalCollectionItem' }
      | { __typename?: 'LinkedItem' }
      | { __typename?: 'MobileArticleItem' }
      | {
          __typename?: 'QueryItem';
          type: string;
          attributes: {
            __typename?: 'QueryAttributes';
            query: Record<string, unknown>;
            feedTitle?: string | null;
            feedUrl?: string | null;
            isFeed?: boolean | null;
          };
        }
    >;
  };
};

export type CollectionDtoListFragment = {
  __typename?: 'CollectionDTO';
  idCreatedUtc: string;
  metadata: {
    __typename?: 'CollectionDTOMetadata';
    allessehId: string;
    createdUtc: number;
    isArchived: boolean;
    name: string;
    notes?: string | null;
    publicationKey: string;
    publishUtc?: number | null;
    updatedUtc?: number | null;
  };
  root: {
    __typename?: 'ListContainer';
    type: string;
    collection: Array<
      | {
          __typename?: 'ArticleItem';
          type: string;
          content?: string | null;
          attributes: {
            __typename?: 'ArticleAttributes';
            base_doc_id: string;
            hosted_url: string;
            id: string;
            link: string;
            originContentType?: string | null;
            originId?: string | null;
            product: string;
            seo_id: string;
            status: string;
          };
        }
      | { __typename?: 'ExternalCollectionItem' }
      | { __typename?: 'LinkedItem' }
      | { __typename?: 'MobileArticleItem' }
      | {
          __typename?: 'QueryItem';
          type: string;
          attributes: {
            __typename?: 'QueryAttributes';
            query: Record<string, unknown>;
            feedTitle?: string | null;
            feedUrl?: string | null;
            isFeed?: boolean | null;
          };
        }
    >;
  };
};

export type CollectionDtoCreateMutationVariables = Exact<{
  collectionDTOCreateInput: CollectionDtoCreateInput;
}>;

export type CollectionDtoCreateMutation = {
  __typename?: 'Mutation';
  collectionDTOCreate: {
    __typename?: 'CollectionDTO';
    idCreatedUtc: string;
    metadata: {
      __typename?: 'CollectionDTOMetadata';
      allessehId: string;
      createdUtc: number;
      isArchived: boolean;
      name: string;
      notes?: string | null;
      publicationKey: string;
      publishUtc?: number | null;
      updatedUtc?: number | null;
      creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
      revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
    };
    root: {
      __typename?: 'ListContainer';
      type: string;
      collection: Array<
        | {
            __typename?: 'ArticleItem';
            type: string;
            content?: string | null;
            attributes: {
              __typename?: 'ArticleAttributes';
              base_doc_id: string;
              hosted_url: string;
              id: string;
              link: string;
              originContentType?: string | null;
              originId?: string | null;
              product: string;
              seo_id: string;
              status: string;
            };
          }
        | { __typename?: 'ExternalCollectionItem' }
        | { __typename?: 'LinkedItem' }
        | { __typename?: 'MobileArticleItem' }
        | {
            __typename?: 'QueryItem';
            type: string;
            attributes: {
              __typename?: 'QueryAttributes';
              query: Record<string, unknown>;
              feedTitle?: string | null;
              feedUrl?: string | null;
              isFeed?: boolean | null;
            };
          }
      >;
    };
  };
};

export type CollectionDtoUpdateMutationVariables = Exact<{
  collectionDTOUpdateInput: CollectionDtoMutationInput;
}>;

export type CollectionDtoUpdateMutation = {
  __typename?: 'Mutation';
  collectionDTOUpdate: {
    __typename?: 'CollectionDTO';
    idCreatedUtc: string;
    metadata: {
      __typename?: 'CollectionDTOMetadata';
      allessehId: string;
      createdUtc: number;
      isArchived: boolean;
      name: string;
      notes?: string | null;
      publicationKey: string;
      publishUtc?: number | null;
      updatedUtc?: number | null;
      creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
      revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
    };
    root: {
      __typename?: 'ListContainer';
      type: string;
      collection: Array<
        | {
            __typename?: 'ArticleItem';
            type: string;
            content?: string | null;
            attributes: {
              __typename?: 'ArticleAttributes';
              base_doc_id: string;
              hosted_url: string;
              id: string;
              link: string;
              originContentType?: string | null;
              originId?: string | null;
              product: string;
              seo_id: string;
              status: string;
            };
          }
        | { __typename?: 'ExternalCollectionItem' }
        | { __typename?: 'LinkedItem' }
        | { __typename?: 'MobileArticleItem' }
        | {
            __typename?: 'QueryItem';
            type: string;
            attributes: {
              __typename?: 'QueryAttributes';
              query: Record<string, unknown>;
              feedTitle?: string | null;
              feedUrl?: string | null;
              isFeed?: boolean | null;
            };
          }
      >;
    };
  };
};

export type CollectionDtoCopyMutationVariables = Exact<{
  collectionDTOCopyInput: CollectionDtoMutationInput;
}>;

export type CollectionDtoCopyMutation = {
  __typename?: 'Mutation';
  collectionDTOCopy: {
    __typename?: 'CollectionDTO';
    idCreatedUtc: string;
    metadata: {
      __typename?: 'CollectionDTOMetadata';
      allessehId: string;
      createdUtc: number;
      isArchived: boolean;
      name: string;
      notes?: string | null;
      publicationKey: string;
      publishUtc?: number | null;
      updatedUtc?: number | null;
      creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
      revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
    };
    root: {
      __typename?: 'ListContainer';
      type: string;
      collection: Array<
        | {
            __typename?: 'ArticleItem';
            type: string;
            content?: string | null;
            attributes: {
              __typename?: 'ArticleAttributes';
              base_doc_id: string;
              hosted_url: string;
              id: string;
              link: string;
              originContentType?: string | null;
              originId?: string | null;
              product: string;
              seo_id: string;
              status: string;
            };
          }
        | { __typename?: 'ExternalCollectionItem' }
        | { __typename?: 'LinkedItem' }
        | { __typename?: 'MobileArticleItem' }
        | {
            __typename?: 'QueryItem';
            type: string;
            attributes: {
              __typename?: 'QueryAttributes';
              query: Record<string, unknown>;
              feedTitle?: string | null;
              feedUrl?: string | null;
              isFeed?: boolean | null;
            };
          }
      >;
    };
  };
};

export type CollectionDtoArchiveMutationVariables = Exact<{
  collectionDTOArchiveInput: CollectionDtoArchiveInput;
}>;

export type CollectionDtoArchiveMutation = {
  __typename?: 'Mutation';
  collectionDTOArchive: {
    __typename?: 'CollectionDTO';
    idCreatedUtc: string;
    metadata: {
      __typename?: 'CollectionDTOMetadata';
      allessehId: string;
      createdUtc: number;
      isArchived: boolean;
      name: string;
      notes?: string | null;
      publicationKey: string;
      publishUtc?: number | null;
      updatedUtc?: number | null;
      creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
      revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
    };
    root: {
      __typename?: 'ListContainer';
      type: string;
      collection: Array<
        | {
            __typename?: 'ArticleItem';
            type: string;
            content?: string | null;
            attributes: {
              __typename?: 'ArticleAttributes';
              base_doc_id: string;
              hosted_url: string;
              id: string;
              link: string;
              originContentType?: string | null;
              originId?: string | null;
              product: string;
              seo_id: string;
              status: string;
            };
          }
        | { __typename?: 'ExternalCollectionItem' }
        | { __typename?: 'LinkedItem' }
        | { __typename?: 'MobileArticleItem' }
        | {
            __typename?: 'QueryItem';
            type: string;
            attributes: {
              __typename?: 'QueryAttributes';
              query: Record<string, unknown>;
              feedTitle?: string | null;
              feedUrl?: string | null;
              isFeed?: boolean | null;
            };
          }
      >;
    };
  };
};

export type CollectionsDtoQueryVariables = Exact<{
  collectionsDTOInput: CollectionsDtoInput;
  paginationParams: PaginationParams;
}>;

export type CollectionsDtoQuery = {
  __typename?: 'Query';
  collectionsDTO: {
    __typename?: 'CollectionDTOConnection';
    edges: Array<{
      __typename?: 'CollectionDTOEdge';
      node: {
        __typename?: 'CollectionDTO';
        idCreatedUtc: string;
        metadata: {
          __typename?: 'CollectionDTOMetadata';
          allessehId: string;
          createdUtc: number;
          isArchived: boolean;
          name: string;
          notes?: string | null;
          publicationKey: string;
          publishUtc?: number | null;
          updatedUtc?: number | null;
        };
        root: {
          __typename?: 'ListContainer';
          type: string;
          collection: Array<
            | {
                __typename?: 'ArticleItem';
                type: string;
                content?: string | null;
                attributes: {
                  __typename?: 'ArticleAttributes';
                  base_doc_id: string;
                  hosted_url: string;
                  id: string;
                  link: string;
                  originContentType?: string | null;
                  originId?: string | null;
                  product: string;
                  seo_id: string;
                  status: string;
                };
              }
            | { __typename?: 'ExternalCollectionItem' }
            | { __typename?: 'LinkedItem' }
            | { __typename?: 'MobileArticleItem' }
            | {
                __typename?: 'QueryItem';
                type: string;
                attributes: {
                  __typename?: 'QueryAttributes';
                  query: Record<string, unknown>;
                  feedTitle?: string | null;
                  feedUrl?: string | null;
                  isFeed?: boolean | null;
                };
              }
          >;
        };
      };
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      hasNextPage: boolean;
      hasPreviousPage?: boolean | null;
      startCursor?: string | null;
    };
  };
};

export type CollectionDtoByIdQueryVariables = Exact<{
  id: Scalars['String'];
  publicationKey: Scalars['String'];
}>;

export type CollectionDtoByIdQuery = {
  __typename?: 'Query';
  collectionDTOById: {
    __typename?: 'CollectionDTO';
    idCreatedUtc: string;
    metadata: {
      __typename?: 'CollectionDTOMetadata';
      allessehId: string;
      createdUtc: number;
      isArchived: boolean;
      name: string;
      notes?: string | null;
      publicationKey: string;
      publishUtc?: number | null;
      updatedUtc?: number | null;
      creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
      revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
    };
    root: {
      __typename?: 'ListContainer';
      type: string;
      collection: Array<
        | {
            __typename?: 'ArticleItem';
            type: string;
            content?: string | null;
            attributes: {
              __typename?: 'ArticleAttributes';
              base_doc_id: string;
              hosted_url: string;
              id: string;
              link: string;
              originContentType?: string | null;
              originId?: string | null;
              product: string;
              seo_id: string;
              status: string;
            };
          }
        | { __typename?: 'ExternalCollectionItem' }
        | { __typename?: 'LinkedItem' }
        | { __typename?: 'MobileArticleItem' }
        | {
            __typename?: 'QueryItem';
            type: string;
            attributes: {
              __typename?: 'QueryAttributes';
              query: Record<string, unknown>;
              feedTitle?: string | null;
              feedUrl?: string | null;
              isFeed?: boolean | null;
            };
          }
      >;
    };
  };
};

export type IssueContainerFragmentFragment = {
  __typename?: 'IssueContainer';
  type: string;
  attributes: { __typename?: 'IssueAttributes'; issueKey: string; issueDate: string; status: string };
  collection: Array<{
    __typename?: 'IssueSectionContainer';
    type: string;
    subtype?: string | null;
    attributes: {
      __typename?: 'IssueSectionAttributes';
      adPlacementType?: string | null;
      adZone?: string | null;
      isHidden: boolean;
      issueDate?: string | null;
      pageType: string;
      routeKey: string;
      sectionKey: string;
      sectionLabel: string;
      summaryPriority: string;
      upstreamAllessehCollectionId?: string | null;
    };
    collection: Array<{
      __typename?: 'PageContainer';
      type: string;
      attributes: { __typename?: 'PageAttributes'; layoutId?: string | null };
      collection: Array<{
        __typename?: 'ModuleContainer';
        type: string;
        attributes: {
          __typename?: 'ModuleAttributes';
          pageModule?: {
            __typename?: 'PageModule';
            uiModuleType: UiModuleType;
            moduleItems: Array<{
              __typename?: 'PageModuleItem';
              itemType: PageModuleItemType;
              itemFields: {
                __typename?: 'PageModuleItemFields';
                contentItem?: {
                  __typename?: 'PageModuleItemContent';
                  originId: string;
                  originContentType: string;
                  content?: string | null;
                  base_doc_id: string;
                  hosted_url: string;
                  id: string;
                  link: string;
                  product: string;
                  seo_id: string;
                  status: string;
                } | null;
                queryItem?: { __typename?: 'PageModuleItemQuery'; jsonQuery: string } | null;
                collectionItem?: {
                  __typename?: 'PageModuleItemCollection';
                  idCreatedUtc: string;
                  collection?: {
                    __typename?: 'Collection';
                    allessehCollectionId: string;
                    idCreatedUtc: string;
                    id: string;
                    createdUtc: number;
                    updatedUtc?: number | null;
                    name: string;
                    isArchived: boolean;
                    publicationKey: string;
                    allessehJsonQuery?: string | null;
                    creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
                    revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
                    parameters: {
                      __typename?: 'CollectionParameters';
                      offPlatform?: {
                        __typename?: 'OffPlatformParams';
                        minItems?: number | null;
                        maxItems?: number | null;
                        moduleDisplayName: string;
                        defaultAltSummVariant: string;
                        hostingPageURL: string;
                      } | null;
                    };
                    contentItems: Array<{
                      __typename?: 'CollectionContentItem';
                      originId: string;
                      originContentType: string;
                      content?: string | null;
                      base_doc_id: string;
                      hosted_url: string;
                      id: string;
                      link: string;
                      product: string;
                      seo_id: string;
                      status: string;
                    }>;
                  } | null;
                } | null;
                allessehCollectionItem?: {
                  __typename?: 'PageModuleItemAllessehCollection';
                  allessehCollectionId: string;
                } | null;
              };
            }>;
            uiModuleFields: {
              __typename?: 'UiModule';
              basicModule?: {
                __typename?: 'UiBasicModule';
                treatmentType: UiBasicTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
              } | null;
            };
          } | null;
        };
        collection: Array<
          | {
              __typename?: 'ArticleItem';
              content?: string | null;
              type: string;
              attributes: {
                __typename?: 'ArticleAttributes';
                base_doc_id: string;
                hosted_url: string;
                id: string;
                link: string;
                originContentType?: string | null;
                originId?: string | null;
                product: string;
                seo_id: string;
                status: string;
              };
            }
          | {
              __typename?: 'ExternalCollectionItem';
              type: string;
              attributes: { __typename?: 'ExternalCollectionAttributes'; id: string; repo: string };
            }
          | { __typename?: 'LinkedItem' }
          | { __typename?: 'MobileArticleItem' }
          | {
              __typename?: 'QueryItem';
              type: string;
              attributes: { __typename?: 'QueryAttributes'; query: Record<string, unknown> };
            }
        >;
      }>;
    }>;
  }>;
};

export type IssueSectionContainerFragmentFragment = {
  __typename?: 'IssueSectionContainer';
  type: string;
  subtype?: string | null;
  attributes: {
    __typename?: 'IssueSectionAttributes';
    adPlacementType?: string | null;
    adZone?: string | null;
    isHidden: boolean;
    issueDate?: string | null;
    pageType: string;
    routeKey: string;
    sectionKey: string;
    sectionLabel: string;
    summaryPriority: string;
    upstreamAllessehCollectionId?: string | null;
  };
  collection: Array<{
    __typename?: 'PageContainer';
    type: string;
    attributes: { __typename?: 'PageAttributes'; layoutId?: string | null };
    collection: Array<{
      __typename?: 'ModuleContainer';
      type: string;
      attributes: {
        __typename?: 'ModuleAttributes';
        pageModule?: {
          __typename?: 'PageModule';
          uiModuleType: UiModuleType;
          moduleItems: Array<{
            __typename?: 'PageModuleItem';
            itemType: PageModuleItemType;
            itemFields: {
              __typename?: 'PageModuleItemFields';
              contentItem?: {
                __typename?: 'PageModuleItemContent';
                originId: string;
                originContentType: string;
                content?: string | null;
                base_doc_id: string;
                hosted_url: string;
                id: string;
                link: string;
                product: string;
                seo_id: string;
                status: string;
              } | null;
              queryItem?: { __typename?: 'PageModuleItemQuery'; jsonQuery: string } | null;
              collectionItem?: {
                __typename?: 'PageModuleItemCollection';
                idCreatedUtc: string;
                collection?: {
                  __typename?: 'Collection';
                  allessehCollectionId: string;
                  idCreatedUtc: string;
                  id: string;
                  createdUtc: number;
                  updatedUtc?: number | null;
                  name: string;
                  isArchived: boolean;
                  publicationKey: string;
                  allessehJsonQuery?: string | null;
                  creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
                  revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
                  parameters: {
                    __typename?: 'CollectionParameters';
                    offPlatform?: {
                      __typename?: 'OffPlatformParams';
                      minItems?: number | null;
                      maxItems?: number | null;
                      moduleDisplayName: string;
                      defaultAltSummVariant: string;
                      hostingPageURL: string;
                    } | null;
                  };
                  contentItems: Array<{
                    __typename?: 'CollectionContentItem';
                    originId: string;
                    originContentType: string;
                    content?: string | null;
                    base_doc_id: string;
                    hosted_url: string;
                    id: string;
                    link: string;
                    product: string;
                    seo_id: string;
                    status: string;
                  }>;
                } | null;
              } | null;
              allessehCollectionItem?: {
                __typename?: 'PageModuleItemAllessehCollection';
                allessehCollectionId: string;
              } | null;
            };
          }>;
          uiModuleFields: {
            __typename?: 'UiModule';
            basicModule?: {
              __typename?: 'UiBasicModule';
              treatmentType: UiBasicTreatmentType;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
            } | null;
          };
        } | null;
      };
      collection: Array<
        | {
            __typename?: 'ArticleItem';
            content?: string | null;
            type: string;
            attributes: {
              __typename?: 'ArticleAttributes';
              base_doc_id: string;
              hosted_url: string;
              id: string;
              link: string;
              originContentType?: string | null;
              originId?: string | null;
              product: string;
              seo_id: string;
              status: string;
            };
          }
        | {
            __typename?: 'ExternalCollectionItem';
            type: string;
            attributes: { __typename?: 'ExternalCollectionAttributes'; id: string; repo: string };
          }
        | { __typename?: 'LinkedItem' }
        | { __typename?: 'MobileArticleItem' }
        | {
            __typename?: 'QueryItem';
            type: string;
            attributes: { __typename?: 'QueryAttributes'; query: Record<string, unknown> };
          }
      >;
    }>;
  }>;
};

export type PageContainerFragmentFragment = {
  __typename?: 'PageContainer';
  type: string;
  attributes: { __typename?: 'PageAttributes'; layoutId?: string | null };
  collection: Array<{
    __typename?: 'ModuleContainer';
    type: string;
    attributes: {
      __typename?: 'ModuleAttributes';
      pageModule?: {
        __typename?: 'PageModule';
        uiModuleType: UiModuleType;
        moduleItems: Array<{
          __typename?: 'PageModuleItem';
          itemType: PageModuleItemType;
          itemFields: {
            __typename?: 'PageModuleItemFields';
            contentItem?: {
              __typename?: 'PageModuleItemContent';
              originId: string;
              originContentType: string;
              content?: string | null;
              base_doc_id: string;
              hosted_url: string;
              id: string;
              link: string;
              product: string;
              seo_id: string;
              status: string;
            } | null;
            queryItem?: { __typename?: 'PageModuleItemQuery'; jsonQuery: string } | null;
            collectionItem?: {
              __typename?: 'PageModuleItemCollection';
              idCreatedUtc: string;
              collection?: {
                __typename?: 'Collection';
                allessehCollectionId: string;
                idCreatedUtc: string;
                id: string;
                createdUtc: number;
                updatedUtc?: number | null;
                name: string;
                isArchived: boolean;
                publicationKey: string;
                allessehJsonQuery?: string | null;
                creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
                revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
                parameters: {
                  __typename?: 'CollectionParameters';
                  offPlatform?: {
                    __typename?: 'OffPlatformParams';
                    minItems?: number | null;
                    maxItems?: number | null;
                    moduleDisplayName: string;
                    defaultAltSummVariant: string;
                    hostingPageURL: string;
                  } | null;
                };
                contentItems: Array<{
                  __typename?: 'CollectionContentItem';
                  originId: string;
                  originContentType: string;
                  content?: string | null;
                  base_doc_id: string;
                  hosted_url: string;
                  id: string;
                  link: string;
                  product: string;
                  seo_id: string;
                  status: string;
                }>;
              } | null;
            } | null;
            allessehCollectionItem?: {
              __typename?: 'PageModuleItemAllessehCollection';
              allessehCollectionId: string;
            } | null;
          };
        }>;
        uiModuleFields: {
          __typename?: 'UiModule';
          basicModule?: {
            __typename?: 'UiBasicModule';
            treatmentType: UiBasicTreatmentType;
            contentTypes: Array<PublicationSettingSearchableContentType>;
            allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
          } | null;
        };
      } | null;
    };
    collection: Array<
      | {
          __typename?: 'ArticleItem';
          content?: string | null;
          type: string;
          attributes: {
            __typename?: 'ArticleAttributes';
            base_doc_id: string;
            hosted_url: string;
            id: string;
            link: string;
            originContentType?: string | null;
            originId?: string | null;
            product: string;
            seo_id: string;
            status: string;
          };
        }
      | {
          __typename?: 'ExternalCollectionItem';
          type: string;
          attributes: { __typename?: 'ExternalCollectionAttributes'; id: string; repo: string };
        }
      | { __typename?: 'LinkedItem' }
      | { __typename?: 'MobileArticleItem' }
      | {
          __typename?: 'QueryItem';
          type: string;
          attributes: { __typename?: 'QueryAttributes'; query: Record<string, unknown> };
        }
    >;
  }>;
};

export type ModuleContainerFragmentFragment = {
  __typename?: 'ModuleContainer';
  type: string;
  attributes: {
    __typename?: 'ModuleAttributes';
    pageModule?: {
      __typename?: 'PageModule';
      uiModuleType: UiModuleType;
      moduleItems: Array<{
        __typename?: 'PageModuleItem';
        itemType: PageModuleItemType;
        itemFields: {
          __typename?: 'PageModuleItemFields';
          contentItem?: {
            __typename?: 'PageModuleItemContent';
            originId: string;
            originContentType: string;
            content?: string | null;
            base_doc_id: string;
            hosted_url: string;
            id: string;
            link: string;
            product: string;
            seo_id: string;
            status: string;
          } | null;
          queryItem?: { __typename?: 'PageModuleItemQuery'; jsonQuery: string } | null;
          collectionItem?: {
            __typename?: 'PageModuleItemCollection';
            idCreatedUtc: string;
            collection?: {
              __typename?: 'Collection';
              allessehCollectionId: string;
              idCreatedUtc: string;
              id: string;
              createdUtc: number;
              updatedUtc?: number | null;
              name: string;
              isArchived: boolean;
              publicationKey: string;
              allessehJsonQuery?: string | null;
              creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
              revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
              parameters: {
                __typename?: 'CollectionParameters';
                offPlatform?: {
                  __typename?: 'OffPlatformParams';
                  minItems?: number | null;
                  maxItems?: number | null;
                  moduleDisplayName: string;
                  defaultAltSummVariant: string;
                  hostingPageURL: string;
                } | null;
              };
              contentItems: Array<{
                __typename?: 'CollectionContentItem';
                originId: string;
                originContentType: string;
                content?: string | null;
                base_doc_id: string;
                hosted_url: string;
                id: string;
                link: string;
                product: string;
                seo_id: string;
                status: string;
              }>;
            } | null;
          } | null;
          allessehCollectionItem?: {
            __typename?: 'PageModuleItemAllessehCollection';
            allessehCollectionId: string;
          } | null;
        };
      }>;
      uiModuleFields: {
        __typename?: 'UiModule';
        basicModule?: {
          __typename?: 'UiBasicModule';
          treatmentType: UiBasicTreatmentType;
          contentTypes: Array<PublicationSettingSearchableContentType>;
          allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
        } | null;
      };
    } | null;
  };
  collection: Array<
    | {
        __typename?: 'ArticleItem';
        content?: string | null;
        type: string;
        attributes: {
          __typename?: 'ArticleAttributes';
          base_doc_id: string;
          hosted_url: string;
          id: string;
          link: string;
          originContentType?: string | null;
          originId?: string | null;
          product: string;
          seo_id: string;
          status: string;
        };
      }
    | {
        __typename?: 'ExternalCollectionItem';
        type: string;
        attributes: { __typename?: 'ExternalCollectionAttributes'; id: string; repo: string };
      }
    | { __typename?: 'LinkedItem' }
    | { __typename?: 'MobileArticleItem' }
    | {
        __typename?: 'QueryItem';
        type: string;
        attributes: { __typename?: 'QueryAttributes'; query: Record<string, unknown> };
      }
  >;
};

export type ArticleFragmentFragment = {
  __typename?: 'ArticleItem';
  content?: string | null;
  type: string;
  attributes: {
    __typename?: 'ArticleAttributes';
    base_doc_id: string;
    hosted_url: string;
    id: string;
    link: string;
    originContentType?: string | null;
    originId?: string | null;
    product: string;
    seo_id: string;
    status: string;
  };
};

export type QueryFragmentFragment = {
  __typename?: 'QueryItem';
  type: string;
  attributes: { __typename?: 'QueryAttributes'; query: Record<string, unknown> };
};

export type ExternalCollectionFragmentFragment = {
  __typename?: 'ExternalCollectionItem';
  type: string;
  attributes: { __typename?: 'ExternalCollectionAttributes'; id: string; repo: string };
};

export type CreateItpMutationVariables = Exact<{
  itpCreateInput: ItpCreateInput;
  publicationKey: Scalars['String'];
}>;

export type CreateItpMutation = {
  __typename?: 'Mutation';
  createITP: {
    __typename?: 'ITPIssue';
    issueId: string;
    issueDate: string;
    createdUtc: number;
    publishUtc?: number | null;
    updatedUtc?: number | null;
    status: ItpIssueStatus;
    label: string;
    summaryPriority: string;
    creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
    revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
  };
};

export type DeleteItpMutationVariables = Exact<{
  issueId: Scalars['String'];
  publicationKey: Scalars['String'];
}>;

export type DeleteItpMutation = {
  __typename?: 'Mutation';
  deleteITP: {
    __typename?: 'ITPIssue';
    issueId: string;
    issueDate: string;
    createdUtc: number;
    publishUtc?: number | null;
    updatedUtc?: number | null;
    status: ItpIssueStatus;
    label: string;
    summaryPriority: string;
    creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
    revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
  };
};

export type SaveItpMutationVariables = Exact<{
  itpSaveInput: ItpSaveInput;
  publicationKey: Scalars['String'];
}>;

export type SaveItpMutation = {
  __typename?: 'Mutation';
  saveITP: {
    __typename?: 'ITPIssueWithPages';
    createdUtc: number;
    issueDate: string;
    issueId: string;
    label: string;
    publishUtc?: number | null;
    refreshedUtc?: number | null;
    status: ItpIssueStatus;
    updatedUtc?: number | null;
    creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
    pages: Array<{
      __typename?: 'ITPPage';
      adType: string;
      adZones: string;
      allessehCollectionId?: string | null;
      isHidden: boolean;
      issueId: string;
      label: string;
      pageType: string;
    }>;
    revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
  };
};

export type PublishItpMutationVariables = Exact<{
  itpSaveInput: ItpSaveInput;
  publicationKey: Scalars['String'];
}>;

export type PublishItpMutation = {
  __typename?: 'Mutation';
  publishITP: {
    __typename?: 'ITPIssueWithPages';
    createdUtc: number;
    issueDate: string;
    issueId: string;
    label: string;
    publishUtc?: number | null;
    refreshedUtc?: number | null;
    status: ItpIssueStatus;
    updatedUtc?: number | null;
    creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
    pages: Array<{
      __typename?: 'ITPPage';
      adType: string;
      adZones: string;
      allessehCollectionId?: string | null;
      isHidden: boolean;
      issueId: string;
      label: string;
      pageType: string;
    }>;
    revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
  };
};

export type PreviewItpLinkMutationVariables = Exact<{
  itpSaveInput: ItpSaveInput;
  publicationKey: Scalars['String'];
}>;

export type PreviewItpLinkMutation = { __typename?: 'Mutation'; previewItpLink?: Array<string> | null };

export type LastSevenItpIssuesQueryVariables = Exact<{
  publicationKey: Scalars['String'];
}>;

export type LastSevenItpIssuesQuery = {
  __typename?: 'Query';
  lastSevenITPIssues: Array<{
    __typename?: 'ITPIssue';
    issueId: string;
    issueDate: string;
    createdUtc: number;
    publishUtc?: number | null;
    updatedUtc?: number | null;
    status: ItpIssueStatus;
    label: string;
    summaryPriority: string;
    creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
    revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
  }>;
};

export type ItpByDateQueryVariables = Exact<{
  publicationKey: Scalars['String'];
  issueDate: Scalars['String'];
}>;

export type ItpByDateQuery = {
  __typename?: 'Query';
  itpByDate: {
    __typename?: 'ITPIssueWithPages';
    createdUtc: number;
    issueDate: string;
    issueId: string;
    label: string;
    publishUtc?: number | null;
    refreshedUtc?: number | null;
    status: ItpIssueStatus;
    updatedUtc?: number | null;
    summaryPriority: string;
    revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
    creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
    pages: Array<{
      __typename?: 'ITPPage';
      adType: string;
      adZones: string;
      allessehCollectionId?: string | null;
      isHidden: boolean;
      issueId: string;
      label: string;
      pageType: string;
      pageModules: Array<{
        __typename?: 'PageModule';
        uiModuleType: UiModuleType;
        moduleItems: Array<{
          __typename?: 'PageModuleItem';
          itemType: PageModuleItemType;
          itemFields: {
            __typename?: 'PageModuleItemFields';
            contentItem?: {
              __typename?: 'PageModuleItemContent';
              originId: string;
              originContentType: string;
              content?: string | null;
              base_doc_id: string;
              hosted_url: string;
              id: string;
              link: string;
              product: string;
              seo_id: string;
              status: string;
            } | null;
            queryItem?: { __typename?: 'PageModuleItemQuery'; jsonQuery: string } | null;
            collectionItem?: {
              __typename?: 'PageModuleItemCollection';
              idCreatedUtc: string;
              collection?: {
                __typename?: 'Collection';
                allessehCollectionId: string;
                idCreatedUtc: string;
                id: string;
                createdUtc: number;
                updatedUtc?: number | null;
                name: string;
                isArchived: boolean;
                publicationKey: string;
                allessehJsonQuery?: string | null;
                creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
                revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
                parameters: {
                  __typename?: 'CollectionParameters';
                  offPlatform?: {
                    __typename?: 'OffPlatformParams';
                    minItems?: number | null;
                    maxItems?: number | null;
                    moduleDisplayName: string;
                    defaultAltSummVariant: string;
                    hostingPageURL: string;
                  } | null;
                };
                contentItems: Array<{
                  __typename?: 'CollectionContentItem';
                  originId: string;
                  originContentType: string;
                  content?: string | null;
                  base_doc_id: string;
                  hosted_url: string;
                  id: string;
                  link: string;
                  product: string;
                  seo_id: string;
                  status: string;
                }>;
              } | null;
            } | null;
            allessehCollectionItem?: {
              __typename?: 'PageModuleItemAllessehCollection';
              allessehCollectionId: string;
            } | null;
          };
        }>;
        uiModuleFields: {
          __typename?: 'UiModule';
          basicModule?: {
            __typename?: 'UiBasicModule';
            treatmentType: UiBasicTreatmentType;
            contentTypes: Array<PublicationSettingSearchableContentType>;
            allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
          } | null;
        };
      }>;
    }>;
  };
};

export type ImportItpContentQueryVariables = Exact<{
  publicationKey: Scalars['String'];
  itpImportContentInput: ItpImportContentInput;
}>;

export type ImportItpContentQuery = {
  __typename?: 'Query';
  importITPContent: Array<
    Array<{
      __typename?: 'PageModule';
      uiModuleType: UiModuleType;
      error?: string | null;
      uiModuleFields: {
        __typename?: 'UiModule';
        basicModule?: {
          __typename?: 'UiBasicModule';
          contentTypes: Array<PublicationSettingSearchableContentType>;
          treatmentType: UiBasicTreatmentType;
          allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
        } | null;
      };
      moduleItems: Array<{
        __typename?: 'PageModuleItem';
        itemType: PageModuleItemType;
        itemFields: {
          __typename?: 'PageModuleItemFields';
          contentItem?: {
            __typename?: 'PageModuleItemContent';
            originId: string;
            originContentType: string;
            content?: string | null;
          } | null;
        };
      }>;
    }>
  >;
};

export type GetDefaultItpPagesQueryVariables = Exact<{
  publicationKey: Scalars['String'];
  issueDate: Scalars['String'];
}>;

export type GetDefaultItpPagesQuery = {
  __typename?: 'Query';
  getDefaultITPPages: Array<{
    __typename?: 'ITPPage';
    adType: string;
    adZones: string;
    allessehCollectionId?: string | null;
    isHidden: boolean;
    issueId: string;
    label: string;
    pageType: string;
    pageModules: Array<{
      __typename?: 'PageModule';
      uiModuleType: UiModuleType;
      moduleItems: Array<{
        __typename?: 'PageModuleItem';
        itemType: PageModuleItemType;
        itemFields: {
          __typename?: 'PageModuleItemFields';
          contentItem?: {
            __typename?: 'PageModuleItemContent';
            originId: string;
            originContentType: string;
            content?: string | null;
            base_doc_id: string;
            hosted_url: string;
            id: string;
            link: string;
            product: string;
            seo_id: string;
            status: string;
          } | null;
          queryItem?: { __typename?: 'PageModuleItemQuery'; jsonQuery: string } | null;
          collectionItem?: {
            __typename?: 'PageModuleItemCollection';
            idCreatedUtc: string;
            collection?: {
              __typename?: 'Collection';
              allessehCollectionId: string;
              idCreatedUtc: string;
              id: string;
              createdUtc: number;
              updatedUtc?: number | null;
              name: string;
              isArchived: boolean;
              publicationKey: string;
              allessehJsonQuery?: string | null;
              creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
              revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
              parameters: {
                __typename?: 'CollectionParameters';
                offPlatform?: {
                  __typename?: 'OffPlatformParams';
                  minItems?: number | null;
                  maxItems?: number | null;
                  moduleDisplayName: string;
                  defaultAltSummVariant: string;
                  hostingPageURL: string;
                } | null;
              };
              contentItems: Array<{
                __typename?: 'CollectionContentItem';
                originId: string;
                originContentType: string;
                content?: string | null;
                base_doc_id: string;
                hosted_url: string;
                id: string;
                link: string;
                product: string;
                seo_id: string;
                status: string;
              }>;
            } | null;
          } | null;
          allessehCollectionItem?: {
            __typename?: 'PageModuleItemAllessehCollection';
            allessehCollectionId: string;
          } | null;
        };
      }>;
      uiModuleFields: {
        __typename?: 'UiModule';
        basicModule?: {
          __typename?: 'UiBasicModule';
          treatmentType: UiBasicTreatmentType;
          contentTypes: Array<PublicationSettingSearchableContentType>;
          allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
        } | null;
      };
    }>;
  }>;
};

export type IssueFragment = {
  __typename?: 'ITPIssue';
  issueId: string;
  issueDate: string;
  createdUtc: number;
  publishUtc?: number | null;
  updatedUtc?: number | null;
  status: ItpIssueStatus;
  label: string;
  summaryPriority: string;
  creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
  revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
};

export type IssueWithPagesFragment = {
  __typename?: 'ITPIssueWithPages';
  createdUtc: number;
  issueDate: string;
  issueId: string;
  label: string;
  publishUtc?: number | null;
  refreshedUtc?: number | null;
  status: ItpIssueStatus;
  updatedUtc?: number | null;
  summaryPriority: string;
  creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
  pages: Array<{
    __typename?: 'ITPPage';
    adType: string;
    adZones: string;
    allessehCollectionId?: string | null;
    isHidden: boolean;
    issueId: string;
    label: string;
    pageType: string;
    pageModules: Array<{
      __typename?: 'PageModule';
      uiModuleType: UiModuleType;
      moduleItems: Array<{
        __typename?: 'PageModuleItem';
        itemType: PageModuleItemType;
        itemFields: {
          __typename?: 'PageModuleItemFields';
          contentItem?: {
            __typename?: 'PageModuleItemContent';
            originId: string;
            originContentType: string;
            content?: string | null;
            base_doc_id: string;
            hosted_url: string;
            id: string;
            link: string;
            product: string;
            seo_id: string;
            status: string;
          } | null;
          queryItem?: { __typename?: 'PageModuleItemQuery'; jsonQuery: string } | null;
          collectionItem?: {
            __typename?: 'PageModuleItemCollection';
            idCreatedUtc: string;
            collection?: {
              __typename?: 'Collection';
              allessehCollectionId: string;
              idCreatedUtc: string;
              id: string;
              createdUtc: number;
              updatedUtc?: number | null;
              name: string;
              isArchived: boolean;
              publicationKey: string;
              allessehJsonQuery?: string | null;
              creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
              revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
              parameters: {
                __typename?: 'CollectionParameters';
                offPlatform?: {
                  __typename?: 'OffPlatformParams';
                  minItems?: number | null;
                  maxItems?: number | null;
                  moduleDisplayName: string;
                  defaultAltSummVariant: string;
                  hostingPageURL: string;
                } | null;
              };
              contentItems: Array<{
                __typename?: 'CollectionContentItem';
                originId: string;
                originContentType: string;
                content?: string | null;
                base_doc_id: string;
                hosted_url: string;
                id: string;
                link: string;
                product: string;
                seo_id: string;
                status: string;
              }>;
            } | null;
          } | null;
          allessehCollectionItem?: {
            __typename?: 'PageModuleItemAllessehCollection';
            allessehCollectionId: string;
          } | null;
        };
      }>;
      uiModuleFields: {
        __typename?: 'UiModule';
        basicModule?: {
          __typename?: 'UiBasicModule';
          treatmentType: UiBasicTreatmentType;
          contentTypes: Array<PublicationSettingSearchableContentType>;
          allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
        } | null;
      };
    }>;
  }>;
};

export type ItpPageFragmentFragment = {
  __typename?: 'ITPPage';
  adType: string;
  adZones: string;
  allessehCollectionId?: string | null;
  isHidden: boolean;
  issueId: string;
  label: string;
  pageType: string;
  pageModules: Array<{
    __typename?: 'PageModule';
    uiModuleType: UiModuleType;
    moduleItems: Array<{
      __typename?: 'PageModuleItem';
      itemType: PageModuleItemType;
      itemFields: {
        __typename?: 'PageModuleItemFields';
        contentItem?: {
          __typename?: 'PageModuleItemContent';
          originId: string;
          originContentType: string;
          content?: string | null;
          base_doc_id: string;
          hosted_url: string;
          id: string;
          link: string;
          product: string;
          seo_id: string;
          status: string;
        } | null;
        queryItem?: { __typename?: 'PageModuleItemQuery'; jsonQuery: string } | null;
        collectionItem?: {
          __typename?: 'PageModuleItemCollection';
          idCreatedUtc: string;
          collection?: {
            __typename?: 'Collection';
            allessehCollectionId: string;
            idCreatedUtc: string;
            id: string;
            createdUtc: number;
            updatedUtc?: number | null;
            name: string;
            isArchived: boolean;
            publicationKey: string;
            allessehJsonQuery?: string | null;
            creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
            revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
            parameters: {
              __typename?: 'CollectionParameters';
              offPlatform?: {
                __typename?: 'OffPlatformParams';
                minItems?: number | null;
                maxItems?: number | null;
                moduleDisplayName: string;
                defaultAltSummVariant: string;
                hostingPageURL: string;
              } | null;
            };
            contentItems: Array<{
              __typename?: 'CollectionContentItem';
              originId: string;
              originContentType: string;
              content?: string | null;
              base_doc_id: string;
              hosted_url: string;
              id: string;
              link: string;
              product: string;
              seo_id: string;
              status: string;
            }>;
          } | null;
        } | null;
        allessehCollectionItem?: {
          __typename?: 'PageModuleItemAllessehCollection';
          allessehCollectionId: string;
        } | null;
      };
    }>;
    uiModuleFields: {
      __typename?: 'UiModule';
      basicModule?: {
        __typename?: 'UiBasicModule';
        treatmentType: UiBasicTreatmentType;
        contentTypes: Array<PublicationSettingSearchableContentType>;
        allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
      } | null;
    };
  }>;
};

export type ItpPageModuleFragmentFragment = {
  __typename?: 'PageModule';
  uiModuleType: UiModuleType;
  moduleItems: Array<{
    __typename?: 'PageModuleItem';
    itemType: PageModuleItemType;
    itemFields: {
      __typename?: 'PageModuleItemFields';
      contentItem?: {
        __typename?: 'PageModuleItemContent';
        originId: string;
        originContentType: string;
        content?: string | null;
        base_doc_id: string;
        hosted_url: string;
        id: string;
        link: string;
        product: string;
        seo_id: string;
        status: string;
      } | null;
      queryItem?: { __typename?: 'PageModuleItemQuery'; jsonQuery: string } | null;
      collectionItem?: {
        __typename?: 'PageModuleItemCollection';
        idCreatedUtc: string;
        collection?: {
          __typename?: 'Collection';
          allessehCollectionId: string;
          idCreatedUtc: string;
          id: string;
          createdUtc: number;
          updatedUtc?: number | null;
          name: string;
          isArchived: boolean;
          publicationKey: string;
          allessehJsonQuery?: string | null;
          creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
          revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
          parameters: {
            __typename?: 'CollectionParameters';
            offPlatform?: {
              __typename?: 'OffPlatformParams';
              minItems?: number | null;
              maxItems?: number | null;
              moduleDisplayName: string;
              defaultAltSummVariant: string;
              hostingPageURL: string;
            } | null;
          };
          contentItems: Array<{
            __typename?: 'CollectionContentItem';
            originId: string;
            originContentType: string;
            content?: string | null;
            base_doc_id: string;
            hosted_url: string;
            id: string;
            link: string;
            product: string;
            seo_id: string;
            status: string;
          }>;
        } | null;
      } | null;
      allessehCollectionItem?: { __typename?: 'PageModuleItemAllessehCollection'; allessehCollectionId: string } | null;
    };
  }>;
  uiModuleFields: {
    __typename?: 'UiModule';
    basicModule?: {
      __typename?: 'UiBasicModule';
      treatmentType: UiBasicTreatmentType;
      contentTypes: Array<PublicationSettingSearchableContentType>;
      allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
    } | null;
  };
};

export type ItpDtoFragmentFragment = {
  __typename?: 'ItpDTO';
  type: string;
  metadata: {
    __typename?: 'ItpMetadata';
    allessehId: string;
    createdUtc: number;
    name: string;
    publicationKey: string;
    publishUtc?: number | null;
    refreshedUtc?: number | null;
    updatedUtc?: number | null;
    creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
    revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
  };
  root: {
    __typename?: 'IssueContainer';
    type: string;
    attributes: { __typename?: 'IssueAttributes'; issueKey: string; issueDate: string; status: string };
    collection: Array<{
      __typename?: 'IssueSectionContainer';
      type: string;
      subtype?: string | null;
      attributes: {
        __typename?: 'IssueSectionAttributes';
        adPlacementType?: string | null;
        adZone?: string | null;
        isHidden: boolean;
        issueDate?: string | null;
        pageType: string;
        routeKey: string;
        sectionKey: string;
        sectionLabel: string;
        summaryPriority: string;
        upstreamAllessehCollectionId?: string | null;
      };
      collection: Array<{
        __typename?: 'PageContainer';
        type: string;
        attributes: { __typename?: 'PageAttributes'; layoutId?: string | null };
        collection: Array<{
          __typename?: 'ModuleContainer';
          type: string;
          attributes: {
            __typename?: 'ModuleAttributes';
            pageModule?: {
              __typename?: 'PageModule';
              uiModuleType: UiModuleType;
              moduleItems: Array<{
                __typename?: 'PageModuleItem';
                itemType: PageModuleItemType;
                itemFields: {
                  __typename?: 'PageModuleItemFields';
                  contentItem?: {
                    __typename?: 'PageModuleItemContent';
                    originId: string;
                    originContentType: string;
                    content?: string | null;
                    base_doc_id: string;
                    hosted_url: string;
                    id: string;
                    link: string;
                    product: string;
                    seo_id: string;
                    status: string;
                  } | null;
                  queryItem?: { __typename?: 'PageModuleItemQuery'; jsonQuery: string } | null;
                  collectionItem?: {
                    __typename?: 'PageModuleItemCollection';
                    idCreatedUtc: string;
                    collection?: {
                      __typename?: 'Collection';
                      allessehCollectionId: string;
                      idCreatedUtc: string;
                      id: string;
                      createdUtc: number;
                      updatedUtc?: number | null;
                      name: string;
                      isArchived: boolean;
                      publicationKey: string;
                      allessehJsonQuery?: string | null;
                      creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
                      revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
                      parameters: {
                        __typename?: 'CollectionParameters';
                        offPlatform?: {
                          __typename?: 'OffPlatformParams';
                          minItems?: number | null;
                          maxItems?: number | null;
                          moduleDisplayName: string;
                          defaultAltSummVariant: string;
                          hostingPageURL: string;
                        } | null;
                      };
                      contentItems: Array<{
                        __typename?: 'CollectionContentItem';
                        originId: string;
                        originContentType: string;
                        content?: string | null;
                        base_doc_id: string;
                        hosted_url: string;
                        id: string;
                        link: string;
                        product: string;
                        seo_id: string;
                        status: string;
                      }>;
                    } | null;
                  } | null;
                  allessehCollectionItem?: {
                    __typename?: 'PageModuleItemAllessehCollection';
                    allessehCollectionId: string;
                  } | null;
                };
              }>;
              uiModuleFields: {
                __typename?: 'UiModule';
                basicModule?: {
                  __typename?: 'UiBasicModule';
                  treatmentType: UiBasicTreatmentType;
                  contentTypes: Array<PublicationSettingSearchableContentType>;
                  allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                } | null;
              };
            } | null;
          };
          collection: Array<
            | {
                __typename?: 'ArticleItem';
                content?: string | null;
                type: string;
                attributes: {
                  __typename?: 'ArticleAttributes';
                  base_doc_id: string;
                  hosted_url: string;
                  id: string;
                  link: string;
                  originContentType?: string | null;
                  originId?: string | null;
                  product: string;
                  seo_id: string;
                  status: string;
                };
              }
            | {
                __typename?: 'ExternalCollectionItem';
                type: string;
                attributes: { __typename?: 'ExternalCollectionAttributes'; id: string; repo: string };
              }
            | { __typename?: 'LinkedItem' }
            | { __typename?: 'MobileArticleItem' }
            | {
                __typename?: 'QueryItem';
                type: string;
                attributes: { __typename?: 'QueryAttributes'; query: Record<string, unknown> };
              }
          >;
        }>;
      }>;
    }>;
  };
};

export type CreateItpDtoMutationVariables = Exact<{
  itpDTOCreateInput: ItpDtoCreateInput;
  publicationKey: Scalars['String'];
}>;

export type CreateItpDtoMutation = {
  __typename?: 'Mutation';
  createItpDTO: {
    __typename?: 'ItpDTO';
    type: string;
    metadata: {
      __typename?: 'ItpMetadata';
      allessehId: string;
      createdUtc: number;
      name: string;
      publicationKey: string;
      publishUtc?: number | null;
      refreshedUtc?: number | null;
      updatedUtc?: number | null;
      creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
      revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
    };
    root: {
      __typename?: 'IssueContainer';
      type: string;
      attributes: { __typename?: 'IssueAttributes'; issueKey: string; issueDate: string; status: string };
      collection: Array<{
        __typename?: 'IssueSectionContainer';
        type: string;
        subtype?: string | null;
        attributes: {
          __typename?: 'IssueSectionAttributes';
          adPlacementType?: string | null;
          adZone?: string | null;
          isHidden: boolean;
          issueDate?: string | null;
          pageType: string;
          routeKey: string;
          sectionKey: string;
          sectionLabel: string;
          summaryPriority: string;
          upstreamAllessehCollectionId?: string | null;
        };
        collection: Array<{
          __typename?: 'PageContainer';
          type: string;
          attributes: { __typename?: 'PageAttributes'; layoutId?: string | null };
          collection: Array<{
            __typename?: 'ModuleContainer';
            type: string;
            attributes: {
              __typename?: 'ModuleAttributes';
              pageModule?: {
                __typename?: 'PageModule';
                uiModuleType: UiModuleType;
                moduleItems: Array<{
                  __typename?: 'PageModuleItem';
                  itemType: PageModuleItemType;
                  itemFields: {
                    __typename?: 'PageModuleItemFields';
                    contentItem?: {
                      __typename?: 'PageModuleItemContent';
                      originId: string;
                      originContentType: string;
                      content?: string | null;
                      base_doc_id: string;
                      hosted_url: string;
                      id: string;
                      link: string;
                      product: string;
                      seo_id: string;
                      status: string;
                    } | null;
                    queryItem?: { __typename?: 'PageModuleItemQuery'; jsonQuery: string } | null;
                    collectionItem?: {
                      __typename?: 'PageModuleItemCollection';
                      idCreatedUtc: string;
                      collection?: {
                        __typename?: 'Collection';
                        allessehCollectionId: string;
                        idCreatedUtc: string;
                        id: string;
                        createdUtc: number;
                        updatedUtc?: number | null;
                        name: string;
                        isArchived: boolean;
                        publicationKey: string;
                        allessehJsonQuery?: string | null;
                        creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
                        revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
                        parameters: {
                          __typename?: 'CollectionParameters';
                          offPlatform?: {
                            __typename?: 'OffPlatformParams';
                            minItems?: number | null;
                            maxItems?: number | null;
                            moduleDisplayName: string;
                            defaultAltSummVariant: string;
                            hostingPageURL: string;
                          } | null;
                        };
                        contentItems: Array<{
                          __typename?: 'CollectionContentItem';
                          originId: string;
                          originContentType: string;
                          content?: string | null;
                          base_doc_id: string;
                          hosted_url: string;
                          id: string;
                          link: string;
                          product: string;
                          seo_id: string;
                          status: string;
                        }>;
                      } | null;
                    } | null;
                    allessehCollectionItem?: {
                      __typename?: 'PageModuleItemAllessehCollection';
                      allessehCollectionId: string;
                    } | null;
                  };
                }>;
                uiModuleFields: {
                  __typename?: 'UiModule';
                  basicModule?: {
                    __typename?: 'UiBasicModule';
                    treatmentType: UiBasicTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                  } | null;
                };
              } | null;
            };
            collection: Array<
              | {
                  __typename?: 'ArticleItem';
                  content?: string | null;
                  type: string;
                  attributes: {
                    __typename?: 'ArticleAttributes';
                    base_doc_id: string;
                    hosted_url: string;
                    id: string;
                    link: string;
                    originContentType?: string | null;
                    originId?: string | null;
                    product: string;
                    seo_id: string;
                    status: string;
                  };
                }
              | {
                  __typename?: 'ExternalCollectionItem';
                  type: string;
                  attributes: { __typename?: 'ExternalCollectionAttributes'; id: string; repo: string };
                }
              | { __typename?: 'LinkedItem' }
              | { __typename?: 'MobileArticleItem' }
              | {
                  __typename?: 'QueryItem';
                  type: string;
                  attributes: { __typename?: 'QueryAttributes'; query: Record<string, unknown> };
                }
            >;
          }>;
        }>;
      }>;
    };
  };
};

export type DeleteItpDtoMutationVariables = Exact<{
  allessehId: Scalars['String'];
  publicationKey: Scalars['String'];
}>;

export type DeleteItpDtoMutation = { __typename?: 'Mutation'; deleteItpDTO: boolean };

export type SaveItpDtoMutationVariables = Exact<{
  itpDTOSaveInput: ItpDtoSaveInput;
  publicationKey: Scalars['String'];
}>;

export type SaveItpDtoMutation = {
  __typename?: 'Mutation';
  saveItpDTO: {
    __typename?: 'ItpDTO';
    type: string;
    metadata: {
      __typename?: 'ItpMetadata';
      allessehId: string;
      createdUtc: number;
      name: string;
      publicationKey: string;
      publishUtc?: number | null;
      refreshedUtc?: number | null;
      updatedUtc?: number | null;
      creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
      revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
    };
    root: {
      __typename?: 'IssueContainer';
      type: string;
      attributes: { __typename?: 'IssueAttributes'; issueKey: string; issueDate: string; status: string };
      collection: Array<{
        __typename?: 'IssueSectionContainer';
        type: string;
        subtype?: string | null;
        attributes: {
          __typename?: 'IssueSectionAttributes';
          adPlacementType?: string | null;
          adZone?: string | null;
          isHidden: boolean;
          issueDate?: string | null;
          pageType: string;
          routeKey: string;
          sectionKey: string;
          sectionLabel: string;
          summaryPriority: string;
          upstreamAllessehCollectionId?: string | null;
        };
        collection: Array<{
          __typename?: 'PageContainer';
          type: string;
          attributes: { __typename?: 'PageAttributes'; layoutId?: string | null };
          collection: Array<{
            __typename?: 'ModuleContainer';
            type: string;
            attributes: {
              __typename?: 'ModuleAttributes';
              pageModule?: {
                __typename?: 'PageModule';
                uiModuleType: UiModuleType;
                moduleItems: Array<{
                  __typename?: 'PageModuleItem';
                  itemType: PageModuleItemType;
                  itemFields: {
                    __typename?: 'PageModuleItemFields';
                    contentItem?: {
                      __typename?: 'PageModuleItemContent';
                      originId: string;
                      originContentType: string;
                      content?: string | null;
                      base_doc_id: string;
                      hosted_url: string;
                      id: string;
                      link: string;
                      product: string;
                      seo_id: string;
                      status: string;
                    } | null;
                    queryItem?: { __typename?: 'PageModuleItemQuery'; jsonQuery: string } | null;
                    collectionItem?: {
                      __typename?: 'PageModuleItemCollection';
                      idCreatedUtc: string;
                      collection?: {
                        __typename?: 'Collection';
                        allessehCollectionId: string;
                        idCreatedUtc: string;
                        id: string;
                        createdUtc: number;
                        updatedUtc?: number | null;
                        name: string;
                        isArchived: boolean;
                        publicationKey: string;
                        allessehJsonQuery?: string | null;
                        creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
                        revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
                        parameters: {
                          __typename?: 'CollectionParameters';
                          offPlatform?: {
                            __typename?: 'OffPlatformParams';
                            minItems?: number | null;
                            maxItems?: number | null;
                            moduleDisplayName: string;
                            defaultAltSummVariant: string;
                            hostingPageURL: string;
                          } | null;
                        };
                        contentItems: Array<{
                          __typename?: 'CollectionContentItem';
                          originId: string;
                          originContentType: string;
                          content?: string | null;
                          base_doc_id: string;
                          hosted_url: string;
                          id: string;
                          link: string;
                          product: string;
                          seo_id: string;
                          status: string;
                        }>;
                      } | null;
                    } | null;
                    allessehCollectionItem?: {
                      __typename?: 'PageModuleItemAllessehCollection';
                      allessehCollectionId: string;
                    } | null;
                  };
                }>;
                uiModuleFields: {
                  __typename?: 'UiModule';
                  basicModule?: {
                    __typename?: 'UiBasicModule';
                    treatmentType: UiBasicTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                  } | null;
                };
              } | null;
            };
            collection: Array<
              | {
                  __typename?: 'ArticleItem';
                  content?: string | null;
                  type: string;
                  attributes: {
                    __typename?: 'ArticleAttributes';
                    base_doc_id: string;
                    hosted_url: string;
                    id: string;
                    link: string;
                    originContentType?: string | null;
                    originId?: string | null;
                    product: string;
                    seo_id: string;
                    status: string;
                  };
                }
              | {
                  __typename?: 'ExternalCollectionItem';
                  type: string;
                  attributes: { __typename?: 'ExternalCollectionAttributes'; id: string; repo: string };
                }
              | { __typename?: 'LinkedItem' }
              | { __typename?: 'MobileArticleItem' }
              | {
                  __typename?: 'QueryItem';
                  type: string;
                  attributes: { __typename?: 'QueryAttributes'; query: Record<string, unknown> };
                }
            >;
          }>;
        }>;
      }>;
    };
  };
};

export type PublishItpDtoMutationVariables = Exact<{
  itpDTOSaveInput: ItpDtoSaveInput;
  publicationKey: Scalars['String'];
}>;

export type PublishItpDtoMutation = {
  __typename?: 'Mutation';
  publishItpDTO: {
    __typename?: 'ItpDTO';
    type: string;
    metadata: {
      __typename?: 'ItpMetadata';
      allessehId: string;
      createdUtc: number;
      name: string;
      publicationKey: string;
      publishUtc?: number | null;
      refreshedUtc?: number | null;
      updatedUtc?: number | null;
      creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
      revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
    };
    root: {
      __typename?: 'IssueContainer';
      type: string;
      attributes: { __typename?: 'IssueAttributes'; issueKey: string; issueDate: string; status: string };
      collection: Array<{
        __typename?: 'IssueSectionContainer';
        type: string;
        subtype?: string | null;
        attributes: {
          __typename?: 'IssueSectionAttributes';
          adPlacementType?: string | null;
          adZone?: string | null;
          isHidden: boolean;
          issueDate?: string | null;
          pageType: string;
          routeKey: string;
          sectionKey: string;
          sectionLabel: string;
          summaryPriority: string;
          upstreamAllessehCollectionId?: string | null;
        };
        collection: Array<{
          __typename?: 'PageContainer';
          type: string;
          attributes: { __typename?: 'PageAttributes'; layoutId?: string | null };
          collection: Array<{
            __typename?: 'ModuleContainer';
            type: string;
            attributes: {
              __typename?: 'ModuleAttributes';
              pageModule?: {
                __typename?: 'PageModule';
                uiModuleType: UiModuleType;
                moduleItems: Array<{
                  __typename?: 'PageModuleItem';
                  itemType: PageModuleItemType;
                  itemFields: {
                    __typename?: 'PageModuleItemFields';
                    contentItem?: {
                      __typename?: 'PageModuleItemContent';
                      originId: string;
                      originContentType: string;
                      content?: string | null;
                      base_doc_id: string;
                      hosted_url: string;
                      id: string;
                      link: string;
                      product: string;
                      seo_id: string;
                      status: string;
                    } | null;
                    queryItem?: { __typename?: 'PageModuleItemQuery'; jsonQuery: string } | null;
                    collectionItem?: {
                      __typename?: 'PageModuleItemCollection';
                      idCreatedUtc: string;
                      collection?: {
                        __typename?: 'Collection';
                        allessehCollectionId: string;
                        idCreatedUtc: string;
                        id: string;
                        createdUtc: number;
                        updatedUtc?: number | null;
                        name: string;
                        isArchived: boolean;
                        publicationKey: string;
                        allessehJsonQuery?: string | null;
                        creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
                        revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
                        parameters: {
                          __typename?: 'CollectionParameters';
                          offPlatform?: {
                            __typename?: 'OffPlatformParams';
                            minItems?: number | null;
                            maxItems?: number | null;
                            moduleDisplayName: string;
                            defaultAltSummVariant: string;
                            hostingPageURL: string;
                          } | null;
                        };
                        contentItems: Array<{
                          __typename?: 'CollectionContentItem';
                          originId: string;
                          originContentType: string;
                          content?: string | null;
                          base_doc_id: string;
                          hosted_url: string;
                          id: string;
                          link: string;
                          product: string;
                          seo_id: string;
                          status: string;
                        }>;
                      } | null;
                    } | null;
                    allessehCollectionItem?: {
                      __typename?: 'PageModuleItemAllessehCollection';
                      allessehCollectionId: string;
                    } | null;
                  };
                }>;
                uiModuleFields: {
                  __typename?: 'UiModule';
                  basicModule?: {
                    __typename?: 'UiBasicModule';
                    treatmentType: UiBasicTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                  } | null;
                };
              } | null;
            };
            collection: Array<
              | {
                  __typename?: 'ArticleItem';
                  content?: string | null;
                  type: string;
                  attributes: {
                    __typename?: 'ArticleAttributes';
                    base_doc_id: string;
                    hosted_url: string;
                    id: string;
                    link: string;
                    originContentType?: string | null;
                    originId?: string | null;
                    product: string;
                    seo_id: string;
                    status: string;
                  };
                }
              | {
                  __typename?: 'ExternalCollectionItem';
                  type: string;
                  attributes: { __typename?: 'ExternalCollectionAttributes'; id: string; repo: string };
                }
              | { __typename?: 'LinkedItem' }
              | { __typename?: 'MobileArticleItem' }
              | {
                  __typename?: 'QueryItem';
                  type: string;
                  attributes: { __typename?: 'QueryAttributes'; query: Record<string, unknown> };
                }
            >;
          }>;
        }>;
      }>;
    };
  };
};

export type PreviewItpDtoLinkMutationVariables = Exact<{
  itpDTOSaveInput: ItpDtoSaveInput;
  publicationKey: Scalars['String'];
}>;

export type PreviewItpDtoLinkMutation = { __typename?: 'Mutation'; previewItpDTOLink?: Array<string> | null };

export type DefaultItpIssueStateQueryVariables = Exact<{
  publicationKey: Scalars['String'];
  issueDate: Scalars['String'];
}>;

export type DefaultItpIssueStateQuery = {
  __typename?: 'Query';
  getDefaultITPIssueState: {
    __typename?: 'ItpDTO';
    type: string;
    metadata: {
      __typename?: 'ItpMetadata';
      allessehId: string;
      createdUtc: number;
      name: string;
      publicationKey: string;
      publishUtc?: number | null;
      refreshedUtc?: number | null;
      updatedUtc?: number | null;
      creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
      revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
    };
    root: {
      __typename?: 'IssueContainer';
      type: string;
      attributes: { __typename?: 'IssueAttributes'; issueKey: string; issueDate: string; status: string };
      collection: Array<{
        __typename?: 'IssueSectionContainer';
        type: string;
        subtype?: string | null;
        attributes: {
          __typename?: 'IssueSectionAttributes';
          adPlacementType?: string | null;
          adZone?: string | null;
          isHidden: boolean;
          issueDate?: string | null;
          pageType: string;
          routeKey: string;
          sectionKey: string;
          sectionLabel: string;
          summaryPriority: string;
          upstreamAllessehCollectionId?: string | null;
        };
        collection: Array<{
          __typename?: 'PageContainer';
          type: string;
          attributes: { __typename?: 'PageAttributes'; layoutId?: string | null };
          collection: Array<{
            __typename?: 'ModuleContainer';
            type: string;
            attributes: {
              __typename?: 'ModuleAttributes';
              pageModule?: {
                __typename?: 'PageModule';
                uiModuleType: UiModuleType;
                moduleItems: Array<{
                  __typename?: 'PageModuleItem';
                  itemType: PageModuleItemType;
                  itemFields: {
                    __typename?: 'PageModuleItemFields';
                    contentItem?: {
                      __typename?: 'PageModuleItemContent';
                      originId: string;
                      originContentType: string;
                      content?: string | null;
                      base_doc_id: string;
                      hosted_url: string;
                      id: string;
                      link: string;
                      product: string;
                      seo_id: string;
                      status: string;
                    } | null;
                    queryItem?: { __typename?: 'PageModuleItemQuery'; jsonQuery: string } | null;
                    collectionItem?: {
                      __typename?: 'PageModuleItemCollection';
                      idCreatedUtc: string;
                      collection?: {
                        __typename?: 'Collection';
                        allessehCollectionId: string;
                        idCreatedUtc: string;
                        id: string;
                        createdUtc: number;
                        updatedUtc?: number | null;
                        name: string;
                        isArchived: boolean;
                        publicationKey: string;
                        allessehJsonQuery?: string | null;
                        creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
                        revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
                        parameters: {
                          __typename?: 'CollectionParameters';
                          offPlatform?: {
                            __typename?: 'OffPlatformParams';
                            minItems?: number | null;
                            maxItems?: number | null;
                            moduleDisplayName: string;
                            defaultAltSummVariant: string;
                            hostingPageURL: string;
                          } | null;
                        };
                        contentItems: Array<{
                          __typename?: 'CollectionContentItem';
                          originId: string;
                          originContentType: string;
                          content?: string | null;
                          base_doc_id: string;
                          hosted_url: string;
                          id: string;
                          link: string;
                          product: string;
                          seo_id: string;
                          status: string;
                        }>;
                      } | null;
                    } | null;
                    allessehCollectionItem?: {
                      __typename?: 'PageModuleItemAllessehCollection';
                      allessehCollectionId: string;
                    } | null;
                  };
                }>;
                uiModuleFields: {
                  __typename?: 'UiModule';
                  basicModule?: {
                    __typename?: 'UiBasicModule';
                    treatmentType: UiBasicTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                  } | null;
                };
              } | null;
            };
            collection: Array<
              | {
                  __typename?: 'ArticleItem';
                  content?: string | null;
                  type: string;
                  attributes: {
                    __typename?: 'ArticleAttributes';
                    base_doc_id: string;
                    hosted_url: string;
                    id: string;
                    link: string;
                    originContentType?: string | null;
                    originId?: string | null;
                    product: string;
                    seo_id: string;
                    status: string;
                  };
                }
              | {
                  __typename?: 'ExternalCollectionItem';
                  type: string;
                  attributes: { __typename?: 'ExternalCollectionAttributes'; id: string; repo: string };
                }
              | { __typename?: 'LinkedItem' }
              | { __typename?: 'MobileArticleItem' }
              | {
                  __typename?: 'QueryItem';
                  type: string;
                  attributes: { __typename?: 'QueryAttributes'; query: Record<string, unknown> };
                }
            >;
          }>;
        }>;
      }>;
    };
  };
};

export type LastSevenItpDtOsQueryVariables = Exact<{
  publicationKey: Scalars['String'];
}>;

export type LastSevenItpDtOsQuery = {
  __typename?: 'Query';
  lastSevenItpDTOs: Array<{
    __typename?: 'ItpDTO';
    type: string;
    metadata: {
      __typename?: 'ItpMetadata';
      allessehId: string;
      createdUtc: number;
      name: string;
      publicationKey: string;
      publishUtc?: number | null;
      refreshedUtc?: number | null;
      updatedUtc?: number | null;
      creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
      revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
    };
    root: {
      __typename?: 'IssueContainer';
      type: string;
      attributes: { __typename?: 'IssueAttributes'; issueKey: string; issueDate: string; status: string };
      collection: Array<{
        __typename?: 'IssueSectionContainer';
        type: string;
        subtype?: string | null;
        attributes: {
          __typename?: 'IssueSectionAttributes';
          adPlacementType?: string | null;
          adZone?: string | null;
          isHidden: boolean;
          issueDate?: string | null;
          pageType: string;
          routeKey: string;
          sectionKey: string;
          sectionLabel: string;
          summaryPriority: string;
          upstreamAllessehCollectionId?: string | null;
        };
        collection: Array<{
          __typename?: 'PageContainer';
          type: string;
          attributes: { __typename?: 'PageAttributes'; layoutId?: string | null };
          collection: Array<{
            __typename?: 'ModuleContainer';
            type: string;
            attributes: {
              __typename?: 'ModuleAttributes';
              pageModule?: {
                __typename?: 'PageModule';
                uiModuleType: UiModuleType;
                moduleItems: Array<{
                  __typename?: 'PageModuleItem';
                  itemType: PageModuleItemType;
                  itemFields: {
                    __typename?: 'PageModuleItemFields';
                    contentItem?: {
                      __typename?: 'PageModuleItemContent';
                      originId: string;
                      originContentType: string;
                      content?: string | null;
                      base_doc_id: string;
                      hosted_url: string;
                      id: string;
                      link: string;
                      product: string;
                      seo_id: string;
                      status: string;
                    } | null;
                    queryItem?: { __typename?: 'PageModuleItemQuery'; jsonQuery: string } | null;
                    collectionItem?: {
                      __typename?: 'PageModuleItemCollection';
                      idCreatedUtc: string;
                      collection?: {
                        __typename?: 'Collection';
                        allessehCollectionId: string;
                        idCreatedUtc: string;
                        id: string;
                        createdUtc: number;
                        updatedUtc?: number | null;
                        name: string;
                        isArchived: boolean;
                        publicationKey: string;
                        allessehJsonQuery?: string | null;
                        creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
                        revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
                        parameters: {
                          __typename?: 'CollectionParameters';
                          offPlatform?: {
                            __typename?: 'OffPlatformParams';
                            minItems?: number | null;
                            maxItems?: number | null;
                            moduleDisplayName: string;
                            defaultAltSummVariant: string;
                            hostingPageURL: string;
                          } | null;
                        };
                        contentItems: Array<{
                          __typename?: 'CollectionContentItem';
                          originId: string;
                          originContentType: string;
                          content?: string | null;
                          base_doc_id: string;
                          hosted_url: string;
                          id: string;
                          link: string;
                          product: string;
                          seo_id: string;
                          status: string;
                        }>;
                      } | null;
                    } | null;
                    allessehCollectionItem?: {
                      __typename?: 'PageModuleItemAllessehCollection';
                      allessehCollectionId: string;
                    } | null;
                  };
                }>;
                uiModuleFields: {
                  __typename?: 'UiModule';
                  basicModule?: {
                    __typename?: 'UiBasicModule';
                    treatmentType: UiBasicTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                  } | null;
                };
              } | null;
            };
            collection: Array<
              | {
                  __typename?: 'ArticleItem';
                  content?: string | null;
                  type: string;
                  attributes: {
                    __typename?: 'ArticleAttributes';
                    base_doc_id: string;
                    hosted_url: string;
                    id: string;
                    link: string;
                    originContentType?: string | null;
                    originId?: string | null;
                    product: string;
                    seo_id: string;
                    status: string;
                  };
                }
              | {
                  __typename?: 'ExternalCollectionItem';
                  type: string;
                  attributes: { __typename?: 'ExternalCollectionAttributes'; id: string; repo: string };
                }
              | { __typename?: 'LinkedItem' }
              | { __typename?: 'MobileArticleItem' }
              | {
                  __typename?: 'QueryItem';
                  type: string;
                  attributes: { __typename?: 'QueryAttributes'; query: Record<string, unknown> };
                }
            >;
          }>;
        }>;
      }>;
    };
  }>;
};

export type ItpDtoByDateQueryVariables = Exact<{
  publicationKey: Scalars['String'];
  issueDate: Scalars['String'];
}>;

export type ItpDtoByDateQuery = {
  __typename?: 'Query';
  itpDTOByDate: {
    __typename?: 'ItpDTO';
    type: string;
    metadata: {
      __typename?: 'ItpMetadata';
      allessehId: string;
      createdUtc: number;
      name: string;
      publicationKey: string;
      publishUtc?: number | null;
      refreshedUtc?: number | null;
      updatedUtc?: number | null;
      creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
      revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
    };
    root: {
      __typename?: 'IssueContainer';
      type: string;
      attributes: { __typename?: 'IssueAttributes'; issueKey: string; issueDate: string; status: string };
      collection: Array<{
        __typename?: 'IssueSectionContainer';
        type: string;
        subtype?: string | null;
        attributes: {
          __typename?: 'IssueSectionAttributes';
          adPlacementType?: string | null;
          adZone?: string | null;
          isHidden: boolean;
          issueDate?: string | null;
          pageType: string;
          routeKey: string;
          sectionKey: string;
          sectionLabel: string;
          summaryPriority: string;
          upstreamAllessehCollectionId?: string | null;
        };
        collection: Array<{
          __typename?: 'PageContainer';
          type: string;
          attributes: { __typename?: 'PageAttributes'; layoutId?: string | null };
          collection: Array<{
            __typename?: 'ModuleContainer';
            type: string;
            attributes: {
              __typename?: 'ModuleAttributes';
              pageModule?: {
                __typename?: 'PageModule';
                uiModuleType: UiModuleType;
                moduleItems: Array<{
                  __typename?: 'PageModuleItem';
                  itemType: PageModuleItemType;
                  itemFields: {
                    __typename?: 'PageModuleItemFields';
                    contentItem?: {
                      __typename?: 'PageModuleItemContent';
                      originId: string;
                      originContentType: string;
                      content?: string | null;
                      base_doc_id: string;
                      hosted_url: string;
                      id: string;
                      link: string;
                      product: string;
                      seo_id: string;
                      status: string;
                    } | null;
                    queryItem?: { __typename?: 'PageModuleItemQuery'; jsonQuery: string } | null;
                    collectionItem?: {
                      __typename?: 'PageModuleItemCollection';
                      idCreatedUtc: string;
                      collection?: {
                        __typename?: 'Collection';
                        allessehCollectionId: string;
                        idCreatedUtc: string;
                        id: string;
                        createdUtc: number;
                        updatedUtc?: number | null;
                        name: string;
                        isArchived: boolean;
                        publicationKey: string;
                        allessehJsonQuery?: string | null;
                        creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
                        revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
                        parameters: {
                          __typename?: 'CollectionParameters';
                          offPlatform?: {
                            __typename?: 'OffPlatformParams';
                            minItems?: number | null;
                            maxItems?: number | null;
                            moduleDisplayName: string;
                            defaultAltSummVariant: string;
                            hostingPageURL: string;
                          } | null;
                        };
                        contentItems: Array<{
                          __typename?: 'CollectionContentItem';
                          originId: string;
                          originContentType: string;
                          content?: string | null;
                          base_doc_id: string;
                          hosted_url: string;
                          id: string;
                          link: string;
                          product: string;
                          seo_id: string;
                          status: string;
                        }>;
                      } | null;
                    } | null;
                    allessehCollectionItem?: {
                      __typename?: 'PageModuleItemAllessehCollection';
                      allessehCollectionId: string;
                    } | null;
                  };
                }>;
                uiModuleFields: {
                  __typename?: 'UiModule';
                  basicModule?: {
                    __typename?: 'UiBasicModule';
                    treatmentType: UiBasicTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                  } | null;
                };
              } | null;
            };
            collection: Array<
              | {
                  __typename?: 'ArticleItem';
                  content?: string | null;
                  type: string;
                  attributes: {
                    __typename?: 'ArticleAttributes';
                    base_doc_id: string;
                    hosted_url: string;
                    id: string;
                    link: string;
                    originContentType?: string | null;
                    originId?: string | null;
                    product: string;
                    seo_id: string;
                    status: string;
                  };
                }
              | {
                  __typename?: 'ExternalCollectionItem';
                  type: string;
                  attributes: { __typename?: 'ExternalCollectionAttributes'; id: string; repo: string };
                }
              | { __typename?: 'LinkedItem' }
              | { __typename?: 'MobileArticleItem' }
              | {
                  __typename?: 'QueryItem';
                  type: string;
                  attributes: { __typename?: 'QueryAttributes'; query: Record<string, unknown> };
                }
            >;
          }>;
        }>;
      }>;
    };
  };
};

export type ImportItpDtoContentQueryVariables = Exact<{
  publicationKey: Scalars['String'];
  itpDTOImportContentInput: ItpDtoImportContentInput;
}>;

export type ImportItpDtoContentQuery = {
  __typename?: 'Query';
  importItpDTOContent: {
    __typename?: 'ItpImportResponse';
    newIds: Array<string>;
    staleIds: Array<string>;
    issue: {
      __typename?: 'ItpDTO';
      type: string;
      metadata: {
        __typename?: 'ItpMetadata';
        allessehId: string;
        createdUtc: number;
        name: string;
        publicationKey: string;
        publishUtc?: number | null;
        refreshedUtc?: number | null;
        updatedUtc?: number | null;
        creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
        revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
      };
      root: {
        __typename?: 'IssueContainer';
        type: string;
        attributes: { __typename?: 'IssueAttributes'; issueKey: string; issueDate: string; status: string };
        collection: Array<{
          __typename?: 'IssueSectionContainer';
          type: string;
          subtype?: string | null;
          attributes: {
            __typename?: 'IssueSectionAttributes';
            adPlacementType?: string | null;
            adZone?: string | null;
            isHidden: boolean;
            issueDate?: string | null;
            pageType: string;
            routeKey: string;
            sectionKey: string;
            sectionLabel: string;
            summaryPriority: string;
            upstreamAllessehCollectionId?: string | null;
          };
          collection: Array<{
            __typename?: 'PageContainer';
            type: string;
            attributes: { __typename?: 'PageAttributes'; layoutId?: string | null };
            collection: Array<{
              __typename?: 'ModuleContainer';
              type: string;
              attributes: {
                __typename?: 'ModuleAttributes';
                pageModule?: {
                  __typename?: 'PageModule';
                  uiModuleType: UiModuleType;
                  moduleItems: Array<{
                    __typename?: 'PageModuleItem';
                    itemType: PageModuleItemType;
                    itemFields: {
                      __typename?: 'PageModuleItemFields';
                      contentItem?: {
                        __typename?: 'PageModuleItemContent';
                        originId: string;
                        originContentType: string;
                        content?: string | null;
                        base_doc_id: string;
                        hosted_url: string;
                        id: string;
                        link: string;
                        product: string;
                        seo_id: string;
                        status: string;
                      } | null;
                      queryItem?: { __typename?: 'PageModuleItemQuery'; jsonQuery: string } | null;
                      collectionItem?: {
                        __typename?: 'PageModuleItemCollection';
                        idCreatedUtc: string;
                        collection?: {
                          __typename?: 'Collection';
                          allessehCollectionId: string;
                          idCreatedUtc: string;
                          id: string;
                          createdUtc: number;
                          updatedUtc?: number | null;
                          name: string;
                          isArchived: boolean;
                          publicationKey: string;
                          allessehJsonQuery?: string | null;
                          creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
                          revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
                          parameters: {
                            __typename?: 'CollectionParameters';
                            offPlatform?: {
                              __typename?: 'OffPlatformParams';
                              minItems?: number | null;
                              maxItems?: number | null;
                              moduleDisplayName: string;
                              defaultAltSummVariant: string;
                              hostingPageURL: string;
                            } | null;
                          };
                          contentItems: Array<{
                            __typename?: 'CollectionContentItem';
                            originId: string;
                            originContentType: string;
                            content?: string | null;
                            base_doc_id: string;
                            hosted_url: string;
                            id: string;
                            link: string;
                            product: string;
                            seo_id: string;
                            status: string;
                          }>;
                        } | null;
                      } | null;
                      allessehCollectionItem?: {
                        __typename?: 'PageModuleItemAllessehCollection';
                        allessehCollectionId: string;
                      } | null;
                    };
                  }>;
                  uiModuleFields: {
                    __typename?: 'UiModule';
                    basicModule?: {
                      __typename?: 'UiBasicModule';
                      treatmentType: UiBasicTreatmentType;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                    } | null;
                  };
                } | null;
              };
              collection: Array<
                | {
                    __typename?: 'ArticleItem';
                    content?: string | null;
                    type: string;
                    attributes: {
                      __typename?: 'ArticleAttributes';
                      base_doc_id: string;
                      hosted_url: string;
                      id: string;
                      link: string;
                      originContentType?: string | null;
                      originId?: string | null;
                      product: string;
                      seo_id: string;
                      status: string;
                    };
                  }
                | {
                    __typename?: 'ExternalCollectionItem';
                    type: string;
                    attributes: { __typename?: 'ExternalCollectionAttributes'; id: string; repo: string };
                  }
                | { __typename?: 'LinkedItem' }
                | { __typename?: 'MobileArticleItem' }
                | {
                    __typename?: 'QueryItem';
                    type: string;
                    attributes: { __typename?: 'QueryAttributes'; query: Record<string, unknown> };
                  }
              >;
            }>;
          }>;
        }>;
      };
    };
  };
};

export type NewsletterListItemNewsletterListItemFragment = {
  __typename?: 'NewsletterListItem';
  id: string;
  name: string;
  subject: string;
  product: string;
  description: string;
  defaultCampaignDetails?: {
    __typename?: 'NewsletterItemDefaultCampaignDetails';
    sender_name: string;
    reply_to_email: string;
    Subject: string;
    pre_header_text: string;
  } | null;
  schedule?: { __typename?: 'NewsletterItemSchedule'; cron: string; timezone: string } | null;
};

export type NewsletterListItemsQueryVariables = Exact<{
  publicationKey: Scalars['String'];
}>;

export type NewsletterListItemsQuery = {
  __typename?: 'Query';
  getNewsletterList: Array<{
    __typename?: 'NewsletterListItem';
    id: string;
    name: string;
    subject: string;
    product: string;
    description: string;
    defaultCampaignDetails?: {
      __typename?: 'NewsletterItemDefaultCampaignDetails';
      sender_name: string;
      reply_to_email: string;
      Subject: string;
      pre_header_text: string;
    } | null;
    schedule?: { __typename?: 'NewsletterItemSchedule'; cron: string; timezone: string } | null;
  }>;
};

export type NewsletterDtoFragment = {
  __typename?: 'NewsletterDTO';
  metadata: {
    __typename?: 'BaseMetadata';
    allessehId: string;
    createdUtc: number;
    name: string;
    publicationKey: string;
    publishUtc?: number | null;
    updatedUtc?: number | null;
  };
  root: {
    __typename?: 'NewsletterPageContainer';
    subtype?: string | null;
    type: string;
    collection: Array<{
      __typename?: 'ModuleContainer';
      subtype?: string | null;
      type: string;
      collection: Array<
        | {
            __typename?: 'ArticleItem';
            content?: string | null;
            type: string;
            attributes: {
              __typename?: 'ArticleAttributes';
              base_doc_id: string;
              hosted_url: string;
              id: string;
              link: string;
              originContentType?: string | null;
              originId?: string | null;
              product: string;
              seo_id: string;
              status: string;
            };
          }
        | { __typename?: 'ExternalCollectionItem' }
        | { __typename?: 'LinkedItem' }
        | { __typename?: 'MobileArticleItem' }
        | { __typename?: 'QueryItem' }
      >;
      attributes: {
        __typename?: 'ModuleAttributes';
        moduleId?: string | null;
        pageModule?: {
          __typename?: 'PageModule';
          uiModuleType: UiModuleType;
          uiModuleFields: {
            __typename?: 'UiModule';
            basicModule?: {
              __typename?: 'UiBasicModule';
              treatmentType: UiBasicTreatmentType;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
            } | null;
            titleModule?: {
              __typename?: 'UiTitleModule';
              treatmentType: UiTitleTreatmentType;
              title?: string | null;
              titleUrl?: string | null;
              subtitle?: string | null;
              subtitleUrl?: string | null;
              allowedMeta?: Array<Metadata> | null;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
            } | null;
            rankedModule?: {
              __typename?: 'UiRankedModule';
              treatmentType: UiRankedTreatmentType;
              title: string;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
            } | null;
            textModule?: {
              __typename?: 'UiTextModule';
              treatmentType: UiTextTreatmentType;
              mainText: string;
              secondaryText: string;
              allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
            } | null;
            basicOptionalModule?: {
              __typename?: 'UiBasicOptionalModule';
              treatmentType: UiBasicOptionalTreatmentType;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
              moduleName?: string | null;
            } | null;
            feedsModule?: {
              __typename?: 'UiFeedsModule';
              treatmentType: UiFeedsTreatmentType;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
            } | null;
          };
          moduleItems: Array<{
            __typename?: 'PageModuleItem';
            itemType: PageModuleItemType;
            itemFields: {
              __typename?: 'PageModuleItemFields';
              contentItem?: {
                __typename?: 'PageModuleItemContent';
                originId: string;
                originContentType: string;
                content?: string | null;
              } | null;
              queryItem?: {
                __typename?: 'PageModuleItemQuery';
                jsonQuery: string;
                isFeed?: boolean | null;
                title?: string | null;
                url?: string | null;
              } | null;
              collectionItem?: {
                __typename?: 'PageModuleItemCollection';
                idCreatedUtc: string;
                collection?: {
                  __typename?: 'Collection';
                  allessehCollectionId: string;
                  idCreatedUtc: string;
                  id: string;
                  createdUtc: number;
                  updatedUtc?: number | null;
                  name: string;
                  isArchived: boolean;
                  allessehJsonQuery?: string | null;
                  contentItems: Array<{
                    __typename?: 'CollectionContentItem';
                    originId: string;
                    originContentType: string;
                    content?: string | null;
                  }>;
                } | null;
              } | null;
              allessehCollectionItem?: {
                __typename?: 'PageModuleItemAllessehCollection';
                allessehCollectionId: string;
              } | null;
              linkedItem?: {
                __typename?: 'PageModuleItemLinkedItem';
                headline: string;
                summary?: string | null;
                url: string;
                media?: string | null;
              } | null;
            };
          }>;
        } | null;
      };
    }>;
    attributes: {
      __typename?: 'NewsletterPageAttributes';
      campaignId: string;
      layoutId?: string | null;
      newsletterId: number;
      preHeaderText: string;
      recipients?: string | null;
      replyToEmail: string;
      senderName: string;
      subject: string;
    };
  };
};

export type CreateNewsletterMutationVariables = Exact<{
  newsletterInput: NewsletterInput;
}>;

export type CreateNewsletterMutation = {
  __typename?: 'Mutation';
  createNewsletter: {
    __typename?: 'NewsletterDTO';
    metadata: {
      __typename?: 'BaseMetadata';
      allessehId: string;
      createdUtc: number;
      name: string;
      publicationKey: string;
      publishUtc?: number | null;
      updatedUtc?: number | null;
    };
    root: {
      __typename?: 'NewsletterPageContainer';
      subtype?: string | null;
      type: string;
      collection: Array<{
        __typename?: 'ModuleContainer';
        subtype?: string | null;
        type: string;
        collection: Array<
          | {
              __typename?: 'ArticleItem';
              content?: string | null;
              type: string;
              attributes: {
                __typename?: 'ArticleAttributes';
                base_doc_id: string;
                hosted_url: string;
                id: string;
                link: string;
                originContentType?: string | null;
                originId?: string | null;
                product: string;
                seo_id: string;
                status: string;
              };
            }
          | { __typename?: 'ExternalCollectionItem' }
          | { __typename?: 'LinkedItem' }
          | { __typename?: 'MobileArticleItem' }
          | { __typename?: 'QueryItem' }
        >;
        attributes: {
          __typename?: 'ModuleAttributes';
          moduleId?: string | null;
          pageModule?: {
            __typename?: 'PageModule';
            uiModuleType: UiModuleType;
            uiModuleFields: {
              __typename?: 'UiModule';
              basicModule?: {
                __typename?: 'UiBasicModule';
                treatmentType: UiBasicTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
              } | null;
              titleModule?: {
                __typename?: 'UiTitleModule';
                treatmentType: UiTitleTreatmentType;
                title?: string | null;
                titleUrl?: string | null;
                subtitle?: string | null;
                subtitleUrl?: string | null;
                allowedMeta?: Array<Metadata> | null;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
              } | null;
              rankedModule?: {
                __typename?: 'UiRankedModule';
                treatmentType: UiRankedTreatmentType;
                title: string;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
              } | null;
              textModule?: {
                __typename?: 'UiTextModule';
                treatmentType: UiTextTreatmentType;
                mainText: string;
                secondaryText: string;
                allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
              } | null;
              basicOptionalModule?: {
                __typename?: 'UiBasicOptionalModule';
                treatmentType: UiBasicOptionalTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                moduleName?: string | null;
              } | null;
              feedsModule?: {
                __typename?: 'UiFeedsModule';
                treatmentType: UiFeedsTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
              } | null;
            };
            moduleItems: Array<{
              __typename?: 'PageModuleItem';
              itemType: PageModuleItemType;
              itemFields: {
                __typename?: 'PageModuleItemFields';
                contentItem?: {
                  __typename?: 'PageModuleItemContent';
                  originId: string;
                  originContentType: string;
                  content?: string | null;
                } | null;
                queryItem?: {
                  __typename?: 'PageModuleItemQuery';
                  jsonQuery: string;
                  isFeed?: boolean | null;
                  title?: string | null;
                  url?: string | null;
                } | null;
                collectionItem?: {
                  __typename?: 'PageModuleItemCollection';
                  idCreatedUtc: string;
                  collection?: {
                    __typename?: 'Collection';
                    allessehCollectionId: string;
                    idCreatedUtc: string;
                    id: string;
                    createdUtc: number;
                    updatedUtc?: number | null;
                    name: string;
                    isArchived: boolean;
                    allessehJsonQuery?: string | null;
                    contentItems: Array<{
                      __typename?: 'CollectionContentItem';
                      originId: string;
                      originContentType: string;
                      content?: string | null;
                    }>;
                  } | null;
                } | null;
                allessehCollectionItem?: {
                  __typename?: 'PageModuleItemAllessehCollection';
                  allessehCollectionId: string;
                } | null;
                linkedItem?: {
                  __typename?: 'PageModuleItemLinkedItem';
                  headline: string;
                  summary?: string | null;
                  url: string;
                  media?: string | null;
                } | null;
              };
            }>;
          } | null;
        };
      }>;
      attributes: {
        __typename?: 'NewsletterPageAttributes';
        campaignId: string;
        layoutId?: string | null;
        newsletterId: number;
        preHeaderText: string;
        recipients?: string | null;
        replyToEmail: string;
        senderName: string;
        subject: string;
      };
    };
  };
};

export type CreatePreviewNewsletterMutationVariables = Exact<{
  newsletterInput: NewsletterInput;
}>;

export type CreatePreviewNewsletterMutation = {
  __typename?: 'Mutation';
  createPreviewNewsletter: {
    __typename?: 'NewsletterDTO';
    metadata: {
      __typename?: 'BaseMetadata';
      allessehId: string;
      createdUtc: number;
      name: string;
      publicationKey: string;
      publishUtc?: number | null;
      updatedUtc?: number | null;
    };
    root: {
      __typename?: 'NewsletterPageContainer';
      subtype?: string | null;
      type: string;
      collection: Array<{
        __typename?: 'ModuleContainer';
        subtype?: string | null;
        type: string;
        collection: Array<
          | {
              __typename?: 'ArticleItem';
              content?: string | null;
              type: string;
              attributes: {
                __typename?: 'ArticleAttributes';
                base_doc_id: string;
                hosted_url: string;
                id: string;
                link: string;
                originContentType?: string | null;
                originId?: string | null;
                product: string;
                seo_id: string;
                status: string;
              };
            }
          | { __typename?: 'ExternalCollectionItem' }
          | { __typename?: 'LinkedItem' }
          | { __typename?: 'MobileArticleItem' }
          | { __typename?: 'QueryItem' }
        >;
        attributes: {
          __typename?: 'ModuleAttributes';
          moduleId?: string | null;
          pageModule?: {
            __typename?: 'PageModule';
            uiModuleType: UiModuleType;
            uiModuleFields: {
              __typename?: 'UiModule';
              basicModule?: {
                __typename?: 'UiBasicModule';
                treatmentType: UiBasicTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
              } | null;
              titleModule?: {
                __typename?: 'UiTitleModule';
                treatmentType: UiTitleTreatmentType;
                title?: string | null;
                titleUrl?: string | null;
                subtitle?: string | null;
                subtitleUrl?: string | null;
                allowedMeta?: Array<Metadata> | null;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
              } | null;
              rankedModule?: {
                __typename?: 'UiRankedModule';
                treatmentType: UiRankedTreatmentType;
                title: string;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
              } | null;
              textModule?: {
                __typename?: 'UiTextModule';
                treatmentType: UiTextTreatmentType;
                mainText: string;
                secondaryText: string;
                allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
              } | null;
              basicOptionalModule?: {
                __typename?: 'UiBasicOptionalModule';
                treatmentType: UiBasicOptionalTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                moduleName?: string | null;
              } | null;
              feedsModule?: {
                __typename?: 'UiFeedsModule';
                treatmentType: UiFeedsTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
              } | null;
            };
            moduleItems: Array<{
              __typename?: 'PageModuleItem';
              itemType: PageModuleItemType;
              itemFields: {
                __typename?: 'PageModuleItemFields';
                contentItem?: {
                  __typename?: 'PageModuleItemContent';
                  originId: string;
                  originContentType: string;
                  content?: string | null;
                } | null;
                queryItem?: {
                  __typename?: 'PageModuleItemQuery';
                  jsonQuery: string;
                  isFeed?: boolean | null;
                  title?: string | null;
                  url?: string | null;
                } | null;
                collectionItem?: {
                  __typename?: 'PageModuleItemCollection';
                  idCreatedUtc: string;
                  collection?: {
                    __typename?: 'Collection';
                    allessehCollectionId: string;
                    idCreatedUtc: string;
                    id: string;
                    createdUtc: number;
                    updatedUtc?: number | null;
                    name: string;
                    isArchived: boolean;
                    allessehJsonQuery?: string | null;
                    contentItems: Array<{
                      __typename?: 'CollectionContentItem';
                      originId: string;
                      originContentType: string;
                      content?: string | null;
                    }>;
                  } | null;
                } | null;
                allessehCollectionItem?: {
                  __typename?: 'PageModuleItemAllessehCollection';
                  allessehCollectionId: string;
                } | null;
                linkedItem?: {
                  __typename?: 'PageModuleItemLinkedItem';
                  headline: string;
                  summary?: string | null;
                  url: string;
                  media?: string | null;
                } | null;
              };
            }>;
          } | null;
        };
      }>;
      attributes: {
        __typename?: 'NewsletterPageAttributes';
        campaignId: string;
        layoutId?: string | null;
        newsletterId: number;
        preHeaderText: string;
        recipients?: string | null;
        replyToEmail: string;
        senderName: string;
        subject: string;
      };
    };
  };
};

export type GetNewslettersQueryVariables = Exact<{
  newslettersSearchInput: NewslettersSearchInput;
  paginationParams: PaginationParams;
}>;

export type GetNewslettersQuery = {
  __typename?: 'Query';
  getNewsletters: {
    __typename?: 'NewsletterDTOConnection';
    edges: Array<{
      __typename?: 'NewsletterDTOEdge';
      node: {
        __typename?: 'NewsletterDTO';
        metadata: {
          __typename?: 'BaseMetadata';
          allessehId: string;
          createdUtc: number;
          name: string;
          publicationKey: string;
          publishUtc?: number | null;
          updatedUtc?: number | null;
        };
        root: {
          __typename?: 'NewsletterPageContainer';
          subtype?: string | null;
          type: string;
          collection: Array<{
            __typename?: 'ModuleContainer';
            subtype?: string | null;
            type: string;
            collection: Array<
              | {
                  __typename?: 'ArticleItem';
                  content?: string | null;
                  type: string;
                  attributes: {
                    __typename?: 'ArticleAttributes';
                    base_doc_id: string;
                    hosted_url: string;
                    id: string;
                    link: string;
                    originContentType?: string | null;
                    originId?: string | null;
                    product: string;
                    seo_id: string;
                    status: string;
                  };
                }
              | { __typename?: 'ExternalCollectionItem' }
              | { __typename?: 'LinkedItem' }
              | { __typename?: 'MobileArticleItem' }
              | { __typename?: 'QueryItem' }
            >;
            attributes: {
              __typename?: 'ModuleAttributes';
              moduleId?: string | null;
              pageModule?: {
                __typename?: 'PageModule';
                uiModuleType: UiModuleType;
                uiModuleFields: {
                  __typename?: 'UiModule';
                  basicModule?: {
                    __typename?: 'UiBasicModule';
                    treatmentType: UiBasicTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                  } | null;
                  titleModule?: {
                    __typename?: 'UiTitleModule';
                    treatmentType: UiTitleTreatmentType;
                    title?: string | null;
                    titleUrl?: string | null;
                    subtitle?: string | null;
                    subtitleUrl?: string | null;
                    allowedMeta?: Array<Metadata> | null;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
                  } | null;
                  rankedModule?: {
                    __typename?: 'UiRankedModule';
                    treatmentType: UiRankedTreatmentType;
                    title: string;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
                  } | null;
                  textModule?: {
                    __typename?: 'UiTextModule';
                    treatmentType: UiTextTreatmentType;
                    mainText: string;
                    secondaryText: string;
                    allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
                  } | null;
                  basicOptionalModule?: {
                    __typename?: 'UiBasicOptionalModule';
                    treatmentType: UiBasicOptionalTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                    moduleName?: string | null;
                  } | null;
                  feedsModule?: {
                    __typename?: 'UiFeedsModule';
                    treatmentType: UiFeedsTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
                  } | null;
                };
                moduleItems: Array<{
                  __typename?: 'PageModuleItem';
                  itemType: PageModuleItemType;
                  itemFields: {
                    __typename?: 'PageModuleItemFields';
                    contentItem?: {
                      __typename?: 'PageModuleItemContent';
                      originId: string;
                      originContentType: string;
                      content?: string | null;
                    } | null;
                    queryItem?: {
                      __typename?: 'PageModuleItemQuery';
                      jsonQuery: string;
                      isFeed?: boolean | null;
                      title?: string | null;
                      url?: string | null;
                    } | null;
                    collectionItem?: {
                      __typename?: 'PageModuleItemCollection';
                      idCreatedUtc: string;
                      collection?: {
                        __typename?: 'Collection';
                        allessehCollectionId: string;
                        idCreatedUtc: string;
                        id: string;
                        createdUtc: number;
                        updatedUtc?: number | null;
                        name: string;
                        isArchived: boolean;
                        allessehJsonQuery?: string | null;
                        contentItems: Array<{
                          __typename?: 'CollectionContentItem';
                          originId: string;
                          originContentType: string;
                          content?: string | null;
                        }>;
                      } | null;
                    } | null;
                    allessehCollectionItem?: {
                      __typename?: 'PageModuleItemAllessehCollection';
                      allessehCollectionId: string;
                    } | null;
                    linkedItem?: {
                      __typename?: 'PageModuleItemLinkedItem';
                      headline: string;
                      summary?: string | null;
                      url: string;
                      media?: string | null;
                    } | null;
                  };
                }>;
              } | null;
            };
          }>;
          attributes: {
            __typename?: 'NewsletterPageAttributes';
            campaignId: string;
            layoutId?: string | null;
            newsletterId: number;
            preHeaderText: string;
            recipients?: string | null;
            replyToEmail: string;
            senderName: string;
            subject: string;
          };
        };
      };
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      hasNextPage: boolean;
      hasPreviousPage?: boolean | null;
      startCursor?: string | null;
    };
  };
};

export type NewsletterByIdQueryVariables = Exact<{
  id: Scalars['String'];
  publicationKey: Scalars['String'];
}>;

export type NewsletterByIdQuery = {
  __typename?: 'Query';
  newsletterById: {
    __typename?: 'NewsletterDTO';
    metadata: {
      __typename?: 'BaseMetadata';
      allessehId: string;
      createdUtc: number;
      name: string;
      publicationKey: string;
      publishUtc?: number | null;
      updatedUtc?: number | null;
    };
    root: {
      __typename?: 'NewsletterPageContainer';
      subtype?: string | null;
      type: string;
      collection: Array<{
        __typename?: 'ModuleContainer';
        subtype?: string | null;
        type: string;
        collection: Array<
          | {
              __typename?: 'ArticleItem';
              content?: string | null;
              type: string;
              attributes: {
                __typename?: 'ArticleAttributes';
                base_doc_id: string;
                hosted_url: string;
                id: string;
                link: string;
                originContentType?: string | null;
                originId?: string | null;
                product: string;
                seo_id: string;
                status: string;
              };
            }
          | { __typename?: 'ExternalCollectionItem' }
          | { __typename?: 'LinkedItem' }
          | { __typename?: 'MobileArticleItem' }
          | { __typename?: 'QueryItem' }
        >;
        attributes: {
          __typename?: 'ModuleAttributes';
          moduleId?: string | null;
          pageModule?: {
            __typename?: 'PageModule';
            uiModuleType: UiModuleType;
            uiModuleFields: {
              __typename?: 'UiModule';
              basicModule?: {
                __typename?: 'UiBasicModule';
                treatmentType: UiBasicTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
              } | null;
              titleModule?: {
                __typename?: 'UiTitleModule';
                treatmentType: UiTitleTreatmentType;
                title?: string | null;
                titleUrl?: string | null;
                subtitle?: string | null;
                subtitleUrl?: string | null;
                allowedMeta?: Array<Metadata> | null;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
              } | null;
              rankedModule?: {
                __typename?: 'UiRankedModule';
                treatmentType: UiRankedTreatmentType;
                title: string;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
              } | null;
              textModule?: {
                __typename?: 'UiTextModule';
                treatmentType: UiTextTreatmentType;
                mainText: string;
                secondaryText: string;
                allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
              } | null;
              basicOptionalModule?: {
                __typename?: 'UiBasicOptionalModule';
                treatmentType: UiBasicOptionalTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                moduleName?: string | null;
              } | null;
              feedsModule?: {
                __typename?: 'UiFeedsModule';
                treatmentType: UiFeedsTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
              } | null;
            };
            moduleItems: Array<{
              __typename?: 'PageModuleItem';
              itemType: PageModuleItemType;
              itemFields: {
                __typename?: 'PageModuleItemFields';
                contentItem?: {
                  __typename?: 'PageModuleItemContent';
                  originId: string;
                  originContentType: string;
                  content?: string | null;
                } | null;
                queryItem?: {
                  __typename?: 'PageModuleItemQuery';
                  jsonQuery: string;
                  isFeed?: boolean | null;
                  title?: string | null;
                  url?: string | null;
                } | null;
                collectionItem?: {
                  __typename?: 'PageModuleItemCollection';
                  idCreatedUtc: string;
                  collection?: {
                    __typename?: 'Collection';
                    allessehCollectionId: string;
                    idCreatedUtc: string;
                    id: string;
                    createdUtc: number;
                    updatedUtc?: number | null;
                    name: string;
                    isArchived: boolean;
                    allessehJsonQuery?: string | null;
                    contentItems: Array<{
                      __typename?: 'CollectionContentItem';
                      originId: string;
                      originContentType: string;
                      content?: string | null;
                    }>;
                  } | null;
                } | null;
                allessehCollectionItem?: {
                  __typename?: 'PageModuleItemAllessehCollection';
                  allessehCollectionId: string;
                } | null;
                linkedItem?: {
                  __typename?: 'PageModuleItemLinkedItem';
                  headline: string;
                  summary?: string | null;
                  url: string;
                  media?: string | null;
                } | null;
              };
            }>;
          } | null;
        };
      }>;
      attributes: {
        __typename?: 'NewsletterPageAttributes';
        campaignId: string;
        layoutId?: string | null;
        newsletterId: number;
        preHeaderText: string;
        recipients?: string | null;
        replyToEmail: string;
        senderName: string;
        subject: string;
      };
    };
  };
};

export type OffPlatformDtoFragment = {
  __typename?: 'OffPlatformDTO';
  idCreatedUtc: string;
  metadata: {
    __typename?: 'OffPlatformMetadata';
    allessehId: string;
    consumer: string;
    createdUtc: number;
    isArchived: boolean;
    name: string;
    notes?: string | null;
    publicationKey: string;
    publishUtc?: number | null;
    updatedUtc?: number | null;
    creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
    revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
  };
  root: {
    __typename?: 'OffPlatformListContainer';
    type: string;
    subtype?: string | null;
    collection: Array<
      | {
          __typename?: 'ArticleItem';
          content?: string | null;
          type: string;
          attributes: {
            __typename?: 'ArticleAttributes';
            base_doc_id: string;
            hosted_url: string;
            id: string;
            link: string;
            originContentType?: string | null;
            originId?: string | null;
            product: string;
            seo_id: string;
            status: string;
          };
        }
      | { __typename?: 'ExternalCollectionItem' }
      | { __typename?: 'LinkedItem' }
      | { __typename?: 'MobileArticleItem' }
      | {
          __typename?: 'QueryItem';
          type: string;
          attributes: {
            __typename?: 'QueryAttributes';
            query: Record<string, unknown>;
            feedTitle?: string | null;
            feedUrl?: string | null;
            isFeed?: boolean | null;
          };
        }
    >;
    attributes: {
      __typename?: 'OffPlatformListAttributes';
      defaultAltSummVariant: string;
      hostingPageURL: string;
      maxItems: number;
      minItems: number;
      moduleDisplayName: string;
    };
  };
};

export type OffPlatformDtoListFragment = {
  __typename?: 'OffPlatformDTO';
  idCreatedUtc: string;
  metadata: {
    __typename?: 'OffPlatformMetadata';
    allessehId: string;
    createdUtc: number;
    isArchived: boolean;
    name: string;
    publicationKey: string;
    publishUtc?: number | null;
    updatedUtc?: number | null;
  };
  root: {
    __typename?: 'OffPlatformListContainer';
    type: string;
    subtype?: string | null;
    collection: Array<
      | {
          __typename?: 'ArticleItem';
          type: string;
          attributes: {
            __typename?: 'ArticleAttributes';
            base_doc_id: string;
            hosted_url: string;
            id: string;
            link: string;
            originContentType?: string | null;
            originId?: string | null;
            product: string;
            seo_id: string;
            status: string;
          };
        }
      | { __typename?: 'ExternalCollectionItem' }
      | { __typename?: 'LinkedItem' }
      | { __typename?: 'MobileArticleItem' }
      | {
          __typename?: 'QueryItem';
          type: string;
          attributes: {
            __typename?: 'QueryAttributes';
            query: Record<string, unknown>;
            feedTitle?: string | null;
            feedUrl?: string | null;
            isFeed?: boolean | null;
          };
        }
    >;
  };
};

export type UpdateOffPlatformMutationVariables = Exact<{
  offPlatformUpdateInput: OffPlatformUpdateInput;
}>;

export type UpdateOffPlatformMutation = {
  __typename?: 'Mutation';
  updateOffPlatform: {
    __typename?: 'OffPlatformDTO';
    idCreatedUtc: string;
    metadata: {
      __typename?: 'OffPlatformMetadata';
      allessehId: string;
      consumer: string;
      createdUtc: number;
      isArchived: boolean;
      name: string;
      notes?: string | null;
      publicationKey: string;
      publishUtc?: number | null;
      updatedUtc?: number | null;
      creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
      revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
    };
    root: {
      __typename?: 'OffPlatformListContainer';
      type: string;
      subtype?: string | null;
      collection: Array<
        | {
            __typename?: 'ArticleItem';
            content?: string | null;
            type: string;
            attributes: {
              __typename?: 'ArticleAttributes';
              base_doc_id: string;
              hosted_url: string;
              id: string;
              link: string;
              originContentType?: string | null;
              originId?: string | null;
              product: string;
              seo_id: string;
              status: string;
            };
          }
        | { __typename?: 'ExternalCollectionItem' }
        | { __typename?: 'LinkedItem' }
        | { __typename?: 'MobileArticleItem' }
        | {
            __typename?: 'QueryItem';
            type: string;
            attributes: {
              __typename?: 'QueryAttributes';
              query: Record<string, unknown>;
              feedTitle?: string | null;
              feedUrl?: string | null;
              isFeed?: boolean | null;
            };
          }
      >;
      attributes: {
        __typename?: 'OffPlatformListAttributes';
        defaultAltSummVariant: string;
        hostingPageURL: string;
        maxItems: number;
        minItems: number;
        moduleDisplayName: string;
      };
    };
  };
};

export type ConvertToOffPlatformMutationVariables = Exact<{
  convertToOffPlatformInput: ConvertToOffPlatformInput;
}>;

export type ConvertToOffPlatformMutation = {
  __typename?: 'Mutation';
  convertToOffPlatform: {
    __typename?: 'OffPlatformDTO';
    idCreatedUtc: string;
    metadata: {
      __typename?: 'OffPlatformMetadata';
      allessehId: string;
      consumer: string;
      createdUtc: number;
      isArchived: boolean;
      name: string;
      notes?: string | null;
      publicationKey: string;
      publishUtc?: number | null;
      updatedUtc?: number | null;
      creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
      revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
    };
    root: {
      __typename?: 'OffPlatformListContainer';
      type: string;
      subtype?: string | null;
      collection: Array<
        | {
            __typename?: 'ArticleItem';
            content?: string | null;
            type: string;
            attributes: {
              __typename?: 'ArticleAttributes';
              base_doc_id: string;
              hosted_url: string;
              id: string;
              link: string;
              originContentType?: string | null;
              originId?: string | null;
              product: string;
              seo_id: string;
              status: string;
            };
          }
        | { __typename?: 'ExternalCollectionItem' }
        | { __typename?: 'LinkedItem' }
        | { __typename?: 'MobileArticleItem' }
        | {
            __typename?: 'QueryItem';
            type: string;
            attributes: {
              __typename?: 'QueryAttributes';
              query: Record<string, unknown>;
              feedTitle?: string | null;
              feedUrl?: string | null;
              isFeed?: boolean | null;
            };
          }
      >;
      attributes: {
        __typename?: 'OffPlatformListAttributes';
        defaultAltSummVariant: string;
        hostingPageURL: string;
        maxItems: number;
        minItems: number;
        moduleDisplayName: string;
      };
    };
  };
};

export type GetAllOffPlatformQueryVariables = Exact<{
  offPlatformInput: OffPlatformInput;
  paginationParams: PaginationParams;
}>;

export type GetAllOffPlatformQuery = {
  __typename?: 'Query';
  getAllOffPlatform: {
    __typename?: 'OffPlatformDTOConnection';
    edges: Array<{
      __typename?: 'OffPlatformDTOEdge';
      node: {
        __typename?: 'OffPlatformDTO';
        idCreatedUtc: string;
        metadata: {
          __typename?: 'OffPlatformMetadata';
          allessehId: string;
          createdUtc: number;
          isArchived: boolean;
          name: string;
          publicationKey: string;
          publishUtc?: number | null;
          updatedUtc?: number | null;
        };
        root: {
          __typename?: 'OffPlatformListContainer';
          type: string;
          subtype?: string | null;
          collection: Array<
            | {
                __typename?: 'ArticleItem';
                type: string;
                attributes: {
                  __typename?: 'ArticleAttributes';
                  base_doc_id: string;
                  hosted_url: string;
                  id: string;
                  link: string;
                  originContentType?: string | null;
                  originId?: string | null;
                  product: string;
                  seo_id: string;
                  status: string;
                };
              }
            | { __typename?: 'ExternalCollectionItem' }
            | { __typename?: 'LinkedItem' }
            | { __typename?: 'MobileArticleItem' }
            | {
                __typename?: 'QueryItem';
                type: string;
                attributes: {
                  __typename?: 'QueryAttributes';
                  query: Record<string, unknown>;
                  feedTitle?: string | null;
                  feedUrl?: string | null;
                  isFeed?: boolean | null;
                };
              }
          >;
        };
      };
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      hasNextPage: boolean;
      hasPreviousPage?: boolean | null;
      startCursor?: string | null;
    };
  };
};

export type OffPlatformByIdQueryVariables = Exact<{
  id: Scalars['String'];
  publicationKey: Scalars['String'];
}>;

export type OffPlatformByIdQuery = {
  __typename?: 'Query';
  offPlatformById: {
    __typename?: 'OffPlatformDTO';
    idCreatedUtc: string;
    metadata: {
      __typename?: 'OffPlatformMetadata';
      allessehId: string;
      consumer: string;
      createdUtc: number;
      isArchived: boolean;
      name: string;
      notes?: string | null;
      publicationKey: string;
      publishUtc?: number | null;
      updatedUtc?: number | null;
      creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
      revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
    };
    root: {
      __typename?: 'OffPlatformListContainer';
      type: string;
      subtype?: string | null;
      collection: Array<
        | {
            __typename?: 'ArticleItem';
            content?: string | null;
            type: string;
            attributes: {
              __typename?: 'ArticleAttributes';
              base_doc_id: string;
              hosted_url: string;
              id: string;
              link: string;
              originContentType?: string | null;
              originId?: string | null;
              product: string;
              seo_id: string;
              status: string;
            };
          }
        | { __typename?: 'ExternalCollectionItem' }
        | { __typename?: 'LinkedItem' }
        | { __typename?: 'MobileArticleItem' }
        | {
            __typename?: 'QueryItem';
            type: string;
            attributes: {
              __typename?: 'QueryAttributes';
              query: Record<string, unknown>;
              feedTitle?: string | null;
              feedUrl?: string | null;
              isFeed?: boolean | null;
            };
          }
      >;
      attributes: {
        __typename?: 'OffPlatformListAttributes';
        defaultAltSummVariant: string;
        hostingPageURL: string;
        maxItems: number;
        minItems: number;
        moduleDisplayName: string;
      };
    };
  };
};

export type PageDtoMetadataFragment = {
  __typename?: 'BaseMetadata';
  allessehId: string;
  createdUtc: number;
  name: string;
  publicationKey: string;
  publishUtc?: number | null;
  updatedUtc?: number | null;
  creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
  revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
};

export type PageDtoDataFragment = {
  __typename?: 'PageDTO';
  type: string;
  metadata: {
    __typename?: 'BaseMetadata';
    allessehId: string;
    createdUtc: number;
    name: string;
    publicationKey: string;
    publishUtc?: number | null;
    updatedUtc?: number | null;
    creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
    revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
  };
  root: {
    __typename?: 'SectionContainer';
    type: string;
    attributes: {
      __typename?: 'SectionAttributes';
      adPlacementType?: string | null;
      adZone?: string | null;
      isHidden: boolean;
      pageType: string;
      routeKey: string;
      sectionKey?: string | null;
      sectionLabel?: string | null;
      summaryPriority: string;
    };
    collection: Array<{
      __typename?: 'PageContainer';
      type: string;
      attributes: { __typename?: 'PageAttributes'; layoutId?: string | null };
      collection: Array<{
        __typename?: 'ModuleContainer';
        type: string;
        attributes: {
          __typename?: 'ModuleAttributes';
          moduleId?: string | null;
          pageModule?: {
            __typename?: 'PageModule';
            uiModuleType: UiModuleType;
            uiModuleFields: {
              __typename?: 'UiModule';
              basicModule?: {
                __typename?: 'UiBasicModule';
                treatmentType: UiBasicTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
              } | null;
              titleModule?: {
                __typename?: 'UiTitleModule';
                treatmentType: UiTitleTreatmentType;
                title?: string | null;
                titleUrl?: string | null;
                subtitle?: string | null;
                subtitleUrl?: string | null;
                allowedMeta?: Array<Metadata> | null;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
              } | null;
              rankedModule?: {
                __typename?: 'UiRankedModule';
                treatmentType: UiRankedTreatmentType;
                title: string;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
              } | null;
              textModule?: {
                __typename?: 'UiTextModule';
                treatmentType: UiTextTreatmentType;
                mainText: string;
                secondaryText: string;
                allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
              } | null;
              basicOptionalModule?: {
                __typename?: 'UiBasicOptionalModule';
                treatmentType: UiBasicOptionalTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                moduleName?: string | null;
              } | null;
              feedsModule?: {
                __typename?: 'UiFeedsModule';
                treatmentType: UiFeedsTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
              } | null;
            };
          } | null;
        };
        collection: Array<
          | {
              __typename?: 'ArticleItem';
              type: string;
              content?: string | null;
              attributes: {
                __typename?: 'ArticleAttributes';
                base_doc_id: string;
                hosted_url: string;
                id: string;
                link: string;
                originContentType?: string | null;
                originId?: string | null;
                product: string;
                seo_id: string;
                status: string;
              };
            }
          | {
              __typename?: 'ExternalCollectionItem';
              type: string;
              metadata: { __typename?: 'ExternalCollectionMetadata'; id: string; name: string; createdUtc: number };
              contentItems: Array<
                | {
                    __typename?: 'ArticleItem';
                    type: string;
                    content?: string | null;
                    attributes: {
                      __typename?: 'ArticleAttributes';
                      base_doc_id: string;
                      hosted_url: string;
                      id: string;
                      link: string;
                      originContentType?: string | null;
                      originId?: string | null;
                      product: string;
                      seo_id: string;
                      status: string;
                    };
                  }
                | { __typename?: 'ExternalCollectionItem' }
                | { __typename?: 'LinkedItem' }
                | { __typename?: 'MobileArticleItem' }
                | {
                    __typename?: 'QueryItem';
                    type: string;
                    attributes: { __typename?: 'QueryAttributes'; query: Record<string, unknown> };
                  }
              >;
              attributes: { __typename?: 'ExternalCollectionAttributes'; id: string; repo: string };
            }
          | {
              __typename?: 'LinkedItem';
              type: string;
              attributes: {
                __typename?: 'LinkedItemAttributes';
                id: string;
                product: string;
                title: string;
                description?: string | null;
                hosted_url: string;
                image?: {
                  __typename?: 'ImageAttributes';
                  id: string;
                  alternate_text: string;
                  credit: string;
                  height: number;
                  name: string;
                  reuse_type: string;
                  media_type: string;
                  width: number;
                  alt_images: Array<string>;
                  type: string;
                  src: {
                    __typename?: 'ImageSourceAttributes';
                    image_id: string;
                    base_url: string;
                    path: string;
                    params: { __typename?: 'ImageParams'; size: number };
                  };
                  properties: { __typename?: 'Properties'; imphotoid: string; location: string };
                } | null;
              };
            }
          | {
              __typename?: 'MobileArticleItem';
              type: string;
              subtype?: string | null;
              content?: string | null;
              attributes: {
                __typename?: 'MobileArticleAttributes';
                base_doc_id: string;
                hosted_url: string;
                id: string;
                link: string;
                originContentType?: string | null;
                originId?: string | null;
                product: string;
                seo_id: string;
                status: string;
                showImage: boolean;
                showImageBelow: boolean;
                showFlashline: boolean;
              };
            }
          | {
              __typename?: 'QueryItem';
              type: string;
              attributes: {
                __typename?: 'QueryAttributes';
                query: Record<string, unknown>;
                isFeed?: boolean | null;
                feedTitle?: string | null;
                feedUrl?: string | null;
              };
            }
        >;
      }>;
    }>;
  };
};

export type PageDtoPreviewLinkMutationVariables = Exact<{
  pagePreviewLinkInput: PageDtoPreviewLinkInput;
}>;

export type PageDtoPreviewLinkMutation = { __typename?: 'Mutation'; pageDTOPreviewLink?: string | null };

export type PageDtoUpdateMutationVariables = Exact<{
  pageUpdateInput: PageDtoUpdateInput;
}>;

export type PageDtoUpdateMutation = {
  __typename?: 'Mutation';
  pageDTOUpdate: {
    __typename?: 'PageDTO';
    type: string;
    metadata: {
      __typename?: 'BaseMetadata';
      allessehId: string;
      createdUtc: number;
      name: string;
      publicationKey: string;
      publishUtc?: number | null;
      updatedUtc?: number | null;
      creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
      revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
    };
    root: {
      __typename?: 'SectionContainer';
      type: string;
      attributes: {
        __typename?: 'SectionAttributes';
        adPlacementType?: string | null;
        adZone?: string | null;
        isHidden: boolean;
        pageType: string;
        routeKey: string;
        sectionKey?: string | null;
        sectionLabel?: string | null;
        summaryPriority: string;
      };
      collection: Array<{
        __typename?: 'PageContainer';
        type: string;
        attributes: { __typename?: 'PageAttributes'; layoutId?: string | null };
        collection: Array<{
          __typename?: 'ModuleContainer';
          type: string;
          attributes: {
            __typename?: 'ModuleAttributes';
            moduleId?: string | null;
            pageModule?: {
              __typename?: 'PageModule';
              uiModuleType: UiModuleType;
              uiModuleFields: {
                __typename?: 'UiModule';
                basicModule?: {
                  __typename?: 'UiBasicModule';
                  treatmentType: UiBasicTreatmentType;
                  contentTypes: Array<PublicationSettingSearchableContentType>;
                  allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                } | null;
                titleModule?: {
                  __typename?: 'UiTitleModule';
                  treatmentType: UiTitleTreatmentType;
                  title?: string | null;
                  titleUrl?: string | null;
                  subtitle?: string | null;
                  subtitleUrl?: string | null;
                  allowedMeta?: Array<Metadata> | null;
                  contentTypes: Array<PublicationSettingSearchableContentType>;
                  allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
                } | null;
                rankedModule?: {
                  __typename?: 'UiRankedModule';
                  treatmentType: UiRankedTreatmentType;
                  title: string;
                  contentTypes: Array<PublicationSettingSearchableContentType>;
                  allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
                } | null;
                textModule?: {
                  __typename?: 'UiTextModule';
                  treatmentType: UiTextTreatmentType;
                  mainText: string;
                  secondaryText: string;
                  allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
                } | null;
                basicOptionalModule?: {
                  __typename?: 'UiBasicOptionalModule';
                  treatmentType: UiBasicOptionalTreatmentType;
                  contentTypes: Array<PublicationSettingSearchableContentType>;
                  allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                  moduleName?: string | null;
                } | null;
                feedsModule?: {
                  __typename?: 'UiFeedsModule';
                  treatmentType: UiFeedsTreatmentType;
                  contentTypes: Array<PublicationSettingSearchableContentType>;
                  allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
                } | null;
              };
            } | null;
          };
          collection: Array<
            | {
                __typename?: 'ArticleItem';
                type: string;
                content?: string | null;
                attributes: {
                  __typename?: 'ArticleAttributes';
                  base_doc_id: string;
                  hosted_url: string;
                  id: string;
                  link: string;
                  originContentType?: string | null;
                  originId?: string | null;
                  product: string;
                  seo_id: string;
                  status: string;
                };
              }
            | {
                __typename?: 'ExternalCollectionItem';
                type: string;
                metadata: { __typename?: 'ExternalCollectionMetadata'; id: string; name: string; createdUtc: number };
                contentItems: Array<
                  | {
                      __typename?: 'ArticleItem';
                      type: string;
                      content?: string | null;
                      attributes: {
                        __typename?: 'ArticleAttributes';
                        base_doc_id: string;
                        hosted_url: string;
                        id: string;
                        link: string;
                        originContentType?: string | null;
                        originId?: string | null;
                        product: string;
                        seo_id: string;
                        status: string;
                      };
                    }
                  | { __typename?: 'ExternalCollectionItem' }
                  | { __typename?: 'LinkedItem' }
                  | { __typename?: 'MobileArticleItem' }
                  | {
                      __typename?: 'QueryItem';
                      type: string;
                      attributes: { __typename?: 'QueryAttributes'; query: Record<string, unknown> };
                    }
                >;
                attributes: { __typename?: 'ExternalCollectionAttributes'; id: string; repo: string };
              }
            | {
                __typename?: 'LinkedItem';
                type: string;
                attributes: {
                  __typename?: 'LinkedItemAttributes';
                  id: string;
                  product: string;
                  title: string;
                  description?: string | null;
                  hosted_url: string;
                  image?: {
                    __typename?: 'ImageAttributes';
                    id: string;
                    alternate_text: string;
                    credit: string;
                    height: number;
                    name: string;
                    reuse_type: string;
                    media_type: string;
                    width: number;
                    alt_images: Array<string>;
                    type: string;
                    src: {
                      __typename?: 'ImageSourceAttributes';
                      image_id: string;
                      base_url: string;
                      path: string;
                      params: { __typename?: 'ImageParams'; size: number };
                    };
                    properties: { __typename?: 'Properties'; imphotoid: string; location: string };
                  } | null;
                };
              }
            | {
                __typename?: 'MobileArticleItem';
                type: string;
                subtype?: string | null;
                content?: string | null;
                attributes: {
                  __typename?: 'MobileArticleAttributes';
                  base_doc_id: string;
                  hosted_url: string;
                  id: string;
                  link: string;
                  originContentType?: string | null;
                  originId?: string | null;
                  product: string;
                  seo_id: string;
                  status: string;
                  showImage: boolean;
                  showImageBelow: boolean;
                  showFlashline: boolean;
                };
              }
            | {
                __typename?: 'QueryItem';
                type: string;
                attributes: {
                  __typename?: 'QueryAttributes';
                  query: Record<string, unknown>;
                  isFeed?: boolean | null;
                  feedTitle?: string | null;
                  feedUrl?: string | null;
                };
              }
          >;
        }>;
      }>;
    };
  };
};

export type CreateWsjSectionFrontPageMutationVariables = Exact<{
  wsjSectionFrontInput: WsjSectionFrontCreateInput;
}>;

export type CreateWsjSectionFrontPageMutation = {
  __typename?: 'Mutation';
  createWSJSectionFrontPage: {
    __typename?: 'PageDTO';
    type: string;
    metadata: {
      __typename?: 'BaseMetadata';
      allessehId: string;
      createdUtc: number;
      name: string;
      publicationKey: string;
      publishUtc?: number | null;
      updatedUtc?: number | null;
      creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
      revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
    };
    root: {
      __typename?: 'SectionContainer';
      type: string;
      attributes: {
        __typename?: 'SectionAttributes';
        adPlacementType?: string | null;
        adZone?: string | null;
        isHidden: boolean;
        pageType: string;
        routeKey: string;
        sectionKey?: string | null;
        sectionLabel?: string | null;
        summaryPriority: string;
      };
      collection: Array<{
        __typename?: 'PageContainer';
        type: string;
        attributes: { __typename?: 'PageAttributes'; layoutId?: string | null };
        collection: Array<{
          __typename?: 'ModuleContainer';
          type: string;
          attributes: {
            __typename?: 'ModuleAttributes';
            moduleId?: string | null;
            pageModule?: {
              __typename?: 'PageModule';
              uiModuleType: UiModuleType;
              uiModuleFields: {
                __typename?: 'UiModule';
                basicModule?: {
                  __typename?: 'UiBasicModule';
                  treatmentType: UiBasicTreatmentType;
                  contentTypes: Array<PublicationSettingSearchableContentType>;
                  allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                } | null;
                titleModule?: {
                  __typename?: 'UiTitleModule';
                  treatmentType: UiTitleTreatmentType;
                  title?: string | null;
                  titleUrl?: string | null;
                  subtitle?: string | null;
                  subtitleUrl?: string | null;
                  allowedMeta?: Array<Metadata> | null;
                  contentTypes: Array<PublicationSettingSearchableContentType>;
                  allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
                } | null;
                rankedModule?: {
                  __typename?: 'UiRankedModule';
                  treatmentType: UiRankedTreatmentType;
                  title: string;
                  contentTypes: Array<PublicationSettingSearchableContentType>;
                  allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
                } | null;
                textModule?: {
                  __typename?: 'UiTextModule';
                  treatmentType: UiTextTreatmentType;
                  mainText: string;
                  secondaryText: string;
                  allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
                } | null;
                basicOptionalModule?: {
                  __typename?: 'UiBasicOptionalModule';
                  treatmentType: UiBasicOptionalTreatmentType;
                  contentTypes: Array<PublicationSettingSearchableContentType>;
                  allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                  moduleName?: string | null;
                } | null;
                feedsModule?: {
                  __typename?: 'UiFeedsModule';
                  treatmentType: UiFeedsTreatmentType;
                  contentTypes: Array<PublicationSettingSearchableContentType>;
                  allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
                } | null;
              };
            } | null;
          };
          collection: Array<
            | {
                __typename?: 'ArticleItem';
                type: string;
                content?: string | null;
                attributes: {
                  __typename?: 'ArticleAttributes';
                  base_doc_id: string;
                  hosted_url: string;
                  id: string;
                  link: string;
                  originContentType?: string | null;
                  originId?: string | null;
                  product: string;
                  seo_id: string;
                  status: string;
                };
              }
            | {
                __typename?: 'ExternalCollectionItem';
                type: string;
                metadata: { __typename?: 'ExternalCollectionMetadata'; id: string; name: string; createdUtc: number };
                contentItems: Array<
                  | {
                      __typename?: 'ArticleItem';
                      type: string;
                      content?: string | null;
                      attributes: {
                        __typename?: 'ArticleAttributes';
                        base_doc_id: string;
                        hosted_url: string;
                        id: string;
                        link: string;
                        originContentType?: string | null;
                        originId?: string | null;
                        product: string;
                        seo_id: string;
                        status: string;
                      };
                    }
                  | { __typename?: 'ExternalCollectionItem' }
                  | { __typename?: 'LinkedItem' }
                  | { __typename?: 'MobileArticleItem' }
                  | {
                      __typename?: 'QueryItem';
                      type: string;
                      attributes: { __typename?: 'QueryAttributes'; query: Record<string, unknown> };
                    }
                >;
                attributes: { __typename?: 'ExternalCollectionAttributes'; id: string; repo: string };
              }
            | {
                __typename?: 'LinkedItem';
                type: string;
                attributes: {
                  __typename?: 'LinkedItemAttributes';
                  id: string;
                  product: string;
                  title: string;
                  description?: string | null;
                  hosted_url: string;
                  image?: {
                    __typename?: 'ImageAttributes';
                    id: string;
                    alternate_text: string;
                    credit: string;
                    height: number;
                    name: string;
                    reuse_type: string;
                    media_type: string;
                    width: number;
                    alt_images: Array<string>;
                    type: string;
                    src: {
                      __typename?: 'ImageSourceAttributes';
                      image_id: string;
                      base_url: string;
                      path: string;
                      params: { __typename?: 'ImageParams'; size: number };
                    };
                    properties: { __typename?: 'Properties'; imphotoid: string; location: string };
                  } | null;
                };
              }
            | {
                __typename?: 'MobileArticleItem';
                type: string;
                subtype?: string | null;
                content?: string | null;
                attributes: {
                  __typename?: 'MobileArticleAttributes';
                  base_doc_id: string;
                  hosted_url: string;
                  id: string;
                  link: string;
                  originContentType?: string | null;
                  originId?: string | null;
                  product: string;
                  seo_id: string;
                  status: string;
                  showImage: boolean;
                  showImageBelow: boolean;
                  showFlashline: boolean;
                };
              }
            | {
                __typename?: 'QueryItem';
                type: string;
                attributes: {
                  __typename?: 'QueryAttributes';
                  query: Record<string, unknown>;
                  isFeed?: boolean | null;
                  feedTitle?: string | null;
                  feedUrl?: string | null;
                };
              }
          >;
        }>;
      }>;
    };
  };
};

export type PagesDtoQueryVariables = Exact<{
  pagesInput: PagesDtoInput;
  paginationParams: PaginationParams;
}>;

export type PagesDtoQuery = {
  __typename?: 'Query';
  pagesDTO: {
    __typename?: 'PageDTOConnection';
    edges: Array<{
      __typename?: 'PageDTOEdge';
      node: {
        __typename?: 'PageDTO';
        type: string;
        metadata: {
          __typename?: 'BaseMetadata';
          allessehId: string;
          createdUtc: number;
          name: string;
          publicationKey: string;
          publishUtc?: number | null;
          updatedUtc?: number | null;
          creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
          revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
        };
        root: {
          __typename?: 'SectionContainer';
          attributes: {
            __typename?: 'SectionAttributes';
            adPlacementType?: string | null;
            adZone?: string | null;
            isHidden: boolean;
            pageType: string;
            routeKey: string;
            summaryPriority: string;
          };
          collection: Array<{
            __typename?: 'PageContainer';
            attributes: { __typename?: 'PageAttributes'; layoutId?: string | null };
          }>;
        };
      };
    }>;
    pageInfo: { __typename?: 'PageInfo'; endCursor?: string | null; hasNextPage: boolean };
  };
};

export type PageDtoByAllessehIdQueryVariables = Exact<{
  allessehId: Scalars['String'];
  publicationKey: Scalars['String'];
}>;

export type PageDtoByAllessehIdQuery = {
  __typename?: 'Query';
  pageDTOByAllessehId: {
    __typename?: 'PageDTO';
    type: string;
    metadata: {
      __typename?: 'BaseMetadata';
      allessehId: string;
      createdUtc: number;
      name: string;
      publicationKey: string;
      publishUtc?: number | null;
      updatedUtc?: number | null;
      creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
      revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
    };
    root: {
      __typename?: 'SectionContainer';
      type: string;
      attributes: {
        __typename?: 'SectionAttributes';
        adPlacementType?: string | null;
        adZone?: string | null;
        isHidden: boolean;
        pageType: string;
        routeKey: string;
        sectionKey?: string | null;
        sectionLabel?: string | null;
        summaryPriority: string;
      };
      collection: Array<{
        __typename?: 'PageContainer';
        type: string;
        attributes: { __typename?: 'PageAttributes'; layoutId?: string | null };
        collection: Array<{
          __typename?: 'ModuleContainer';
          type: string;
          attributes: {
            __typename?: 'ModuleAttributes';
            moduleId?: string | null;
            pageModule?: {
              __typename?: 'PageModule';
              uiModuleType: UiModuleType;
              uiModuleFields: {
                __typename?: 'UiModule';
                basicModule?: {
                  __typename?: 'UiBasicModule';
                  treatmentType: UiBasicTreatmentType;
                  contentTypes: Array<PublicationSettingSearchableContentType>;
                  allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                } | null;
                titleModule?: {
                  __typename?: 'UiTitleModule';
                  treatmentType: UiTitleTreatmentType;
                  title?: string | null;
                  titleUrl?: string | null;
                  subtitle?: string | null;
                  subtitleUrl?: string | null;
                  allowedMeta?: Array<Metadata> | null;
                  contentTypes: Array<PublicationSettingSearchableContentType>;
                  allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
                } | null;
                rankedModule?: {
                  __typename?: 'UiRankedModule';
                  treatmentType: UiRankedTreatmentType;
                  title: string;
                  contentTypes: Array<PublicationSettingSearchableContentType>;
                  allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
                } | null;
                textModule?: {
                  __typename?: 'UiTextModule';
                  treatmentType: UiTextTreatmentType;
                  mainText: string;
                  secondaryText: string;
                  allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
                } | null;
                basicOptionalModule?: {
                  __typename?: 'UiBasicOptionalModule';
                  treatmentType: UiBasicOptionalTreatmentType;
                  contentTypes: Array<PublicationSettingSearchableContentType>;
                  allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                  moduleName?: string | null;
                } | null;
                feedsModule?: {
                  __typename?: 'UiFeedsModule';
                  treatmentType: UiFeedsTreatmentType;
                  contentTypes: Array<PublicationSettingSearchableContentType>;
                  allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
                } | null;
              };
            } | null;
          };
          collection: Array<
            | {
                __typename?: 'ArticleItem';
                type: string;
                content?: string | null;
                attributes: {
                  __typename?: 'ArticleAttributes';
                  base_doc_id: string;
                  hosted_url: string;
                  id: string;
                  link: string;
                  originContentType?: string | null;
                  originId?: string | null;
                  product: string;
                  seo_id: string;
                  status: string;
                };
              }
            | {
                __typename?: 'ExternalCollectionItem';
                type: string;
                metadata: { __typename?: 'ExternalCollectionMetadata'; id: string; name: string; createdUtc: number };
                contentItems: Array<
                  | {
                      __typename?: 'ArticleItem';
                      type: string;
                      content?: string | null;
                      attributes: {
                        __typename?: 'ArticleAttributes';
                        base_doc_id: string;
                        hosted_url: string;
                        id: string;
                        link: string;
                        originContentType?: string | null;
                        originId?: string | null;
                        product: string;
                        seo_id: string;
                        status: string;
                      };
                    }
                  | { __typename?: 'ExternalCollectionItem' }
                  | { __typename?: 'LinkedItem' }
                  | { __typename?: 'MobileArticleItem' }
                  | {
                      __typename?: 'QueryItem';
                      type: string;
                      attributes: { __typename?: 'QueryAttributes'; query: Record<string, unknown> };
                    }
                >;
                attributes: { __typename?: 'ExternalCollectionAttributes'; id: string; repo: string };
              }
            | {
                __typename?: 'LinkedItem';
                type: string;
                attributes: {
                  __typename?: 'LinkedItemAttributes';
                  id: string;
                  product: string;
                  title: string;
                  description?: string | null;
                  hosted_url: string;
                  image?: {
                    __typename?: 'ImageAttributes';
                    id: string;
                    alternate_text: string;
                    credit: string;
                    height: number;
                    name: string;
                    reuse_type: string;
                    media_type: string;
                    width: number;
                    alt_images: Array<string>;
                    type: string;
                    src: {
                      __typename?: 'ImageSourceAttributes';
                      image_id: string;
                      base_url: string;
                      path: string;
                      params: { __typename?: 'ImageParams'; size: number };
                    };
                    properties: { __typename?: 'Properties'; imphotoid: string; location: string };
                  } | null;
                };
              }
            | {
                __typename?: 'MobileArticleItem';
                type: string;
                subtype?: string | null;
                content?: string | null;
                attributes: {
                  __typename?: 'MobileArticleAttributes';
                  base_doc_id: string;
                  hosted_url: string;
                  id: string;
                  link: string;
                  originContentType?: string | null;
                  originId?: string | null;
                  product: string;
                  seo_id: string;
                  status: string;
                  showImage: boolean;
                  showImageBelow: boolean;
                  showFlashline: boolean;
                };
              }
            | {
                __typename?: 'QueryItem';
                type: string;
                attributes: {
                  __typename?: 'QueryAttributes';
                  query: Record<string, unknown>;
                  isFeed?: boolean | null;
                  feedTitle?: string | null;
                  feedUrl?: string | null;
                };
              }
          >;
        }>;
      }>;
    };
  };
};

export type PagesDtoForCollectionIdQueryVariables = Exact<{
  publicationKey: Scalars['String'];
  collectionId: Scalars['String'];
}>;

export type PagesDtoForCollectionIdQuery = {
  __typename?: 'Query';
  pagesDTOForCollectionId: Array<{
    __typename?: 'PagesDTOForCollection';
    numRevisions: number;
    latestPage: {
      __typename?: 'PageDTO';
      metadata: { __typename?: 'BaseMetadata'; allessehId: string; name: string; publishUtc?: number | null };
    };
  }>;
};

export type IsPreviewDraftPageQueryVariables = Exact<{
  allessehId: Scalars['String'];
}>;

export type IsPreviewDraftPageQuery = { __typename?: 'Query'; isPreviewDraftPage: boolean };

export type BasicModuleFragmentFragment = {
  __typename?: 'UiBasicModule';
  treatmentType: UiBasicTreatmentType;
  contentTypes: Array<PublicationSettingSearchableContentType>;
  allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
};

export type BasicOptionalModuleFragmentFragment = {
  __typename?: 'UiBasicOptionalModule';
  treatmentType: UiBasicOptionalTreatmentType;
  contentTypes: Array<PublicationSettingSearchableContentType>;
  allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
  moduleName?: string | null;
};

export type FeedsModuleFragmentFragment = {
  __typename?: 'UiFeedsModule';
  treatmentType: UiFeedsTreatmentType;
  contentTypes: Array<PublicationSettingSearchableContentType>;
  allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
};

export type RankedModuleFragmentFragment = {
  __typename?: 'UiRankedModule';
  treatmentType: UiRankedTreatmentType;
  title: string;
  contentTypes: Array<PublicationSettingSearchableContentType>;
  allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
};

export type TextModuleFragmentFragment = {
  __typename?: 'UiTextModule';
  treatmentType: UiTextTreatmentType;
  mainText: string;
  secondaryText: string;
  allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
};

export type TitleModuleFragmentFragment = {
  __typename?: 'UiTitleModule';
  treatmentType: UiTitleTreatmentType;
  title?: string | null;
  titleUrl?: string | null;
  subtitle?: string | null;
  subtitleUrl?: string | null;
  allowedMeta?: Array<Metadata> | null;
  contentTypes: Array<PublicationSettingSearchableContentType>;
  allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
};

export type TwoColumnModuleFragmentFragment = {
  __typename?: 'UiTwoColumnModule';
  treatmentType: UiTwoColumnTreatmentType;
  leftModules: Array<{
    __typename?: 'PageModule';
    uiModuleType: UiModuleType;
    uiModuleFields: {
      __typename?: 'UiModule';
      basicModule?: {
        __typename?: 'UiBasicModule';
        treatmentType: UiBasicTreatmentType;
        contentTypes: Array<PublicationSettingSearchableContentType>;
        allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
      } | null;
      titleModule?: {
        __typename?: 'UiTitleModule';
        treatmentType: UiTitleTreatmentType;
        title?: string | null;
        titleUrl?: string | null;
        subtitle?: string | null;
        subtitleUrl?: string | null;
        allowedMeta?: Array<Metadata> | null;
        contentTypes: Array<PublicationSettingSearchableContentType>;
        allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
      } | null;
      rankedModule?: {
        __typename?: 'UiRankedModule';
        treatmentType: UiRankedTreatmentType;
        title: string;
        contentTypes: Array<PublicationSettingSearchableContentType>;
        allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
      } | null;
      textModule?: {
        __typename?: 'UiTextModule';
        treatmentType: UiTextTreatmentType;
        mainText: string;
        secondaryText: string;
        allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
      } | null;
      basicOptionalModule?: {
        __typename?: 'UiBasicOptionalModule';
        treatmentType: UiBasicOptionalTreatmentType;
        contentTypes: Array<PublicationSettingSearchableContentType>;
        allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
        moduleName?: string | null;
      } | null;
      feedsModule?: {
        __typename?: 'UiFeedsModule';
        treatmentType: UiFeedsTreatmentType;
        contentTypes: Array<PublicationSettingSearchableContentType>;
        allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
      } | null;
    };
    moduleItems: Array<{
      __typename?: 'PageModuleItem';
      itemType: PageModuleItemType;
      itemFields: {
        __typename?: 'PageModuleItemFields';
        contentItem?: {
          __typename?: 'PageModuleItemContent';
          originId: string;
          originContentType: string;
          content?: string | null;
        } | null;
        queryItem?: {
          __typename?: 'PageModuleItemQuery';
          jsonQuery: string;
          isFeed?: boolean | null;
          title?: string | null;
          url?: string | null;
        } | null;
        collectionItem?: {
          __typename?: 'PageModuleItemCollection';
          idCreatedUtc: string;
          collection?: {
            __typename?: 'Collection';
            allessehCollectionId: string;
            idCreatedUtc: string;
            id: string;
            createdUtc: number;
            updatedUtc?: number | null;
            name: string;
            isArchived: boolean;
            allessehJsonQuery?: string | null;
            contentItems: Array<{
              __typename?: 'CollectionContentItem';
              originId: string;
              originContentType: string;
              content?: string | null;
            }>;
          } | null;
        } | null;
        allessehCollectionItem?: {
          __typename?: 'PageModuleItemAllessehCollection';
          allessehCollectionId: string;
        } | null;
        linkedItem?: {
          __typename?: 'PageModuleItemLinkedItem';
          headline: string;
          summary?: string | null;
          url: string;
          media?: string | null;
        } | null;
      };
    }>;
  }>;
  rightModules: Array<{
    __typename?: 'PageModule';
    uiModuleType: UiModuleType;
    uiModuleFields: {
      __typename?: 'UiModule';
      basicModule?: {
        __typename?: 'UiBasicModule';
        treatmentType: UiBasicTreatmentType;
        contentTypes: Array<PublicationSettingSearchableContentType>;
        allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
      } | null;
      titleModule?: {
        __typename?: 'UiTitleModule';
        treatmentType: UiTitleTreatmentType;
        title?: string | null;
        titleUrl?: string | null;
        subtitle?: string | null;
        subtitleUrl?: string | null;
        allowedMeta?: Array<Metadata> | null;
        contentTypes: Array<PublicationSettingSearchableContentType>;
        allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
      } | null;
      rankedModule?: {
        __typename?: 'UiRankedModule';
        treatmentType: UiRankedTreatmentType;
        title: string;
        contentTypes: Array<PublicationSettingSearchableContentType>;
        allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
      } | null;
      textModule?: {
        __typename?: 'UiTextModule';
        treatmentType: UiTextTreatmentType;
        mainText: string;
        secondaryText: string;
        allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
      } | null;
      basicOptionalModule?: {
        __typename?: 'UiBasicOptionalModule';
        treatmentType: UiBasicOptionalTreatmentType;
        contentTypes: Array<PublicationSettingSearchableContentType>;
        allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
        moduleName?: string | null;
      } | null;
      feedsModule?: {
        __typename?: 'UiFeedsModule';
        treatmentType: UiFeedsTreatmentType;
        contentTypes: Array<PublicationSettingSearchableContentType>;
        allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
      } | null;
    };
    moduleItems: Array<{
      __typename?: 'PageModuleItem';
      itemType: PageModuleItemType;
      itemFields: {
        __typename?: 'PageModuleItemFields';
        contentItem?: {
          __typename?: 'PageModuleItemContent';
          originId: string;
          originContentType: string;
          content?: string | null;
        } | null;
        queryItem?: {
          __typename?: 'PageModuleItemQuery';
          jsonQuery: string;
          isFeed?: boolean | null;
          title?: string | null;
          url?: string | null;
        } | null;
        collectionItem?: {
          __typename?: 'PageModuleItemCollection';
          idCreatedUtc: string;
          collection?: {
            __typename?: 'Collection';
            allessehCollectionId: string;
            idCreatedUtc: string;
            id: string;
            createdUtc: number;
            updatedUtc?: number | null;
            name: string;
            isArchived: boolean;
            allessehJsonQuery?: string | null;
            contentItems: Array<{
              __typename?: 'CollectionContentItem';
              originId: string;
              originContentType: string;
              content?: string | null;
            }>;
          } | null;
        } | null;
        allessehCollectionItem?: {
          __typename?: 'PageModuleItemAllessehCollection';
          allessehCollectionId: string;
        } | null;
        linkedItem?: {
          __typename?: 'PageModuleItemLinkedItem';
          headline: string;
          summary?: string | null;
          url: string;
          media?: string | null;
        } | null;
      };
    }>;
  }>;
};

export type PageModuleSubFieldsFragmentFragment = {
  __typename?: 'PageModule';
  uiModuleType: UiModuleType;
  moduleItems: Array<{
    __typename?: 'PageModuleItem';
    itemType: PageModuleItemType;
    itemFields: {
      __typename?: 'PageModuleItemFields';
      contentItem?: {
        __typename?: 'PageModuleItemContent';
        originId: string;
        originContentType: string;
        content?: string | null;
      } | null;
      queryItem?: {
        __typename?: 'PageModuleItemQuery';
        jsonQuery: string;
        isFeed?: boolean | null;
        title?: string | null;
        url?: string | null;
      } | null;
      collectionItem?: {
        __typename?: 'PageModuleItemCollection';
        idCreatedUtc: string;
        collection?: {
          __typename?: 'Collection';
          allessehCollectionId: string;
          idCreatedUtc: string;
          id: string;
          createdUtc: number;
          updatedUtc?: number | null;
          name: string;
          isArchived: boolean;
          allessehJsonQuery?: string | null;
          contentItems: Array<{
            __typename?: 'CollectionContentItem';
            originId: string;
            originContentType: string;
            content?: string | null;
          }>;
        } | null;
      } | null;
      allessehCollectionItem?: { __typename?: 'PageModuleItemAllessehCollection'; allessehCollectionId: string } | null;
      linkedItem?: {
        __typename?: 'PageModuleItemLinkedItem';
        headline: string;
        summary?: string | null;
        url: string;
        media?: string | null;
      } | null;
    };
  }>;
};

export type PageModuleUiModuleFieldsFragmentFragment = {
  __typename?: 'UiModule';
  basicModule?: {
    __typename?: 'UiBasicModule';
    treatmentType: UiBasicTreatmentType;
    contentTypes: Array<PublicationSettingSearchableContentType>;
    allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
  } | null;
  titleModule?: {
    __typename?: 'UiTitleModule';
    treatmentType: UiTitleTreatmentType;
    title?: string | null;
    titleUrl?: string | null;
    subtitle?: string | null;
    subtitleUrl?: string | null;
    allowedMeta?: Array<Metadata> | null;
    contentTypes: Array<PublicationSettingSearchableContentType>;
    allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
  } | null;
  rankedModule?: {
    __typename?: 'UiRankedModule';
    treatmentType: UiRankedTreatmentType;
    title: string;
    contentTypes: Array<PublicationSettingSearchableContentType>;
    allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
  } | null;
  textModule?: {
    __typename?: 'UiTextModule';
    treatmentType: UiTextTreatmentType;
    mainText: string;
    secondaryText: string;
    allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
  } | null;
  basicOptionalModule?: {
    __typename?: 'UiBasicOptionalModule';
    treatmentType: UiBasicOptionalTreatmentType;
    contentTypes: Array<PublicationSettingSearchableContentType>;
    allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
    moduleName?: string | null;
  } | null;
  feedsModule?: {
    __typename?: 'UiFeedsModule';
    treatmentType: UiFeedsTreatmentType;
    contentTypes: Array<PublicationSettingSearchableContentType>;
    allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
  } | null;
};

export type PageModuleFragmentFragment = {
  __typename?: 'PageModule';
  uiModuleType: UiModuleType;
  uiModuleFields: {
    __typename?: 'UiModule';
    twoColumnModule?: {
      __typename?: 'UiTwoColumnModule';
      treatmentType: UiTwoColumnTreatmentType;
      leftModules: Array<{
        __typename?: 'PageModule';
        uiModuleType: UiModuleType;
        uiModuleFields: {
          __typename?: 'UiModule';
          basicModule?: {
            __typename?: 'UiBasicModule';
            treatmentType: UiBasicTreatmentType;
            contentTypes: Array<PublicationSettingSearchableContentType>;
            allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
          } | null;
          titleModule?: {
            __typename?: 'UiTitleModule';
            treatmentType: UiTitleTreatmentType;
            title?: string | null;
            titleUrl?: string | null;
            subtitle?: string | null;
            subtitleUrl?: string | null;
            allowedMeta?: Array<Metadata> | null;
            contentTypes: Array<PublicationSettingSearchableContentType>;
            allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
          } | null;
          rankedModule?: {
            __typename?: 'UiRankedModule';
            treatmentType: UiRankedTreatmentType;
            title: string;
            contentTypes: Array<PublicationSettingSearchableContentType>;
            allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
          } | null;
          textModule?: {
            __typename?: 'UiTextModule';
            treatmentType: UiTextTreatmentType;
            mainText: string;
            secondaryText: string;
            allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
          } | null;
          basicOptionalModule?: {
            __typename?: 'UiBasicOptionalModule';
            treatmentType: UiBasicOptionalTreatmentType;
            contentTypes: Array<PublicationSettingSearchableContentType>;
            allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
            moduleName?: string | null;
          } | null;
          feedsModule?: {
            __typename?: 'UiFeedsModule';
            treatmentType: UiFeedsTreatmentType;
            contentTypes: Array<PublicationSettingSearchableContentType>;
            allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
          } | null;
        };
        moduleItems: Array<{
          __typename?: 'PageModuleItem';
          itemType: PageModuleItemType;
          itemFields: {
            __typename?: 'PageModuleItemFields';
            contentItem?: {
              __typename?: 'PageModuleItemContent';
              originId: string;
              originContentType: string;
              content?: string | null;
            } | null;
            queryItem?: {
              __typename?: 'PageModuleItemQuery';
              jsonQuery: string;
              isFeed?: boolean | null;
              title?: string | null;
              url?: string | null;
            } | null;
            collectionItem?: {
              __typename?: 'PageModuleItemCollection';
              idCreatedUtc: string;
              collection?: {
                __typename?: 'Collection';
                allessehCollectionId: string;
                idCreatedUtc: string;
                id: string;
                createdUtc: number;
                updatedUtc?: number | null;
                name: string;
                isArchived: boolean;
                allessehJsonQuery?: string | null;
                contentItems: Array<{
                  __typename?: 'CollectionContentItem';
                  originId: string;
                  originContentType: string;
                  content?: string | null;
                }>;
              } | null;
            } | null;
            allessehCollectionItem?: {
              __typename?: 'PageModuleItemAllessehCollection';
              allessehCollectionId: string;
            } | null;
            linkedItem?: {
              __typename?: 'PageModuleItemLinkedItem';
              headline: string;
              summary?: string | null;
              url: string;
              media?: string | null;
            } | null;
          };
        }>;
      }>;
      rightModules: Array<{
        __typename?: 'PageModule';
        uiModuleType: UiModuleType;
        uiModuleFields: {
          __typename?: 'UiModule';
          basicModule?: {
            __typename?: 'UiBasicModule';
            treatmentType: UiBasicTreatmentType;
            contentTypes: Array<PublicationSettingSearchableContentType>;
            allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
          } | null;
          titleModule?: {
            __typename?: 'UiTitleModule';
            treatmentType: UiTitleTreatmentType;
            title?: string | null;
            titleUrl?: string | null;
            subtitle?: string | null;
            subtitleUrl?: string | null;
            allowedMeta?: Array<Metadata> | null;
            contentTypes: Array<PublicationSettingSearchableContentType>;
            allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
          } | null;
          rankedModule?: {
            __typename?: 'UiRankedModule';
            treatmentType: UiRankedTreatmentType;
            title: string;
            contentTypes: Array<PublicationSettingSearchableContentType>;
            allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
          } | null;
          textModule?: {
            __typename?: 'UiTextModule';
            treatmentType: UiTextTreatmentType;
            mainText: string;
            secondaryText: string;
            allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
          } | null;
          basicOptionalModule?: {
            __typename?: 'UiBasicOptionalModule';
            treatmentType: UiBasicOptionalTreatmentType;
            contentTypes: Array<PublicationSettingSearchableContentType>;
            allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
            moduleName?: string | null;
          } | null;
          feedsModule?: {
            __typename?: 'UiFeedsModule';
            treatmentType: UiFeedsTreatmentType;
            contentTypes: Array<PublicationSettingSearchableContentType>;
            allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
          } | null;
        };
        moduleItems: Array<{
          __typename?: 'PageModuleItem';
          itemType: PageModuleItemType;
          itemFields: {
            __typename?: 'PageModuleItemFields';
            contentItem?: {
              __typename?: 'PageModuleItemContent';
              originId: string;
              originContentType: string;
              content?: string | null;
            } | null;
            queryItem?: {
              __typename?: 'PageModuleItemQuery';
              jsonQuery: string;
              isFeed?: boolean | null;
              title?: string | null;
              url?: string | null;
            } | null;
            collectionItem?: {
              __typename?: 'PageModuleItemCollection';
              idCreatedUtc: string;
              collection?: {
                __typename?: 'Collection';
                allessehCollectionId: string;
                idCreatedUtc: string;
                id: string;
                createdUtc: number;
                updatedUtc?: number | null;
                name: string;
                isArchived: boolean;
                allessehJsonQuery?: string | null;
                contentItems: Array<{
                  __typename?: 'CollectionContentItem';
                  originId: string;
                  originContentType: string;
                  content?: string | null;
                }>;
              } | null;
            } | null;
            allessehCollectionItem?: {
              __typename?: 'PageModuleItemAllessehCollection';
              allessehCollectionId: string;
            } | null;
            linkedItem?: {
              __typename?: 'PageModuleItemLinkedItem';
              headline: string;
              summary?: string | null;
              url: string;
              media?: string | null;
            } | null;
          };
        }>;
      }>;
    } | null;
    basicModule?: {
      __typename?: 'UiBasicModule';
      treatmentType: UiBasicTreatmentType;
      contentTypes: Array<PublicationSettingSearchableContentType>;
      allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
    } | null;
    titleModule?: {
      __typename?: 'UiTitleModule';
      treatmentType: UiTitleTreatmentType;
      title?: string | null;
      titleUrl?: string | null;
      subtitle?: string | null;
      subtitleUrl?: string | null;
      allowedMeta?: Array<Metadata> | null;
      contentTypes: Array<PublicationSettingSearchableContentType>;
      allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
    } | null;
    rankedModule?: {
      __typename?: 'UiRankedModule';
      treatmentType: UiRankedTreatmentType;
      title: string;
      contentTypes: Array<PublicationSettingSearchableContentType>;
      allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
    } | null;
    textModule?: {
      __typename?: 'UiTextModule';
      treatmentType: UiTextTreatmentType;
      mainText: string;
      secondaryText: string;
      allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
    } | null;
    basicOptionalModule?: {
      __typename?: 'UiBasicOptionalModule';
      treatmentType: UiBasicOptionalTreatmentType;
      contentTypes: Array<PublicationSettingSearchableContentType>;
      allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
      moduleName?: string | null;
    } | null;
    feedsModule?: {
      __typename?: 'UiFeedsModule';
      treatmentType: UiFeedsTreatmentType;
      contentTypes: Array<PublicationSettingSearchableContentType>;
      allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
    } | null;
  };
  moduleItems: Array<{
    __typename?: 'PageModuleItem';
    itemType: PageModuleItemType;
    itemFields: {
      __typename?: 'PageModuleItemFields';
      contentItem?: {
        __typename?: 'PageModuleItemContent';
        originId: string;
        originContentType: string;
        content?: string | null;
      } | null;
      queryItem?: {
        __typename?: 'PageModuleItemQuery';
        jsonQuery: string;
        isFeed?: boolean | null;
        title?: string | null;
        url?: string | null;
      } | null;
      collectionItem?: {
        __typename?: 'PageModuleItemCollection';
        idCreatedUtc: string;
        collection?: {
          __typename?: 'Collection';
          allessehCollectionId: string;
          idCreatedUtc: string;
          id: string;
          createdUtc: number;
          updatedUtc?: number | null;
          name: string;
          isArchived: boolean;
          allessehJsonQuery?: string | null;
          contentItems: Array<{
            __typename?: 'CollectionContentItem';
            originId: string;
            originContentType: string;
            content?: string | null;
          }>;
        } | null;
      } | null;
      allessehCollectionItem?: { __typename?: 'PageModuleItemAllessehCollection'; allessehCollectionId: string } | null;
      linkedItem?: {
        __typename?: 'PageModuleItemLinkedItem';
        headline: string;
        summary?: string | null;
        url: string;
        media?: string | null;
      } | null;
    };
  }>;
};

export type PageModuleFragmentRecursiveFragment = {
  __typename?: 'PageModule';
  uiModuleType: UiModuleType;
  uiModuleFields: {
    __typename?: 'UiModule';
    basicModule?: {
      __typename?: 'UiBasicModule';
      treatmentType: UiBasicTreatmentType;
      contentTypes: Array<PublicationSettingSearchableContentType>;
      allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
    } | null;
    titleModule?: {
      __typename?: 'UiTitleModule';
      treatmentType: UiTitleTreatmentType;
      title?: string | null;
      titleUrl?: string | null;
      subtitle?: string | null;
      subtitleUrl?: string | null;
      allowedMeta?: Array<Metadata> | null;
      contentTypes: Array<PublicationSettingSearchableContentType>;
      allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
    } | null;
    rankedModule?: {
      __typename?: 'UiRankedModule';
      treatmentType: UiRankedTreatmentType;
      title: string;
      contentTypes: Array<PublicationSettingSearchableContentType>;
      allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
    } | null;
    textModule?: {
      __typename?: 'UiTextModule';
      treatmentType: UiTextTreatmentType;
      mainText: string;
      secondaryText: string;
      allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
    } | null;
    basicOptionalModule?: {
      __typename?: 'UiBasicOptionalModule';
      treatmentType: UiBasicOptionalTreatmentType;
      contentTypes: Array<PublicationSettingSearchableContentType>;
      allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
      moduleName?: string | null;
    } | null;
    feedsModule?: {
      __typename?: 'UiFeedsModule';
      treatmentType: UiFeedsTreatmentType;
      contentTypes: Array<PublicationSettingSearchableContentType>;
      allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
    } | null;
  };
  moduleItems: Array<{
    __typename?: 'PageModuleItem';
    itemType: PageModuleItemType;
    itemFields: {
      __typename?: 'PageModuleItemFields';
      contentItem?: {
        __typename?: 'PageModuleItemContent';
        originId: string;
        originContentType: string;
        content?: string | null;
      } | null;
      queryItem?: {
        __typename?: 'PageModuleItemQuery';
        jsonQuery: string;
        isFeed?: boolean | null;
        title?: string | null;
        url?: string | null;
      } | null;
      collectionItem?: {
        __typename?: 'PageModuleItemCollection';
        idCreatedUtc: string;
        collection?: {
          __typename?: 'Collection';
          allessehCollectionId: string;
          idCreatedUtc: string;
          id: string;
          createdUtc: number;
          updatedUtc?: number | null;
          name: string;
          isArchived: boolean;
          allessehJsonQuery?: string | null;
          contentItems: Array<{
            __typename?: 'CollectionContentItem';
            originId: string;
            originContentType: string;
            content?: string | null;
          }>;
        } | null;
      } | null;
      allessehCollectionItem?: { __typename?: 'PageModuleItemAllessehCollection'; allessehCollectionId: string } | null;
      linkedItem?: {
        __typename?: 'PageModuleItemLinkedItem';
        headline: string;
        summary?: string | null;
        url: string;
        media?: string | null;
      } | null;
    };
  }>;
};

export type PageTypeSettingByPublicationKeyPageTypeQueryVariables = Exact<{
  publicationKey: Scalars['String'];
  pageType: PageType;
}>;

export type PageTypeSettingByPublicationKeyPageTypeQuery = {
  __typename?: 'Query';
  pageTypeSettingByPublicationKeyPageType: {
    __typename?: 'PageTypeSetting';
    contentTypes: Array<PublicationSettingSearchableContentType>;
    layouts: Array<{
      __typename?: 'Layout';
      id: string;
      name: string;
      deprecated?: boolean | null;
      availableTreatmentTypes?: Array<string> | null;
      requiredLayoutModules: Array<{
        __typename?: 'PageModule';
        uiModuleType: UiModuleType;
        uiModuleFields: {
          __typename?: 'UiModule';
          twoColumnModule?: {
            __typename?: 'UiTwoColumnModule';
            treatmentType: UiTwoColumnTreatmentType;
            leftModules: Array<{
              __typename?: 'PageModule';
              uiModuleType: UiModuleType;
              uiModuleFields: {
                __typename?: 'UiModule';
                basicModule?: {
                  __typename?: 'UiBasicModule';
                  treatmentType: UiBasicTreatmentType;
                  contentTypes: Array<PublicationSettingSearchableContentType>;
                  allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                } | null;
                titleModule?: {
                  __typename?: 'UiTitleModule';
                  treatmentType: UiTitleTreatmentType;
                  title?: string | null;
                  titleUrl?: string | null;
                  subtitle?: string | null;
                  subtitleUrl?: string | null;
                  allowedMeta?: Array<Metadata> | null;
                  contentTypes: Array<PublicationSettingSearchableContentType>;
                  allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
                } | null;
                rankedModule?: {
                  __typename?: 'UiRankedModule';
                  treatmentType: UiRankedTreatmentType;
                  title: string;
                  contentTypes: Array<PublicationSettingSearchableContentType>;
                  allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
                } | null;
                textModule?: {
                  __typename?: 'UiTextModule';
                  treatmentType: UiTextTreatmentType;
                  mainText: string;
                  secondaryText: string;
                  allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
                } | null;
                basicOptionalModule?: {
                  __typename?: 'UiBasicOptionalModule';
                  treatmentType: UiBasicOptionalTreatmentType;
                  contentTypes: Array<PublicationSettingSearchableContentType>;
                  allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                  moduleName?: string | null;
                } | null;
                feedsModule?: {
                  __typename?: 'UiFeedsModule';
                  treatmentType: UiFeedsTreatmentType;
                  contentTypes: Array<PublicationSettingSearchableContentType>;
                  allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
                } | null;
              };
              moduleItems: Array<{
                __typename?: 'PageModuleItem';
                itemType: PageModuleItemType;
                itemFields: {
                  __typename?: 'PageModuleItemFields';
                  contentItem?: {
                    __typename?: 'PageModuleItemContent';
                    originId: string;
                    originContentType: string;
                    content?: string | null;
                  } | null;
                  queryItem?: {
                    __typename?: 'PageModuleItemQuery';
                    jsonQuery: string;
                    isFeed?: boolean | null;
                    title?: string | null;
                    url?: string | null;
                  } | null;
                  collectionItem?: {
                    __typename?: 'PageModuleItemCollection';
                    idCreatedUtc: string;
                    collection?: {
                      __typename?: 'Collection';
                      allessehCollectionId: string;
                      idCreatedUtc: string;
                      id: string;
                      createdUtc: number;
                      updatedUtc?: number | null;
                      name: string;
                      isArchived: boolean;
                      allessehJsonQuery?: string | null;
                      contentItems: Array<{
                        __typename?: 'CollectionContentItem';
                        originId: string;
                        originContentType: string;
                        content?: string | null;
                      }>;
                    } | null;
                  } | null;
                  allessehCollectionItem?: {
                    __typename?: 'PageModuleItemAllessehCollection';
                    allessehCollectionId: string;
                  } | null;
                  linkedItem?: {
                    __typename?: 'PageModuleItemLinkedItem';
                    headline: string;
                    summary?: string | null;
                    url: string;
                    media?: string | null;
                  } | null;
                };
              }>;
            }>;
            rightModules: Array<{
              __typename?: 'PageModule';
              uiModuleType: UiModuleType;
              uiModuleFields: {
                __typename?: 'UiModule';
                basicModule?: {
                  __typename?: 'UiBasicModule';
                  treatmentType: UiBasicTreatmentType;
                  contentTypes: Array<PublicationSettingSearchableContentType>;
                  allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                } | null;
                titleModule?: {
                  __typename?: 'UiTitleModule';
                  treatmentType: UiTitleTreatmentType;
                  title?: string | null;
                  titleUrl?: string | null;
                  subtitle?: string | null;
                  subtitleUrl?: string | null;
                  allowedMeta?: Array<Metadata> | null;
                  contentTypes: Array<PublicationSettingSearchableContentType>;
                  allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
                } | null;
                rankedModule?: {
                  __typename?: 'UiRankedModule';
                  treatmentType: UiRankedTreatmentType;
                  title: string;
                  contentTypes: Array<PublicationSettingSearchableContentType>;
                  allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
                } | null;
                textModule?: {
                  __typename?: 'UiTextModule';
                  treatmentType: UiTextTreatmentType;
                  mainText: string;
                  secondaryText: string;
                  allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
                } | null;
                basicOptionalModule?: {
                  __typename?: 'UiBasicOptionalModule';
                  treatmentType: UiBasicOptionalTreatmentType;
                  contentTypes: Array<PublicationSettingSearchableContentType>;
                  allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                  moduleName?: string | null;
                } | null;
                feedsModule?: {
                  __typename?: 'UiFeedsModule';
                  treatmentType: UiFeedsTreatmentType;
                  contentTypes: Array<PublicationSettingSearchableContentType>;
                  allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
                } | null;
              };
              moduleItems: Array<{
                __typename?: 'PageModuleItem';
                itemType: PageModuleItemType;
                itemFields: {
                  __typename?: 'PageModuleItemFields';
                  contentItem?: {
                    __typename?: 'PageModuleItemContent';
                    originId: string;
                    originContentType: string;
                    content?: string | null;
                  } | null;
                  queryItem?: {
                    __typename?: 'PageModuleItemQuery';
                    jsonQuery: string;
                    isFeed?: boolean | null;
                    title?: string | null;
                    url?: string | null;
                  } | null;
                  collectionItem?: {
                    __typename?: 'PageModuleItemCollection';
                    idCreatedUtc: string;
                    collection?: {
                      __typename?: 'Collection';
                      allessehCollectionId: string;
                      idCreatedUtc: string;
                      id: string;
                      createdUtc: number;
                      updatedUtc?: number | null;
                      name: string;
                      isArchived: boolean;
                      allessehJsonQuery?: string | null;
                      contentItems: Array<{
                        __typename?: 'CollectionContentItem';
                        originId: string;
                        originContentType: string;
                        content?: string | null;
                      }>;
                    } | null;
                  } | null;
                  allessehCollectionItem?: {
                    __typename?: 'PageModuleItemAllessehCollection';
                    allessehCollectionId: string;
                  } | null;
                  linkedItem?: {
                    __typename?: 'PageModuleItemLinkedItem';
                    headline: string;
                    summary?: string | null;
                    url: string;
                    media?: string | null;
                  } | null;
                };
              }>;
            }>;
          } | null;
          basicModule?: {
            __typename?: 'UiBasicModule';
            treatmentType: UiBasicTreatmentType;
            contentTypes: Array<PublicationSettingSearchableContentType>;
            allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
          } | null;
          titleModule?: {
            __typename?: 'UiTitleModule';
            treatmentType: UiTitleTreatmentType;
            title?: string | null;
            titleUrl?: string | null;
            subtitle?: string | null;
            subtitleUrl?: string | null;
            allowedMeta?: Array<Metadata> | null;
            contentTypes: Array<PublicationSettingSearchableContentType>;
            allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
          } | null;
          rankedModule?: {
            __typename?: 'UiRankedModule';
            treatmentType: UiRankedTreatmentType;
            title: string;
            contentTypes: Array<PublicationSettingSearchableContentType>;
            allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
          } | null;
          textModule?: {
            __typename?: 'UiTextModule';
            treatmentType: UiTextTreatmentType;
            mainText: string;
            secondaryText: string;
            allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
          } | null;
          basicOptionalModule?: {
            __typename?: 'UiBasicOptionalModule';
            treatmentType: UiBasicOptionalTreatmentType;
            contentTypes: Array<PublicationSettingSearchableContentType>;
            allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
            moduleName?: string | null;
          } | null;
          feedsModule?: {
            __typename?: 'UiFeedsModule';
            treatmentType: UiFeedsTreatmentType;
            contentTypes: Array<PublicationSettingSearchableContentType>;
            allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
          } | null;
        };
        moduleItems: Array<{
          __typename?: 'PageModuleItem';
          itemType: PageModuleItemType;
          itemFields: {
            __typename?: 'PageModuleItemFields';
            contentItem?: {
              __typename?: 'PageModuleItemContent';
              originId: string;
              originContentType: string;
              content?: string | null;
            } | null;
            queryItem?: {
              __typename?: 'PageModuleItemQuery';
              jsonQuery: string;
              isFeed?: boolean | null;
              title?: string | null;
              url?: string | null;
            } | null;
            collectionItem?: {
              __typename?: 'PageModuleItemCollection';
              idCreatedUtc: string;
              collection?: {
                __typename?: 'Collection';
                allessehCollectionId: string;
                idCreatedUtc: string;
                id: string;
                createdUtc: number;
                updatedUtc?: number | null;
                name: string;
                isArchived: boolean;
                allessehJsonQuery?: string | null;
                contentItems: Array<{
                  __typename?: 'CollectionContentItem';
                  originId: string;
                  originContentType: string;
                  content?: string | null;
                }>;
              } | null;
            } | null;
            allessehCollectionItem?: {
              __typename?: 'PageModuleItemAllessehCollection';
              allessehCollectionId: string;
            } | null;
            linkedItem?: {
              __typename?: 'PageModuleItemLinkedItem';
              headline: string;
              summary?: string | null;
              url: string;
              media?: string | null;
            } | null;
          };
        }>;
      }>;
      availableRequiredLayoutModules: Array<{
        __typename?: 'AvailableRequiredLayoutModule';
        uiModuleType: UiModuleType;
        minimumAllowed: number;
        maximumAllowed: number;
        defaultModule: {
          __typename?: 'PageModule';
          uiModuleType: UiModuleType;
          uiModuleFields: {
            __typename?: 'UiModule';
            twoColumnModule?: {
              __typename?: 'UiTwoColumnModule';
              treatmentType: UiTwoColumnTreatmentType;
              leftModules: Array<{
                __typename?: 'PageModule';
                uiModuleType: UiModuleType;
                uiModuleFields: {
                  __typename?: 'UiModule';
                  basicModule?: {
                    __typename?: 'UiBasicModule';
                    treatmentType: UiBasicTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                  } | null;
                  titleModule?: {
                    __typename?: 'UiTitleModule';
                    treatmentType: UiTitleTreatmentType;
                    title?: string | null;
                    titleUrl?: string | null;
                    subtitle?: string | null;
                    subtitleUrl?: string | null;
                    allowedMeta?: Array<Metadata> | null;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
                  } | null;
                  rankedModule?: {
                    __typename?: 'UiRankedModule';
                    treatmentType: UiRankedTreatmentType;
                    title: string;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
                  } | null;
                  textModule?: {
                    __typename?: 'UiTextModule';
                    treatmentType: UiTextTreatmentType;
                    mainText: string;
                    secondaryText: string;
                    allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
                  } | null;
                  basicOptionalModule?: {
                    __typename?: 'UiBasicOptionalModule';
                    treatmentType: UiBasicOptionalTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                    moduleName?: string | null;
                  } | null;
                  feedsModule?: {
                    __typename?: 'UiFeedsModule';
                    treatmentType: UiFeedsTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
                  } | null;
                };
                moduleItems: Array<{
                  __typename?: 'PageModuleItem';
                  itemType: PageModuleItemType;
                  itemFields: {
                    __typename?: 'PageModuleItemFields';
                    contentItem?: {
                      __typename?: 'PageModuleItemContent';
                      originId: string;
                      originContentType: string;
                      content?: string | null;
                    } | null;
                    queryItem?: {
                      __typename?: 'PageModuleItemQuery';
                      jsonQuery: string;
                      isFeed?: boolean | null;
                      title?: string | null;
                      url?: string | null;
                    } | null;
                    collectionItem?: {
                      __typename?: 'PageModuleItemCollection';
                      idCreatedUtc: string;
                      collection?: {
                        __typename?: 'Collection';
                        allessehCollectionId: string;
                        idCreatedUtc: string;
                        id: string;
                        createdUtc: number;
                        updatedUtc?: number | null;
                        name: string;
                        isArchived: boolean;
                        allessehJsonQuery?: string | null;
                        contentItems: Array<{
                          __typename?: 'CollectionContentItem';
                          originId: string;
                          originContentType: string;
                          content?: string | null;
                        }>;
                      } | null;
                    } | null;
                    allessehCollectionItem?: {
                      __typename?: 'PageModuleItemAllessehCollection';
                      allessehCollectionId: string;
                    } | null;
                    linkedItem?: {
                      __typename?: 'PageModuleItemLinkedItem';
                      headline: string;
                      summary?: string | null;
                      url: string;
                      media?: string | null;
                    } | null;
                  };
                }>;
              }>;
              rightModules: Array<{
                __typename?: 'PageModule';
                uiModuleType: UiModuleType;
                uiModuleFields: {
                  __typename?: 'UiModule';
                  basicModule?: {
                    __typename?: 'UiBasicModule';
                    treatmentType: UiBasicTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                  } | null;
                  titleModule?: {
                    __typename?: 'UiTitleModule';
                    treatmentType: UiTitleTreatmentType;
                    title?: string | null;
                    titleUrl?: string | null;
                    subtitle?: string | null;
                    subtitleUrl?: string | null;
                    allowedMeta?: Array<Metadata> | null;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
                  } | null;
                  rankedModule?: {
                    __typename?: 'UiRankedModule';
                    treatmentType: UiRankedTreatmentType;
                    title: string;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
                  } | null;
                  textModule?: {
                    __typename?: 'UiTextModule';
                    treatmentType: UiTextTreatmentType;
                    mainText: string;
                    secondaryText: string;
                    allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
                  } | null;
                  basicOptionalModule?: {
                    __typename?: 'UiBasicOptionalModule';
                    treatmentType: UiBasicOptionalTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                    moduleName?: string | null;
                  } | null;
                  feedsModule?: {
                    __typename?: 'UiFeedsModule';
                    treatmentType: UiFeedsTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
                  } | null;
                };
                moduleItems: Array<{
                  __typename?: 'PageModuleItem';
                  itemType: PageModuleItemType;
                  itemFields: {
                    __typename?: 'PageModuleItemFields';
                    contentItem?: {
                      __typename?: 'PageModuleItemContent';
                      originId: string;
                      originContentType: string;
                      content?: string | null;
                    } | null;
                    queryItem?: {
                      __typename?: 'PageModuleItemQuery';
                      jsonQuery: string;
                      isFeed?: boolean | null;
                      title?: string | null;
                      url?: string | null;
                    } | null;
                    collectionItem?: {
                      __typename?: 'PageModuleItemCollection';
                      idCreatedUtc: string;
                      collection?: {
                        __typename?: 'Collection';
                        allessehCollectionId: string;
                        idCreatedUtc: string;
                        id: string;
                        createdUtc: number;
                        updatedUtc?: number | null;
                        name: string;
                        isArchived: boolean;
                        allessehJsonQuery?: string | null;
                        contentItems: Array<{
                          __typename?: 'CollectionContentItem';
                          originId: string;
                          originContentType: string;
                          content?: string | null;
                        }>;
                      } | null;
                    } | null;
                    allessehCollectionItem?: {
                      __typename?: 'PageModuleItemAllessehCollection';
                      allessehCollectionId: string;
                    } | null;
                    linkedItem?: {
                      __typename?: 'PageModuleItemLinkedItem';
                      headline: string;
                      summary?: string | null;
                      url: string;
                      media?: string | null;
                    } | null;
                  };
                }>;
              }>;
            } | null;
            basicModule?: {
              __typename?: 'UiBasicModule';
              treatmentType: UiBasicTreatmentType;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
            } | null;
            titleModule?: {
              __typename?: 'UiTitleModule';
              treatmentType: UiTitleTreatmentType;
              title?: string | null;
              titleUrl?: string | null;
              subtitle?: string | null;
              subtitleUrl?: string | null;
              allowedMeta?: Array<Metadata> | null;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
            } | null;
            rankedModule?: {
              __typename?: 'UiRankedModule';
              treatmentType: UiRankedTreatmentType;
              title: string;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
            } | null;
            textModule?: {
              __typename?: 'UiTextModule';
              treatmentType: UiTextTreatmentType;
              mainText: string;
              secondaryText: string;
              allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
            } | null;
            basicOptionalModule?: {
              __typename?: 'UiBasicOptionalModule';
              treatmentType: UiBasicOptionalTreatmentType;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
              moduleName?: string | null;
            } | null;
            feedsModule?: {
              __typename?: 'UiFeedsModule';
              treatmentType: UiFeedsTreatmentType;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
            } | null;
          };
          moduleItems: Array<{
            __typename?: 'PageModuleItem';
            itemType: PageModuleItemType;
            itemFields: {
              __typename?: 'PageModuleItemFields';
              contentItem?: {
                __typename?: 'PageModuleItemContent';
                originId: string;
                originContentType: string;
                content?: string | null;
              } | null;
              queryItem?: {
                __typename?: 'PageModuleItemQuery';
                jsonQuery: string;
                isFeed?: boolean | null;
                title?: string | null;
                url?: string | null;
              } | null;
              collectionItem?: {
                __typename?: 'PageModuleItemCollection';
                idCreatedUtc: string;
                collection?: {
                  __typename?: 'Collection';
                  allessehCollectionId: string;
                  idCreatedUtc: string;
                  id: string;
                  createdUtc: number;
                  updatedUtc?: number | null;
                  name: string;
                  isArchived: boolean;
                  allessehJsonQuery?: string | null;
                  contentItems: Array<{
                    __typename?: 'CollectionContentItem';
                    originId: string;
                    originContentType: string;
                    content?: string | null;
                  }>;
                } | null;
              } | null;
              allessehCollectionItem?: {
                __typename?: 'PageModuleItemAllessehCollection';
                allessehCollectionId: string;
              } | null;
              linkedItem?: {
                __typename?: 'PageModuleItemLinkedItem';
                headline: string;
                summary?: string | null;
                url: string;
                media?: string | null;
              } | null;
            };
          }>;
        };
      }>;
      availableLayoutModules: Array<{
        __typename?: 'AvailableLayoutModule';
        uiModuleType: UiModuleType;
        minimumAllowed: number;
        maximumAllowed: number;
        allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
        defaultModule: {
          __typename?: 'PageModule';
          uiModuleType: UiModuleType;
          uiModuleFields: {
            __typename?: 'UiModule';
            twoColumnModule?: {
              __typename?: 'UiTwoColumnModule';
              treatmentType: UiTwoColumnTreatmentType;
              leftModules: Array<{
                __typename?: 'PageModule';
                uiModuleType: UiModuleType;
                uiModuleFields: {
                  __typename?: 'UiModule';
                  basicModule?: {
                    __typename?: 'UiBasicModule';
                    treatmentType: UiBasicTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                  } | null;
                  titleModule?: {
                    __typename?: 'UiTitleModule';
                    treatmentType: UiTitleTreatmentType;
                    title?: string | null;
                    titleUrl?: string | null;
                    subtitle?: string | null;
                    subtitleUrl?: string | null;
                    allowedMeta?: Array<Metadata> | null;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
                  } | null;
                  rankedModule?: {
                    __typename?: 'UiRankedModule';
                    treatmentType: UiRankedTreatmentType;
                    title: string;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
                  } | null;
                  textModule?: {
                    __typename?: 'UiTextModule';
                    treatmentType: UiTextTreatmentType;
                    mainText: string;
                    secondaryText: string;
                    allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
                  } | null;
                  basicOptionalModule?: {
                    __typename?: 'UiBasicOptionalModule';
                    treatmentType: UiBasicOptionalTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                    moduleName?: string | null;
                  } | null;
                  feedsModule?: {
                    __typename?: 'UiFeedsModule';
                    treatmentType: UiFeedsTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
                  } | null;
                };
                moduleItems: Array<{
                  __typename?: 'PageModuleItem';
                  itemType: PageModuleItemType;
                  itemFields: {
                    __typename?: 'PageModuleItemFields';
                    contentItem?: {
                      __typename?: 'PageModuleItemContent';
                      originId: string;
                      originContentType: string;
                      content?: string | null;
                    } | null;
                    queryItem?: {
                      __typename?: 'PageModuleItemQuery';
                      jsonQuery: string;
                      isFeed?: boolean | null;
                      title?: string | null;
                      url?: string | null;
                    } | null;
                    collectionItem?: {
                      __typename?: 'PageModuleItemCollection';
                      idCreatedUtc: string;
                      collection?: {
                        __typename?: 'Collection';
                        allessehCollectionId: string;
                        idCreatedUtc: string;
                        id: string;
                        createdUtc: number;
                        updatedUtc?: number | null;
                        name: string;
                        isArchived: boolean;
                        allessehJsonQuery?: string | null;
                        contentItems: Array<{
                          __typename?: 'CollectionContentItem';
                          originId: string;
                          originContentType: string;
                          content?: string | null;
                        }>;
                      } | null;
                    } | null;
                    allessehCollectionItem?: {
                      __typename?: 'PageModuleItemAllessehCollection';
                      allessehCollectionId: string;
                    } | null;
                    linkedItem?: {
                      __typename?: 'PageModuleItemLinkedItem';
                      headline: string;
                      summary?: string | null;
                      url: string;
                      media?: string | null;
                    } | null;
                  };
                }>;
              }>;
              rightModules: Array<{
                __typename?: 'PageModule';
                uiModuleType: UiModuleType;
                uiModuleFields: {
                  __typename?: 'UiModule';
                  basicModule?: {
                    __typename?: 'UiBasicModule';
                    treatmentType: UiBasicTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                  } | null;
                  titleModule?: {
                    __typename?: 'UiTitleModule';
                    treatmentType: UiTitleTreatmentType;
                    title?: string | null;
                    titleUrl?: string | null;
                    subtitle?: string | null;
                    subtitleUrl?: string | null;
                    allowedMeta?: Array<Metadata> | null;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
                  } | null;
                  rankedModule?: {
                    __typename?: 'UiRankedModule';
                    treatmentType: UiRankedTreatmentType;
                    title: string;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
                  } | null;
                  textModule?: {
                    __typename?: 'UiTextModule';
                    treatmentType: UiTextTreatmentType;
                    mainText: string;
                    secondaryText: string;
                    allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
                  } | null;
                  basicOptionalModule?: {
                    __typename?: 'UiBasicOptionalModule';
                    treatmentType: UiBasicOptionalTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                    moduleName?: string | null;
                  } | null;
                  feedsModule?: {
                    __typename?: 'UiFeedsModule';
                    treatmentType: UiFeedsTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
                  } | null;
                };
                moduleItems: Array<{
                  __typename?: 'PageModuleItem';
                  itemType: PageModuleItemType;
                  itemFields: {
                    __typename?: 'PageModuleItemFields';
                    contentItem?: {
                      __typename?: 'PageModuleItemContent';
                      originId: string;
                      originContentType: string;
                      content?: string | null;
                    } | null;
                    queryItem?: {
                      __typename?: 'PageModuleItemQuery';
                      jsonQuery: string;
                      isFeed?: boolean | null;
                      title?: string | null;
                      url?: string | null;
                    } | null;
                    collectionItem?: {
                      __typename?: 'PageModuleItemCollection';
                      idCreatedUtc: string;
                      collection?: {
                        __typename?: 'Collection';
                        allessehCollectionId: string;
                        idCreatedUtc: string;
                        id: string;
                        createdUtc: number;
                        updatedUtc?: number | null;
                        name: string;
                        isArchived: boolean;
                        allessehJsonQuery?: string | null;
                        contentItems: Array<{
                          __typename?: 'CollectionContentItem';
                          originId: string;
                          originContentType: string;
                          content?: string | null;
                        }>;
                      } | null;
                    } | null;
                    allessehCollectionItem?: {
                      __typename?: 'PageModuleItemAllessehCollection';
                      allessehCollectionId: string;
                    } | null;
                    linkedItem?: {
                      __typename?: 'PageModuleItemLinkedItem';
                      headline: string;
                      summary?: string | null;
                      url: string;
                      media?: string | null;
                    } | null;
                  };
                }>;
              }>;
            } | null;
            basicModule?: {
              __typename?: 'UiBasicModule';
              treatmentType: UiBasicTreatmentType;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
            } | null;
            titleModule?: {
              __typename?: 'UiTitleModule';
              treatmentType: UiTitleTreatmentType;
              title?: string | null;
              titleUrl?: string | null;
              subtitle?: string | null;
              subtitleUrl?: string | null;
              allowedMeta?: Array<Metadata> | null;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
            } | null;
            rankedModule?: {
              __typename?: 'UiRankedModule';
              treatmentType: UiRankedTreatmentType;
              title: string;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
            } | null;
            textModule?: {
              __typename?: 'UiTextModule';
              treatmentType: UiTextTreatmentType;
              mainText: string;
              secondaryText: string;
              allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
            } | null;
            basicOptionalModule?: {
              __typename?: 'UiBasicOptionalModule';
              treatmentType: UiBasicOptionalTreatmentType;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
              moduleName?: string | null;
            } | null;
            feedsModule?: {
              __typename?: 'UiFeedsModule';
              treatmentType: UiFeedsTreatmentType;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
            } | null;
          };
          moduleItems: Array<{
            __typename?: 'PageModuleItem';
            itemType: PageModuleItemType;
            itemFields: {
              __typename?: 'PageModuleItemFields';
              contentItem?: {
                __typename?: 'PageModuleItemContent';
                originId: string;
                originContentType: string;
                content?: string | null;
              } | null;
              queryItem?: {
                __typename?: 'PageModuleItemQuery';
                jsonQuery: string;
                isFeed?: boolean | null;
                title?: string | null;
                url?: string | null;
              } | null;
              collectionItem?: {
                __typename?: 'PageModuleItemCollection';
                idCreatedUtc: string;
                collection?: {
                  __typename?: 'Collection';
                  allessehCollectionId: string;
                  idCreatedUtc: string;
                  id: string;
                  createdUtc: number;
                  updatedUtc?: number | null;
                  name: string;
                  isArchived: boolean;
                  allessehJsonQuery?: string | null;
                  contentItems: Array<{
                    __typename?: 'CollectionContentItem';
                    originId: string;
                    originContentType: string;
                    content?: string | null;
                  }>;
                } | null;
              } | null;
              allessehCollectionItem?: {
                __typename?: 'PageModuleItemAllessehCollection';
                allessehCollectionId: string;
              } | null;
              linkedItem?: {
                __typename?: 'PageModuleItemLinkedItem';
                headline: string;
                summary?: string | null;
                url: string;
                media?: string | null;
              } | null;
            };
          }>;
        };
      }>;
    }>;
    treatmentTypeSettings: Array<{
      __typename?: 'TreatmentTypeSetting';
      treatmentType: string;
      treatmentTypeKey?: string | null;
      minRequiredContentItems: number;
      maxRequiredContentItems: number;
      label: string;
      contentTypes: Array<PublicationSettingSearchableContentType>;
      module?: {
        __typename?: 'PageModule';
        uiModuleType: UiModuleType;
        uiModuleFields: {
          __typename?: 'UiModule';
          twoColumnModule?: {
            __typename?: 'UiTwoColumnModule';
            treatmentType: UiTwoColumnTreatmentType;
            leftModules: Array<{
              __typename?: 'PageModule';
              uiModuleType: UiModuleType;
              uiModuleFields: {
                __typename?: 'UiModule';
                basicModule?: {
                  __typename?: 'UiBasicModule';
                  treatmentType: UiBasicTreatmentType;
                  contentTypes: Array<PublicationSettingSearchableContentType>;
                  allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                } | null;
                titleModule?: {
                  __typename?: 'UiTitleModule';
                  treatmentType: UiTitleTreatmentType;
                  title?: string | null;
                  titleUrl?: string | null;
                  subtitle?: string | null;
                  subtitleUrl?: string | null;
                  allowedMeta?: Array<Metadata> | null;
                  contentTypes: Array<PublicationSettingSearchableContentType>;
                  allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
                } | null;
                rankedModule?: {
                  __typename?: 'UiRankedModule';
                  treatmentType: UiRankedTreatmentType;
                  title: string;
                  contentTypes: Array<PublicationSettingSearchableContentType>;
                  allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
                } | null;
                textModule?: {
                  __typename?: 'UiTextModule';
                  treatmentType: UiTextTreatmentType;
                  mainText: string;
                  secondaryText: string;
                  allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
                } | null;
                basicOptionalModule?: {
                  __typename?: 'UiBasicOptionalModule';
                  treatmentType: UiBasicOptionalTreatmentType;
                  contentTypes: Array<PublicationSettingSearchableContentType>;
                  allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                  moduleName?: string | null;
                } | null;
                feedsModule?: {
                  __typename?: 'UiFeedsModule';
                  treatmentType: UiFeedsTreatmentType;
                  contentTypes: Array<PublicationSettingSearchableContentType>;
                  allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
                } | null;
              };
              moduleItems: Array<{
                __typename?: 'PageModuleItem';
                itemType: PageModuleItemType;
                itemFields: {
                  __typename?: 'PageModuleItemFields';
                  contentItem?: {
                    __typename?: 'PageModuleItemContent';
                    originId: string;
                    originContentType: string;
                    content?: string | null;
                  } | null;
                  queryItem?: {
                    __typename?: 'PageModuleItemQuery';
                    jsonQuery: string;
                    isFeed?: boolean | null;
                    title?: string | null;
                    url?: string | null;
                  } | null;
                  collectionItem?: {
                    __typename?: 'PageModuleItemCollection';
                    idCreatedUtc: string;
                    collection?: {
                      __typename?: 'Collection';
                      allessehCollectionId: string;
                      idCreatedUtc: string;
                      id: string;
                      createdUtc: number;
                      updatedUtc?: number | null;
                      name: string;
                      isArchived: boolean;
                      allessehJsonQuery?: string | null;
                      contentItems: Array<{
                        __typename?: 'CollectionContentItem';
                        originId: string;
                        originContentType: string;
                        content?: string | null;
                      }>;
                    } | null;
                  } | null;
                  allessehCollectionItem?: {
                    __typename?: 'PageModuleItemAllessehCollection';
                    allessehCollectionId: string;
                  } | null;
                  linkedItem?: {
                    __typename?: 'PageModuleItemLinkedItem';
                    headline: string;
                    summary?: string | null;
                    url: string;
                    media?: string | null;
                  } | null;
                };
              }>;
            }>;
            rightModules: Array<{
              __typename?: 'PageModule';
              uiModuleType: UiModuleType;
              uiModuleFields: {
                __typename?: 'UiModule';
                basicModule?: {
                  __typename?: 'UiBasicModule';
                  treatmentType: UiBasicTreatmentType;
                  contentTypes: Array<PublicationSettingSearchableContentType>;
                  allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                } | null;
                titleModule?: {
                  __typename?: 'UiTitleModule';
                  treatmentType: UiTitleTreatmentType;
                  title?: string | null;
                  titleUrl?: string | null;
                  subtitle?: string | null;
                  subtitleUrl?: string | null;
                  allowedMeta?: Array<Metadata> | null;
                  contentTypes: Array<PublicationSettingSearchableContentType>;
                  allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
                } | null;
                rankedModule?: {
                  __typename?: 'UiRankedModule';
                  treatmentType: UiRankedTreatmentType;
                  title: string;
                  contentTypes: Array<PublicationSettingSearchableContentType>;
                  allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
                } | null;
                textModule?: {
                  __typename?: 'UiTextModule';
                  treatmentType: UiTextTreatmentType;
                  mainText: string;
                  secondaryText: string;
                  allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
                } | null;
                basicOptionalModule?: {
                  __typename?: 'UiBasicOptionalModule';
                  treatmentType: UiBasicOptionalTreatmentType;
                  contentTypes: Array<PublicationSettingSearchableContentType>;
                  allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                  moduleName?: string | null;
                } | null;
                feedsModule?: {
                  __typename?: 'UiFeedsModule';
                  treatmentType: UiFeedsTreatmentType;
                  contentTypes: Array<PublicationSettingSearchableContentType>;
                  allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
                } | null;
              };
              moduleItems: Array<{
                __typename?: 'PageModuleItem';
                itemType: PageModuleItemType;
                itemFields: {
                  __typename?: 'PageModuleItemFields';
                  contentItem?: {
                    __typename?: 'PageModuleItemContent';
                    originId: string;
                    originContentType: string;
                    content?: string | null;
                  } | null;
                  queryItem?: {
                    __typename?: 'PageModuleItemQuery';
                    jsonQuery: string;
                    isFeed?: boolean | null;
                    title?: string | null;
                    url?: string | null;
                  } | null;
                  collectionItem?: {
                    __typename?: 'PageModuleItemCollection';
                    idCreatedUtc: string;
                    collection?: {
                      __typename?: 'Collection';
                      allessehCollectionId: string;
                      idCreatedUtc: string;
                      id: string;
                      createdUtc: number;
                      updatedUtc?: number | null;
                      name: string;
                      isArchived: boolean;
                      allessehJsonQuery?: string | null;
                      contentItems: Array<{
                        __typename?: 'CollectionContentItem';
                        originId: string;
                        originContentType: string;
                        content?: string | null;
                      }>;
                    } | null;
                  } | null;
                  allessehCollectionItem?: {
                    __typename?: 'PageModuleItemAllessehCollection';
                    allessehCollectionId: string;
                  } | null;
                  linkedItem?: {
                    __typename?: 'PageModuleItemLinkedItem';
                    headline: string;
                    summary?: string | null;
                    url: string;
                    media?: string | null;
                  } | null;
                };
              }>;
            }>;
          } | null;
          basicModule?: {
            __typename?: 'UiBasicModule';
            treatmentType: UiBasicTreatmentType;
            contentTypes: Array<PublicationSettingSearchableContentType>;
            allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
          } | null;
          titleModule?: {
            __typename?: 'UiTitleModule';
            treatmentType: UiTitleTreatmentType;
            title?: string | null;
            titleUrl?: string | null;
            subtitle?: string | null;
            subtitleUrl?: string | null;
            allowedMeta?: Array<Metadata> | null;
            contentTypes: Array<PublicationSettingSearchableContentType>;
            allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
          } | null;
          rankedModule?: {
            __typename?: 'UiRankedModule';
            treatmentType: UiRankedTreatmentType;
            title: string;
            contentTypes: Array<PublicationSettingSearchableContentType>;
            allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
          } | null;
          textModule?: {
            __typename?: 'UiTextModule';
            treatmentType: UiTextTreatmentType;
            mainText: string;
            secondaryText: string;
            allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
          } | null;
          basicOptionalModule?: {
            __typename?: 'UiBasicOptionalModule';
            treatmentType: UiBasicOptionalTreatmentType;
            contentTypes: Array<PublicationSettingSearchableContentType>;
            allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
            moduleName?: string | null;
          } | null;
          feedsModule?: {
            __typename?: 'UiFeedsModule';
            treatmentType: UiFeedsTreatmentType;
            contentTypes: Array<PublicationSettingSearchableContentType>;
            allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
          } | null;
        };
        moduleItems: Array<{
          __typename?: 'PageModuleItem';
          itemType: PageModuleItemType;
          itemFields: {
            __typename?: 'PageModuleItemFields';
            contentItem?: {
              __typename?: 'PageModuleItemContent';
              originId: string;
              originContentType: string;
              content?: string | null;
            } | null;
            queryItem?: {
              __typename?: 'PageModuleItemQuery';
              jsonQuery: string;
              isFeed?: boolean | null;
              title?: string | null;
              url?: string | null;
            } | null;
            collectionItem?: {
              __typename?: 'PageModuleItemCollection';
              idCreatedUtc: string;
              collection?: {
                __typename?: 'Collection';
                allessehCollectionId: string;
                idCreatedUtc: string;
                id: string;
                createdUtc: number;
                updatedUtc?: number | null;
                name: string;
                isArchived: boolean;
                allessehJsonQuery?: string | null;
                contentItems: Array<{
                  __typename?: 'CollectionContentItem';
                  originId: string;
                  originContentType: string;
                  content?: string | null;
                }>;
              } | null;
            } | null;
            allessehCollectionItem?: {
              __typename?: 'PageModuleItemAllessehCollection';
              allessehCollectionId: string;
            } | null;
            linkedItem?: {
              __typename?: 'PageModuleItemLinkedItem';
              headline: string;
              summary?: string | null;
              url: string;
              media?: string | null;
            } | null;
          };
        }>;
      } | null;
    }>;
  };
};

export type PageEditPageFragment = {
  __typename?: 'Page';
  name: string;
  notes?: string | null;
  revisionGroupKey: string;
  createdUtc: number;
  isMobileAppScreen: boolean;
  layoutId: string;
  routeKey: string;
  pageType: PageType;
  publishUtc?: number | null;
  creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
  revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
  config?: { __typename?: 'PageRouteConfig'; summaryPriority: string } | null;
  pageModules: Array<{
    __typename?: 'PageModule';
    uiModuleType: UiModuleType;
    uiModuleFields: {
      __typename?: 'UiModule';
      twoColumnModule?: {
        __typename?: 'UiTwoColumnModule';
        treatmentType: UiTwoColumnTreatmentType;
        leftModules: Array<{
          __typename?: 'PageModule';
          uiModuleType: UiModuleType;
          uiModuleFields: {
            __typename?: 'UiModule';
            basicModule?: {
              __typename?: 'UiBasicModule';
              treatmentType: UiBasicTreatmentType;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
            } | null;
            titleModule?: {
              __typename?: 'UiTitleModule';
              treatmentType: UiTitleTreatmentType;
              title?: string | null;
              titleUrl?: string | null;
              subtitle?: string | null;
              subtitleUrl?: string | null;
              allowedMeta?: Array<Metadata> | null;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
            } | null;
            rankedModule?: {
              __typename?: 'UiRankedModule';
              treatmentType: UiRankedTreatmentType;
              title: string;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
            } | null;
            textModule?: {
              __typename?: 'UiTextModule';
              treatmentType: UiTextTreatmentType;
              mainText: string;
              secondaryText: string;
              allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
            } | null;
            basicOptionalModule?: {
              __typename?: 'UiBasicOptionalModule';
              treatmentType: UiBasicOptionalTreatmentType;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
              moduleName?: string | null;
            } | null;
            feedsModule?: {
              __typename?: 'UiFeedsModule';
              treatmentType: UiFeedsTreatmentType;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
            } | null;
          };
          moduleItems: Array<{
            __typename?: 'PageModuleItem';
            itemType: PageModuleItemType;
            itemFields: {
              __typename?: 'PageModuleItemFields';
              contentItem?: {
                __typename?: 'PageModuleItemContent';
                originId: string;
                originContentType: string;
                content?: string | null;
              } | null;
              queryItem?: {
                __typename?: 'PageModuleItemQuery';
                jsonQuery: string;
                isFeed?: boolean | null;
                title?: string | null;
                url?: string | null;
              } | null;
              collectionItem?: {
                __typename?: 'PageModuleItemCollection';
                idCreatedUtc: string;
                collection?: {
                  __typename?: 'Collection';
                  allessehCollectionId: string;
                  idCreatedUtc: string;
                  id: string;
                  createdUtc: number;
                  updatedUtc?: number | null;
                  name: string;
                  isArchived: boolean;
                  allessehJsonQuery?: string | null;
                  contentItems: Array<{
                    __typename?: 'CollectionContentItem';
                    originId: string;
                    originContentType: string;
                    content?: string | null;
                  }>;
                } | null;
              } | null;
              allessehCollectionItem?: {
                __typename?: 'PageModuleItemAllessehCollection';
                allessehCollectionId: string;
              } | null;
              linkedItem?: {
                __typename?: 'PageModuleItemLinkedItem';
                headline: string;
                summary?: string | null;
                url: string;
                media?: string | null;
              } | null;
            };
          }>;
        }>;
        rightModules: Array<{
          __typename?: 'PageModule';
          uiModuleType: UiModuleType;
          uiModuleFields: {
            __typename?: 'UiModule';
            basicModule?: {
              __typename?: 'UiBasicModule';
              treatmentType: UiBasicTreatmentType;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
            } | null;
            titleModule?: {
              __typename?: 'UiTitleModule';
              treatmentType: UiTitleTreatmentType;
              title?: string | null;
              titleUrl?: string | null;
              subtitle?: string | null;
              subtitleUrl?: string | null;
              allowedMeta?: Array<Metadata> | null;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
            } | null;
            rankedModule?: {
              __typename?: 'UiRankedModule';
              treatmentType: UiRankedTreatmentType;
              title: string;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
            } | null;
            textModule?: {
              __typename?: 'UiTextModule';
              treatmentType: UiTextTreatmentType;
              mainText: string;
              secondaryText: string;
              allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
            } | null;
            basicOptionalModule?: {
              __typename?: 'UiBasicOptionalModule';
              treatmentType: UiBasicOptionalTreatmentType;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
              moduleName?: string | null;
            } | null;
            feedsModule?: {
              __typename?: 'UiFeedsModule';
              treatmentType: UiFeedsTreatmentType;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
            } | null;
          };
          moduleItems: Array<{
            __typename?: 'PageModuleItem';
            itemType: PageModuleItemType;
            itemFields: {
              __typename?: 'PageModuleItemFields';
              contentItem?: {
                __typename?: 'PageModuleItemContent';
                originId: string;
                originContentType: string;
                content?: string | null;
              } | null;
              queryItem?: {
                __typename?: 'PageModuleItemQuery';
                jsonQuery: string;
                isFeed?: boolean | null;
                title?: string | null;
                url?: string | null;
              } | null;
              collectionItem?: {
                __typename?: 'PageModuleItemCollection';
                idCreatedUtc: string;
                collection?: {
                  __typename?: 'Collection';
                  allessehCollectionId: string;
                  idCreatedUtc: string;
                  id: string;
                  createdUtc: number;
                  updatedUtc?: number | null;
                  name: string;
                  isArchived: boolean;
                  allessehJsonQuery?: string | null;
                  contentItems: Array<{
                    __typename?: 'CollectionContentItem';
                    originId: string;
                    originContentType: string;
                    content?: string | null;
                  }>;
                } | null;
              } | null;
              allessehCollectionItem?: {
                __typename?: 'PageModuleItemAllessehCollection';
                allessehCollectionId: string;
              } | null;
              linkedItem?: {
                __typename?: 'PageModuleItemLinkedItem';
                headline: string;
                summary?: string | null;
                url: string;
                media?: string | null;
              } | null;
            };
          }>;
        }>;
      } | null;
      basicModule?: {
        __typename?: 'UiBasicModule';
        treatmentType: UiBasicTreatmentType;
        contentTypes: Array<PublicationSettingSearchableContentType>;
        allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
      } | null;
      titleModule?: {
        __typename?: 'UiTitleModule';
        treatmentType: UiTitleTreatmentType;
        title?: string | null;
        titleUrl?: string | null;
        subtitle?: string | null;
        subtitleUrl?: string | null;
        allowedMeta?: Array<Metadata> | null;
        contentTypes: Array<PublicationSettingSearchableContentType>;
        allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
      } | null;
      rankedModule?: {
        __typename?: 'UiRankedModule';
        treatmentType: UiRankedTreatmentType;
        title: string;
        contentTypes: Array<PublicationSettingSearchableContentType>;
        allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
      } | null;
      textModule?: {
        __typename?: 'UiTextModule';
        treatmentType: UiTextTreatmentType;
        mainText: string;
        secondaryText: string;
        allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
      } | null;
      basicOptionalModule?: {
        __typename?: 'UiBasicOptionalModule';
        treatmentType: UiBasicOptionalTreatmentType;
        contentTypes: Array<PublicationSettingSearchableContentType>;
        allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
        moduleName?: string | null;
      } | null;
      feedsModule?: {
        __typename?: 'UiFeedsModule';
        treatmentType: UiFeedsTreatmentType;
        contentTypes: Array<PublicationSettingSearchableContentType>;
        allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
      } | null;
    };
    moduleItems: Array<{
      __typename?: 'PageModuleItem';
      itemType: PageModuleItemType;
      itemFields: {
        __typename?: 'PageModuleItemFields';
        contentItem?: {
          __typename?: 'PageModuleItemContent';
          originId: string;
          originContentType: string;
          content?: string | null;
        } | null;
        queryItem?: {
          __typename?: 'PageModuleItemQuery';
          jsonQuery: string;
          isFeed?: boolean | null;
          title?: string | null;
          url?: string | null;
        } | null;
        collectionItem?: {
          __typename?: 'PageModuleItemCollection';
          idCreatedUtc: string;
          collection?: {
            __typename?: 'Collection';
            allessehCollectionId: string;
            idCreatedUtc: string;
            id: string;
            createdUtc: number;
            updatedUtc?: number | null;
            name: string;
            isArchived: boolean;
            allessehJsonQuery?: string | null;
            contentItems: Array<{
              __typename?: 'CollectionContentItem';
              originId: string;
              originContentType: string;
              content?: string | null;
            }>;
          } | null;
        } | null;
        allessehCollectionItem?: {
          __typename?: 'PageModuleItemAllessehCollection';
          allessehCollectionId: string;
        } | null;
        linkedItem?: {
          __typename?: 'PageModuleItemLinkedItem';
          headline: string;
          summary?: string | null;
          url: string;
          media?: string | null;
        } | null;
      };
    }>;
  }>;
};

export type PageUpdateMutationVariables = Exact<{
  pageUpdateInput: PageUpdateInput;
}>;

export type PageUpdateMutation = {
  __typename?: 'Mutation';
  pageUpdate: {
    __typename?: 'Page';
    name: string;
    notes?: string | null;
    revisionGroupKey: string;
    createdUtc: number;
    isMobileAppScreen: boolean;
    layoutId: string;
    routeKey: string;
    pageType: PageType;
    publishUtc?: number | null;
    creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
    revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
    config?: { __typename?: 'PageRouteConfig'; summaryPriority: string } | null;
    pageModules: Array<{
      __typename?: 'PageModule';
      uiModuleType: UiModuleType;
      uiModuleFields: {
        __typename?: 'UiModule';
        twoColumnModule?: {
          __typename?: 'UiTwoColumnModule';
          treatmentType: UiTwoColumnTreatmentType;
          leftModules: Array<{
            __typename?: 'PageModule';
            uiModuleType: UiModuleType;
            uiModuleFields: {
              __typename?: 'UiModule';
              basicModule?: {
                __typename?: 'UiBasicModule';
                treatmentType: UiBasicTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
              } | null;
              titleModule?: {
                __typename?: 'UiTitleModule';
                treatmentType: UiTitleTreatmentType;
                title?: string | null;
                titleUrl?: string | null;
                subtitle?: string | null;
                subtitleUrl?: string | null;
                allowedMeta?: Array<Metadata> | null;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
              } | null;
              rankedModule?: {
                __typename?: 'UiRankedModule';
                treatmentType: UiRankedTreatmentType;
                title: string;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
              } | null;
              textModule?: {
                __typename?: 'UiTextModule';
                treatmentType: UiTextTreatmentType;
                mainText: string;
                secondaryText: string;
                allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
              } | null;
              basicOptionalModule?: {
                __typename?: 'UiBasicOptionalModule';
                treatmentType: UiBasicOptionalTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                moduleName?: string | null;
              } | null;
              feedsModule?: {
                __typename?: 'UiFeedsModule';
                treatmentType: UiFeedsTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
              } | null;
            };
            moduleItems: Array<{
              __typename?: 'PageModuleItem';
              itemType: PageModuleItemType;
              itemFields: {
                __typename?: 'PageModuleItemFields';
                contentItem?: {
                  __typename?: 'PageModuleItemContent';
                  originId: string;
                  originContentType: string;
                  content?: string | null;
                } | null;
                queryItem?: {
                  __typename?: 'PageModuleItemQuery';
                  jsonQuery: string;
                  isFeed?: boolean | null;
                  title?: string | null;
                  url?: string | null;
                } | null;
                collectionItem?: {
                  __typename?: 'PageModuleItemCollection';
                  idCreatedUtc: string;
                  collection?: {
                    __typename?: 'Collection';
                    allessehCollectionId: string;
                    idCreatedUtc: string;
                    id: string;
                    createdUtc: number;
                    updatedUtc?: number | null;
                    name: string;
                    isArchived: boolean;
                    allessehJsonQuery?: string | null;
                    contentItems: Array<{
                      __typename?: 'CollectionContentItem';
                      originId: string;
                      originContentType: string;
                      content?: string | null;
                    }>;
                  } | null;
                } | null;
                allessehCollectionItem?: {
                  __typename?: 'PageModuleItemAllessehCollection';
                  allessehCollectionId: string;
                } | null;
                linkedItem?: {
                  __typename?: 'PageModuleItemLinkedItem';
                  headline: string;
                  summary?: string | null;
                  url: string;
                  media?: string | null;
                } | null;
              };
            }>;
          }>;
          rightModules: Array<{
            __typename?: 'PageModule';
            uiModuleType: UiModuleType;
            uiModuleFields: {
              __typename?: 'UiModule';
              basicModule?: {
                __typename?: 'UiBasicModule';
                treatmentType: UiBasicTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
              } | null;
              titleModule?: {
                __typename?: 'UiTitleModule';
                treatmentType: UiTitleTreatmentType;
                title?: string | null;
                titleUrl?: string | null;
                subtitle?: string | null;
                subtitleUrl?: string | null;
                allowedMeta?: Array<Metadata> | null;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
              } | null;
              rankedModule?: {
                __typename?: 'UiRankedModule';
                treatmentType: UiRankedTreatmentType;
                title: string;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
              } | null;
              textModule?: {
                __typename?: 'UiTextModule';
                treatmentType: UiTextTreatmentType;
                mainText: string;
                secondaryText: string;
                allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
              } | null;
              basicOptionalModule?: {
                __typename?: 'UiBasicOptionalModule';
                treatmentType: UiBasicOptionalTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                moduleName?: string | null;
              } | null;
              feedsModule?: {
                __typename?: 'UiFeedsModule';
                treatmentType: UiFeedsTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
              } | null;
            };
            moduleItems: Array<{
              __typename?: 'PageModuleItem';
              itemType: PageModuleItemType;
              itemFields: {
                __typename?: 'PageModuleItemFields';
                contentItem?: {
                  __typename?: 'PageModuleItemContent';
                  originId: string;
                  originContentType: string;
                  content?: string | null;
                } | null;
                queryItem?: {
                  __typename?: 'PageModuleItemQuery';
                  jsonQuery: string;
                  isFeed?: boolean | null;
                  title?: string | null;
                  url?: string | null;
                } | null;
                collectionItem?: {
                  __typename?: 'PageModuleItemCollection';
                  idCreatedUtc: string;
                  collection?: {
                    __typename?: 'Collection';
                    allessehCollectionId: string;
                    idCreatedUtc: string;
                    id: string;
                    createdUtc: number;
                    updatedUtc?: number | null;
                    name: string;
                    isArchived: boolean;
                    allessehJsonQuery?: string | null;
                    contentItems: Array<{
                      __typename?: 'CollectionContentItem';
                      originId: string;
                      originContentType: string;
                      content?: string | null;
                    }>;
                  } | null;
                } | null;
                allessehCollectionItem?: {
                  __typename?: 'PageModuleItemAllessehCollection';
                  allessehCollectionId: string;
                } | null;
                linkedItem?: {
                  __typename?: 'PageModuleItemLinkedItem';
                  headline: string;
                  summary?: string | null;
                  url: string;
                  media?: string | null;
                } | null;
              };
            }>;
          }>;
        } | null;
        basicModule?: {
          __typename?: 'UiBasicModule';
          treatmentType: UiBasicTreatmentType;
          contentTypes: Array<PublicationSettingSearchableContentType>;
          allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
        } | null;
        titleModule?: {
          __typename?: 'UiTitleModule';
          treatmentType: UiTitleTreatmentType;
          title?: string | null;
          titleUrl?: string | null;
          subtitle?: string | null;
          subtitleUrl?: string | null;
          allowedMeta?: Array<Metadata> | null;
          contentTypes: Array<PublicationSettingSearchableContentType>;
          allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
        } | null;
        rankedModule?: {
          __typename?: 'UiRankedModule';
          treatmentType: UiRankedTreatmentType;
          title: string;
          contentTypes: Array<PublicationSettingSearchableContentType>;
          allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
        } | null;
        textModule?: {
          __typename?: 'UiTextModule';
          treatmentType: UiTextTreatmentType;
          mainText: string;
          secondaryText: string;
          allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
        } | null;
        basicOptionalModule?: {
          __typename?: 'UiBasicOptionalModule';
          treatmentType: UiBasicOptionalTreatmentType;
          contentTypes: Array<PublicationSettingSearchableContentType>;
          allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
          moduleName?: string | null;
        } | null;
        feedsModule?: {
          __typename?: 'UiFeedsModule';
          treatmentType: UiFeedsTreatmentType;
          contentTypes: Array<PublicationSettingSearchableContentType>;
          allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
        } | null;
      };
      moduleItems: Array<{
        __typename?: 'PageModuleItem';
        itemType: PageModuleItemType;
        itemFields: {
          __typename?: 'PageModuleItemFields';
          contentItem?: {
            __typename?: 'PageModuleItemContent';
            originId: string;
            originContentType: string;
            content?: string | null;
          } | null;
          queryItem?: {
            __typename?: 'PageModuleItemQuery';
            jsonQuery: string;
            isFeed?: boolean | null;
            title?: string | null;
            url?: string | null;
          } | null;
          collectionItem?: {
            __typename?: 'PageModuleItemCollection';
            idCreatedUtc: string;
            collection?: {
              __typename?: 'Collection';
              allessehCollectionId: string;
              idCreatedUtc: string;
              id: string;
              createdUtc: number;
              updatedUtc?: number | null;
              name: string;
              isArchived: boolean;
              allessehJsonQuery?: string | null;
              contentItems: Array<{
                __typename?: 'CollectionContentItem';
                originId: string;
                originContentType: string;
                content?: string | null;
              }>;
            } | null;
          } | null;
          allessehCollectionItem?: {
            __typename?: 'PageModuleItemAllessehCollection';
            allessehCollectionId: string;
          } | null;
          linkedItem?: {
            __typename?: 'PageModuleItemLinkedItem';
            headline: string;
            summary?: string | null;
            url: string;
            media?: string | null;
          } | null;
        };
      }>;
    }>;
  };
};

export type PagePreviewLinkMutationVariables = Exact<{
  pagePreviewLinkInput: PagePreviewLinkInput;
}>;

export type PagePreviewLinkMutation = { __typename?: 'Mutation'; pagePreviewLink?: string | null };

export type PageDeleteMutationVariables = Exact<{
  pageDeleteInput: PageDeleteInput;
}>;

export type PageDeleteMutation = {
  __typename?: 'Mutation';
  pageDelete: {
    __typename?: 'Page';
    name: string;
    notes?: string | null;
    revisionGroupKey: string;
    createdUtc: number;
    isMobileAppScreen: boolean;
    layoutId: string;
    routeKey: string;
    pageType: PageType;
    publishUtc?: number | null;
    creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
    revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
    config?: { __typename?: 'PageRouteConfig'; summaryPriority: string } | null;
    pageModules: Array<{
      __typename?: 'PageModule';
      uiModuleType: UiModuleType;
      uiModuleFields: {
        __typename?: 'UiModule';
        twoColumnModule?: {
          __typename?: 'UiTwoColumnModule';
          treatmentType: UiTwoColumnTreatmentType;
          leftModules: Array<{
            __typename?: 'PageModule';
            uiModuleType: UiModuleType;
            uiModuleFields: {
              __typename?: 'UiModule';
              basicModule?: {
                __typename?: 'UiBasicModule';
                treatmentType: UiBasicTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
              } | null;
              titleModule?: {
                __typename?: 'UiTitleModule';
                treatmentType: UiTitleTreatmentType;
                title?: string | null;
                titleUrl?: string | null;
                subtitle?: string | null;
                subtitleUrl?: string | null;
                allowedMeta?: Array<Metadata> | null;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
              } | null;
              rankedModule?: {
                __typename?: 'UiRankedModule';
                treatmentType: UiRankedTreatmentType;
                title: string;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
              } | null;
              textModule?: {
                __typename?: 'UiTextModule';
                treatmentType: UiTextTreatmentType;
                mainText: string;
                secondaryText: string;
                allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
              } | null;
              basicOptionalModule?: {
                __typename?: 'UiBasicOptionalModule';
                treatmentType: UiBasicOptionalTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                moduleName?: string | null;
              } | null;
              feedsModule?: {
                __typename?: 'UiFeedsModule';
                treatmentType: UiFeedsTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
              } | null;
            };
            moduleItems: Array<{
              __typename?: 'PageModuleItem';
              itemType: PageModuleItemType;
              itemFields: {
                __typename?: 'PageModuleItemFields';
                contentItem?: {
                  __typename?: 'PageModuleItemContent';
                  originId: string;
                  originContentType: string;
                  content?: string | null;
                } | null;
                queryItem?: {
                  __typename?: 'PageModuleItemQuery';
                  jsonQuery: string;
                  isFeed?: boolean | null;
                  title?: string | null;
                  url?: string | null;
                } | null;
                collectionItem?: {
                  __typename?: 'PageModuleItemCollection';
                  idCreatedUtc: string;
                  collection?: {
                    __typename?: 'Collection';
                    allessehCollectionId: string;
                    idCreatedUtc: string;
                    id: string;
                    createdUtc: number;
                    updatedUtc?: number | null;
                    name: string;
                    isArchived: boolean;
                    allessehJsonQuery?: string | null;
                    contentItems: Array<{
                      __typename?: 'CollectionContentItem';
                      originId: string;
                      originContentType: string;
                      content?: string | null;
                    }>;
                  } | null;
                } | null;
                allessehCollectionItem?: {
                  __typename?: 'PageModuleItemAllessehCollection';
                  allessehCollectionId: string;
                } | null;
                linkedItem?: {
                  __typename?: 'PageModuleItemLinkedItem';
                  headline: string;
                  summary?: string | null;
                  url: string;
                  media?: string | null;
                } | null;
              };
            }>;
          }>;
          rightModules: Array<{
            __typename?: 'PageModule';
            uiModuleType: UiModuleType;
            uiModuleFields: {
              __typename?: 'UiModule';
              basicModule?: {
                __typename?: 'UiBasicModule';
                treatmentType: UiBasicTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
              } | null;
              titleModule?: {
                __typename?: 'UiTitleModule';
                treatmentType: UiTitleTreatmentType;
                title?: string | null;
                titleUrl?: string | null;
                subtitle?: string | null;
                subtitleUrl?: string | null;
                allowedMeta?: Array<Metadata> | null;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
              } | null;
              rankedModule?: {
                __typename?: 'UiRankedModule';
                treatmentType: UiRankedTreatmentType;
                title: string;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
              } | null;
              textModule?: {
                __typename?: 'UiTextModule';
                treatmentType: UiTextTreatmentType;
                mainText: string;
                secondaryText: string;
                allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
              } | null;
              basicOptionalModule?: {
                __typename?: 'UiBasicOptionalModule';
                treatmentType: UiBasicOptionalTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                moduleName?: string | null;
              } | null;
              feedsModule?: {
                __typename?: 'UiFeedsModule';
                treatmentType: UiFeedsTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
              } | null;
            };
            moduleItems: Array<{
              __typename?: 'PageModuleItem';
              itemType: PageModuleItemType;
              itemFields: {
                __typename?: 'PageModuleItemFields';
                contentItem?: {
                  __typename?: 'PageModuleItemContent';
                  originId: string;
                  originContentType: string;
                  content?: string | null;
                } | null;
                queryItem?: {
                  __typename?: 'PageModuleItemQuery';
                  jsonQuery: string;
                  isFeed?: boolean | null;
                  title?: string | null;
                  url?: string | null;
                } | null;
                collectionItem?: {
                  __typename?: 'PageModuleItemCollection';
                  idCreatedUtc: string;
                  collection?: {
                    __typename?: 'Collection';
                    allessehCollectionId: string;
                    idCreatedUtc: string;
                    id: string;
                    createdUtc: number;
                    updatedUtc?: number | null;
                    name: string;
                    isArchived: boolean;
                    allessehJsonQuery?: string | null;
                    contentItems: Array<{
                      __typename?: 'CollectionContentItem';
                      originId: string;
                      originContentType: string;
                      content?: string | null;
                    }>;
                  } | null;
                } | null;
                allessehCollectionItem?: {
                  __typename?: 'PageModuleItemAllessehCollection';
                  allessehCollectionId: string;
                } | null;
                linkedItem?: {
                  __typename?: 'PageModuleItemLinkedItem';
                  headline: string;
                  summary?: string | null;
                  url: string;
                  media?: string | null;
                } | null;
              };
            }>;
          }>;
        } | null;
        basicModule?: {
          __typename?: 'UiBasicModule';
          treatmentType: UiBasicTreatmentType;
          contentTypes: Array<PublicationSettingSearchableContentType>;
          allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
        } | null;
        titleModule?: {
          __typename?: 'UiTitleModule';
          treatmentType: UiTitleTreatmentType;
          title?: string | null;
          titleUrl?: string | null;
          subtitle?: string | null;
          subtitleUrl?: string | null;
          allowedMeta?: Array<Metadata> | null;
          contentTypes: Array<PublicationSettingSearchableContentType>;
          allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
        } | null;
        rankedModule?: {
          __typename?: 'UiRankedModule';
          treatmentType: UiRankedTreatmentType;
          title: string;
          contentTypes: Array<PublicationSettingSearchableContentType>;
          allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
        } | null;
        textModule?: {
          __typename?: 'UiTextModule';
          treatmentType: UiTextTreatmentType;
          mainText: string;
          secondaryText: string;
          allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
        } | null;
        basicOptionalModule?: {
          __typename?: 'UiBasicOptionalModule';
          treatmentType: UiBasicOptionalTreatmentType;
          contentTypes: Array<PublicationSettingSearchableContentType>;
          allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
          moduleName?: string | null;
        } | null;
        feedsModule?: {
          __typename?: 'UiFeedsModule';
          treatmentType: UiFeedsTreatmentType;
          contentTypes: Array<PublicationSettingSearchableContentType>;
          allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
        } | null;
      };
      moduleItems: Array<{
        __typename?: 'PageModuleItem';
        itemType: PageModuleItemType;
        itemFields: {
          __typename?: 'PageModuleItemFields';
          contentItem?: {
            __typename?: 'PageModuleItemContent';
            originId: string;
            originContentType: string;
            content?: string | null;
          } | null;
          queryItem?: {
            __typename?: 'PageModuleItemQuery';
            jsonQuery: string;
            isFeed?: boolean | null;
            title?: string | null;
            url?: string | null;
          } | null;
          collectionItem?: {
            __typename?: 'PageModuleItemCollection';
            idCreatedUtc: string;
            collection?: {
              __typename?: 'Collection';
              allessehCollectionId: string;
              idCreatedUtc: string;
              id: string;
              createdUtc: number;
              updatedUtc?: number | null;
              name: string;
              isArchived: boolean;
              allessehJsonQuery?: string | null;
              contentItems: Array<{
                __typename?: 'CollectionContentItem';
                originId: string;
                originContentType: string;
                content?: string | null;
              }>;
            } | null;
          } | null;
          allessehCollectionItem?: {
            __typename?: 'PageModuleItemAllessehCollection';
            allessehCollectionId: string;
          } | null;
          linkedItem?: {
            __typename?: 'PageModuleItemLinkedItem';
            headline: string;
            summary?: string | null;
            url: string;
            media?: string | null;
          } | null;
        };
      }>;
    }>;
  };
};

export type PagesQueryVariables = Exact<{
  pagesInput: PagesInput;
  paginationParams: PaginationParams;
}>;

export type PagesQuery = {
  __typename?: 'Query';
  pages: {
    __typename?: 'PageConnection';
    edges: Array<{
      __typename?: 'PageEdge';
      node: { __typename?: 'Page'; name: string; revisionGroupKey: string; pageType: PageType; routeKey: string };
    }>;
    pageInfo: { __typename?: 'PageInfo'; endCursor?: string | null; hasNextPage: boolean };
  };
};

export type PageByRevisionGroupKeyQueryVariables = Exact<{
  revisionGroupKey: Scalars['String'];
  publicationKey: Scalars['String'];
}>;

export type PageByRevisionGroupKeyQuery = {
  __typename?: 'Query';
  pageByRevisionGroupKey: {
    __typename?: 'Page';
    name: string;
    notes?: string | null;
    revisionGroupKey: string;
    createdUtc: number;
    isMobileAppScreen: boolean;
    layoutId: string;
    routeKey: string;
    pageType: PageType;
    publishUtc?: number | null;
    creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
    revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
    config?: { __typename?: 'PageRouteConfig'; summaryPriority: string } | null;
    pageModules: Array<{
      __typename?: 'PageModule';
      uiModuleType: UiModuleType;
      uiModuleFields: {
        __typename?: 'UiModule';
        twoColumnModule?: {
          __typename?: 'UiTwoColumnModule';
          treatmentType: UiTwoColumnTreatmentType;
          leftModules: Array<{
            __typename?: 'PageModule';
            uiModuleType: UiModuleType;
            uiModuleFields: {
              __typename?: 'UiModule';
              basicModule?: {
                __typename?: 'UiBasicModule';
                treatmentType: UiBasicTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
              } | null;
              titleModule?: {
                __typename?: 'UiTitleModule';
                treatmentType: UiTitleTreatmentType;
                title?: string | null;
                titleUrl?: string | null;
                subtitle?: string | null;
                subtitleUrl?: string | null;
                allowedMeta?: Array<Metadata> | null;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
              } | null;
              rankedModule?: {
                __typename?: 'UiRankedModule';
                treatmentType: UiRankedTreatmentType;
                title: string;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
              } | null;
              textModule?: {
                __typename?: 'UiTextModule';
                treatmentType: UiTextTreatmentType;
                mainText: string;
                secondaryText: string;
                allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
              } | null;
              basicOptionalModule?: {
                __typename?: 'UiBasicOptionalModule';
                treatmentType: UiBasicOptionalTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                moduleName?: string | null;
              } | null;
              feedsModule?: {
                __typename?: 'UiFeedsModule';
                treatmentType: UiFeedsTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
              } | null;
            };
            moduleItems: Array<{
              __typename?: 'PageModuleItem';
              itemType: PageModuleItemType;
              itemFields: {
                __typename?: 'PageModuleItemFields';
                contentItem?: {
                  __typename?: 'PageModuleItemContent';
                  originId: string;
                  originContentType: string;
                  content?: string | null;
                } | null;
                queryItem?: {
                  __typename?: 'PageModuleItemQuery';
                  jsonQuery: string;
                  isFeed?: boolean | null;
                  title?: string | null;
                  url?: string | null;
                } | null;
                collectionItem?: {
                  __typename?: 'PageModuleItemCollection';
                  idCreatedUtc: string;
                  collection?: {
                    __typename?: 'Collection';
                    allessehCollectionId: string;
                    idCreatedUtc: string;
                    id: string;
                    createdUtc: number;
                    updatedUtc?: number | null;
                    name: string;
                    isArchived: boolean;
                    allessehJsonQuery?: string | null;
                    contentItems: Array<{
                      __typename?: 'CollectionContentItem';
                      originId: string;
                      originContentType: string;
                      content?: string | null;
                    }>;
                  } | null;
                } | null;
                allessehCollectionItem?: {
                  __typename?: 'PageModuleItemAllessehCollection';
                  allessehCollectionId: string;
                } | null;
                linkedItem?: {
                  __typename?: 'PageModuleItemLinkedItem';
                  headline: string;
                  summary?: string | null;
                  url: string;
                  media?: string | null;
                } | null;
              };
            }>;
          }>;
          rightModules: Array<{
            __typename?: 'PageModule';
            uiModuleType: UiModuleType;
            uiModuleFields: {
              __typename?: 'UiModule';
              basicModule?: {
                __typename?: 'UiBasicModule';
                treatmentType: UiBasicTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
              } | null;
              titleModule?: {
                __typename?: 'UiTitleModule';
                treatmentType: UiTitleTreatmentType;
                title?: string | null;
                titleUrl?: string | null;
                subtitle?: string | null;
                subtitleUrl?: string | null;
                allowedMeta?: Array<Metadata> | null;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
              } | null;
              rankedModule?: {
                __typename?: 'UiRankedModule';
                treatmentType: UiRankedTreatmentType;
                title: string;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
              } | null;
              textModule?: {
                __typename?: 'UiTextModule';
                treatmentType: UiTextTreatmentType;
                mainText: string;
                secondaryText: string;
                allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
              } | null;
              basicOptionalModule?: {
                __typename?: 'UiBasicOptionalModule';
                treatmentType: UiBasicOptionalTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                moduleName?: string | null;
              } | null;
              feedsModule?: {
                __typename?: 'UiFeedsModule';
                treatmentType: UiFeedsTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
              } | null;
            };
            moduleItems: Array<{
              __typename?: 'PageModuleItem';
              itemType: PageModuleItemType;
              itemFields: {
                __typename?: 'PageModuleItemFields';
                contentItem?: {
                  __typename?: 'PageModuleItemContent';
                  originId: string;
                  originContentType: string;
                  content?: string | null;
                } | null;
                queryItem?: {
                  __typename?: 'PageModuleItemQuery';
                  jsonQuery: string;
                  isFeed?: boolean | null;
                  title?: string | null;
                  url?: string | null;
                } | null;
                collectionItem?: {
                  __typename?: 'PageModuleItemCollection';
                  idCreatedUtc: string;
                  collection?: {
                    __typename?: 'Collection';
                    allessehCollectionId: string;
                    idCreatedUtc: string;
                    id: string;
                    createdUtc: number;
                    updatedUtc?: number | null;
                    name: string;
                    isArchived: boolean;
                    allessehJsonQuery?: string | null;
                    contentItems: Array<{
                      __typename?: 'CollectionContentItem';
                      originId: string;
                      originContentType: string;
                      content?: string | null;
                    }>;
                  } | null;
                } | null;
                allessehCollectionItem?: {
                  __typename?: 'PageModuleItemAllessehCollection';
                  allessehCollectionId: string;
                } | null;
                linkedItem?: {
                  __typename?: 'PageModuleItemLinkedItem';
                  headline: string;
                  summary?: string | null;
                  url: string;
                  media?: string | null;
                } | null;
              };
            }>;
          }>;
        } | null;
        basicModule?: {
          __typename?: 'UiBasicModule';
          treatmentType: UiBasicTreatmentType;
          contentTypes: Array<PublicationSettingSearchableContentType>;
          allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
        } | null;
        titleModule?: {
          __typename?: 'UiTitleModule';
          treatmentType: UiTitleTreatmentType;
          title?: string | null;
          titleUrl?: string | null;
          subtitle?: string | null;
          subtitleUrl?: string | null;
          allowedMeta?: Array<Metadata> | null;
          contentTypes: Array<PublicationSettingSearchableContentType>;
          allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
        } | null;
        rankedModule?: {
          __typename?: 'UiRankedModule';
          treatmentType: UiRankedTreatmentType;
          title: string;
          contentTypes: Array<PublicationSettingSearchableContentType>;
          allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
        } | null;
        textModule?: {
          __typename?: 'UiTextModule';
          treatmentType: UiTextTreatmentType;
          mainText: string;
          secondaryText: string;
          allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
        } | null;
        basicOptionalModule?: {
          __typename?: 'UiBasicOptionalModule';
          treatmentType: UiBasicOptionalTreatmentType;
          contentTypes: Array<PublicationSettingSearchableContentType>;
          allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
          moduleName?: string | null;
        } | null;
        feedsModule?: {
          __typename?: 'UiFeedsModule';
          treatmentType: UiFeedsTreatmentType;
          contentTypes: Array<PublicationSettingSearchableContentType>;
          allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
        } | null;
      };
      moduleItems: Array<{
        __typename?: 'PageModuleItem';
        itemType: PageModuleItemType;
        itemFields: {
          __typename?: 'PageModuleItemFields';
          contentItem?: {
            __typename?: 'PageModuleItemContent';
            originId: string;
            originContentType: string;
            content?: string | null;
          } | null;
          queryItem?: {
            __typename?: 'PageModuleItemQuery';
            jsonQuery: string;
            isFeed?: boolean | null;
            title?: string | null;
            url?: string | null;
          } | null;
          collectionItem?: {
            __typename?: 'PageModuleItemCollection';
            idCreatedUtc: string;
            collection?: {
              __typename?: 'Collection';
              allessehCollectionId: string;
              idCreatedUtc: string;
              id: string;
              createdUtc: number;
              updatedUtc?: number | null;
              name: string;
              isArchived: boolean;
              allessehJsonQuery?: string | null;
              contentItems: Array<{
                __typename?: 'CollectionContentItem';
                originId: string;
                originContentType: string;
                content?: string | null;
              }>;
            } | null;
          } | null;
          allessehCollectionItem?: {
            __typename?: 'PageModuleItemAllessehCollection';
            allessehCollectionId: string;
          } | null;
          linkedItem?: {
            __typename?: 'PageModuleItemLinkedItem';
            headline: string;
            summary?: string | null;
            url: string;
            media?: string | null;
          } | null;
        };
      }>;
    }>;
  };
};

export type PagesPublishedByRevisionGroupKeyQueryVariables = Exact<{
  revisionGroupKey: Scalars['String'];
  paginationParams: PaginationParams;
  publicationKey: Scalars['String'];
}>;

export type PagesPublishedByRevisionGroupKeyQuery = {
  __typename?: 'Query';
  pagesPublishedByRevisionGroupKey: {
    __typename?: 'PageConnection';
    edges: Array<{
      __typename?: 'PageEdge';
      cursor: string;
      node: {
        __typename?: 'Page';
        name: string;
        notes?: string | null;
        revisionGroupKey: string;
        createdUtc: number;
        isMobileAppScreen: boolean;
        layoutId: string;
        routeKey: string;
        pageType: PageType;
        publishUtc?: number | null;
        creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
        revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
        config?: { __typename?: 'PageRouteConfig'; summaryPriority: string } | null;
        pageModules: Array<{
          __typename?: 'PageModule';
          uiModuleType: UiModuleType;
          uiModuleFields: {
            __typename?: 'UiModule';
            twoColumnModule?: {
              __typename?: 'UiTwoColumnModule';
              treatmentType: UiTwoColumnTreatmentType;
              leftModules: Array<{
                __typename?: 'PageModule';
                uiModuleType: UiModuleType;
                uiModuleFields: {
                  __typename?: 'UiModule';
                  basicModule?: {
                    __typename?: 'UiBasicModule';
                    treatmentType: UiBasicTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                  } | null;
                  titleModule?: {
                    __typename?: 'UiTitleModule';
                    treatmentType: UiTitleTreatmentType;
                    title?: string | null;
                    titleUrl?: string | null;
                    subtitle?: string | null;
                    subtitleUrl?: string | null;
                    allowedMeta?: Array<Metadata> | null;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
                  } | null;
                  rankedModule?: {
                    __typename?: 'UiRankedModule';
                    treatmentType: UiRankedTreatmentType;
                    title: string;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
                  } | null;
                  textModule?: {
                    __typename?: 'UiTextModule';
                    treatmentType: UiTextTreatmentType;
                    mainText: string;
                    secondaryText: string;
                    allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
                  } | null;
                  basicOptionalModule?: {
                    __typename?: 'UiBasicOptionalModule';
                    treatmentType: UiBasicOptionalTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                    moduleName?: string | null;
                  } | null;
                  feedsModule?: {
                    __typename?: 'UiFeedsModule';
                    treatmentType: UiFeedsTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
                  } | null;
                };
                moduleItems: Array<{
                  __typename?: 'PageModuleItem';
                  itemType: PageModuleItemType;
                  itemFields: {
                    __typename?: 'PageModuleItemFields';
                    contentItem?: {
                      __typename?: 'PageModuleItemContent';
                      originId: string;
                      originContentType: string;
                      content?: string | null;
                    } | null;
                    queryItem?: {
                      __typename?: 'PageModuleItemQuery';
                      jsonQuery: string;
                      isFeed?: boolean | null;
                      title?: string | null;
                      url?: string | null;
                    } | null;
                    collectionItem?: {
                      __typename?: 'PageModuleItemCollection';
                      idCreatedUtc: string;
                      collection?: {
                        __typename?: 'Collection';
                        allessehCollectionId: string;
                        idCreatedUtc: string;
                        id: string;
                        createdUtc: number;
                        updatedUtc?: number | null;
                        name: string;
                        isArchived: boolean;
                        allessehJsonQuery?: string | null;
                        contentItems: Array<{
                          __typename?: 'CollectionContentItem';
                          originId: string;
                          originContentType: string;
                          content?: string | null;
                        }>;
                      } | null;
                    } | null;
                    allessehCollectionItem?: {
                      __typename?: 'PageModuleItemAllessehCollection';
                      allessehCollectionId: string;
                    } | null;
                    linkedItem?: {
                      __typename?: 'PageModuleItemLinkedItem';
                      headline: string;
                      summary?: string | null;
                      url: string;
                      media?: string | null;
                    } | null;
                  };
                }>;
              }>;
              rightModules: Array<{
                __typename?: 'PageModule';
                uiModuleType: UiModuleType;
                uiModuleFields: {
                  __typename?: 'UiModule';
                  basicModule?: {
                    __typename?: 'UiBasicModule';
                    treatmentType: UiBasicTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                  } | null;
                  titleModule?: {
                    __typename?: 'UiTitleModule';
                    treatmentType: UiTitleTreatmentType;
                    title?: string | null;
                    titleUrl?: string | null;
                    subtitle?: string | null;
                    subtitleUrl?: string | null;
                    allowedMeta?: Array<Metadata> | null;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
                  } | null;
                  rankedModule?: {
                    __typename?: 'UiRankedModule';
                    treatmentType: UiRankedTreatmentType;
                    title: string;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
                  } | null;
                  textModule?: {
                    __typename?: 'UiTextModule';
                    treatmentType: UiTextTreatmentType;
                    mainText: string;
                    secondaryText: string;
                    allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
                  } | null;
                  basicOptionalModule?: {
                    __typename?: 'UiBasicOptionalModule';
                    treatmentType: UiBasicOptionalTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                    moduleName?: string | null;
                  } | null;
                  feedsModule?: {
                    __typename?: 'UiFeedsModule';
                    treatmentType: UiFeedsTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
                  } | null;
                };
                moduleItems: Array<{
                  __typename?: 'PageModuleItem';
                  itemType: PageModuleItemType;
                  itemFields: {
                    __typename?: 'PageModuleItemFields';
                    contentItem?: {
                      __typename?: 'PageModuleItemContent';
                      originId: string;
                      originContentType: string;
                      content?: string | null;
                    } | null;
                    queryItem?: {
                      __typename?: 'PageModuleItemQuery';
                      jsonQuery: string;
                      isFeed?: boolean | null;
                      title?: string | null;
                      url?: string | null;
                    } | null;
                    collectionItem?: {
                      __typename?: 'PageModuleItemCollection';
                      idCreatedUtc: string;
                      collection?: {
                        __typename?: 'Collection';
                        allessehCollectionId: string;
                        idCreatedUtc: string;
                        id: string;
                        createdUtc: number;
                        updatedUtc?: number | null;
                        name: string;
                        isArchived: boolean;
                        allessehJsonQuery?: string | null;
                        contentItems: Array<{
                          __typename?: 'CollectionContentItem';
                          originId: string;
                          originContentType: string;
                          content?: string | null;
                        }>;
                      } | null;
                    } | null;
                    allessehCollectionItem?: {
                      __typename?: 'PageModuleItemAllessehCollection';
                      allessehCollectionId: string;
                    } | null;
                    linkedItem?: {
                      __typename?: 'PageModuleItemLinkedItem';
                      headline: string;
                      summary?: string | null;
                      url: string;
                      media?: string | null;
                    } | null;
                  };
                }>;
              }>;
            } | null;
            basicModule?: {
              __typename?: 'UiBasicModule';
              treatmentType: UiBasicTreatmentType;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
            } | null;
            titleModule?: {
              __typename?: 'UiTitleModule';
              treatmentType: UiTitleTreatmentType;
              title?: string | null;
              titleUrl?: string | null;
              subtitle?: string | null;
              subtitleUrl?: string | null;
              allowedMeta?: Array<Metadata> | null;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
            } | null;
            rankedModule?: {
              __typename?: 'UiRankedModule';
              treatmentType: UiRankedTreatmentType;
              title: string;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
            } | null;
            textModule?: {
              __typename?: 'UiTextModule';
              treatmentType: UiTextTreatmentType;
              mainText: string;
              secondaryText: string;
              allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
            } | null;
            basicOptionalModule?: {
              __typename?: 'UiBasicOptionalModule';
              treatmentType: UiBasicOptionalTreatmentType;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
              moduleName?: string | null;
            } | null;
            feedsModule?: {
              __typename?: 'UiFeedsModule';
              treatmentType: UiFeedsTreatmentType;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
            } | null;
          };
          moduleItems: Array<{
            __typename?: 'PageModuleItem';
            itemType: PageModuleItemType;
            itemFields: {
              __typename?: 'PageModuleItemFields';
              contentItem?: {
                __typename?: 'PageModuleItemContent';
                originId: string;
                originContentType: string;
                content?: string | null;
              } | null;
              queryItem?: {
                __typename?: 'PageModuleItemQuery';
                jsonQuery: string;
                isFeed?: boolean | null;
                title?: string | null;
                url?: string | null;
              } | null;
              collectionItem?: {
                __typename?: 'PageModuleItemCollection';
                idCreatedUtc: string;
                collection?: {
                  __typename?: 'Collection';
                  allessehCollectionId: string;
                  idCreatedUtc: string;
                  id: string;
                  createdUtc: number;
                  updatedUtc?: number | null;
                  name: string;
                  isArchived: boolean;
                  allessehJsonQuery?: string | null;
                  contentItems: Array<{
                    __typename?: 'CollectionContentItem';
                    originId: string;
                    originContentType: string;
                    content?: string | null;
                  }>;
                } | null;
              } | null;
              allessehCollectionItem?: {
                __typename?: 'PageModuleItemAllessehCollection';
                allessehCollectionId: string;
              } | null;
              linkedItem?: {
                __typename?: 'PageModuleItemLinkedItem';
                headline: string;
                summary?: string | null;
                url: string;
                media?: string | null;
              } | null;
            };
          }>;
        }>;
      };
    }>;
    pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type PagesByPublishUtcTimestampQueryVariables = Exact<{
  revisionGroupKey: Scalars['String'];
  publishUtc: Scalars['Float'];
  paginationParams: PaginationParams;
  publicationKey: Scalars['String'];
}>;

export type PagesByPublishUtcTimestampQuery = {
  __typename?: 'Query';
  pagesByPublishUtcTimestamp: {
    __typename?: 'PageConnection';
    edges: Array<{
      __typename?: 'PageEdge';
      cursor: string;
      node: {
        __typename?: 'Page';
        name: string;
        notes?: string | null;
        revisionGroupKey: string;
        createdUtc: number;
        isMobileAppScreen: boolean;
        layoutId: string;
        routeKey: string;
        pageType: PageType;
        publishUtc?: number | null;
        creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
        revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
        config?: { __typename?: 'PageRouteConfig'; summaryPriority: string } | null;
        pageModules: Array<{
          __typename?: 'PageModule';
          uiModuleType: UiModuleType;
          uiModuleFields: {
            __typename?: 'UiModule';
            twoColumnModule?: {
              __typename?: 'UiTwoColumnModule';
              treatmentType: UiTwoColumnTreatmentType;
              leftModules: Array<{
                __typename?: 'PageModule';
                uiModuleType: UiModuleType;
                uiModuleFields: {
                  __typename?: 'UiModule';
                  basicModule?: {
                    __typename?: 'UiBasicModule';
                    treatmentType: UiBasicTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                  } | null;
                  titleModule?: {
                    __typename?: 'UiTitleModule';
                    treatmentType: UiTitleTreatmentType;
                    title?: string | null;
                    titleUrl?: string | null;
                    subtitle?: string | null;
                    subtitleUrl?: string | null;
                    allowedMeta?: Array<Metadata> | null;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
                  } | null;
                  rankedModule?: {
                    __typename?: 'UiRankedModule';
                    treatmentType: UiRankedTreatmentType;
                    title: string;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
                  } | null;
                  textModule?: {
                    __typename?: 'UiTextModule';
                    treatmentType: UiTextTreatmentType;
                    mainText: string;
                    secondaryText: string;
                    allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
                  } | null;
                  basicOptionalModule?: {
                    __typename?: 'UiBasicOptionalModule';
                    treatmentType: UiBasicOptionalTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                    moduleName?: string | null;
                  } | null;
                  feedsModule?: {
                    __typename?: 'UiFeedsModule';
                    treatmentType: UiFeedsTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
                  } | null;
                };
                moduleItems: Array<{
                  __typename?: 'PageModuleItem';
                  itemType: PageModuleItemType;
                  itemFields: {
                    __typename?: 'PageModuleItemFields';
                    contentItem?: {
                      __typename?: 'PageModuleItemContent';
                      originId: string;
                      originContentType: string;
                      content?: string | null;
                    } | null;
                    queryItem?: {
                      __typename?: 'PageModuleItemQuery';
                      jsonQuery: string;
                      isFeed?: boolean | null;
                      title?: string | null;
                      url?: string | null;
                    } | null;
                    collectionItem?: {
                      __typename?: 'PageModuleItemCollection';
                      idCreatedUtc: string;
                      collection?: {
                        __typename?: 'Collection';
                        allessehCollectionId: string;
                        idCreatedUtc: string;
                        id: string;
                        createdUtc: number;
                        updatedUtc?: number | null;
                        name: string;
                        isArchived: boolean;
                        allessehJsonQuery?: string | null;
                        contentItems: Array<{
                          __typename?: 'CollectionContentItem';
                          originId: string;
                          originContentType: string;
                          content?: string | null;
                        }>;
                      } | null;
                    } | null;
                    allessehCollectionItem?: {
                      __typename?: 'PageModuleItemAllessehCollection';
                      allessehCollectionId: string;
                    } | null;
                    linkedItem?: {
                      __typename?: 'PageModuleItemLinkedItem';
                      headline: string;
                      summary?: string | null;
                      url: string;
                      media?: string | null;
                    } | null;
                  };
                }>;
              }>;
              rightModules: Array<{
                __typename?: 'PageModule';
                uiModuleType: UiModuleType;
                uiModuleFields: {
                  __typename?: 'UiModule';
                  basicModule?: {
                    __typename?: 'UiBasicModule';
                    treatmentType: UiBasicTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                  } | null;
                  titleModule?: {
                    __typename?: 'UiTitleModule';
                    treatmentType: UiTitleTreatmentType;
                    title?: string | null;
                    titleUrl?: string | null;
                    subtitle?: string | null;
                    subtitleUrl?: string | null;
                    allowedMeta?: Array<Metadata> | null;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
                  } | null;
                  rankedModule?: {
                    __typename?: 'UiRankedModule';
                    treatmentType: UiRankedTreatmentType;
                    title: string;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
                  } | null;
                  textModule?: {
                    __typename?: 'UiTextModule';
                    treatmentType: UiTextTreatmentType;
                    mainText: string;
                    secondaryText: string;
                    allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
                  } | null;
                  basicOptionalModule?: {
                    __typename?: 'UiBasicOptionalModule';
                    treatmentType: UiBasicOptionalTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                    moduleName?: string | null;
                  } | null;
                  feedsModule?: {
                    __typename?: 'UiFeedsModule';
                    treatmentType: UiFeedsTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
                  } | null;
                };
                moduleItems: Array<{
                  __typename?: 'PageModuleItem';
                  itemType: PageModuleItemType;
                  itemFields: {
                    __typename?: 'PageModuleItemFields';
                    contentItem?: {
                      __typename?: 'PageModuleItemContent';
                      originId: string;
                      originContentType: string;
                      content?: string | null;
                    } | null;
                    queryItem?: {
                      __typename?: 'PageModuleItemQuery';
                      jsonQuery: string;
                      isFeed?: boolean | null;
                      title?: string | null;
                      url?: string | null;
                    } | null;
                    collectionItem?: {
                      __typename?: 'PageModuleItemCollection';
                      idCreatedUtc: string;
                      collection?: {
                        __typename?: 'Collection';
                        allessehCollectionId: string;
                        idCreatedUtc: string;
                        id: string;
                        createdUtc: number;
                        updatedUtc?: number | null;
                        name: string;
                        isArchived: boolean;
                        allessehJsonQuery?: string | null;
                        contentItems: Array<{
                          __typename?: 'CollectionContentItem';
                          originId: string;
                          originContentType: string;
                          content?: string | null;
                        }>;
                      } | null;
                    } | null;
                    allessehCollectionItem?: {
                      __typename?: 'PageModuleItemAllessehCollection';
                      allessehCollectionId: string;
                    } | null;
                    linkedItem?: {
                      __typename?: 'PageModuleItemLinkedItem';
                      headline: string;
                      summary?: string | null;
                      url: string;
                      media?: string | null;
                    } | null;
                  };
                }>;
              }>;
            } | null;
            basicModule?: {
              __typename?: 'UiBasicModule';
              treatmentType: UiBasicTreatmentType;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
            } | null;
            titleModule?: {
              __typename?: 'UiTitleModule';
              treatmentType: UiTitleTreatmentType;
              title?: string | null;
              titleUrl?: string | null;
              subtitle?: string | null;
              subtitleUrl?: string | null;
              allowedMeta?: Array<Metadata> | null;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
            } | null;
            rankedModule?: {
              __typename?: 'UiRankedModule';
              treatmentType: UiRankedTreatmentType;
              title: string;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
            } | null;
            textModule?: {
              __typename?: 'UiTextModule';
              treatmentType: UiTextTreatmentType;
              mainText: string;
              secondaryText: string;
              allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
            } | null;
            basicOptionalModule?: {
              __typename?: 'UiBasicOptionalModule';
              treatmentType: UiBasicOptionalTreatmentType;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
              moduleName?: string | null;
            } | null;
            feedsModule?: {
              __typename?: 'UiFeedsModule';
              treatmentType: UiFeedsTreatmentType;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
            } | null;
          };
          moduleItems: Array<{
            __typename?: 'PageModuleItem';
            itemType: PageModuleItemType;
            itemFields: {
              __typename?: 'PageModuleItemFields';
              contentItem?: {
                __typename?: 'PageModuleItemContent';
                originId: string;
                originContentType: string;
                content?: string | null;
              } | null;
              queryItem?: {
                __typename?: 'PageModuleItemQuery';
                jsonQuery: string;
                isFeed?: boolean | null;
                title?: string | null;
                url?: string | null;
              } | null;
              collectionItem?: {
                __typename?: 'PageModuleItemCollection';
                idCreatedUtc: string;
                collection?: {
                  __typename?: 'Collection';
                  allessehCollectionId: string;
                  idCreatedUtc: string;
                  id: string;
                  createdUtc: number;
                  updatedUtc?: number | null;
                  name: string;
                  isArchived: boolean;
                  allessehJsonQuery?: string | null;
                  contentItems: Array<{
                    __typename?: 'CollectionContentItem';
                    originId: string;
                    originContentType: string;
                    content?: string | null;
                  }>;
                } | null;
              } | null;
              allessehCollectionItem?: {
                __typename?: 'PageModuleItemAllessehCollection';
                allessehCollectionId: string;
              } | null;
              linkedItem?: {
                __typename?: 'PageModuleItemLinkedItem';
                headline: string;
                summary?: string | null;
                url: string;
                media?: string | null;
              } | null;
            };
          }>;
        }>;
      };
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      hasPreviousPage?: boolean | null;
      hasNextPage: boolean;
      startCursor?: string | null;
      endCursor?: string | null;
    };
  };
};

export type PagesPublishedOnDateQueryVariables = Exact<{
  revisionGroupKey: Scalars['String'];
  publishUtc: Scalars['Float'];
  paginationParams: PaginationParams;
  publicationKey: Scalars['String'];
}>;

export type PagesPublishedOnDateQuery = {
  __typename?: 'Query';
  pagesPublishedOnDate: {
    __typename?: 'PageConnection';
    edges: Array<{
      __typename?: 'PageEdge';
      cursor: string;
      node: {
        __typename?: 'Page';
        name: string;
        notes?: string | null;
        revisionGroupKey: string;
        createdUtc: number;
        isMobileAppScreen: boolean;
        layoutId: string;
        routeKey: string;
        pageType: PageType;
        publishUtc?: number | null;
        creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
        revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
        config?: { __typename?: 'PageRouteConfig'; summaryPriority: string } | null;
        pageModules: Array<{
          __typename?: 'PageModule';
          uiModuleType: UiModuleType;
          uiModuleFields: {
            __typename?: 'UiModule';
            twoColumnModule?: {
              __typename?: 'UiTwoColumnModule';
              treatmentType: UiTwoColumnTreatmentType;
              leftModules: Array<{
                __typename?: 'PageModule';
                uiModuleType: UiModuleType;
                uiModuleFields: {
                  __typename?: 'UiModule';
                  basicModule?: {
                    __typename?: 'UiBasicModule';
                    treatmentType: UiBasicTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                  } | null;
                  titleModule?: {
                    __typename?: 'UiTitleModule';
                    treatmentType: UiTitleTreatmentType;
                    title?: string | null;
                    titleUrl?: string | null;
                    subtitle?: string | null;
                    subtitleUrl?: string | null;
                    allowedMeta?: Array<Metadata> | null;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
                  } | null;
                  rankedModule?: {
                    __typename?: 'UiRankedModule';
                    treatmentType: UiRankedTreatmentType;
                    title: string;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
                  } | null;
                  textModule?: {
                    __typename?: 'UiTextModule';
                    treatmentType: UiTextTreatmentType;
                    mainText: string;
                    secondaryText: string;
                    allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
                  } | null;
                  basicOptionalModule?: {
                    __typename?: 'UiBasicOptionalModule';
                    treatmentType: UiBasicOptionalTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                    moduleName?: string | null;
                  } | null;
                  feedsModule?: {
                    __typename?: 'UiFeedsModule';
                    treatmentType: UiFeedsTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
                  } | null;
                };
                moduleItems: Array<{
                  __typename?: 'PageModuleItem';
                  itemType: PageModuleItemType;
                  itemFields: {
                    __typename?: 'PageModuleItemFields';
                    contentItem?: {
                      __typename?: 'PageModuleItemContent';
                      originId: string;
                      originContentType: string;
                      content?: string | null;
                    } | null;
                    queryItem?: {
                      __typename?: 'PageModuleItemQuery';
                      jsonQuery: string;
                      isFeed?: boolean | null;
                      title?: string | null;
                      url?: string | null;
                    } | null;
                    collectionItem?: {
                      __typename?: 'PageModuleItemCollection';
                      idCreatedUtc: string;
                      collection?: {
                        __typename?: 'Collection';
                        allessehCollectionId: string;
                        idCreatedUtc: string;
                        id: string;
                        createdUtc: number;
                        updatedUtc?: number | null;
                        name: string;
                        isArchived: boolean;
                        allessehJsonQuery?: string | null;
                        contentItems: Array<{
                          __typename?: 'CollectionContentItem';
                          originId: string;
                          originContentType: string;
                          content?: string | null;
                        }>;
                      } | null;
                    } | null;
                    allessehCollectionItem?: {
                      __typename?: 'PageModuleItemAllessehCollection';
                      allessehCollectionId: string;
                    } | null;
                    linkedItem?: {
                      __typename?: 'PageModuleItemLinkedItem';
                      headline: string;
                      summary?: string | null;
                      url: string;
                      media?: string | null;
                    } | null;
                  };
                }>;
              }>;
              rightModules: Array<{
                __typename?: 'PageModule';
                uiModuleType: UiModuleType;
                uiModuleFields: {
                  __typename?: 'UiModule';
                  basicModule?: {
                    __typename?: 'UiBasicModule';
                    treatmentType: UiBasicTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                  } | null;
                  titleModule?: {
                    __typename?: 'UiTitleModule';
                    treatmentType: UiTitleTreatmentType;
                    title?: string | null;
                    titleUrl?: string | null;
                    subtitle?: string | null;
                    subtitleUrl?: string | null;
                    allowedMeta?: Array<Metadata> | null;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
                  } | null;
                  rankedModule?: {
                    __typename?: 'UiRankedModule';
                    treatmentType: UiRankedTreatmentType;
                    title: string;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
                  } | null;
                  textModule?: {
                    __typename?: 'UiTextModule';
                    treatmentType: UiTextTreatmentType;
                    mainText: string;
                    secondaryText: string;
                    allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
                  } | null;
                  basicOptionalModule?: {
                    __typename?: 'UiBasicOptionalModule';
                    treatmentType: UiBasicOptionalTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                    moduleName?: string | null;
                  } | null;
                  feedsModule?: {
                    __typename?: 'UiFeedsModule';
                    treatmentType: UiFeedsTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
                  } | null;
                };
                moduleItems: Array<{
                  __typename?: 'PageModuleItem';
                  itemType: PageModuleItemType;
                  itemFields: {
                    __typename?: 'PageModuleItemFields';
                    contentItem?: {
                      __typename?: 'PageModuleItemContent';
                      originId: string;
                      originContentType: string;
                      content?: string | null;
                    } | null;
                    queryItem?: {
                      __typename?: 'PageModuleItemQuery';
                      jsonQuery: string;
                      isFeed?: boolean | null;
                      title?: string | null;
                      url?: string | null;
                    } | null;
                    collectionItem?: {
                      __typename?: 'PageModuleItemCollection';
                      idCreatedUtc: string;
                      collection?: {
                        __typename?: 'Collection';
                        allessehCollectionId: string;
                        idCreatedUtc: string;
                        id: string;
                        createdUtc: number;
                        updatedUtc?: number | null;
                        name: string;
                        isArchived: boolean;
                        allessehJsonQuery?: string | null;
                        contentItems: Array<{
                          __typename?: 'CollectionContentItem';
                          originId: string;
                          originContentType: string;
                          content?: string | null;
                        }>;
                      } | null;
                    } | null;
                    allessehCollectionItem?: {
                      __typename?: 'PageModuleItemAllessehCollection';
                      allessehCollectionId: string;
                    } | null;
                    linkedItem?: {
                      __typename?: 'PageModuleItemLinkedItem';
                      headline: string;
                      summary?: string | null;
                      url: string;
                      media?: string | null;
                    } | null;
                  };
                }>;
              }>;
            } | null;
            basicModule?: {
              __typename?: 'UiBasicModule';
              treatmentType: UiBasicTreatmentType;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
            } | null;
            titleModule?: {
              __typename?: 'UiTitleModule';
              treatmentType: UiTitleTreatmentType;
              title?: string | null;
              titleUrl?: string | null;
              subtitle?: string | null;
              subtitleUrl?: string | null;
              allowedMeta?: Array<Metadata> | null;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
            } | null;
            rankedModule?: {
              __typename?: 'UiRankedModule';
              treatmentType: UiRankedTreatmentType;
              title: string;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
            } | null;
            textModule?: {
              __typename?: 'UiTextModule';
              treatmentType: UiTextTreatmentType;
              mainText: string;
              secondaryText: string;
              allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
            } | null;
            basicOptionalModule?: {
              __typename?: 'UiBasicOptionalModule';
              treatmentType: UiBasicOptionalTreatmentType;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
              moduleName?: string | null;
            } | null;
            feedsModule?: {
              __typename?: 'UiFeedsModule';
              treatmentType: UiFeedsTreatmentType;
              contentTypes: Array<PublicationSettingSearchableContentType>;
              allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
            } | null;
          };
          moduleItems: Array<{
            __typename?: 'PageModuleItem';
            itemType: PageModuleItemType;
            itemFields: {
              __typename?: 'PageModuleItemFields';
              contentItem?: {
                __typename?: 'PageModuleItemContent';
                originId: string;
                originContentType: string;
                content?: string | null;
              } | null;
              queryItem?: {
                __typename?: 'PageModuleItemQuery';
                jsonQuery: string;
                isFeed?: boolean | null;
                title?: string | null;
                url?: string | null;
              } | null;
              collectionItem?: {
                __typename?: 'PageModuleItemCollection';
                idCreatedUtc: string;
                collection?: {
                  __typename?: 'Collection';
                  allessehCollectionId: string;
                  idCreatedUtc: string;
                  id: string;
                  createdUtc: number;
                  updatedUtc?: number | null;
                  name: string;
                  isArchived: boolean;
                  allessehJsonQuery?: string | null;
                  contentItems: Array<{
                    __typename?: 'CollectionContentItem';
                    originId: string;
                    originContentType: string;
                    content?: string | null;
                  }>;
                } | null;
              } | null;
              allessehCollectionItem?: {
                __typename?: 'PageModuleItemAllessehCollection';
                allessehCollectionId: string;
              } | null;
              linkedItem?: {
                __typename?: 'PageModuleItemLinkedItem';
                headline: string;
                summary?: string | null;
                url: string;
                media?: string | null;
              } | null;
            };
          }>;
        }>;
      };
    }>;
  };
};

export type PagesForCollectionIdCreatedUtcQueryVariables = Exact<{
  collectionIdCreatedUtc: Scalars['String'];
  publicationKey: Scalars['String'];
}>;

export type PagesForCollectionIdCreatedUtcQuery = {
  __typename?: 'Query';
  pagesForCollectionIdCreatedUtc: Array<{
    __typename?: 'PagesForCollection';
    numRevisions: number;
    latestPage: { __typename?: 'Page'; name: string; revisionGroupKey: string; publishUtc?: number | null };
  }>;
};

export type PublicationSettingUpdateMutationVariables = Exact<{
  publicationSettingUpdateInput: PublicationSettingUpdateInput;
}>;

export type PublicationSettingUpdateMutation = {
  __typename?: 'Mutation';
  publicationSettingUpdate: {
    __typename?: 'PublicationSetting';
    publicationKey: string;
    searchableContentTypes: Array<PublicationSettingSearchableContentType>;
    defaultContentTypes: Array<PublicationSettingSearchableContentType>;
    baseRoute: string;
    previewBaseRoute: string;
    baseAllessehQuery: string;
    baseProductCardAllessehQuery?: string | null;
    disableAltSummEdit?: boolean | null;
    editableExternalPublications?: Array<string> | null;
    slugMappings?: Record<string, unknown> | null;
    snippetyIMDomain?: string | null;
    snippetyVideoDomain?: string | null;
    snippetyChartDomain?: string | null;
    defaultAltSumm?: string | null;
    baseLiveCoverageAllessehQuery?: string | null;
    baseTappableAllessehQuery?: string | null;
    disableEmbargo?: boolean | null;
    preferredTimezone: { __typename?: 'PreferredTimezone'; timezone: string; timezoneAbbreviation: string };
  };
};

export type PublicationSettingsQueryVariables = Exact<{
  publicationKey: Scalars['String'];
}>;

export type PublicationSettingsQuery = {
  __typename?: 'Query';
  publicationSetting: {
    __typename?: 'PublicationSetting';
    publicationKey: string;
    searchableContentTypes: Array<PublicationSettingSearchableContentType>;
    defaultContentTypes: Array<PublicationSettingSearchableContentType>;
    baseRoute: string;
    previewBaseRoute: string;
    baseAllessehQuery: string;
    baseProductCardAllessehQuery?: string | null;
    disableAltSummEdit?: boolean | null;
    editableExternalPublications?: Array<string> | null;
    slugMappings?: Record<string, unknown> | null;
    snippetyIMDomain?: string | null;
    snippetyVideoDomain?: string | null;
    snippetyChartDomain?: string | null;
    defaultAltSumm?: string | null;
    baseLiveCoverageAllessehQuery?: string | null;
    baseTappableAllessehQuery?: string | null;
    baseAudioAllessehQuery?: string | null;
    baseVideoAllessehQuery?: string | null;
    baseRecipeAllessehQuery?: string | null;
    basePodcastAllessehQuery?: string | null;
    baseWebStoryAllessehQuery?: string | null;
    baseOpinionAllessehQuery?: string | null;
    baseMarketwatchAllessehQuery?: string | null;
    basePentaAllessehQuery?: string | null;
    baseAfpAllessehQuery?: string | null;
    baseWsjAllessehQuery?: string | null;
    baseMansionGlobalAllessehQuery?: string | null;
    baseBarronsAllessehQuery?: string | null;
    baseDowJonesRiskJournalDJEventsAllessehQuery?: string | null;
    baseDowJonesRiskJournalCCOEventsAllessehQuery?: string | null;
    baseDowJonesRiskJournalContributorAllessehQuery?: string | null;
    baseWorldECRAllessehQuery?: string | null;
    baseExportComplianceManagerAllessehQuery?: string | null;
    enabledArtifacts: Array<Artifact>;
    disableEmbargo?: boolean | null;
    itpRequiredPageTypes?: Array<ItpIssuePageType> | null;
    beforePublishValidation?: Record<string, unknown> | null;
    preferredTimezone: { __typename?: 'PreferredTimezone'; timezone: string; timezoneAbbreviation: string };
  };
};

export type ScheduleContentMutationVariables = Exact<{
  scheduledContentCreateInput: ScheduledContentCreateInput;
  publicationKey: Scalars['String'];
}>;

export type ScheduleContentMutation = {
  __typename?: 'Mutation';
  scheduleContent: {
    __typename?: 'ScheduledContent';
    allessehId: string;
    publishUtc: number;
    createdUtc: number;
    status: ScheduledContentStatus;
    contentType: AllessehContentType;
    creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
  };
};

export type RescheduleContentMutationVariables = Exact<{
  scheduledContentRescheduleInput: ScheduledContentRescheduleInput;
  publicationKey: Scalars['String'];
}>;

export type RescheduleContentMutation = {
  __typename?: 'Mutation';
  rescheduleContent: {
    __typename?: 'ScheduledContent';
    allessehId: string;
    publishUtc: number;
    createdUtc: number;
    status: ScheduledContentStatus;
    contentType: AllessehContentType;
    creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
  };
};

export type UpdateScheduledContentMutationVariables = Exact<{
  scheduledContentUpdateInput: ScheduledContentUpdateInput;
  publicationKey: Scalars['String'];
}>;

export type UpdateScheduledContentMutation = {
  __typename?: 'Mutation';
  updateScheduledContent: {
    __typename?: 'ScheduledContent';
    allessehId: string;
    publishUtc: number;
    createdUtc: number;
    updatedUtc?: number | null;
    status: ScheduledContentStatus;
    contentType: AllessehContentType;
    creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
    revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
  };
};

export type CancelScheduledContentMutationVariables = Exact<{
  scheduledContentCancelInput: ScheduledContentCancelInput;
  publicationKey: Scalars['String'];
}>;

export type CancelScheduledContentMutation = {
  __typename?: 'Mutation';
  cancelScheduledContent: {
    __typename?: 'ScheduledContent';
    allessehId: string;
    publishUtc: number;
    createdUtc: number;
    updatedUtc?: number | null;
    status: ScheduledContentStatus;
    contentType: AllessehContentType;
    creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
    revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
  };
};

export type SaveDraftContentMutationVariables = Exact<{
  scheduledContentSaveDraftInput: ScheduledContentSaveDraftInput;
  publicationKey: Scalars['String'];
}>;

export type SaveDraftContentMutation = {
  __typename?: 'Mutation';
  saveDraftContent: {
    __typename?: 'ScheduledContent';
    allessehId: string;
    publishUtc: number;
    createdUtc: number;
    updatedUtc?: number | null;
    status: ScheduledContentStatus;
    contentType: AllessehContentType;
    creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
    revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
  };
};

export type GetScheduledContentByAllessehIdQueryVariables = Exact<{
  publicationKey: Scalars['String'];
  allessehId: Scalars['String'];
  publishUtc?: InputMaybe<Scalars['Float']>;
}>;

export type GetScheduledContentByAllessehIdQuery = {
  __typename?: 'Query';
  scheduledContentByAllessehId: Array<{
    __typename?: 'ScheduledContent';
    allessehId: string;
    publishUtc: number;
    createdUtc: number;
    updatedUtc?: number | null;
    status: ScheduledContentStatus;
    contentType: AllessehContentType;
    creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
    revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
    replacedBy?: { __typename?: 'ReplacedBy'; allessehId: string; publishUtc: number } | null;
    body:
      | {
          __typename?: 'BannerDTO';
          metadata: {
            __typename?: 'BaseMetadata';
            allessehId: string;
            createdUtc: number;
            name: string;
            publicationKey: string;
            publishUtc?: number | null;
            updatedUtc?: number | null;
            creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
            revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
          };
          root: {
            __typename?: 'BannerModuleContainer';
            type: string;
            subtype?: string | null;
            attributes: {
              __typename?: 'BannerModuleAttributes';
              moduleId?: string | null;
              pageModule?: {
                __typename?: 'PageModule';
                uiModuleType: UiModuleType;
                uiModuleFields: {
                  __typename?: 'UiModule';
                  basicModule?: { __typename?: 'UiBasicModule'; treatmentType: UiBasicTreatmentType } | null;
                };
              } | null;
            };
            collection: Array<
              | {
                  __typename?: 'ArticleItem';
                  type: string;
                  content?: string | null;
                  attributes: {
                    __typename?: 'ArticleAttributes';
                    base_doc_id: string;
                    hosted_url: string;
                    id: string;
                    link: string;
                    originContentType?: string | null;
                    originId?: string | null;
                    product: string;
                    seo_id: string;
                    status: string;
                  };
                }
              | { __typename?: 'ExternalCollectionItem' }
              | { __typename?: 'LinkedItem' }
              | { __typename?: 'MobileArticleItem' }
              | { __typename?: 'QueryItem' }
            >;
          };
        }
      | {
          __typename?: 'Collection';
          idCreatedUtc: string;
          id: string;
          createdUtc: number;
          updatedUtc?: number | null;
          allessehCollectionId: string;
          name: string;
          notes?: string | null;
          consumer?: string | null;
          allessehJsonQuery?: string | null;
          isArchived: boolean;
          contentItems: Array<{
            __typename?: 'CollectionContentItem';
            originId: string;
            originContentType: string;
            content?: string | null;
          }>;
          creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
          revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
          parameters: {
            __typename?: 'CollectionParameters';
            offPlatform?: {
              __typename?: 'OffPlatformParams';
              minItems?: number | null;
              maxItems?: number | null;
              moduleDisplayName: string;
              defaultAltSummVariant: string;
              hostingPageURL: string;
            } | null;
          };
        }
      | { __typename?: 'CollectionDTO' }
      | {
          __typename?: 'ITPIssueWithPages';
          createdUtc: number;
          issueDate: string;
          issueId: string;
          label: string;
          publishUtc?: number | null;
          refreshedUtc?: number | null;
          status: ItpIssueStatus;
          updatedUtc?: number | null;
          summaryPriority: string;
          itpRevisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
          creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
          pages: Array<{
            __typename?: 'ITPPage';
            adType: string;
            adZones: string;
            allessehCollectionId?: string | null;
            isHidden: boolean;
            issueId: string;
            label: string;
            pageType: string;
            pageModules: Array<{
              __typename?: 'PageModule';
              uiModuleType: UiModuleType;
              moduleItems: Array<{
                __typename?: 'PageModuleItem';
                itemType: PageModuleItemType;
                itemFields: {
                  __typename?: 'PageModuleItemFields';
                  contentItem?: {
                    __typename?: 'PageModuleItemContent';
                    originId: string;
                    originContentType: string;
                    content?: string | null;
                    base_doc_id: string;
                    hosted_url: string;
                    id: string;
                    link: string;
                    product: string;
                    seo_id: string;
                    status: string;
                  } | null;
                  queryItem?: { __typename?: 'PageModuleItemQuery'; jsonQuery: string } | null;
                  collectionItem?: {
                    __typename?: 'PageModuleItemCollection';
                    idCreatedUtc: string;
                    collection?: {
                      __typename?: 'Collection';
                      allessehCollectionId: string;
                      idCreatedUtc: string;
                      id: string;
                      createdUtc: number;
                      updatedUtc?: number | null;
                      name: string;
                      isArchived: boolean;
                      publicationKey: string;
                      allessehJsonQuery?: string | null;
                      creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
                      revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
                      parameters: {
                        __typename?: 'CollectionParameters';
                        offPlatform?: {
                          __typename?: 'OffPlatformParams';
                          minItems?: number | null;
                          maxItems?: number | null;
                          moduleDisplayName: string;
                          defaultAltSummVariant: string;
                          hostingPageURL: string;
                        } | null;
                      };
                      contentItems: Array<{
                        __typename?: 'CollectionContentItem';
                        originId: string;
                        originContentType: string;
                        content?: string | null;
                        base_doc_id: string;
                        hosted_url: string;
                        id: string;
                        link: string;
                        product: string;
                        seo_id: string;
                        status: string;
                      }>;
                    } | null;
                  } | null;
                  allessehCollectionItem?: {
                    __typename?: 'PageModuleItemAllessehCollection';
                    allessehCollectionId: string;
                  } | null;
                };
              }>;
              uiModuleFields: {
                __typename?: 'UiModule';
                basicModule?: {
                  __typename?: 'UiBasicModule';
                  treatmentType: UiBasicTreatmentType;
                  contentTypes: Array<PublicationSettingSearchableContentType>;
                  allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                } | null;
              };
            }>;
          }>;
        }
      | {
          __typename?: 'NewsletterDTO';
          metadata: {
            __typename?: 'BaseMetadata';
            allessehId: string;
            createdUtc: number;
            name: string;
            publicationKey: string;
            publishUtc?: number | null;
            updatedUtc?: number | null;
          };
          root: {
            __typename?: 'NewsletterPageContainer';
            subtype?: string | null;
            type: string;
            collection: Array<{
              __typename?: 'ModuleContainer';
              subtype?: string | null;
              type: string;
              collection: Array<
                | {
                    __typename?: 'ArticleItem';
                    content?: string | null;
                    type: string;
                    attributes: {
                      __typename?: 'ArticleAttributes';
                      base_doc_id: string;
                      hosted_url: string;
                      id: string;
                      link: string;
                      originContentType?: string | null;
                      originId?: string | null;
                      product: string;
                      seo_id: string;
                      status: string;
                    };
                  }
                | { __typename?: 'ExternalCollectionItem' }
                | { __typename?: 'LinkedItem' }
                | { __typename?: 'MobileArticleItem' }
                | { __typename?: 'QueryItem' }
              >;
              attributes: {
                __typename?: 'ModuleAttributes';
                moduleId?: string | null;
                pageModule?: {
                  __typename?: 'PageModule';
                  uiModuleType: UiModuleType;
                  uiModuleFields: {
                    __typename?: 'UiModule';
                    basicModule?: {
                      __typename?: 'UiBasicModule';
                      treatmentType: UiBasicTreatmentType;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                    } | null;
                    titleModule?: {
                      __typename?: 'UiTitleModule';
                      treatmentType: UiTitleTreatmentType;
                      title?: string | null;
                      titleUrl?: string | null;
                      subtitle?: string | null;
                      subtitleUrl?: string | null;
                      allowedMeta?: Array<Metadata> | null;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
                    } | null;
                    rankedModule?: {
                      __typename?: 'UiRankedModule';
                      treatmentType: UiRankedTreatmentType;
                      title: string;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
                    } | null;
                    textModule?: {
                      __typename?: 'UiTextModule';
                      treatmentType: UiTextTreatmentType;
                      mainText: string;
                      secondaryText: string;
                      allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
                    } | null;
                    basicOptionalModule?: {
                      __typename?: 'UiBasicOptionalModule';
                      treatmentType: UiBasicOptionalTreatmentType;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                      moduleName?: string | null;
                    } | null;
                    feedsModule?: {
                      __typename?: 'UiFeedsModule';
                      treatmentType: UiFeedsTreatmentType;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
                    } | null;
                  };
                  moduleItems: Array<{
                    __typename?: 'PageModuleItem';
                    itemType: PageModuleItemType;
                    itemFields: {
                      __typename?: 'PageModuleItemFields';
                      contentItem?: {
                        __typename?: 'PageModuleItemContent';
                        originId: string;
                        originContentType: string;
                        content?: string | null;
                      } | null;
                      queryItem?: {
                        __typename?: 'PageModuleItemQuery';
                        jsonQuery: string;
                        isFeed?: boolean | null;
                        title?: string | null;
                        url?: string | null;
                      } | null;
                      collectionItem?: {
                        __typename?: 'PageModuleItemCollection';
                        idCreatedUtc: string;
                        collection?: {
                          __typename?: 'Collection';
                          allessehCollectionId: string;
                          idCreatedUtc: string;
                          id: string;
                          createdUtc: number;
                          updatedUtc?: number | null;
                          name: string;
                          isArchived: boolean;
                          allessehJsonQuery?: string | null;
                          contentItems: Array<{
                            __typename?: 'CollectionContentItem';
                            originId: string;
                            originContentType: string;
                            content?: string | null;
                          }>;
                        } | null;
                      } | null;
                      allessehCollectionItem?: {
                        __typename?: 'PageModuleItemAllessehCollection';
                        allessehCollectionId: string;
                      } | null;
                      linkedItem?: {
                        __typename?: 'PageModuleItemLinkedItem';
                        headline: string;
                        summary?: string | null;
                        url: string;
                        media?: string | null;
                      } | null;
                    };
                  }>;
                } | null;
              };
            }>;
            attributes: {
              __typename?: 'NewsletterPageAttributes';
              campaignId: string;
              layoutId?: string | null;
              newsletterId: number;
              preHeaderText: string;
              recipients?: string | null;
              replyToEmail: string;
              senderName: string;
              subject: string;
            };
          };
        }
      | {
          __typename?: 'OffPlatformDTO';
          idCreatedUtc: string;
          metadata: {
            __typename?: 'OffPlatformMetadata';
            allessehId: string;
            consumer: string;
            createdUtc: number;
            isArchived: boolean;
            name: string;
            notes?: string | null;
            publicationKey: string;
            publishUtc?: number | null;
            updatedUtc?: number | null;
            creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
            revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
          };
          root: {
            __typename?: 'OffPlatformListContainer';
            type: string;
            subtype?: string | null;
            collection: Array<
              | {
                  __typename?: 'ArticleItem';
                  content?: string | null;
                  type: string;
                  attributes: {
                    __typename?: 'ArticleAttributes';
                    base_doc_id: string;
                    hosted_url: string;
                    id: string;
                    link: string;
                    originContentType?: string | null;
                    originId?: string | null;
                    product: string;
                    seo_id: string;
                    status: string;
                  };
                }
              | { __typename?: 'ExternalCollectionItem' }
              | { __typename?: 'LinkedItem' }
              | { __typename?: 'MobileArticleItem' }
              | {
                  __typename?: 'QueryItem';
                  type: string;
                  attributes: {
                    __typename?: 'QueryAttributes';
                    query: Record<string, unknown>;
                    feedTitle?: string | null;
                    feedUrl?: string | null;
                    isFeed?: boolean | null;
                  };
                }
            >;
            attributes: {
              __typename?: 'OffPlatformListAttributes';
              defaultAltSummVariant: string;
              hostingPageURL: string;
              maxItems: number;
              minItems: number;
              moduleDisplayName: string;
            };
          };
        }
      | {
          __typename?: 'Page';
          name: string;
          notes?: string | null;
          revisionGroupKey: string;
          createdUtc: number;
          isMobileAppScreen: boolean;
          layoutId: string;
          routeKey: string;
          pageType: PageType;
          publishUtc?: number | null;
          creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
          revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
          config?: { __typename?: 'PageRouteConfig'; summaryPriority: string } | null;
          pageModules: Array<{
            __typename?: 'PageModule';
            uiModuleType: UiModuleType;
            uiModuleFields: {
              __typename?: 'UiModule';
              twoColumnModule?: {
                __typename?: 'UiTwoColumnModule';
                treatmentType: UiTwoColumnTreatmentType;
                leftModules: Array<{
                  __typename?: 'PageModule';
                  uiModuleType: UiModuleType;
                  uiModuleFields: {
                    __typename?: 'UiModule';
                    basicModule?: {
                      __typename?: 'UiBasicModule';
                      treatmentType: UiBasicTreatmentType;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                    } | null;
                    titleModule?: {
                      __typename?: 'UiTitleModule';
                      treatmentType: UiTitleTreatmentType;
                      title?: string | null;
                      titleUrl?: string | null;
                      subtitle?: string | null;
                      subtitleUrl?: string | null;
                      allowedMeta?: Array<Metadata> | null;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
                    } | null;
                    rankedModule?: {
                      __typename?: 'UiRankedModule';
                      treatmentType: UiRankedTreatmentType;
                      title: string;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
                    } | null;
                    textModule?: {
                      __typename?: 'UiTextModule';
                      treatmentType: UiTextTreatmentType;
                      mainText: string;
                      secondaryText: string;
                      allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
                    } | null;
                    basicOptionalModule?: {
                      __typename?: 'UiBasicOptionalModule';
                      treatmentType: UiBasicOptionalTreatmentType;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                      moduleName?: string | null;
                    } | null;
                    feedsModule?: {
                      __typename?: 'UiFeedsModule';
                      treatmentType: UiFeedsTreatmentType;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
                    } | null;
                  };
                  moduleItems: Array<{
                    __typename?: 'PageModuleItem';
                    itemType: PageModuleItemType;
                    itemFields: {
                      __typename?: 'PageModuleItemFields';
                      contentItem?: {
                        __typename?: 'PageModuleItemContent';
                        originId: string;
                        originContentType: string;
                        content?: string | null;
                      } | null;
                      queryItem?: {
                        __typename?: 'PageModuleItemQuery';
                        jsonQuery: string;
                        isFeed?: boolean | null;
                        title?: string | null;
                        url?: string | null;
                      } | null;
                      collectionItem?: {
                        __typename?: 'PageModuleItemCollection';
                        idCreatedUtc: string;
                        collection?: {
                          __typename?: 'Collection';
                          allessehCollectionId: string;
                          idCreatedUtc: string;
                          id: string;
                          createdUtc: number;
                          updatedUtc?: number | null;
                          name: string;
                          isArchived: boolean;
                          allessehJsonQuery?: string | null;
                          contentItems: Array<{
                            __typename?: 'CollectionContentItem';
                            originId: string;
                            originContentType: string;
                            content?: string | null;
                          }>;
                        } | null;
                      } | null;
                      allessehCollectionItem?: {
                        __typename?: 'PageModuleItemAllessehCollection';
                        allessehCollectionId: string;
                      } | null;
                      linkedItem?: {
                        __typename?: 'PageModuleItemLinkedItem';
                        headline: string;
                        summary?: string | null;
                        url: string;
                        media?: string | null;
                      } | null;
                    };
                  }>;
                }>;
                rightModules: Array<{
                  __typename?: 'PageModule';
                  uiModuleType: UiModuleType;
                  uiModuleFields: {
                    __typename?: 'UiModule';
                    basicModule?: {
                      __typename?: 'UiBasicModule';
                      treatmentType: UiBasicTreatmentType;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                    } | null;
                    titleModule?: {
                      __typename?: 'UiTitleModule';
                      treatmentType: UiTitleTreatmentType;
                      title?: string | null;
                      titleUrl?: string | null;
                      subtitle?: string | null;
                      subtitleUrl?: string | null;
                      allowedMeta?: Array<Metadata> | null;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
                    } | null;
                    rankedModule?: {
                      __typename?: 'UiRankedModule';
                      treatmentType: UiRankedTreatmentType;
                      title: string;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
                    } | null;
                    textModule?: {
                      __typename?: 'UiTextModule';
                      treatmentType: UiTextTreatmentType;
                      mainText: string;
                      secondaryText: string;
                      allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
                    } | null;
                    basicOptionalModule?: {
                      __typename?: 'UiBasicOptionalModule';
                      treatmentType: UiBasicOptionalTreatmentType;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                      moduleName?: string | null;
                    } | null;
                    feedsModule?: {
                      __typename?: 'UiFeedsModule';
                      treatmentType: UiFeedsTreatmentType;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
                    } | null;
                  };
                  moduleItems: Array<{
                    __typename?: 'PageModuleItem';
                    itemType: PageModuleItemType;
                    itemFields: {
                      __typename?: 'PageModuleItemFields';
                      contentItem?: {
                        __typename?: 'PageModuleItemContent';
                        originId: string;
                        originContentType: string;
                        content?: string | null;
                      } | null;
                      queryItem?: {
                        __typename?: 'PageModuleItemQuery';
                        jsonQuery: string;
                        isFeed?: boolean | null;
                        title?: string | null;
                        url?: string | null;
                      } | null;
                      collectionItem?: {
                        __typename?: 'PageModuleItemCollection';
                        idCreatedUtc: string;
                        collection?: {
                          __typename?: 'Collection';
                          allessehCollectionId: string;
                          idCreatedUtc: string;
                          id: string;
                          createdUtc: number;
                          updatedUtc?: number | null;
                          name: string;
                          isArchived: boolean;
                          allessehJsonQuery?: string | null;
                          contentItems: Array<{
                            __typename?: 'CollectionContentItem';
                            originId: string;
                            originContentType: string;
                            content?: string | null;
                          }>;
                        } | null;
                      } | null;
                      allessehCollectionItem?: {
                        __typename?: 'PageModuleItemAllessehCollection';
                        allessehCollectionId: string;
                      } | null;
                      linkedItem?: {
                        __typename?: 'PageModuleItemLinkedItem';
                        headline: string;
                        summary?: string | null;
                        url: string;
                        media?: string | null;
                      } | null;
                    };
                  }>;
                }>;
              } | null;
              basicModule?: {
                __typename?: 'UiBasicModule';
                treatmentType: UiBasicTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
              } | null;
              titleModule?: {
                __typename?: 'UiTitleModule';
                treatmentType: UiTitleTreatmentType;
                title?: string | null;
                titleUrl?: string | null;
                subtitle?: string | null;
                subtitleUrl?: string | null;
                allowedMeta?: Array<Metadata> | null;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
              } | null;
              rankedModule?: {
                __typename?: 'UiRankedModule';
                treatmentType: UiRankedTreatmentType;
                title: string;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
              } | null;
              textModule?: {
                __typename?: 'UiTextModule';
                treatmentType: UiTextTreatmentType;
                mainText: string;
                secondaryText: string;
                allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
              } | null;
              basicOptionalModule?: {
                __typename?: 'UiBasicOptionalModule';
                treatmentType: UiBasicOptionalTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                moduleName?: string | null;
              } | null;
              feedsModule?: {
                __typename?: 'UiFeedsModule';
                treatmentType: UiFeedsTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
              } | null;
            };
            moduleItems: Array<{
              __typename?: 'PageModuleItem';
              itemType: PageModuleItemType;
              itemFields: {
                __typename?: 'PageModuleItemFields';
                contentItem?: {
                  __typename?: 'PageModuleItemContent';
                  originId: string;
                  originContentType: string;
                  content?: string | null;
                } | null;
                queryItem?: {
                  __typename?: 'PageModuleItemQuery';
                  jsonQuery: string;
                  isFeed?: boolean | null;
                  title?: string | null;
                  url?: string | null;
                } | null;
                collectionItem?: {
                  __typename?: 'PageModuleItemCollection';
                  idCreatedUtc: string;
                  collection?: {
                    __typename?: 'Collection';
                    allessehCollectionId: string;
                    idCreatedUtc: string;
                    id: string;
                    createdUtc: number;
                    updatedUtc?: number | null;
                    name: string;
                    isArchived: boolean;
                    allessehJsonQuery?: string | null;
                    contentItems: Array<{
                      __typename?: 'CollectionContentItem';
                      originId: string;
                      originContentType: string;
                      content?: string | null;
                    }>;
                  } | null;
                } | null;
                allessehCollectionItem?: {
                  __typename?: 'PageModuleItemAllessehCollection';
                  allessehCollectionId: string;
                } | null;
                linkedItem?: {
                  __typename?: 'PageModuleItemLinkedItem';
                  headline: string;
                  summary?: string | null;
                  url: string;
                  media?: string | null;
                } | null;
              };
            }>;
          }>;
        }
      | {
          __typename?: 'PageDTO';
          type: string;
          metadata: {
            __typename?: 'BaseMetadata';
            allessehId: string;
            createdUtc: number;
            name: string;
            publicationKey: string;
            publishUtc?: number | null;
            updatedUtc?: number | null;
            creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
            revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
          };
          root: {
            __typename?: 'SectionContainer';
            type: string;
            attributes: {
              __typename?: 'SectionAttributes';
              adPlacementType?: string | null;
              adZone?: string | null;
              isHidden: boolean;
              pageType: string;
              routeKey: string;
              sectionKey?: string | null;
              sectionLabel?: string | null;
              summaryPriority: string;
            };
            collection: Array<{
              __typename?: 'PageContainer';
              type: string;
              attributes: { __typename?: 'PageAttributes'; layoutId?: string | null };
              collection: Array<{
                __typename?: 'ModuleContainer';
                type: string;
                attributes: {
                  __typename?: 'ModuleAttributes';
                  moduleId?: string | null;
                  pageModule?: {
                    __typename?: 'PageModule';
                    uiModuleType: UiModuleType;
                    uiModuleFields: {
                      __typename?: 'UiModule';
                      basicModule?: {
                        __typename?: 'UiBasicModule';
                        treatmentType: UiBasicTreatmentType;
                        contentTypes: Array<PublicationSettingSearchableContentType>;
                        allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                      } | null;
                      titleModule?: {
                        __typename?: 'UiTitleModule';
                        treatmentType: UiTitleTreatmentType;
                        title?: string | null;
                        titleUrl?: string | null;
                        subtitle?: string | null;
                        subtitleUrl?: string | null;
                        allowedMeta?: Array<Metadata> | null;
                        contentTypes: Array<PublicationSettingSearchableContentType>;
                        allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
                      } | null;
                      rankedModule?: {
                        __typename?: 'UiRankedModule';
                        treatmentType: UiRankedTreatmentType;
                        title: string;
                        contentTypes: Array<PublicationSettingSearchableContentType>;
                        allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
                      } | null;
                      textModule?: {
                        __typename?: 'UiTextModule';
                        treatmentType: UiTextTreatmentType;
                        mainText: string;
                        secondaryText: string;
                        allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
                      } | null;
                      basicOptionalModule?: {
                        __typename?: 'UiBasicOptionalModule';
                        treatmentType: UiBasicOptionalTreatmentType;
                        contentTypes: Array<PublicationSettingSearchableContentType>;
                        allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                        moduleName?: string | null;
                      } | null;
                      feedsModule?: {
                        __typename?: 'UiFeedsModule';
                        treatmentType: UiFeedsTreatmentType;
                        contentTypes: Array<PublicationSettingSearchableContentType>;
                        allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
                      } | null;
                    };
                  } | null;
                };
                collection: Array<
                  | {
                      __typename?: 'ArticleItem';
                      type: string;
                      content?: string | null;
                      attributes: {
                        __typename?: 'ArticleAttributes';
                        base_doc_id: string;
                        hosted_url: string;
                        id: string;
                        link: string;
                        originContentType?: string | null;
                        originId?: string | null;
                        product: string;
                        seo_id: string;
                        status: string;
                      };
                    }
                  | {
                      __typename?: 'ExternalCollectionItem';
                      type: string;
                      metadata: {
                        __typename?: 'ExternalCollectionMetadata';
                        id: string;
                        name: string;
                        createdUtc: number;
                      };
                      contentItems: Array<
                        | {
                            __typename?: 'ArticleItem';
                            type: string;
                            content?: string | null;
                            attributes: {
                              __typename?: 'ArticleAttributes';
                              base_doc_id: string;
                              hosted_url: string;
                              id: string;
                              link: string;
                              originContentType?: string | null;
                              originId?: string | null;
                              product: string;
                              seo_id: string;
                              status: string;
                            };
                          }
                        | { __typename?: 'ExternalCollectionItem' }
                        | { __typename?: 'LinkedItem' }
                        | { __typename?: 'MobileArticleItem' }
                        | {
                            __typename?: 'QueryItem';
                            type: string;
                            attributes: { __typename?: 'QueryAttributes'; query: Record<string, unknown> };
                          }
                      >;
                      attributes: { __typename?: 'ExternalCollectionAttributes'; id: string; repo: string };
                    }
                  | {
                      __typename?: 'LinkedItem';
                      type: string;
                      attributes: {
                        __typename?: 'LinkedItemAttributes';
                        id: string;
                        product: string;
                        title: string;
                        description?: string | null;
                        hosted_url: string;
                        image?: {
                          __typename?: 'ImageAttributes';
                          id: string;
                          alternate_text: string;
                          credit: string;
                          height: number;
                          name: string;
                          reuse_type: string;
                          media_type: string;
                          width: number;
                          alt_images: Array<string>;
                          type: string;
                          src: {
                            __typename?: 'ImageSourceAttributes';
                            image_id: string;
                            base_url: string;
                            path: string;
                            params: { __typename?: 'ImageParams'; size: number };
                          };
                          properties: { __typename?: 'Properties'; imphotoid: string; location: string };
                        } | null;
                      };
                    }
                  | {
                      __typename?: 'MobileArticleItem';
                      type: string;
                      subtype?: string | null;
                      content?: string | null;
                      attributes: {
                        __typename?: 'MobileArticleAttributes';
                        base_doc_id: string;
                        hosted_url: string;
                        id: string;
                        link: string;
                        originContentType?: string | null;
                        originId?: string | null;
                        product: string;
                        seo_id: string;
                        status: string;
                        showImage: boolean;
                        showImageBelow: boolean;
                        showFlashline: boolean;
                      };
                    }
                  | {
                      __typename?: 'QueryItem';
                      type: string;
                      attributes: {
                        __typename?: 'QueryAttributes';
                        query: Record<string, unknown>;
                        isFeed?: boolean | null;
                        feedTitle?: string | null;
                        feedUrl?: string | null;
                      };
                    }
                >;
              }>;
            }>;
          };
        };
  }>;
};

export type GetLiveContentByAllessehIdQueryVariables = Exact<{
  publicationKey: Scalars['String'];
  allessehId: Scalars['String'];
}>;

export type GetLiveContentByAllessehIdQuery = {
  __typename?: 'Query';
  liveContentByAllessehId: Array<{
    __typename?: 'ScheduledContent';
    allessehId: string;
    publishUtc: number;
    createdUtc: number;
    updatedUtc?: number | null;
    status: ScheduledContentStatus;
    contentType: AllessehContentType;
    creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
    revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
    replacedBy?: { __typename?: 'ReplacedBy'; allessehId: string; publishUtc: number } | null;
    body:
      | {
          __typename?: 'BannerDTO';
          metadata: {
            __typename?: 'BaseMetadata';
            allessehId: string;
            createdUtc: number;
            name: string;
            publicationKey: string;
            publishUtc?: number | null;
            updatedUtc?: number | null;
            creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
            revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
          };
          root: {
            __typename?: 'BannerModuleContainer';
            type: string;
            subtype?: string | null;
            attributes: {
              __typename?: 'BannerModuleAttributes';
              moduleId?: string | null;
              pageModule?: {
                __typename?: 'PageModule';
                uiModuleType: UiModuleType;
                uiModuleFields: {
                  __typename?: 'UiModule';
                  basicModule?: { __typename?: 'UiBasicModule'; treatmentType: UiBasicTreatmentType } | null;
                };
              } | null;
            };
            collection: Array<
              | {
                  __typename?: 'ArticleItem';
                  type: string;
                  content?: string | null;
                  attributes: {
                    __typename?: 'ArticleAttributes';
                    base_doc_id: string;
                    hosted_url: string;
                    id: string;
                    link: string;
                    originContentType?: string | null;
                    originId?: string | null;
                    product: string;
                    seo_id: string;
                    status: string;
                  };
                }
              | { __typename?: 'ExternalCollectionItem' }
              | { __typename?: 'LinkedItem' }
              | { __typename?: 'MobileArticleItem' }
              | { __typename?: 'QueryItem' }
            >;
          };
        }
      | {
          __typename?: 'Collection';
          idCreatedUtc: string;
          id: string;
          createdUtc: number;
          updatedUtc?: number | null;
          allessehCollectionId: string;
          name: string;
          notes?: string | null;
          consumer?: string | null;
          allessehJsonQuery?: string | null;
          isArchived: boolean;
          contentItems: Array<{
            __typename?: 'CollectionContentItem';
            originId: string;
            originContentType: string;
            content?: string | null;
          }>;
          creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
          revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
          parameters: {
            __typename?: 'CollectionParameters';
            offPlatform?: {
              __typename?: 'OffPlatformParams';
              minItems?: number | null;
              maxItems?: number | null;
              moduleDisplayName: string;
              defaultAltSummVariant: string;
              hostingPageURL: string;
            } | null;
          };
        }
      | { __typename?: 'CollectionDTO' }
      | {
          __typename?: 'ITPIssueWithPages';
          createdUtc: number;
          issueDate: string;
          issueId: string;
          label: string;
          publishUtc?: number | null;
          refreshedUtc?: number | null;
          status: ItpIssueStatus;
          updatedUtc?: number | null;
          summaryPriority: string;
          itpRevisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
          creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
          pages: Array<{
            __typename?: 'ITPPage';
            adType: string;
            adZones: string;
            allessehCollectionId?: string | null;
            isHidden: boolean;
            issueId: string;
            label: string;
            pageType: string;
            pageModules: Array<{
              __typename?: 'PageModule';
              uiModuleType: UiModuleType;
              moduleItems: Array<{
                __typename?: 'PageModuleItem';
                itemType: PageModuleItemType;
                itemFields: {
                  __typename?: 'PageModuleItemFields';
                  contentItem?: {
                    __typename?: 'PageModuleItemContent';
                    originId: string;
                    originContentType: string;
                    content?: string | null;
                    base_doc_id: string;
                    hosted_url: string;
                    id: string;
                    link: string;
                    product: string;
                    seo_id: string;
                    status: string;
                  } | null;
                  queryItem?: { __typename?: 'PageModuleItemQuery'; jsonQuery: string } | null;
                  collectionItem?: {
                    __typename?: 'PageModuleItemCollection';
                    idCreatedUtc: string;
                    collection?: {
                      __typename?: 'Collection';
                      allessehCollectionId: string;
                      idCreatedUtc: string;
                      id: string;
                      createdUtc: number;
                      updatedUtc?: number | null;
                      name: string;
                      isArchived: boolean;
                      publicationKey: string;
                      allessehJsonQuery?: string | null;
                      creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
                      revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
                      parameters: {
                        __typename?: 'CollectionParameters';
                        offPlatform?: {
                          __typename?: 'OffPlatformParams';
                          minItems?: number | null;
                          maxItems?: number | null;
                          moduleDisplayName: string;
                          defaultAltSummVariant: string;
                          hostingPageURL: string;
                        } | null;
                      };
                      contentItems: Array<{
                        __typename?: 'CollectionContentItem';
                        originId: string;
                        originContentType: string;
                        content?: string | null;
                        base_doc_id: string;
                        hosted_url: string;
                        id: string;
                        link: string;
                        product: string;
                        seo_id: string;
                        status: string;
                      }>;
                    } | null;
                  } | null;
                  allessehCollectionItem?: {
                    __typename?: 'PageModuleItemAllessehCollection';
                    allessehCollectionId: string;
                  } | null;
                };
              }>;
              uiModuleFields: {
                __typename?: 'UiModule';
                basicModule?: {
                  __typename?: 'UiBasicModule';
                  treatmentType: UiBasicTreatmentType;
                  contentTypes: Array<PublicationSettingSearchableContentType>;
                  allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                } | null;
              };
            }>;
          }>;
        }
      | {
          __typename?: 'NewsletterDTO';
          metadata: {
            __typename?: 'BaseMetadata';
            allessehId: string;
            createdUtc: number;
            name: string;
            publicationKey: string;
            publishUtc?: number | null;
            updatedUtc?: number | null;
          };
          root: {
            __typename?: 'NewsletterPageContainer';
            subtype?: string | null;
            type: string;
            collection: Array<{
              __typename?: 'ModuleContainer';
              subtype?: string | null;
              type: string;
              collection: Array<
                | {
                    __typename?: 'ArticleItem';
                    content?: string | null;
                    type: string;
                    attributes: {
                      __typename?: 'ArticleAttributes';
                      base_doc_id: string;
                      hosted_url: string;
                      id: string;
                      link: string;
                      originContentType?: string | null;
                      originId?: string | null;
                      product: string;
                      seo_id: string;
                      status: string;
                    };
                  }
                | { __typename?: 'ExternalCollectionItem' }
                | { __typename?: 'LinkedItem' }
                | { __typename?: 'MobileArticleItem' }
                | { __typename?: 'QueryItem' }
              >;
              attributes: {
                __typename?: 'ModuleAttributes';
                moduleId?: string | null;
                pageModule?: {
                  __typename?: 'PageModule';
                  uiModuleType: UiModuleType;
                  uiModuleFields: {
                    __typename?: 'UiModule';
                    basicModule?: {
                      __typename?: 'UiBasicModule';
                      treatmentType: UiBasicTreatmentType;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                    } | null;
                    titleModule?: {
                      __typename?: 'UiTitleModule';
                      treatmentType: UiTitleTreatmentType;
                      title?: string | null;
                      titleUrl?: string | null;
                      subtitle?: string | null;
                      subtitleUrl?: string | null;
                      allowedMeta?: Array<Metadata> | null;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
                    } | null;
                    rankedModule?: {
                      __typename?: 'UiRankedModule';
                      treatmentType: UiRankedTreatmentType;
                      title: string;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
                    } | null;
                    textModule?: {
                      __typename?: 'UiTextModule';
                      treatmentType: UiTextTreatmentType;
                      mainText: string;
                      secondaryText: string;
                      allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
                    } | null;
                    basicOptionalModule?: {
                      __typename?: 'UiBasicOptionalModule';
                      treatmentType: UiBasicOptionalTreatmentType;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                      moduleName?: string | null;
                    } | null;
                    feedsModule?: {
                      __typename?: 'UiFeedsModule';
                      treatmentType: UiFeedsTreatmentType;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
                    } | null;
                  };
                  moduleItems: Array<{
                    __typename?: 'PageModuleItem';
                    itemType: PageModuleItemType;
                    itemFields: {
                      __typename?: 'PageModuleItemFields';
                      contentItem?: {
                        __typename?: 'PageModuleItemContent';
                        originId: string;
                        originContentType: string;
                        content?: string | null;
                      } | null;
                      queryItem?: {
                        __typename?: 'PageModuleItemQuery';
                        jsonQuery: string;
                        isFeed?: boolean | null;
                        title?: string | null;
                        url?: string | null;
                      } | null;
                      collectionItem?: {
                        __typename?: 'PageModuleItemCollection';
                        idCreatedUtc: string;
                        collection?: {
                          __typename?: 'Collection';
                          allessehCollectionId: string;
                          idCreatedUtc: string;
                          id: string;
                          createdUtc: number;
                          updatedUtc?: number | null;
                          name: string;
                          isArchived: boolean;
                          allessehJsonQuery?: string | null;
                          contentItems: Array<{
                            __typename?: 'CollectionContentItem';
                            originId: string;
                            originContentType: string;
                            content?: string | null;
                          }>;
                        } | null;
                      } | null;
                      allessehCollectionItem?: {
                        __typename?: 'PageModuleItemAllessehCollection';
                        allessehCollectionId: string;
                      } | null;
                      linkedItem?: {
                        __typename?: 'PageModuleItemLinkedItem';
                        headline: string;
                        summary?: string | null;
                        url: string;
                        media?: string | null;
                      } | null;
                    };
                  }>;
                } | null;
              };
            }>;
            attributes: {
              __typename?: 'NewsletterPageAttributes';
              campaignId: string;
              layoutId?: string | null;
              newsletterId: number;
              preHeaderText: string;
              recipients?: string | null;
              replyToEmail: string;
              senderName: string;
              subject: string;
            };
          };
        }
      | { __typename?: 'OffPlatformDTO' }
      | {
          __typename?: 'Page';
          name: string;
          notes?: string | null;
          revisionGroupKey: string;
          createdUtc: number;
          isMobileAppScreen: boolean;
          layoutId: string;
          routeKey: string;
          pageType: PageType;
          publishUtc?: number | null;
          creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
          revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
          config?: { __typename?: 'PageRouteConfig'; summaryPriority: string } | null;
          pageModules: Array<{
            __typename?: 'PageModule';
            uiModuleType: UiModuleType;
            uiModuleFields: {
              __typename?: 'UiModule';
              twoColumnModule?: {
                __typename?: 'UiTwoColumnModule';
                treatmentType: UiTwoColumnTreatmentType;
                leftModules: Array<{
                  __typename?: 'PageModule';
                  uiModuleType: UiModuleType;
                  uiModuleFields: {
                    __typename?: 'UiModule';
                    basicModule?: {
                      __typename?: 'UiBasicModule';
                      treatmentType: UiBasicTreatmentType;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                    } | null;
                    titleModule?: {
                      __typename?: 'UiTitleModule';
                      treatmentType: UiTitleTreatmentType;
                      title?: string | null;
                      titleUrl?: string | null;
                      subtitle?: string | null;
                      subtitleUrl?: string | null;
                      allowedMeta?: Array<Metadata> | null;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
                    } | null;
                    rankedModule?: {
                      __typename?: 'UiRankedModule';
                      treatmentType: UiRankedTreatmentType;
                      title: string;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
                    } | null;
                    textModule?: {
                      __typename?: 'UiTextModule';
                      treatmentType: UiTextTreatmentType;
                      mainText: string;
                      secondaryText: string;
                      allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
                    } | null;
                    basicOptionalModule?: {
                      __typename?: 'UiBasicOptionalModule';
                      treatmentType: UiBasicOptionalTreatmentType;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                      moduleName?: string | null;
                    } | null;
                    feedsModule?: {
                      __typename?: 'UiFeedsModule';
                      treatmentType: UiFeedsTreatmentType;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
                    } | null;
                  };
                  moduleItems: Array<{
                    __typename?: 'PageModuleItem';
                    itemType: PageModuleItemType;
                    itemFields: {
                      __typename?: 'PageModuleItemFields';
                      contentItem?: {
                        __typename?: 'PageModuleItemContent';
                        originId: string;
                        originContentType: string;
                        content?: string | null;
                      } | null;
                      queryItem?: {
                        __typename?: 'PageModuleItemQuery';
                        jsonQuery: string;
                        isFeed?: boolean | null;
                        title?: string | null;
                        url?: string | null;
                      } | null;
                      collectionItem?: {
                        __typename?: 'PageModuleItemCollection';
                        idCreatedUtc: string;
                        collection?: {
                          __typename?: 'Collection';
                          allessehCollectionId: string;
                          idCreatedUtc: string;
                          id: string;
                          createdUtc: number;
                          updatedUtc?: number | null;
                          name: string;
                          isArchived: boolean;
                          allessehJsonQuery?: string | null;
                          contentItems: Array<{
                            __typename?: 'CollectionContentItem';
                            originId: string;
                            originContentType: string;
                            content?: string | null;
                          }>;
                        } | null;
                      } | null;
                      allessehCollectionItem?: {
                        __typename?: 'PageModuleItemAllessehCollection';
                        allessehCollectionId: string;
                      } | null;
                      linkedItem?: {
                        __typename?: 'PageModuleItemLinkedItem';
                        headline: string;
                        summary?: string | null;
                        url: string;
                        media?: string | null;
                      } | null;
                    };
                  }>;
                }>;
                rightModules: Array<{
                  __typename?: 'PageModule';
                  uiModuleType: UiModuleType;
                  uiModuleFields: {
                    __typename?: 'UiModule';
                    basicModule?: {
                      __typename?: 'UiBasicModule';
                      treatmentType: UiBasicTreatmentType;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                    } | null;
                    titleModule?: {
                      __typename?: 'UiTitleModule';
                      treatmentType: UiTitleTreatmentType;
                      title?: string | null;
                      titleUrl?: string | null;
                      subtitle?: string | null;
                      subtitleUrl?: string | null;
                      allowedMeta?: Array<Metadata> | null;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
                    } | null;
                    rankedModule?: {
                      __typename?: 'UiRankedModule';
                      treatmentType: UiRankedTreatmentType;
                      title: string;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
                    } | null;
                    textModule?: {
                      __typename?: 'UiTextModule';
                      treatmentType: UiTextTreatmentType;
                      mainText: string;
                      secondaryText: string;
                      allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
                    } | null;
                    basicOptionalModule?: {
                      __typename?: 'UiBasicOptionalModule';
                      treatmentType: UiBasicOptionalTreatmentType;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                      moduleName?: string | null;
                    } | null;
                    feedsModule?: {
                      __typename?: 'UiFeedsModule';
                      treatmentType: UiFeedsTreatmentType;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
                    } | null;
                  };
                  moduleItems: Array<{
                    __typename?: 'PageModuleItem';
                    itemType: PageModuleItemType;
                    itemFields: {
                      __typename?: 'PageModuleItemFields';
                      contentItem?: {
                        __typename?: 'PageModuleItemContent';
                        originId: string;
                        originContentType: string;
                        content?: string | null;
                      } | null;
                      queryItem?: {
                        __typename?: 'PageModuleItemQuery';
                        jsonQuery: string;
                        isFeed?: boolean | null;
                        title?: string | null;
                        url?: string | null;
                      } | null;
                      collectionItem?: {
                        __typename?: 'PageModuleItemCollection';
                        idCreatedUtc: string;
                        collection?: {
                          __typename?: 'Collection';
                          allessehCollectionId: string;
                          idCreatedUtc: string;
                          id: string;
                          createdUtc: number;
                          updatedUtc?: number | null;
                          name: string;
                          isArchived: boolean;
                          allessehJsonQuery?: string | null;
                          contentItems: Array<{
                            __typename?: 'CollectionContentItem';
                            originId: string;
                            originContentType: string;
                            content?: string | null;
                          }>;
                        } | null;
                      } | null;
                      allessehCollectionItem?: {
                        __typename?: 'PageModuleItemAllessehCollection';
                        allessehCollectionId: string;
                      } | null;
                      linkedItem?: {
                        __typename?: 'PageModuleItemLinkedItem';
                        headline: string;
                        summary?: string | null;
                        url: string;
                        media?: string | null;
                      } | null;
                    };
                  }>;
                }>;
              } | null;
              basicModule?: {
                __typename?: 'UiBasicModule';
                treatmentType: UiBasicTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
              } | null;
              titleModule?: {
                __typename?: 'UiTitleModule';
                treatmentType: UiTitleTreatmentType;
                title?: string | null;
                titleUrl?: string | null;
                subtitle?: string | null;
                subtitleUrl?: string | null;
                allowedMeta?: Array<Metadata> | null;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
              } | null;
              rankedModule?: {
                __typename?: 'UiRankedModule';
                treatmentType: UiRankedTreatmentType;
                title: string;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
              } | null;
              textModule?: {
                __typename?: 'UiTextModule';
                treatmentType: UiTextTreatmentType;
                mainText: string;
                secondaryText: string;
                allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
              } | null;
              basicOptionalModule?: {
                __typename?: 'UiBasicOptionalModule';
                treatmentType: UiBasicOptionalTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                moduleName?: string | null;
              } | null;
              feedsModule?: {
                __typename?: 'UiFeedsModule';
                treatmentType: UiFeedsTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
              } | null;
            };
            moduleItems: Array<{
              __typename?: 'PageModuleItem';
              itemType: PageModuleItemType;
              itemFields: {
                __typename?: 'PageModuleItemFields';
                contentItem?: {
                  __typename?: 'PageModuleItemContent';
                  originId: string;
                  originContentType: string;
                  content?: string | null;
                } | null;
                queryItem?: {
                  __typename?: 'PageModuleItemQuery';
                  jsonQuery: string;
                  isFeed?: boolean | null;
                  title?: string | null;
                  url?: string | null;
                } | null;
                collectionItem?: {
                  __typename?: 'PageModuleItemCollection';
                  idCreatedUtc: string;
                  collection?: {
                    __typename?: 'Collection';
                    allessehCollectionId: string;
                    idCreatedUtc: string;
                    id: string;
                    createdUtc: number;
                    updatedUtc?: number | null;
                    name: string;
                    isArchived: boolean;
                    allessehJsonQuery?: string | null;
                    contentItems: Array<{
                      __typename?: 'CollectionContentItem';
                      originId: string;
                      originContentType: string;
                      content?: string | null;
                    }>;
                  } | null;
                } | null;
                allessehCollectionItem?: {
                  __typename?: 'PageModuleItemAllessehCollection';
                  allessehCollectionId: string;
                } | null;
                linkedItem?: {
                  __typename?: 'PageModuleItemLinkedItem';
                  headline: string;
                  summary?: string | null;
                  url: string;
                  media?: string | null;
                } | null;
              };
            }>;
          }>;
        }
      | {
          __typename?: 'PageDTO';
          type: string;
          metadata: {
            __typename?: 'BaseMetadata';
            allessehId: string;
            createdUtc: number;
            name: string;
            publicationKey: string;
            publishUtc?: number | null;
            updatedUtc?: number | null;
            creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
            revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
          };
          root: {
            __typename?: 'SectionContainer';
            type: string;
            attributes: {
              __typename?: 'SectionAttributes';
              adPlacementType?: string | null;
              adZone?: string | null;
              isHidden: boolean;
              pageType: string;
              routeKey: string;
              sectionKey?: string | null;
              sectionLabel?: string | null;
              summaryPriority: string;
            };
            collection: Array<{
              __typename?: 'PageContainer';
              type: string;
              attributes: { __typename?: 'PageAttributes'; layoutId?: string | null };
              collection: Array<{
                __typename?: 'ModuleContainer';
                type: string;
                attributes: {
                  __typename?: 'ModuleAttributes';
                  moduleId?: string | null;
                  pageModule?: {
                    __typename?: 'PageModule';
                    uiModuleType: UiModuleType;
                    uiModuleFields: {
                      __typename?: 'UiModule';
                      basicModule?: {
                        __typename?: 'UiBasicModule';
                        treatmentType: UiBasicTreatmentType;
                        contentTypes: Array<PublicationSettingSearchableContentType>;
                        allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                      } | null;
                      titleModule?: {
                        __typename?: 'UiTitleModule';
                        treatmentType: UiTitleTreatmentType;
                        title?: string | null;
                        titleUrl?: string | null;
                        subtitle?: string | null;
                        subtitleUrl?: string | null;
                        allowedMeta?: Array<Metadata> | null;
                        contentTypes: Array<PublicationSettingSearchableContentType>;
                        allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
                      } | null;
                      rankedModule?: {
                        __typename?: 'UiRankedModule';
                        treatmentType: UiRankedTreatmentType;
                        title: string;
                        contentTypes: Array<PublicationSettingSearchableContentType>;
                        allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
                      } | null;
                      textModule?: {
                        __typename?: 'UiTextModule';
                        treatmentType: UiTextTreatmentType;
                        mainText: string;
                        secondaryText: string;
                        allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
                      } | null;
                      basicOptionalModule?: {
                        __typename?: 'UiBasicOptionalModule';
                        treatmentType: UiBasicOptionalTreatmentType;
                        contentTypes: Array<PublicationSettingSearchableContentType>;
                        allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                        moduleName?: string | null;
                      } | null;
                      feedsModule?: {
                        __typename?: 'UiFeedsModule';
                        treatmentType: UiFeedsTreatmentType;
                        contentTypes: Array<PublicationSettingSearchableContentType>;
                        allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
                      } | null;
                    };
                  } | null;
                };
                collection: Array<
                  | {
                      __typename?: 'ArticleItem';
                      type: string;
                      content?: string | null;
                      attributes: {
                        __typename?: 'ArticleAttributes';
                        base_doc_id: string;
                        hosted_url: string;
                        id: string;
                        link: string;
                        originContentType?: string | null;
                        originId?: string | null;
                        product: string;
                        seo_id: string;
                        status: string;
                      };
                    }
                  | {
                      __typename?: 'ExternalCollectionItem';
                      type: string;
                      metadata: {
                        __typename?: 'ExternalCollectionMetadata';
                        id: string;
                        name: string;
                        createdUtc: number;
                      };
                      contentItems: Array<
                        | {
                            __typename?: 'ArticleItem';
                            type: string;
                            content?: string | null;
                            attributes: {
                              __typename?: 'ArticleAttributes';
                              base_doc_id: string;
                              hosted_url: string;
                              id: string;
                              link: string;
                              originContentType?: string | null;
                              originId?: string | null;
                              product: string;
                              seo_id: string;
                              status: string;
                            };
                          }
                        | { __typename?: 'ExternalCollectionItem' }
                        | { __typename?: 'LinkedItem' }
                        | { __typename?: 'MobileArticleItem' }
                        | {
                            __typename?: 'QueryItem';
                            type: string;
                            attributes: { __typename?: 'QueryAttributes'; query: Record<string, unknown> };
                          }
                      >;
                      attributes: { __typename?: 'ExternalCollectionAttributes'; id: string; repo: string };
                    }
                  | {
                      __typename?: 'LinkedItem';
                      type: string;
                      attributes: {
                        __typename?: 'LinkedItemAttributes';
                        id: string;
                        product: string;
                        title: string;
                        description?: string | null;
                        hosted_url: string;
                        image?: {
                          __typename?: 'ImageAttributes';
                          id: string;
                          alternate_text: string;
                          credit: string;
                          height: number;
                          name: string;
                          reuse_type: string;
                          media_type: string;
                          width: number;
                          alt_images: Array<string>;
                          type: string;
                          src: {
                            __typename?: 'ImageSourceAttributes';
                            image_id: string;
                            base_url: string;
                            path: string;
                            params: { __typename?: 'ImageParams'; size: number };
                          };
                          properties: { __typename?: 'Properties'; imphotoid: string; location: string };
                        } | null;
                      };
                    }
                  | {
                      __typename?: 'MobileArticleItem';
                      type: string;
                      subtype?: string | null;
                      content?: string | null;
                      attributes: {
                        __typename?: 'MobileArticleAttributes';
                        base_doc_id: string;
                        hosted_url: string;
                        id: string;
                        link: string;
                        originContentType?: string | null;
                        originId?: string | null;
                        product: string;
                        seo_id: string;
                        status: string;
                        showImage: boolean;
                        showImageBelow: boolean;
                        showFlashline: boolean;
                      };
                    }
                  | {
                      __typename?: 'QueryItem';
                      type: string;
                      attributes: {
                        __typename?: 'QueryAttributes';
                        query: Record<string, unknown>;
                        isFeed?: boolean | null;
                        feedTitle?: string | null;
                        feedUrl?: string | null;
                      };
                    }
                >;
              }>;
            }>;
          };
        };
  }>;
};

export type GetScheduledContentByTimeWithAllessehIdQueryVariables = Exact<{
  allessehId: Scalars['String'];
  maxTimestamp: Scalars['Float'];
}>;

export type GetScheduledContentByTimeWithAllessehIdQuery = {
  __typename?: 'Query';
  scheduledContentByTimeWithAllessehId: Array<{
    __typename?: 'ScheduledContent';
    allessehId: string;
    publishUtc: number;
    createdUtc: number;
    updatedUtc?: number | null;
    status: ScheduledContentStatus;
    contentType: AllessehContentType;
    creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
    revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
    replacedBy?: { __typename?: 'ReplacedBy'; allessehId: string; publishUtc: number } | null;
    body:
      | {
          __typename?: 'BannerDTO';
          metadata: {
            __typename?: 'BaseMetadata';
            allessehId: string;
            createdUtc: number;
            name: string;
            publicationKey: string;
            publishUtc?: number | null;
            updatedUtc?: number | null;
            creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
            revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
          };
          root: {
            __typename?: 'BannerModuleContainer';
            type: string;
            subtype?: string | null;
            attributes: {
              __typename?: 'BannerModuleAttributes';
              moduleId?: string | null;
              pageModule?: {
                __typename?: 'PageModule';
                uiModuleType: UiModuleType;
                uiModuleFields: {
                  __typename?: 'UiModule';
                  basicModule?: { __typename?: 'UiBasicModule'; treatmentType: UiBasicTreatmentType } | null;
                };
              } | null;
            };
            collection: Array<
              | {
                  __typename?: 'ArticleItem';
                  type: string;
                  content?: string | null;
                  attributes: {
                    __typename?: 'ArticleAttributes';
                    base_doc_id: string;
                    hosted_url: string;
                    id: string;
                    link: string;
                    originContentType?: string | null;
                    originId?: string | null;
                    product: string;
                    seo_id: string;
                    status: string;
                  };
                }
              | { __typename?: 'ExternalCollectionItem' }
              | { __typename?: 'LinkedItem' }
              | { __typename?: 'MobileArticleItem' }
              | { __typename?: 'QueryItem' }
            >;
          };
        }
      | {
          __typename?: 'Collection';
          idCreatedUtc: string;
          id: string;
          createdUtc: number;
          updatedUtc?: number | null;
          allessehCollectionId: string;
          name: string;
          notes?: string | null;
          consumer?: string | null;
          allessehJsonQuery?: string | null;
          isArchived: boolean;
          contentItems: Array<{
            __typename?: 'CollectionContentItem';
            originId: string;
            originContentType: string;
            content?: string | null;
          }>;
          creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
          revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
          parameters: {
            __typename?: 'CollectionParameters';
            offPlatform?: {
              __typename?: 'OffPlatformParams';
              minItems?: number | null;
              maxItems?: number | null;
              moduleDisplayName: string;
              defaultAltSummVariant: string;
              hostingPageURL: string;
            } | null;
          };
        }
      | { __typename?: 'CollectionDTO' }
      | {
          __typename?: 'ITPIssueWithPages';
          createdUtc: number;
          issueDate: string;
          issueId: string;
          label: string;
          publishUtc?: number | null;
          refreshedUtc?: number | null;
          status: ItpIssueStatus;
          updatedUtc?: number | null;
          summaryPriority: string;
          itpRevisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
          creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
          pages: Array<{
            __typename?: 'ITPPage';
            adType: string;
            adZones: string;
            allessehCollectionId?: string | null;
            isHidden: boolean;
            issueId: string;
            label: string;
            pageType: string;
            pageModules: Array<{
              __typename?: 'PageModule';
              uiModuleType: UiModuleType;
              moduleItems: Array<{
                __typename?: 'PageModuleItem';
                itemType: PageModuleItemType;
                itemFields: {
                  __typename?: 'PageModuleItemFields';
                  contentItem?: {
                    __typename?: 'PageModuleItemContent';
                    originId: string;
                    originContentType: string;
                    content?: string | null;
                    base_doc_id: string;
                    hosted_url: string;
                    id: string;
                    link: string;
                    product: string;
                    seo_id: string;
                    status: string;
                  } | null;
                  queryItem?: { __typename?: 'PageModuleItemQuery'; jsonQuery: string } | null;
                  collectionItem?: {
                    __typename?: 'PageModuleItemCollection';
                    idCreatedUtc: string;
                    collection?: {
                      __typename?: 'Collection';
                      allessehCollectionId: string;
                      idCreatedUtc: string;
                      id: string;
                      createdUtc: number;
                      updatedUtc?: number | null;
                      name: string;
                      isArchived: boolean;
                      publicationKey: string;
                      allessehJsonQuery?: string | null;
                      creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
                      revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
                      parameters: {
                        __typename?: 'CollectionParameters';
                        offPlatform?: {
                          __typename?: 'OffPlatformParams';
                          minItems?: number | null;
                          maxItems?: number | null;
                          moduleDisplayName: string;
                          defaultAltSummVariant: string;
                          hostingPageURL: string;
                        } | null;
                      };
                      contentItems: Array<{
                        __typename?: 'CollectionContentItem';
                        originId: string;
                        originContentType: string;
                        content?: string | null;
                        base_doc_id: string;
                        hosted_url: string;
                        id: string;
                        link: string;
                        product: string;
                        seo_id: string;
                        status: string;
                      }>;
                    } | null;
                  } | null;
                  allessehCollectionItem?: {
                    __typename?: 'PageModuleItemAllessehCollection';
                    allessehCollectionId: string;
                  } | null;
                };
              }>;
              uiModuleFields: {
                __typename?: 'UiModule';
                basicModule?: {
                  __typename?: 'UiBasicModule';
                  treatmentType: UiBasicTreatmentType;
                  contentTypes: Array<PublicationSettingSearchableContentType>;
                  allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                } | null;
              };
            }>;
          }>;
        }
      | {
          __typename?: 'NewsletterDTO';
          metadata: {
            __typename?: 'BaseMetadata';
            allessehId: string;
            createdUtc: number;
            name: string;
            publicationKey: string;
            publishUtc?: number | null;
            updatedUtc?: number | null;
          };
          root: {
            __typename?: 'NewsletterPageContainer';
            subtype?: string | null;
            type: string;
            collection: Array<{
              __typename?: 'ModuleContainer';
              subtype?: string | null;
              type: string;
              collection: Array<
                | {
                    __typename?: 'ArticleItem';
                    content?: string | null;
                    type: string;
                    attributes: {
                      __typename?: 'ArticleAttributes';
                      base_doc_id: string;
                      hosted_url: string;
                      id: string;
                      link: string;
                      originContentType?: string | null;
                      originId?: string | null;
                      product: string;
                      seo_id: string;
                      status: string;
                    };
                  }
                | { __typename?: 'ExternalCollectionItem' }
                | { __typename?: 'LinkedItem' }
                | { __typename?: 'MobileArticleItem' }
                | { __typename?: 'QueryItem' }
              >;
              attributes: {
                __typename?: 'ModuleAttributes';
                moduleId?: string | null;
                pageModule?: {
                  __typename?: 'PageModule';
                  uiModuleType: UiModuleType;
                  uiModuleFields: {
                    __typename?: 'UiModule';
                    basicModule?: {
                      __typename?: 'UiBasicModule';
                      treatmentType: UiBasicTreatmentType;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                    } | null;
                    titleModule?: {
                      __typename?: 'UiTitleModule';
                      treatmentType: UiTitleTreatmentType;
                      title?: string | null;
                      titleUrl?: string | null;
                      subtitle?: string | null;
                      subtitleUrl?: string | null;
                      allowedMeta?: Array<Metadata> | null;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
                    } | null;
                    rankedModule?: {
                      __typename?: 'UiRankedModule';
                      treatmentType: UiRankedTreatmentType;
                      title: string;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
                    } | null;
                    textModule?: {
                      __typename?: 'UiTextModule';
                      treatmentType: UiTextTreatmentType;
                      mainText: string;
                      secondaryText: string;
                      allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
                    } | null;
                    basicOptionalModule?: {
                      __typename?: 'UiBasicOptionalModule';
                      treatmentType: UiBasicOptionalTreatmentType;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                      moduleName?: string | null;
                    } | null;
                    feedsModule?: {
                      __typename?: 'UiFeedsModule';
                      treatmentType: UiFeedsTreatmentType;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
                    } | null;
                  };
                  moduleItems: Array<{
                    __typename?: 'PageModuleItem';
                    itemType: PageModuleItemType;
                    itemFields: {
                      __typename?: 'PageModuleItemFields';
                      contentItem?: {
                        __typename?: 'PageModuleItemContent';
                        originId: string;
                        originContentType: string;
                        content?: string | null;
                      } | null;
                      queryItem?: {
                        __typename?: 'PageModuleItemQuery';
                        jsonQuery: string;
                        isFeed?: boolean | null;
                        title?: string | null;
                        url?: string | null;
                      } | null;
                      collectionItem?: {
                        __typename?: 'PageModuleItemCollection';
                        idCreatedUtc: string;
                        collection?: {
                          __typename?: 'Collection';
                          allessehCollectionId: string;
                          idCreatedUtc: string;
                          id: string;
                          createdUtc: number;
                          updatedUtc?: number | null;
                          name: string;
                          isArchived: boolean;
                          allessehJsonQuery?: string | null;
                          contentItems: Array<{
                            __typename?: 'CollectionContentItem';
                            originId: string;
                            originContentType: string;
                            content?: string | null;
                          }>;
                        } | null;
                      } | null;
                      allessehCollectionItem?: {
                        __typename?: 'PageModuleItemAllessehCollection';
                        allessehCollectionId: string;
                      } | null;
                      linkedItem?: {
                        __typename?: 'PageModuleItemLinkedItem';
                        headline: string;
                        summary?: string | null;
                        url: string;
                        media?: string | null;
                      } | null;
                    };
                  }>;
                } | null;
              };
            }>;
            attributes: {
              __typename?: 'NewsletterPageAttributes';
              campaignId: string;
              layoutId?: string | null;
              newsletterId: number;
              preHeaderText: string;
              recipients?: string | null;
              replyToEmail: string;
              senderName: string;
              subject: string;
            };
          };
        }
      | { __typename?: 'OffPlatformDTO' }
      | {
          __typename?: 'Page';
          name: string;
          notes?: string | null;
          revisionGroupKey: string;
          createdUtc: number;
          isMobileAppScreen: boolean;
          layoutId: string;
          routeKey: string;
          pageType: PageType;
          publishUtc?: number | null;
          creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
          revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
          config?: { __typename?: 'PageRouteConfig'; summaryPriority: string } | null;
          pageModules: Array<{
            __typename?: 'PageModule';
            uiModuleType: UiModuleType;
            uiModuleFields: {
              __typename?: 'UiModule';
              twoColumnModule?: {
                __typename?: 'UiTwoColumnModule';
                treatmentType: UiTwoColumnTreatmentType;
                leftModules: Array<{
                  __typename?: 'PageModule';
                  uiModuleType: UiModuleType;
                  uiModuleFields: {
                    __typename?: 'UiModule';
                    basicModule?: {
                      __typename?: 'UiBasicModule';
                      treatmentType: UiBasicTreatmentType;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                    } | null;
                    titleModule?: {
                      __typename?: 'UiTitleModule';
                      treatmentType: UiTitleTreatmentType;
                      title?: string | null;
                      titleUrl?: string | null;
                      subtitle?: string | null;
                      subtitleUrl?: string | null;
                      allowedMeta?: Array<Metadata> | null;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
                    } | null;
                    rankedModule?: {
                      __typename?: 'UiRankedModule';
                      treatmentType: UiRankedTreatmentType;
                      title: string;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
                    } | null;
                    textModule?: {
                      __typename?: 'UiTextModule';
                      treatmentType: UiTextTreatmentType;
                      mainText: string;
                      secondaryText: string;
                      allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
                    } | null;
                    basicOptionalModule?: {
                      __typename?: 'UiBasicOptionalModule';
                      treatmentType: UiBasicOptionalTreatmentType;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                      moduleName?: string | null;
                    } | null;
                    feedsModule?: {
                      __typename?: 'UiFeedsModule';
                      treatmentType: UiFeedsTreatmentType;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
                    } | null;
                  };
                  moduleItems: Array<{
                    __typename?: 'PageModuleItem';
                    itemType: PageModuleItemType;
                    itemFields: {
                      __typename?: 'PageModuleItemFields';
                      contentItem?: {
                        __typename?: 'PageModuleItemContent';
                        originId: string;
                        originContentType: string;
                        content?: string | null;
                      } | null;
                      queryItem?: {
                        __typename?: 'PageModuleItemQuery';
                        jsonQuery: string;
                        isFeed?: boolean | null;
                        title?: string | null;
                        url?: string | null;
                      } | null;
                      collectionItem?: {
                        __typename?: 'PageModuleItemCollection';
                        idCreatedUtc: string;
                        collection?: {
                          __typename?: 'Collection';
                          allessehCollectionId: string;
                          idCreatedUtc: string;
                          id: string;
                          createdUtc: number;
                          updatedUtc?: number | null;
                          name: string;
                          isArchived: boolean;
                          allessehJsonQuery?: string | null;
                          contentItems: Array<{
                            __typename?: 'CollectionContentItem';
                            originId: string;
                            originContentType: string;
                            content?: string | null;
                          }>;
                        } | null;
                      } | null;
                      allessehCollectionItem?: {
                        __typename?: 'PageModuleItemAllessehCollection';
                        allessehCollectionId: string;
                      } | null;
                      linkedItem?: {
                        __typename?: 'PageModuleItemLinkedItem';
                        headline: string;
                        summary?: string | null;
                        url: string;
                        media?: string | null;
                      } | null;
                    };
                  }>;
                }>;
                rightModules: Array<{
                  __typename?: 'PageModule';
                  uiModuleType: UiModuleType;
                  uiModuleFields: {
                    __typename?: 'UiModule';
                    basicModule?: {
                      __typename?: 'UiBasicModule';
                      treatmentType: UiBasicTreatmentType;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                    } | null;
                    titleModule?: {
                      __typename?: 'UiTitleModule';
                      treatmentType: UiTitleTreatmentType;
                      title?: string | null;
                      titleUrl?: string | null;
                      subtitle?: string | null;
                      subtitleUrl?: string | null;
                      allowedMeta?: Array<Metadata> | null;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
                    } | null;
                    rankedModule?: {
                      __typename?: 'UiRankedModule';
                      treatmentType: UiRankedTreatmentType;
                      title: string;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
                    } | null;
                    textModule?: {
                      __typename?: 'UiTextModule';
                      treatmentType: UiTextTreatmentType;
                      mainText: string;
                      secondaryText: string;
                      allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
                    } | null;
                    basicOptionalModule?: {
                      __typename?: 'UiBasicOptionalModule';
                      treatmentType: UiBasicOptionalTreatmentType;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                      moduleName?: string | null;
                    } | null;
                    feedsModule?: {
                      __typename?: 'UiFeedsModule';
                      treatmentType: UiFeedsTreatmentType;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
                    } | null;
                  };
                  moduleItems: Array<{
                    __typename?: 'PageModuleItem';
                    itemType: PageModuleItemType;
                    itemFields: {
                      __typename?: 'PageModuleItemFields';
                      contentItem?: {
                        __typename?: 'PageModuleItemContent';
                        originId: string;
                        originContentType: string;
                        content?: string | null;
                      } | null;
                      queryItem?: {
                        __typename?: 'PageModuleItemQuery';
                        jsonQuery: string;
                        isFeed?: boolean | null;
                        title?: string | null;
                        url?: string | null;
                      } | null;
                      collectionItem?: {
                        __typename?: 'PageModuleItemCollection';
                        idCreatedUtc: string;
                        collection?: {
                          __typename?: 'Collection';
                          allessehCollectionId: string;
                          idCreatedUtc: string;
                          id: string;
                          createdUtc: number;
                          updatedUtc?: number | null;
                          name: string;
                          isArchived: boolean;
                          allessehJsonQuery?: string | null;
                          contentItems: Array<{
                            __typename?: 'CollectionContentItem';
                            originId: string;
                            originContentType: string;
                            content?: string | null;
                          }>;
                        } | null;
                      } | null;
                      allessehCollectionItem?: {
                        __typename?: 'PageModuleItemAllessehCollection';
                        allessehCollectionId: string;
                      } | null;
                      linkedItem?: {
                        __typename?: 'PageModuleItemLinkedItem';
                        headline: string;
                        summary?: string | null;
                        url: string;
                        media?: string | null;
                      } | null;
                    };
                  }>;
                }>;
              } | null;
              basicModule?: {
                __typename?: 'UiBasicModule';
                treatmentType: UiBasicTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
              } | null;
              titleModule?: {
                __typename?: 'UiTitleModule';
                treatmentType: UiTitleTreatmentType;
                title?: string | null;
                titleUrl?: string | null;
                subtitle?: string | null;
                subtitleUrl?: string | null;
                allowedMeta?: Array<Metadata> | null;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
              } | null;
              rankedModule?: {
                __typename?: 'UiRankedModule';
                treatmentType: UiRankedTreatmentType;
                title: string;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
              } | null;
              textModule?: {
                __typename?: 'UiTextModule';
                treatmentType: UiTextTreatmentType;
                mainText: string;
                secondaryText: string;
                allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
              } | null;
              basicOptionalModule?: {
                __typename?: 'UiBasicOptionalModule';
                treatmentType: UiBasicOptionalTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                moduleName?: string | null;
              } | null;
              feedsModule?: {
                __typename?: 'UiFeedsModule';
                treatmentType: UiFeedsTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
              } | null;
            };
            moduleItems: Array<{
              __typename?: 'PageModuleItem';
              itemType: PageModuleItemType;
              itemFields: {
                __typename?: 'PageModuleItemFields';
                contentItem?: {
                  __typename?: 'PageModuleItemContent';
                  originId: string;
                  originContentType: string;
                  content?: string | null;
                } | null;
                queryItem?: {
                  __typename?: 'PageModuleItemQuery';
                  jsonQuery: string;
                  isFeed?: boolean | null;
                  title?: string | null;
                  url?: string | null;
                } | null;
                collectionItem?: {
                  __typename?: 'PageModuleItemCollection';
                  idCreatedUtc: string;
                  collection?: {
                    __typename?: 'Collection';
                    allessehCollectionId: string;
                    idCreatedUtc: string;
                    id: string;
                    createdUtc: number;
                    updatedUtc?: number | null;
                    name: string;
                    isArchived: boolean;
                    allessehJsonQuery?: string | null;
                    contentItems: Array<{
                      __typename?: 'CollectionContentItem';
                      originId: string;
                      originContentType: string;
                      content?: string | null;
                    }>;
                  } | null;
                } | null;
                allessehCollectionItem?: {
                  __typename?: 'PageModuleItemAllessehCollection';
                  allessehCollectionId: string;
                } | null;
                linkedItem?: {
                  __typename?: 'PageModuleItemLinkedItem';
                  headline: string;
                  summary?: string | null;
                  url: string;
                  media?: string | null;
                } | null;
              };
            }>;
          }>;
        }
      | {
          __typename?: 'PageDTO';
          type: string;
          metadata: {
            __typename?: 'BaseMetadata';
            allessehId: string;
            createdUtc: number;
            name: string;
            publicationKey: string;
            publishUtc?: number | null;
            updatedUtc?: number | null;
            creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
            revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
          };
          root: {
            __typename?: 'SectionContainer';
            type: string;
            attributes: {
              __typename?: 'SectionAttributes';
              adPlacementType?: string | null;
              adZone?: string | null;
              isHidden: boolean;
              pageType: string;
              routeKey: string;
              sectionKey?: string | null;
              sectionLabel?: string | null;
              summaryPriority: string;
            };
            collection: Array<{
              __typename?: 'PageContainer';
              type: string;
              attributes: { __typename?: 'PageAttributes'; layoutId?: string | null };
              collection: Array<{
                __typename?: 'ModuleContainer';
                type: string;
                attributes: {
                  __typename?: 'ModuleAttributes';
                  moduleId?: string | null;
                  pageModule?: {
                    __typename?: 'PageModule';
                    uiModuleType: UiModuleType;
                    uiModuleFields: {
                      __typename?: 'UiModule';
                      basicModule?: {
                        __typename?: 'UiBasicModule';
                        treatmentType: UiBasicTreatmentType;
                        contentTypes: Array<PublicationSettingSearchableContentType>;
                        allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                      } | null;
                      titleModule?: {
                        __typename?: 'UiTitleModule';
                        treatmentType: UiTitleTreatmentType;
                        title?: string | null;
                        titleUrl?: string | null;
                        subtitle?: string | null;
                        subtitleUrl?: string | null;
                        allowedMeta?: Array<Metadata> | null;
                        contentTypes: Array<PublicationSettingSearchableContentType>;
                        allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
                      } | null;
                      rankedModule?: {
                        __typename?: 'UiRankedModule';
                        treatmentType: UiRankedTreatmentType;
                        title: string;
                        contentTypes: Array<PublicationSettingSearchableContentType>;
                        allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
                      } | null;
                      textModule?: {
                        __typename?: 'UiTextModule';
                        treatmentType: UiTextTreatmentType;
                        mainText: string;
                        secondaryText: string;
                        allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
                      } | null;
                      basicOptionalModule?: {
                        __typename?: 'UiBasicOptionalModule';
                        treatmentType: UiBasicOptionalTreatmentType;
                        contentTypes: Array<PublicationSettingSearchableContentType>;
                        allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                        moduleName?: string | null;
                      } | null;
                      feedsModule?: {
                        __typename?: 'UiFeedsModule';
                        treatmentType: UiFeedsTreatmentType;
                        contentTypes: Array<PublicationSettingSearchableContentType>;
                        allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
                      } | null;
                    };
                  } | null;
                };
                collection: Array<
                  | {
                      __typename?: 'ArticleItem';
                      type: string;
                      content?: string | null;
                      attributes: {
                        __typename?: 'ArticleAttributes';
                        base_doc_id: string;
                        hosted_url: string;
                        id: string;
                        link: string;
                        originContentType?: string | null;
                        originId?: string | null;
                        product: string;
                        seo_id: string;
                        status: string;
                      };
                    }
                  | {
                      __typename?: 'ExternalCollectionItem';
                      type: string;
                      metadata: {
                        __typename?: 'ExternalCollectionMetadata';
                        id: string;
                        name: string;
                        createdUtc: number;
                      };
                      contentItems: Array<
                        | {
                            __typename?: 'ArticleItem';
                            type: string;
                            content?: string | null;
                            attributes: {
                              __typename?: 'ArticleAttributes';
                              base_doc_id: string;
                              hosted_url: string;
                              id: string;
                              link: string;
                              originContentType?: string | null;
                              originId?: string | null;
                              product: string;
                              seo_id: string;
                              status: string;
                            };
                          }
                        | { __typename?: 'ExternalCollectionItem' }
                        | { __typename?: 'LinkedItem' }
                        | { __typename?: 'MobileArticleItem' }
                        | {
                            __typename?: 'QueryItem';
                            type: string;
                            attributes: { __typename?: 'QueryAttributes'; query: Record<string, unknown> };
                          }
                      >;
                      attributes: { __typename?: 'ExternalCollectionAttributes'; id: string; repo: string };
                    }
                  | {
                      __typename?: 'LinkedItem';
                      type: string;
                      attributes: {
                        __typename?: 'LinkedItemAttributes';
                        id: string;
                        product: string;
                        title: string;
                        description?: string | null;
                        hosted_url: string;
                        image?: {
                          __typename?: 'ImageAttributes';
                          id: string;
                          alternate_text: string;
                          credit: string;
                          height: number;
                          name: string;
                          reuse_type: string;
                          media_type: string;
                          width: number;
                          alt_images: Array<string>;
                          type: string;
                          src: {
                            __typename?: 'ImageSourceAttributes';
                            image_id: string;
                            base_url: string;
                            path: string;
                            params: { __typename?: 'ImageParams'; size: number };
                          };
                          properties: { __typename?: 'Properties'; imphotoid: string; location: string };
                        } | null;
                      };
                    }
                  | {
                      __typename?: 'MobileArticleItem';
                      type: string;
                      subtype?: string | null;
                      content?: string | null;
                      attributes: {
                        __typename?: 'MobileArticleAttributes';
                        base_doc_id: string;
                        hosted_url: string;
                        id: string;
                        link: string;
                        originContentType?: string | null;
                        originId?: string | null;
                        product: string;
                        seo_id: string;
                        status: string;
                        showImage: boolean;
                        showImageBelow: boolean;
                        showFlashline: boolean;
                      };
                    }
                  | {
                      __typename?: 'QueryItem';
                      type: string;
                      attributes: {
                        __typename?: 'QueryAttributes';
                        query: Record<string, unknown>;
                        isFeed?: boolean | null;
                        feedTitle?: string | null;
                        feedUrl?: string | null;
                      };
                    }
                >;
              }>;
            }>;
          };
        };
  }>;
};

export type GetScheduledContentByPublicationKeyQueryVariables = Exact<{
  publicationKey: Scalars['String'];
  contentType: AllessehContentType;
  paginationParams: PaginationParams;
  status?: InputMaybe<ScheduledContentStatus>;
}>;

export type GetScheduledContentByPublicationKeyQuery = {
  __typename?: 'Query';
  scheduledContentByPublicationKey: {
    __typename?: 'ScheduledContentConnection';
    pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; endCursor?: string | null };
    edges: Array<{
      __typename?: 'ScheduledContentEdge';
      cursor: string;
      node: {
        __typename?: 'ScheduledContent';
        allessehId: string;
        publishUtc: number;
        createdUtc: number;
        updatedUtc?: number | null;
        status: ScheduledContentStatus;
        contentType: AllessehContentType;
        creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
        revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
        replacedBy?: { __typename?: 'ReplacedBy'; allessehId: string; publishUtc: number } | null;
        body:
          | {
              __typename?: 'BannerDTO';
              metadata: {
                __typename?: 'BaseMetadata';
                allessehId: string;
                createdUtc: number;
                name: string;
                publicationKey: string;
                publishUtc?: number | null;
                updatedUtc?: number | null;
                creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
                revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
              };
              root: {
                __typename?: 'BannerModuleContainer';
                type: string;
                subtype?: string | null;
                attributes: {
                  __typename?: 'BannerModuleAttributes';
                  moduleId?: string | null;
                  pageModule?: {
                    __typename?: 'PageModule';
                    uiModuleType: UiModuleType;
                    uiModuleFields: {
                      __typename?: 'UiModule';
                      basicModule?: { __typename?: 'UiBasicModule'; treatmentType: UiBasicTreatmentType } | null;
                    };
                  } | null;
                };
                collection: Array<
                  | {
                      __typename?: 'ArticleItem';
                      type: string;
                      content?: string | null;
                      attributes: {
                        __typename?: 'ArticleAttributes';
                        base_doc_id: string;
                        hosted_url: string;
                        id: string;
                        link: string;
                        originContentType?: string | null;
                        originId?: string | null;
                        product: string;
                        seo_id: string;
                        status: string;
                      };
                    }
                  | { __typename?: 'ExternalCollectionItem' }
                  | { __typename?: 'LinkedItem' }
                  | { __typename?: 'MobileArticleItem' }
                  | { __typename?: 'QueryItem' }
                >;
              };
            }
          | {
              __typename?: 'Collection';
              idCreatedUtc: string;
              id: string;
              createdUtc: number;
              updatedUtc?: number | null;
              allessehCollectionId: string;
              name: string;
              notes?: string | null;
              consumer?: string | null;
              allessehJsonQuery?: string | null;
              isArchived: boolean;
              contentItems: Array<{
                __typename?: 'CollectionContentItem';
                originId: string;
                originContentType: string;
                content?: string | null;
              }>;
              creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
              revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
              parameters: {
                __typename?: 'CollectionParameters';
                offPlatform?: {
                  __typename?: 'OffPlatformParams';
                  minItems?: number | null;
                  maxItems?: number | null;
                  moduleDisplayName: string;
                  defaultAltSummVariant: string;
                  hostingPageURL: string;
                } | null;
              };
            }
          | { __typename?: 'CollectionDTO' }
          | {
              __typename?: 'ITPIssueWithPages';
              createdUtc: number;
              issueDate: string;
              issueId: string;
              label: string;
              publishUtc?: number | null;
              refreshedUtc?: number | null;
              status: ItpIssueStatus;
              updatedUtc?: number | null;
              summaryPriority: string;
              itpRevisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
              creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
              pages: Array<{
                __typename?: 'ITPPage';
                adType: string;
                adZones: string;
                allessehCollectionId?: string | null;
                isHidden: boolean;
                issueId: string;
                label: string;
                pageType: string;
                pageModules: Array<{
                  __typename?: 'PageModule';
                  uiModuleType: UiModuleType;
                  moduleItems: Array<{
                    __typename?: 'PageModuleItem';
                    itemType: PageModuleItemType;
                    itemFields: {
                      __typename?: 'PageModuleItemFields';
                      contentItem?: {
                        __typename?: 'PageModuleItemContent';
                        originId: string;
                        originContentType: string;
                        content?: string | null;
                        base_doc_id: string;
                        hosted_url: string;
                        id: string;
                        link: string;
                        product: string;
                        seo_id: string;
                        status: string;
                      } | null;
                      queryItem?: { __typename?: 'PageModuleItemQuery'; jsonQuery: string } | null;
                      collectionItem?: {
                        __typename?: 'PageModuleItemCollection';
                        idCreatedUtc: string;
                        collection?: {
                          __typename?: 'Collection';
                          allessehCollectionId: string;
                          idCreatedUtc: string;
                          id: string;
                          createdUtc: number;
                          updatedUtc?: number | null;
                          name: string;
                          isArchived: boolean;
                          publicationKey: string;
                          allessehJsonQuery?: string | null;
                          creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
                          revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
                          parameters: {
                            __typename?: 'CollectionParameters';
                            offPlatform?: {
                              __typename?: 'OffPlatformParams';
                              minItems?: number | null;
                              maxItems?: number | null;
                              moduleDisplayName: string;
                              defaultAltSummVariant: string;
                              hostingPageURL: string;
                            } | null;
                          };
                          contentItems: Array<{
                            __typename?: 'CollectionContentItem';
                            originId: string;
                            originContentType: string;
                            content?: string | null;
                            base_doc_id: string;
                            hosted_url: string;
                            id: string;
                            link: string;
                            product: string;
                            seo_id: string;
                            status: string;
                          }>;
                        } | null;
                      } | null;
                      allessehCollectionItem?: {
                        __typename?: 'PageModuleItemAllessehCollection';
                        allessehCollectionId: string;
                      } | null;
                    };
                  }>;
                  uiModuleFields: {
                    __typename?: 'UiModule';
                    basicModule?: {
                      __typename?: 'UiBasicModule';
                      treatmentType: UiBasicTreatmentType;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                    } | null;
                  };
                }>;
              }>;
            }
          | {
              __typename?: 'NewsletterDTO';
              metadata: {
                __typename?: 'BaseMetadata';
                allessehId: string;
                createdUtc: number;
                name: string;
                publicationKey: string;
                publishUtc?: number | null;
                updatedUtc?: number | null;
              };
              root: {
                __typename?: 'NewsletterPageContainer';
                subtype?: string | null;
                type: string;
                collection: Array<{
                  __typename?: 'ModuleContainer';
                  subtype?: string | null;
                  type: string;
                  collection: Array<
                    | {
                        __typename?: 'ArticleItem';
                        content?: string | null;
                        type: string;
                        attributes: {
                          __typename?: 'ArticleAttributes';
                          base_doc_id: string;
                          hosted_url: string;
                          id: string;
                          link: string;
                          originContentType?: string | null;
                          originId?: string | null;
                          product: string;
                          seo_id: string;
                          status: string;
                        };
                      }
                    | { __typename?: 'ExternalCollectionItem' }
                    | { __typename?: 'LinkedItem' }
                    | { __typename?: 'MobileArticleItem' }
                    | { __typename?: 'QueryItem' }
                  >;
                  attributes: {
                    __typename?: 'ModuleAttributes';
                    moduleId?: string | null;
                    pageModule?: {
                      __typename?: 'PageModule';
                      uiModuleType: UiModuleType;
                      uiModuleFields: {
                        __typename?: 'UiModule';
                        basicModule?: {
                          __typename?: 'UiBasicModule';
                          treatmentType: UiBasicTreatmentType;
                          contentTypes: Array<PublicationSettingSearchableContentType>;
                          allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                        } | null;
                        titleModule?: {
                          __typename?: 'UiTitleModule';
                          treatmentType: UiTitleTreatmentType;
                          title?: string | null;
                          titleUrl?: string | null;
                          subtitle?: string | null;
                          subtitleUrl?: string | null;
                          allowedMeta?: Array<Metadata> | null;
                          contentTypes: Array<PublicationSettingSearchableContentType>;
                          allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
                        } | null;
                        rankedModule?: {
                          __typename?: 'UiRankedModule';
                          treatmentType: UiRankedTreatmentType;
                          title: string;
                          contentTypes: Array<PublicationSettingSearchableContentType>;
                          allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
                        } | null;
                        textModule?: {
                          __typename?: 'UiTextModule';
                          treatmentType: UiTextTreatmentType;
                          mainText: string;
                          secondaryText: string;
                          allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
                        } | null;
                        basicOptionalModule?: {
                          __typename?: 'UiBasicOptionalModule';
                          treatmentType: UiBasicOptionalTreatmentType;
                          contentTypes: Array<PublicationSettingSearchableContentType>;
                          allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                          moduleName?: string | null;
                        } | null;
                        feedsModule?: {
                          __typename?: 'UiFeedsModule';
                          treatmentType: UiFeedsTreatmentType;
                          contentTypes: Array<PublicationSettingSearchableContentType>;
                          allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
                        } | null;
                      };
                      moduleItems: Array<{
                        __typename?: 'PageModuleItem';
                        itemType: PageModuleItemType;
                        itemFields: {
                          __typename?: 'PageModuleItemFields';
                          contentItem?: {
                            __typename?: 'PageModuleItemContent';
                            originId: string;
                            originContentType: string;
                            content?: string | null;
                          } | null;
                          queryItem?: {
                            __typename?: 'PageModuleItemQuery';
                            jsonQuery: string;
                            isFeed?: boolean | null;
                            title?: string | null;
                            url?: string | null;
                          } | null;
                          collectionItem?: {
                            __typename?: 'PageModuleItemCollection';
                            idCreatedUtc: string;
                            collection?: {
                              __typename?: 'Collection';
                              allessehCollectionId: string;
                              idCreatedUtc: string;
                              id: string;
                              createdUtc: number;
                              updatedUtc?: number | null;
                              name: string;
                              isArchived: boolean;
                              allessehJsonQuery?: string | null;
                              contentItems: Array<{
                                __typename?: 'CollectionContentItem';
                                originId: string;
                                originContentType: string;
                                content?: string | null;
                              }>;
                            } | null;
                          } | null;
                          allessehCollectionItem?: {
                            __typename?: 'PageModuleItemAllessehCollection';
                            allessehCollectionId: string;
                          } | null;
                          linkedItem?: {
                            __typename?: 'PageModuleItemLinkedItem';
                            headline: string;
                            summary?: string | null;
                            url: string;
                            media?: string | null;
                          } | null;
                        };
                      }>;
                    } | null;
                  };
                }>;
                attributes: {
                  __typename?: 'NewsletterPageAttributes';
                  campaignId: string;
                  layoutId?: string | null;
                  newsletterId: number;
                  preHeaderText: string;
                  recipients?: string | null;
                  replyToEmail: string;
                  senderName: string;
                  subject: string;
                };
              };
            }
          | { __typename?: 'OffPlatformDTO' }
          | {
              __typename?: 'Page';
              name: string;
              notes?: string | null;
              revisionGroupKey: string;
              createdUtc: number;
              isMobileAppScreen: boolean;
              layoutId: string;
              routeKey: string;
              pageType: PageType;
              publishUtc?: number | null;
              creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
              revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
              config?: { __typename?: 'PageRouteConfig'; summaryPriority: string } | null;
              pageModules: Array<{
                __typename?: 'PageModule';
                uiModuleType: UiModuleType;
                uiModuleFields: {
                  __typename?: 'UiModule';
                  twoColumnModule?: {
                    __typename?: 'UiTwoColumnModule';
                    treatmentType: UiTwoColumnTreatmentType;
                    leftModules: Array<{
                      __typename?: 'PageModule';
                      uiModuleType: UiModuleType;
                      uiModuleFields: {
                        __typename?: 'UiModule';
                        basicModule?: {
                          __typename?: 'UiBasicModule';
                          treatmentType: UiBasicTreatmentType;
                          contentTypes: Array<PublicationSettingSearchableContentType>;
                          allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                        } | null;
                        titleModule?: {
                          __typename?: 'UiTitleModule';
                          treatmentType: UiTitleTreatmentType;
                          title?: string | null;
                          titleUrl?: string | null;
                          subtitle?: string | null;
                          subtitleUrl?: string | null;
                          allowedMeta?: Array<Metadata> | null;
                          contentTypes: Array<PublicationSettingSearchableContentType>;
                          allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
                        } | null;
                        rankedModule?: {
                          __typename?: 'UiRankedModule';
                          treatmentType: UiRankedTreatmentType;
                          title: string;
                          contentTypes: Array<PublicationSettingSearchableContentType>;
                          allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
                        } | null;
                        textModule?: {
                          __typename?: 'UiTextModule';
                          treatmentType: UiTextTreatmentType;
                          mainText: string;
                          secondaryText: string;
                          allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
                        } | null;
                        basicOptionalModule?: {
                          __typename?: 'UiBasicOptionalModule';
                          treatmentType: UiBasicOptionalTreatmentType;
                          contentTypes: Array<PublicationSettingSearchableContentType>;
                          allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                          moduleName?: string | null;
                        } | null;
                        feedsModule?: {
                          __typename?: 'UiFeedsModule';
                          treatmentType: UiFeedsTreatmentType;
                          contentTypes: Array<PublicationSettingSearchableContentType>;
                          allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
                        } | null;
                      };
                      moduleItems: Array<{
                        __typename?: 'PageModuleItem';
                        itemType: PageModuleItemType;
                        itemFields: {
                          __typename?: 'PageModuleItemFields';
                          contentItem?: {
                            __typename?: 'PageModuleItemContent';
                            originId: string;
                            originContentType: string;
                            content?: string | null;
                          } | null;
                          queryItem?: {
                            __typename?: 'PageModuleItemQuery';
                            jsonQuery: string;
                            isFeed?: boolean | null;
                            title?: string | null;
                            url?: string | null;
                          } | null;
                          collectionItem?: {
                            __typename?: 'PageModuleItemCollection';
                            idCreatedUtc: string;
                            collection?: {
                              __typename?: 'Collection';
                              allessehCollectionId: string;
                              idCreatedUtc: string;
                              id: string;
                              createdUtc: number;
                              updatedUtc?: number | null;
                              name: string;
                              isArchived: boolean;
                              allessehJsonQuery?: string | null;
                              contentItems: Array<{
                                __typename?: 'CollectionContentItem';
                                originId: string;
                                originContentType: string;
                                content?: string | null;
                              }>;
                            } | null;
                          } | null;
                          allessehCollectionItem?: {
                            __typename?: 'PageModuleItemAllessehCollection';
                            allessehCollectionId: string;
                          } | null;
                          linkedItem?: {
                            __typename?: 'PageModuleItemLinkedItem';
                            headline: string;
                            summary?: string | null;
                            url: string;
                            media?: string | null;
                          } | null;
                        };
                      }>;
                    }>;
                    rightModules: Array<{
                      __typename?: 'PageModule';
                      uiModuleType: UiModuleType;
                      uiModuleFields: {
                        __typename?: 'UiModule';
                        basicModule?: {
                          __typename?: 'UiBasicModule';
                          treatmentType: UiBasicTreatmentType;
                          contentTypes: Array<PublicationSettingSearchableContentType>;
                          allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                        } | null;
                        titleModule?: {
                          __typename?: 'UiTitleModule';
                          treatmentType: UiTitleTreatmentType;
                          title?: string | null;
                          titleUrl?: string | null;
                          subtitle?: string | null;
                          subtitleUrl?: string | null;
                          allowedMeta?: Array<Metadata> | null;
                          contentTypes: Array<PublicationSettingSearchableContentType>;
                          allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
                        } | null;
                        rankedModule?: {
                          __typename?: 'UiRankedModule';
                          treatmentType: UiRankedTreatmentType;
                          title: string;
                          contentTypes: Array<PublicationSettingSearchableContentType>;
                          allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
                        } | null;
                        textModule?: {
                          __typename?: 'UiTextModule';
                          treatmentType: UiTextTreatmentType;
                          mainText: string;
                          secondaryText: string;
                          allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
                        } | null;
                        basicOptionalModule?: {
                          __typename?: 'UiBasicOptionalModule';
                          treatmentType: UiBasicOptionalTreatmentType;
                          contentTypes: Array<PublicationSettingSearchableContentType>;
                          allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                          moduleName?: string | null;
                        } | null;
                        feedsModule?: {
                          __typename?: 'UiFeedsModule';
                          treatmentType: UiFeedsTreatmentType;
                          contentTypes: Array<PublicationSettingSearchableContentType>;
                          allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
                        } | null;
                      };
                      moduleItems: Array<{
                        __typename?: 'PageModuleItem';
                        itemType: PageModuleItemType;
                        itemFields: {
                          __typename?: 'PageModuleItemFields';
                          contentItem?: {
                            __typename?: 'PageModuleItemContent';
                            originId: string;
                            originContentType: string;
                            content?: string | null;
                          } | null;
                          queryItem?: {
                            __typename?: 'PageModuleItemQuery';
                            jsonQuery: string;
                            isFeed?: boolean | null;
                            title?: string | null;
                            url?: string | null;
                          } | null;
                          collectionItem?: {
                            __typename?: 'PageModuleItemCollection';
                            idCreatedUtc: string;
                            collection?: {
                              __typename?: 'Collection';
                              allessehCollectionId: string;
                              idCreatedUtc: string;
                              id: string;
                              createdUtc: number;
                              updatedUtc?: number | null;
                              name: string;
                              isArchived: boolean;
                              allessehJsonQuery?: string | null;
                              contentItems: Array<{
                                __typename?: 'CollectionContentItem';
                                originId: string;
                                originContentType: string;
                                content?: string | null;
                              }>;
                            } | null;
                          } | null;
                          allessehCollectionItem?: {
                            __typename?: 'PageModuleItemAllessehCollection';
                            allessehCollectionId: string;
                          } | null;
                          linkedItem?: {
                            __typename?: 'PageModuleItemLinkedItem';
                            headline: string;
                            summary?: string | null;
                            url: string;
                            media?: string | null;
                          } | null;
                        };
                      }>;
                    }>;
                  } | null;
                  basicModule?: {
                    __typename?: 'UiBasicModule';
                    treatmentType: UiBasicTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                  } | null;
                  titleModule?: {
                    __typename?: 'UiTitleModule';
                    treatmentType: UiTitleTreatmentType;
                    title?: string | null;
                    titleUrl?: string | null;
                    subtitle?: string | null;
                    subtitleUrl?: string | null;
                    allowedMeta?: Array<Metadata> | null;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
                  } | null;
                  rankedModule?: {
                    __typename?: 'UiRankedModule';
                    treatmentType: UiRankedTreatmentType;
                    title: string;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
                  } | null;
                  textModule?: {
                    __typename?: 'UiTextModule';
                    treatmentType: UiTextTreatmentType;
                    mainText: string;
                    secondaryText: string;
                    allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
                  } | null;
                  basicOptionalModule?: {
                    __typename?: 'UiBasicOptionalModule';
                    treatmentType: UiBasicOptionalTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                    moduleName?: string | null;
                  } | null;
                  feedsModule?: {
                    __typename?: 'UiFeedsModule';
                    treatmentType: UiFeedsTreatmentType;
                    contentTypes: Array<PublicationSettingSearchableContentType>;
                    allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
                  } | null;
                };
                moduleItems: Array<{
                  __typename?: 'PageModuleItem';
                  itemType: PageModuleItemType;
                  itemFields: {
                    __typename?: 'PageModuleItemFields';
                    contentItem?: {
                      __typename?: 'PageModuleItemContent';
                      originId: string;
                      originContentType: string;
                      content?: string | null;
                    } | null;
                    queryItem?: {
                      __typename?: 'PageModuleItemQuery';
                      jsonQuery: string;
                      isFeed?: boolean | null;
                      title?: string | null;
                      url?: string | null;
                    } | null;
                    collectionItem?: {
                      __typename?: 'PageModuleItemCollection';
                      idCreatedUtc: string;
                      collection?: {
                        __typename?: 'Collection';
                        allessehCollectionId: string;
                        idCreatedUtc: string;
                        id: string;
                        createdUtc: number;
                        updatedUtc?: number | null;
                        name: string;
                        isArchived: boolean;
                        allessehJsonQuery?: string | null;
                        contentItems: Array<{
                          __typename?: 'CollectionContentItem';
                          originId: string;
                          originContentType: string;
                          content?: string | null;
                        }>;
                      } | null;
                    } | null;
                    allessehCollectionItem?: {
                      __typename?: 'PageModuleItemAllessehCollection';
                      allessehCollectionId: string;
                    } | null;
                    linkedItem?: {
                      __typename?: 'PageModuleItemLinkedItem';
                      headline: string;
                      summary?: string | null;
                      url: string;
                      media?: string | null;
                    } | null;
                  };
                }>;
              }>;
            }
          | { __typename?: 'PageDTO' };
      };
    }>;
  };
};

export type GetLastNPublishedScheduledContentQueryVariables = Exact<{
  allessehId: Scalars['String'];
  publishUtc?: InputMaybe<Scalars['Float']>;
  status: ScheduledContentStatus;
  n: Scalars['Float'];
}>;

export type GetLastNPublishedScheduledContentQuery = {
  __typename?: 'Query';
  lastNPublishedScheduledContent: Array<{
    __typename?: 'ScheduledContent';
    allessehId: string;
    publishUtc: number;
    createdUtc: number;
    updatedUtc?: number | null;
    status: ScheduledContentStatus;
    contentType: AllessehContentType;
    creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
    revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
    replacedBy?: { __typename?: 'ReplacedBy'; allessehId: string; publishUtc: number } | null;
    body:
      | {
          __typename?: 'BannerDTO';
          metadata: {
            __typename?: 'BaseMetadata';
            allessehId: string;
            createdUtc: number;
            name: string;
            publicationKey: string;
            publishUtc?: number | null;
            updatedUtc?: number | null;
            creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
            revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
          };
          root: {
            __typename?: 'BannerModuleContainer';
            type: string;
            subtype?: string | null;
            attributes: {
              __typename?: 'BannerModuleAttributes';
              moduleId?: string | null;
              pageModule?: {
                __typename?: 'PageModule';
                uiModuleType: UiModuleType;
                uiModuleFields: {
                  __typename?: 'UiModule';
                  basicModule?: { __typename?: 'UiBasicModule'; treatmentType: UiBasicTreatmentType } | null;
                };
              } | null;
            };
            collection: Array<
              | {
                  __typename?: 'ArticleItem';
                  type: string;
                  content?: string | null;
                  attributes: {
                    __typename?: 'ArticleAttributes';
                    base_doc_id: string;
                    hosted_url: string;
                    id: string;
                    link: string;
                    originContentType?: string | null;
                    originId?: string | null;
                    product: string;
                    seo_id: string;
                    status: string;
                  };
                }
              | { __typename?: 'ExternalCollectionItem' }
              | { __typename?: 'LinkedItem' }
              | { __typename?: 'MobileArticleItem' }
              | { __typename?: 'QueryItem' }
            >;
          };
        }
      | {
          __typename?: 'Collection';
          idCreatedUtc: string;
          id: string;
          createdUtc: number;
          updatedUtc?: number | null;
          allessehCollectionId: string;
          name: string;
          notes?: string | null;
          consumer?: string | null;
          allessehJsonQuery?: string | null;
          isArchived: boolean;
          contentItems: Array<{
            __typename?: 'CollectionContentItem';
            originId: string;
            originContentType: string;
            content?: string | null;
          }>;
          creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
          revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
          parameters: {
            __typename?: 'CollectionParameters';
            offPlatform?: {
              __typename?: 'OffPlatformParams';
              minItems?: number | null;
              maxItems?: number | null;
              moduleDisplayName: string;
              defaultAltSummVariant: string;
              hostingPageURL: string;
            } | null;
          };
        }
      | { __typename?: 'CollectionDTO' }
      | {
          __typename?: 'ITPIssueWithPages';
          createdUtc: number;
          issueDate: string;
          issueId: string;
          label: string;
          publishUtc?: number | null;
          refreshedUtc?: number | null;
          status: ItpIssueStatus;
          updatedUtc?: number | null;
          summaryPriority: string;
          itpRevisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
          creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
          pages: Array<{
            __typename?: 'ITPPage';
            adType: string;
            adZones: string;
            allessehCollectionId?: string | null;
            isHidden: boolean;
            issueId: string;
            label: string;
            pageType: string;
            pageModules: Array<{
              __typename?: 'PageModule';
              uiModuleType: UiModuleType;
              moduleItems: Array<{
                __typename?: 'PageModuleItem';
                itemType: PageModuleItemType;
                itemFields: {
                  __typename?: 'PageModuleItemFields';
                  contentItem?: {
                    __typename?: 'PageModuleItemContent';
                    originId: string;
                    originContentType: string;
                    content?: string | null;
                    base_doc_id: string;
                    hosted_url: string;
                    id: string;
                    link: string;
                    product: string;
                    seo_id: string;
                    status: string;
                  } | null;
                  queryItem?: { __typename?: 'PageModuleItemQuery'; jsonQuery: string } | null;
                  collectionItem?: {
                    __typename?: 'PageModuleItemCollection';
                    idCreatedUtc: string;
                    collection?: {
                      __typename?: 'Collection';
                      allessehCollectionId: string;
                      idCreatedUtc: string;
                      id: string;
                      createdUtc: number;
                      updatedUtc?: number | null;
                      name: string;
                      isArchived: boolean;
                      publicationKey: string;
                      allessehJsonQuery?: string | null;
                      creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
                      revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
                      parameters: {
                        __typename?: 'CollectionParameters';
                        offPlatform?: {
                          __typename?: 'OffPlatformParams';
                          minItems?: number | null;
                          maxItems?: number | null;
                          moduleDisplayName: string;
                          defaultAltSummVariant: string;
                          hostingPageURL: string;
                        } | null;
                      };
                      contentItems: Array<{
                        __typename?: 'CollectionContentItem';
                        originId: string;
                        originContentType: string;
                        content?: string | null;
                        base_doc_id: string;
                        hosted_url: string;
                        id: string;
                        link: string;
                        product: string;
                        seo_id: string;
                        status: string;
                      }>;
                    } | null;
                  } | null;
                  allessehCollectionItem?: {
                    __typename?: 'PageModuleItemAllessehCollection';
                    allessehCollectionId: string;
                  } | null;
                };
              }>;
              uiModuleFields: {
                __typename?: 'UiModule';
                basicModule?: {
                  __typename?: 'UiBasicModule';
                  treatmentType: UiBasicTreatmentType;
                  contentTypes: Array<PublicationSettingSearchableContentType>;
                  allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                } | null;
              };
            }>;
          }>;
        }
      | {
          __typename?: 'NewsletterDTO';
          metadata: {
            __typename?: 'BaseMetadata';
            allessehId: string;
            createdUtc: number;
            name: string;
            publicationKey: string;
            publishUtc?: number | null;
            updatedUtc?: number | null;
          };
          root: {
            __typename?: 'NewsletterPageContainer';
            subtype?: string | null;
            type: string;
            collection: Array<{
              __typename?: 'ModuleContainer';
              subtype?: string | null;
              type: string;
              collection: Array<
                | {
                    __typename?: 'ArticleItem';
                    content?: string | null;
                    type: string;
                    attributes: {
                      __typename?: 'ArticleAttributes';
                      base_doc_id: string;
                      hosted_url: string;
                      id: string;
                      link: string;
                      originContentType?: string | null;
                      originId?: string | null;
                      product: string;
                      seo_id: string;
                      status: string;
                    };
                  }
                | { __typename?: 'ExternalCollectionItem' }
                | { __typename?: 'LinkedItem' }
                | { __typename?: 'MobileArticleItem' }
                | { __typename?: 'QueryItem' }
              >;
              attributes: {
                __typename?: 'ModuleAttributes';
                moduleId?: string | null;
                pageModule?: {
                  __typename?: 'PageModule';
                  uiModuleType: UiModuleType;
                  uiModuleFields: {
                    __typename?: 'UiModule';
                    basicModule?: {
                      __typename?: 'UiBasicModule';
                      treatmentType: UiBasicTreatmentType;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                    } | null;
                    titleModule?: {
                      __typename?: 'UiTitleModule';
                      treatmentType: UiTitleTreatmentType;
                      title?: string | null;
                      titleUrl?: string | null;
                      subtitle?: string | null;
                      subtitleUrl?: string | null;
                      allowedMeta?: Array<Metadata> | null;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
                    } | null;
                    rankedModule?: {
                      __typename?: 'UiRankedModule';
                      treatmentType: UiRankedTreatmentType;
                      title: string;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
                    } | null;
                    textModule?: {
                      __typename?: 'UiTextModule';
                      treatmentType: UiTextTreatmentType;
                      mainText: string;
                      secondaryText: string;
                      allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
                    } | null;
                    basicOptionalModule?: {
                      __typename?: 'UiBasicOptionalModule';
                      treatmentType: UiBasicOptionalTreatmentType;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                      moduleName?: string | null;
                    } | null;
                    feedsModule?: {
                      __typename?: 'UiFeedsModule';
                      treatmentType: UiFeedsTreatmentType;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
                    } | null;
                  };
                  moduleItems: Array<{
                    __typename?: 'PageModuleItem';
                    itemType: PageModuleItemType;
                    itemFields: {
                      __typename?: 'PageModuleItemFields';
                      contentItem?: {
                        __typename?: 'PageModuleItemContent';
                        originId: string;
                        originContentType: string;
                        content?: string | null;
                      } | null;
                      queryItem?: {
                        __typename?: 'PageModuleItemQuery';
                        jsonQuery: string;
                        isFeed?: boolean | null;
                        title?: string | null;
                        url?: string | null;
                      } | null;
                      collectionItem?: {
                        __typename?: 'PageModuleItemCollection';
                        idCreatedUtc: string;
                        collection?: {
                          __typename?: 'Collection';
                          allessehCollectionId: string;
                          idCreatedUtc: string;
                          id: string;
                          createdUtc: number;
                          updatedUtc?: number | null;
                          name: string;
                          isArchived: boolean;
                          allessehJsonQuery?: string | null;
                          contentItems: Array<{
                            __typename?: 'CollectionContentItem';
                            originId: string;
                            originContentType: string;
                            content?: string | null;
                          }>;
                        } | null;
                      } | null;
                      allessehCollectionItem?: {
                        __typename?: 'PageModuleItemAllessehCollection';
                        allessehCollectionId: string;
                      } | null;
                      linkedItem?: {
                        __typename?: 'PageModuleItemLinkedItem';
                        headline: string;
                        summary?: string | null;
                        url: string;
                        media?: string | null;
                      } | null;
                    };
                  }>;
                } | null;
              };
            }>;
            attributes: {
              __typename?: 'NewsletterPageAttributes';
              campaignId: string;
              layoutId?: string | null;
              newsletterId: number;
              preHeaderText: string;
              recipients?: string | null;
              replyToEmail: string;
              senderName: string;
              subject: string;
            };
          };
        }
      | {
          __typename?: 'OffPlatformDTO';
          idCreatedUtc: string;
          metadata: {
            __typename?: 'OffPlatformMetadata';
            allessehId: string;
            consumer: string;
            createdUtc: number;
            isArchived: boolean;
            name: string;
            notes?: string | null;
            publicationKey: string;
            publishUtc?: number | null;
            updatedUtc?: number | null;
            creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
            revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
          };
          root: {
            __typename?: 'OffPlatformListContainer';
            type: string;
            subtype?: string | null;
            collection: Array<
              | {
                  __typename?: 'ArticleItem';
                  content?: string | null;
                  type: string;
                  attributes: {
                    __typename?: 'ArticleAttributes';
                    base_doc_id: string;
                    hosted_url: string;
                    id: string;
                    link: string;
                    originContentType?: string | null;
                    originId?: string | null;
                    product: string;
                    seo_id: string;
                    status: string;
                  };
                }
              | { __typename?: 'ExternalCollectionItem' }
              | { __typename?: 'LinkedItem' }
              | { __typename?: 'MobileArticleItem' }
              | {
                  __typename?: 'QueryItem';
                  type: string;
                  attributes: {
                    __typename?: 'QueryAttributes';
                    query: Record<string, unknown>;
                    feedTitle?: string | null;
                    feedUrl?: string | null;
                    isFeed?: boolean | null;
                  };
                }
            >;
            attributes: {
              __typename?: 'OffPlatformListAttributes';
              defaultAltSummVariant: string;
              hostingPageURL: string;
              maxItems: number;
              minItems: number;
              moduleDisplayName: string;
            };
          };
        }
      | {
          __typename?: 'Page';
          name: string;
          notes?: string | null;
          revisionGroupKey: string;
          createdUtc: number;
          isMobileAppScreen: boolean;
          layoutId: string;
          routeKey: string;
          pageType: PageType;
          publishUtc?: number | null;
          creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
          revisorUser: { __typename?: 'AllessehUser'; djUserId: string };
          config?: { __typename?: 'PageRouteConfig'; summaryPriority: string } | null;
          pageModules: Array<{
            __typename?: 'PageModule';
            uiModuleType: UiModuleType;
            uiModuleFields: {
              __typename?: 'UiModule';
              twoColumnModule?: {
                __typename?: 'UiTwoColumnModule';
                treatmentType: UiTwoColumnTreatmentType;
                leftModules: Array<{
                  __typename?: 'PageModule';
                  uiModuleType: UiModuleType;
                  uiModuleFields: {
                    __typename?: 'UiModule';
                    basicModule?: {
                      __typename?: 'UiBasicModule';
                      treatmentType: UiBasicTreatmentType;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                    } | null;
                    titleModule?: {
                      __typename?: 'UiTitleModule';
                      treatmentType: UiTitleTreatmentType;
                      title?: string | null;
                      titleUrl?: string | null;
                      subtitle?: string | null;
                      subtitleUrl?: string | null;
                      allowedMeta?: Array<Metadata> | null;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
                    } | null;
                    rankedModule?: {
                      __typename?: 'UiRankedModule';
                      treatmentType: UiRankedTreatmentType;
                      title: string;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
                    } | null;
                    textModule?: {
                      __typename?: 'UiTextModule';
                      treatmentType: UiTextTreatmentType;
                      mainText: string;
                      secondaryText: string;
                      allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
                    } | null;
                    basicOptionalModule?: {
                      __typename?: 'UiBasicOptionalModule';
                      treatmentType: UiBasicOptionalTreatmentType;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                      moduleName?: string | null;
                    } | null;
                    feedsModule?: {
                      __typename?: 'UiFeedsModule';
                      treatmentType: UiFeedsTreatmentType;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
                    } | null;
                  };
                  moduleItems: Array<{
                    __typename?: 'PageModuleItem';
                    itemType: PageModuleItemType;
                    itemFields: {
                      __typename?: 'PageModuleItemFields';
                      contentItem?: {
                        __typename?: 'PageModuleItemContent';
                        originId: string;
                        originContentType: string;
                        content?: string | null;
                      } | null;
                      queryItem?: {
                        __typename?: 'PageModuleItemQuery';
                        jsonQuery: string;
                        isFeed?: boolean | null;
                        title?: string | null;
                        url?: string | null;
                      } | null;
                      collectionItem?: {
                        __typename?: 'PageModuleItemCollection';
                        idCreatedUtc: string;
                        collection?: {
                          __typename?: 'Collection';
                          allessehCollectionId: string;
                          idCreatedUtc: string;
                          id: string;
                          createdUtc: number;
                          updatedUtc?: number | null;
                          name: string;
                          isArchived: boolean;
                          allessehJsonQuery?: string | null;
                          contentItems: Array<{
                            __typename?: 'CollectionContentItem';
                            originId: string;
                            originContentType: string;
                            content?: string | null;
                          }>;
                        } | null;
                      } | null;
                      allessehCollectionItem?: {
                        __typename?: 'PageModuleItemAllessehCollection';
                        allessehCollectionId: string;
                      } | null;
                      linkedItem?: {
                        __typename?: 'PageModuleItemLinkedItem';
                        headline: string;
                        summary?: string | null;
                        url: string;
                        media?: string | null;
                      } | null;
                    };
                  }>;
                }>;
                rightModules: Array<{
                  __typename?: 'PageModule';
                  uiModuleType: UiModuleType;
                  uiModuleFields: {
                    __typename?: 'UiModule';
                    basicModule?: {
                      __typename?: 'UiBasicModule';
                      treatmentType: UiBasicTreatmentType;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                    } | null;
                    titleModule?: {
                      __typename?: 'UiTitleModule';
                      treatmentType: UiTitleTreatmentType;
                      title?: string | null;
                      titleUrl?: string | null;
                      subtitle?: string | null;
                      subtitleUrl?: string | null;
                      allowedMeta?: Array<Metadata> | null;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
                    } | null;
                    rankedModule?: {
                      __typename?: 'UiRankedModule';
                      treatmentType: UiRankedTreatmentType;
                      title: string;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
                    } | null;
                    textModule?: {
                      __typename?: 'UiTextModule';
                      treatmentType: UiTextTreatmentType;
                      mainText: string;
                      secondaryText: string;
                      allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
                    } | null;
                    basicOptionalModule?: {
                      __typename?: 'UiBasicOptionalModule';
                      treatmentType: UiBasicOptionalTreatmentType;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                      moduleName?: string | null;
                    } | null;
                    feedsModule?: {
                      __typename?: 'UiFeedsModule';
                      treatmentType: UiFeedsTreatmentType;
                      contentTypes: Array<PublicationSettingSearchableContentType>;
                      allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
                    } | null;
                  };
                  moduleItems: Array<{
                    __typename?: 'PageModuleItem';
                    itemType: PageModuleItemType;
                    itemFields: {
                      __typename?: 'PageModuleItemFields';
                      contentItem?: {
                        __typename?: 'PageModuleItemContent';
                        originId: string;
                        originContentType: string;
                        content?: string | null;
                      } | null;
                      queryItem?: {
                        __typename?: 'PageModuleItemQuery';
                        jsonQuery: string;
                        isFeed?: boolean | null;
                        title?: string | null;
                        url?: string | null;
                      } | null;
                      collectionItem?: {
                        __typename?: 'PageModuleItemCollection';
                        idCreatedUtc: string;
                        collection?: {
                          __typename?: 'Collection';
                          allessehCollectionId: string;
                          idCreatedUtc: string;
                          id: string;
                          createdUtc: number;
                          updatedUtc?: number | null;
                          name: string;
                          isArchived: boolean;
                          allessehJsonQuery?: string | null;
                          contentItems: Array<{
                            __typename?: 'CollectionContentItem';
                            originId: string;
                            originContentType: string;
                            content?: string | null;
                          }>;
                        } | null;
                      } | null;
                      allessehCollectionItem?: {
                        __typename?: 'PageModuleItemAllessehCollection';
                        allessehCollectionId: string;
                      } | null;
                      linkedItem?: {
                        __typename?: 'PageModuleItemLinkedItem';
                        headline: string;
                        summary?: string | null;
                        url: string;
                        media?: string | null;
                      } | null;
                    };
                  }>;
                }>;
              } | null;
              basicModule?: {
                __typename?: 'UiBasicModule';
                treatmentType: UiBasicTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
              } | null;
              titleModule?: {
                __typename?: 'UiTitleModule';
                treatmentType: UiTitleTreatmentType;
                title?: string | null;
                titleUrl?: string | null;
                subtitle?: string | null;
                subtitleUrl?: string | null;
                allowedMeta?: Array<Metadata> | null;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
              } | null;
              rankedModule?: {
                __typename?: 'UiRankedModule';
                treatmentType: UiRankedTreatmentType;
                title: string;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
              } | null;
              textModule?: {
                __typename?: 'UiTextModule';
                treatmentType: UiTextTreatmentType;
                mainText: string;
                secondaryText: string;
                allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
              } | null;
              basicOptionalModule?: {
                __typename?: 'UiBasicOptionalModule';
                treatmentType: UiBasicOptionalTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                moduleName?: string | null;
              } | null;
              feedsModule?: {
                __typename?: 'UiFeedsModule';
                treatmentType: UiFeedsTreatmentType;
                contentTypes: Array<PublicationSettingSearchableContentType>;
                allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
              } | null;
            };
            moduleItems: Array<{
              __typename?: 'PageModuleItem';
              itemType: PageModuleItemType;
              itemFields: {
                __typename?: 'PageModuleItemFields';
                contentItem?: {
                  __typename?: 'PageModuleItemContent';
                  originId: string;
                  originContentType: string;
                  content?: string | null;
                } | null;
                queryItem?: {
                  __typename?: 'PageModuleItemQuery';
                  jsonQuery: string;
                  isFeed?: boolean | null;
                  title?: string | null;
                  url?: string | null;
                } | null;
                collectionItem?: {
                  __typename?: 'PageModuleItemCollection';
                  idCreatedUtc: string;
                  collection?: {
                    __typename?: 'Collection';
                    allessehCollectionId: string;
                    idCreatedUtc: string;
                    id: string;
                    createdUtc: number;
                    updatedUtc?: number | null;
                    name: string;
                    isArchived: boolean;
                    allessehJsonQuery?: string | null;
                    contentItems: Array<{
                      __typename?: 'CollectionContentItem';
                      originId: string;
                      originContentType: string;
                      content?: string | null;
                    }>;
                  } | null;
                } | null;
                allessehCollectionItem?: {
                  __typename?: 'PageModuleItemAllessehCollection';
                  allessehCollectionId: string;
                } | null;
                linkedItem?: {
                  __typename?: 'PageModuleItemLinkedItem';
                  headline: string;
                  summary?: string | null;
                  url: string;
                  media?: string | null;
                } | null;
              };
            }>;
          }>;
        }
      | {
          __typename?: 'PageDTO';
          type: string;
          metadata: {
            __typename?: 'BaseMetadata';
            allessehId: string;
            createdUtc: number;
            name: string;
            publicationKey: string;
            publishUtc?: number | null;
            updatedUtc?: number | null;
            creatorUser: { __typename?: 'AllessehUser'; djUserId: string };
            revisorUser?: { __typename?: 'AllessehUser'; djUserId: string } | null;
          };
          root: {
            __typename?: 'SectionContainer';
            type: string;
            attributes: {
              __typename?: 'SectionAttributes';
              adPlacementType?: string | null;
              adZone?: string | null;
              isHidden: boolean;
              pageType: string;
              routeKey: string;
              sectionKey?: string | null;
              sectionLabel?: string | null;
              summaryPriority: string;
            };
            collection: Array<{
              __typename?: 'PageContainer';
              type: string;
              attributes: { __typename?: 'PageAttributes'; layoutId?: string | null };
              collection: Array<{
                __typename?: 'ModuleContainer';
                type: string;
                attributes: {
                  __typename?: 'ModuleAttributes';
                  moduleId?: string | null;
                  pageModule?: {
                    __typename?: 'PageModule';
                    uiModuleType: UiModuleType;
                    uiModuleFields: {
                      __typename?: 'UiModule';
                      basicModule?: {
                        __typename?: 'UiBasicModule';
                        treatmentType: UiBasicTreatmentType;
                        contentTypes: Array<PublicationSettingSearchableContentType>;
                        allowedTreatmentTypes?: Array<UiBasicTreatmentType> | null;
                      } | null;
                      titleModule?: {
                        __typename?: 'UiTitleModule';
                        treatmentType: UiTitleTreatmentType;
                        title?: string | null;
                        titleUrl?: string | null;
                        subtitle?: string | null;
                        subtitleUrl?: string | null;
                        allowedMeta?: Array<Metadata> | null;
                        contentTypes: Array<PublicationSettingSearchableContentType>;
                        allowedTreatmentTypes?: Array<UiTitleTreatmentType> | null;
                      } | null;
                      rankedModule?: {
                        __typename?: 'UiRankedModule';
                        treatmentType: UiRankedTreatmentType;
                        title: string;
                        contentTypes: Array<PublicationSettingSearchableContentType>;
                        allowedTreatmentTypes?: Array<UiRankedTreatmentType> | null;
                      } | null;
                      textModule?: {
                        __typename?: 'UiTextModule';
                        treatmentType: UiTextTreatmentType;
                        mainText: string;
                        secondaryText: string;
                        allowedTreatmentTypes?: Array<UiTextTreatmentType> | null;
                      } | null;
                      basicOptionalModule?: {
                        __typename?: 'UiBasicOptionalModule';
                        treatmentType: UiBasicOptionalTreatmentType;
                        contentTypes: Array<PublicationSettingSearchableContentType>;
                        allowedTreatmentTypes?: Array<UiBasicOptionalTreatmentType> | null;
                        moduleName?: string | null;
                      } | null;
                      feedsModule?: {
                        __typename?: 'UiFeedsModule';
                        treatmentType: UiFeedsTreatmentType;
                        contentTypes: Array<PublicationSettingSearchableContentType>;
                        allowedTreatmentTypes?: Array<UiFeedsTreatmentType> | null;
                      } | null;
                    };
                  } | null;
                };
                collection: Array<
                  | {
                      __typename?: 'ArticleItem';
                      type: string;
                      content?: string | null;
                      attributes: {
                        __typename?: 'ArticleAttributes';
                        base_doc_id: string;
                        hosted_url: string;
                        id: string;
                        link: string;
                        originContentType?: string | null;
                        originId?: string | null;
                        product: string;
                        seo_id: string;
                        status: string;
                      };
                    }
                  | {
                      __typename?: 'ExternalCollectionItem';
                      type: string;
                      metadata: {
                        __typename?: 'ExternalCollectionMetadata';
                        id: string;
                        name: string;
                        createdUtc: number;
                      };
                      contentItems: Array<
                        | {
                            __typename?: 'ArticleItem';
                            type: string;
                            content?: string | null;
                            attributes: {
                              __typename?: 'ArticleAttributes';
                              base_doc_id: string;
                              hosted_url: string;
                              id: string;
                              link: string;
                              originContentType?: string | null;
                              originId?: string | null;
                              product: string;
                              seo_id: string;
                              status: string;
                            };
                          }
                        | { __typename?: 'ExternalCollectionItem' }
                        | { __typename?: 'LinkedItem' }
                        | { __typename?: 'MobileArticleItem' }
                        | {
                            __typename?: 'QueryItem';
                            type: string;
                            attributes: { __typename?: 'QueryAttributes'; query: Record<string, unknown> };
                          }
                      >;
                      attributes: { __typename?: 'ExternalCollectionAttributes'; id: string; repo: string };
                    }
                  | {
                      __typename?: 'LinkedItem';
                      type: string;
                      attributes: {
                        __typename?: 'LinkedItemAttributes';
                        id: string;
                        product: string;
                        title: string;
                        description?: string | null;
                        hosted_url: string;
                        image?: {
                          __typename?: 'ImageAttributes';
                          id: string;
                          alternate_text: string;
                          credit: string;
                          height: number;
                          name: string;
                          reuse_type: string;
                          media_type: string;
                          width: number;
                          alt_images: Array<string>;
                          type: string;
                          src: {
                            __typename?: 'ImageSourceAttributes';
                            image_id: string;
                            base_url: string;
                            path: string;
                            params: { __typename?: 'ImageParams'; size: number };
                          };
                          properties: { __typename?: 'Properties'; imphotoid: string; location: string };
                        } | null;
                      };
                    }
                  | {
                      __typename?: 'MobileArticleItem';
                      type: string;
                      subtype?: string | null;
                      content?: string | null;
                      attributes: {
                        __typename?: 'MobileArticleAttributes';
                        base_doc_id: string;
                        hosted_url: string;
                        id: string;
                        link: string;
                        originContentType?: string | null;
                        originId?: string | null;
                        product: string;
                        seo_id: string;
                        status: string;
                        showImage: boolean;
                        showImageBelow: boolean;
                        showFlashline: boolean;
                      };
                    }
                  | {
                      __typename?: 'QueryItem';
                      type: string;
                      attributes: {
                        __typename?: 'QueryAttributes';
                        query: Record<string, unknown>;
                        isFeed?: boolean | null;
                        feedTitle?: string | null;
                        feedUrl?: string | null;
                      };
                    }
                >;
              }>;
            }>;
          };
        };
  }>;
};

export const BannerDtoArtifactFragmentDoc = `
    fragment BannerDTOArtifact on BannerDTO {
  metadata {
    allessehId
    createdUtc
    name
    publicationKey
    publishUtc
    updatedUtc
    creatorUser {
      djUserId
    }
    revisorUser {
      djUserId
    }
  }
  root {
    type
    subtype
    attributes {
      pageModule {
        uiModuleType
        uiModuleFields {
          basicModule {
            treatmentType
          }
        }
      }
      moduleId
    }
    collection {
      ... on ArticleItem {
        type
        content
        attributes {
          base_doc_id
          hosted_url
          id
          link
          originContentType
          originId
          product
          seo_id
          status
        }
      }
    }
  }
}
    `;
export const CollectionEditCollectionFragmentDoc = `
    fragment CollectionEditCollection on Collection {
  idCreatedUtc
  id
  createdUtc
  updatedUtc
  allessehCollectionId
  name
  notes
  consumer
  contentItems {
    originId
    originContentType
    content
  }
  allessehJsonQuery
  creatorUser {
    djUserId
  }
  isArchived
  revisorUser {
    djUserId
  }
  parameters {
    offPlatform {
      minItems
      maxItems
      moduleDisplayName
      defaultAltSummVariant
      hostingPageURL
    }
  }
}
    `;
export const CollectionScheduleCollectionFragmentDoc = `
    fragment CollectionScheduleCollection on Collection {
  ...CollectionEditCollection
  publishUtc
}
    `;
export const CollectionDtoFragmentDoc = `
    fragment CollectionDTO on CollectionDTO {
  idCreatedUtc
  metadata {
    allessehId
    createdUtc
    isArchived
    name
    notes
    publicationKey
    publishUtc
    updatedUtc
    creatorUser {
      djUserId
    }
    revisorUser {
      djUserId
    }
  }
  root {
    type
    collection {
      ... on QueryItem {
        type
        attributes {
          query
          feedTitle
          feedUrl
          isFeed
        }
      }
      ... on ArticleItem {
        type
        content
        attributes {
          base_doc_id
          hosted_url
          id
          link
          originContentType
          originId
          product
          seo_id
          status
        }
      }
    }
  }
}
    `;
export const CollectionDtoListFragmentDoc = `
    fragment CollectionDTOList on CollectionDTO {
  idCreatedUtc
  metadata {
    allessehId
    createdUtc
    isArchived
    name
    notes
    publicationKey
    publishUtc
    updatedUtc
  }
  root {
    type
    collection {
      ... on QueryItem {
        type
        attributes {
          query
          feedTitle
          feedUrl
          isFeed
        }
      }
      ... on ArticleItem {
        type
        content
        attributes {
          base_doc_id
          hosted_url
          id
          link
          originContentType
          originId
          product
          seo_id
          status
        }
      }
    }
  }
}
    `;
export const IssueFragmentDoc = `
    fragment Issue on ITPIssue {
  issueId
  issueDate
  createdUtc
  publishUtc
  updatedUtc
  creatorUser {
    djUserId
  }
  revisorUser {
    djUserId
  }
  status
  label
  summaryPriority
}
    `;
export const ItpPageModuleFragmentFragmentDoc = `
    fragment ITPPageModuleFragment on PageModule {
  moduleItems {
    itemType
    itemFields {
      contentItem {
        originId
        originContentType
        content
        base_doc_id
        hosted_url
        id
        link
        product
        seo_id
        status
      }
      queryItem {
        jsonQuery
      }
      collectionItem {
        idCreatedUtc
        collection {
          allessehCollectionId
          idCreatedUtc
          id
          createdUtc
          updatedUtc
          name
          isArchived
          creatorUser {
            djUserId
          }
          revisorUser {
            djUserId
          }
          parameters {
            offPlatform {
              minItems
              maxItems
              moduleDisplayName
              defaultAltSummVariant
              hostingPageURL
            }
          }
          publicationKey
          contentItems {
            originId
            originContentType
            content
            base_doc_id
            hosted_url
            id
            link
            product
            seo_id
            status
          }
          allessehJsonQuery
        }
      }
      allessehCollectionItem {
        allessehCollectionId
      }
    }
  }
  uiModuleType
  uiModuleFields {
    basicModule {
      treatmentType
      contentTypes
      allowedTreatmentTypes
    }
  }
}
    `;
export const IssueWithPagesFragmentDoc = `
    fragment IssueWithPages on ITPIssueWithPages {
  createdUtc
  creatorUser {
    djUserId
  }
  issueDate
  issueId
  label
  pages {
    adType
    adZones
    allessehCollectionId
    isHidden
    issueId
    label
    pageModules {
      ...ITPPageModuleFragment
    }
    pageType
  }
  publishUtc
  refreshedUtc
  status
  updatedUtc
  summaryPriority
}
    `;
export const ItpPageFragmentFragmentDoc = `
    fragment ITPPageFragment on ITPPage {
  adType
  adZones
  allessehCollectionId
  isHidden
  issueId
  label
  pageModules {
    ...ITPPageModuleFragment
  }
  pageType
}
    `;
export const ArticleFragmentFragmentDoc = `
    fragment ArticleFragment on ArticleItem {
  attributes {
    base_doc_id
    hosted_url
    id
    link
    originContentType
    originId
    product
    seo_id
    status
  }
  content
  type
}
    `;
export const QueryFragmentFragmentDoc = `
    fragment QueryFragment on QueryItem {
  attributes {
    query
  }
  type
}
    `;
export const ExternalCollectionFragmentFragmentDoc = `
    fragment ExternalCollectionFragment on ExternalCollectionItem {
  attributes {
    id
    repo
  }
  type
}
    `;
export const ModuleContainerFragmentFragmentDoc = `
    fragment ModuleContainerFragment on ModuleContainer {
  attributes {
    pageModule {
      ...ITPPageModuleFragment
    }
  }
  collection {
    ... on ArticleItem {
      ...ArticleFragment
    }
    ... on QueryItem {
      ...QueryFragment
    }
    ... on ExternalCollectionItem {
      ...ExternalCollectionFragment
    }
  }
  type
}
    `;
export const PageContainerFragmentFragmentDoc = `
    fragment PageContainerFragment on PageContainer {
  attributes {
    layoutId
  }
  collection {
    ...ModuleContainerFragment
  }
  type
}
    `;
export const IssueSectionContainerFragmentFragmentDoc = `
    fragment IssueSectionContainerFragment on IssueSectionContainer {
  attributes {
    adPlacementType
    adZone
    isHidden
    issueDate
    pageType
    routeKey
    sectionKey
    sectionLabel
    summaryPriority
    upstreamAllessehCollectionId
  }
  collection {
    ...PageContainerFragment
  }
  type
  subtype
}
    `;
export const IssueContainerFragmentFragmentDoc = `
    fragment IssueContainerFragment on IssueContainer {
  attributes {
    issueKey
    issueDate
    status
  }
  collection {
    ...IssueSectionContainerFragment
  }
  type
}
    `;
export const ItpDtoFragmentFragmentDoc = `
    fragment ItpDTOFragment on ItpDTO {
  metadata {
    allessehId
    createdUtc
    creatorUser {
      djUserId
    }
    name
    publicationKey
    publishUtc
    refreshedUtc
    revisorUser {
      djUserId
    }
    updatedUtc
  }
  root {
    ...IssueContainerFragment
  }
  type
}
    `;
export const NewsletterListItemNewsletterListItemFragmentDoc = `
    fragment NewsletterListItemNewsletterListItem on NewsletterListItem {
  id
  name
  subject
  product
  description
  defaultCampaignDetails {
    sender_name
    reply_to_email
    Subject
    pre_header_text
  }
  schedule {
    cron
    timezone
  }
}
    `;
export const CollectionPageCollectionFragmentDoc = `
    fragment CollectionPageCollection on Collection {
  allessehCollectionId
  idCreatedUtc
  id
  createdUtc
  updatedUtc
  name
  isArchived
  contentItems {
    originId
    originContentType
    content
  }
  allessehJsonQuery
}
    `;
export const PageModuleSubFieldsFragmentFragmentDoc = `
    fragment PageModuleSubFieldsFragment on PageModule {
  moduleItems {
    itemType
    itemFields {
      contentItem {
        originId
        originContentType
        content
      }
      queryItem {
        jsonQuery
        isFeed
        title
        url
      }
      collectionItem {
        idCreatedUtc
        collection {
          ...CollectionPageCollection
        }
      }
      allessehCollectionItem {
        allessehCollectionId
      }
      linkedItem {
        headline
        summary
        url
        media
      }
    }
  }
  uiModuleType
}
    `;
export const BasicModuleFragmentFragmentDoc = `
    fragment BasicModuleFragment on UiBasicModule {
  treatmentType
  contentTypes
  allowedTreatmentTypes
}
    `;
export const TitleModuleFragmentFragmentDoc = `
    fragment TitleModuleFragment on UiTitleModule {
  treatmentType
  title
  titleUrl
  subtitle
  subtitleUrl
  allowedMeta
  contentTypes
  allowedTreatmentTypes
}
    `;
export const RankedModuleFragmentFragmentDoc = `
    fragment RankedModuleFragment on UiRankedModule {
  treatmentType
  title
  contentTypes
  allowedTreatmentTypes
}
    `;
export const TextModuleFragmentFragmentDoc = `
    fragment TextModuleFragment on UiTextModule {
  treatmentType
  mainText
  secondaryText
  allowedTreatmentTypes
}
    `;
export const BasicOptionalModuleFragmentFragmentDoc = `
    fragment BasicOptionalModuleFragment on UiBasicOptionalModule {
  treatmentType
  contentTypes
  allowedTreatmentTypes
  moduleName
}
    `;
export const FeedsModuleFragmentFragmentDoc = `
    fragment FeedsModuleFragment on UiFeedsModule {
  treatmentType
  contentTypes
  allowedTreatmentTypes
}
    `;
export const PageModuleUiModuleFieldsFragmentFragmentDoc = `
    fragment PageModuleUiModuleFieldsFragment on UiModule {
  basicModule {
    ...BasicModuleFragment
  }
  titleModule {
    ...TitleModuleFragment
  }
  rankedModule {
    ...RankedModuleFragment
  }
  textModule {
    ...TextModuleFragment
  }
  basicOptionalModule {
    ...BasicOptionalModuleFragment
  }
  feedsModule {
    ...FeedsModuleFragment
  }
}
    `;
export const PageModuleFragmentRecursiveFragmentDoc = `
    fragment PageModuleFragmentRecursive on PageModule {
  ...PageModuleSubFieldsFragment
  uiModuleFields {
    ...PageModuleUiModuleFieldsFragment
  }
}
    `;
export const NewsletterDtoFragmentDoc = `
    fragment NewsletterDTO on NewsletterDTO {
  metadata {
    allessehId
    createdUtc
    name
    publicationKey
    publishUtc
    updatedUtc
  }
  root {
    subtype
    type
    collection {
      collection {
        ... on ArticleItem {
          content
          attributes {
            base_doc_id
            hosted_url
            id
            link
            originContentType
            originId
            product
            seo_id
            status
          }
          type
        }
      }
      subtype
      type
      attributes {
        pageModule {
          ...PageModuleFragmentRecursive
        }
        moduleId
      }
    }
    attributes {
      campaignId
      layoutId
      newsletterId
      preHeaderText
      recipients
      replyToEmail
      senderName
      subject
    }
  }
}
    `;
export const OffPlatformDtoFragmentDoc = `
    fragment OffPlatformDTO on OffPlatformDTO {
  metadata {
    allessehId
    consumer
    createdUtc
    isArchived
    name
    notes
    publicationKey
    publishUtc
    updatedUtc
    creatorUser {
      djUserId
    }
    revisorUser {
      djUserId
    }
  }
  root {
    collection {
      ... on ArticleItem {
        content
        type
        attributes {
          base_doc_id
          hosted_url
          id
          link
          originContentType
          originId
          product
          seo_id
          status
        }
      }
      ... on QueryItem {
        type
        attributes {
          query
          feedTitle
          feedUrl
          isFeed
        }
      }
    }
    attributes {
      defaultAltSummVariant
      hostingPageURL
      maxItems
      minItems
      moduleDisplayName
    }
    type
    subtype
  }
  idCreatedUtc
}
    `;
export const OffPlatformDtoListFragmentDoc = `
    fragment OffPlatformDTOList on OffPlatformDTO {
  metadata {
    allessehId
    createdUtc
    isArchived
    name
    publicationKey
    publishUtc
    updatedUtc
  }
  root {
    type
    subtype
    collection {
      ... on ArticleItem {
        type
        attributes {
          base_doc_id
          hosted_url
          id
          link
          originContentType
          originId
          product
          seo_id
          status
        }
      }
      ... on QueryItem {
        type
        attributes {
          query
          feedTitle
          feedUrl
          isFeed
        }
      }
    }
  }
  idCreatedUtc
}
    `;
export const PageDtoMetadataFragmentDoc = `
    fragment PageDTOMetadata on BaseMetadata {
  allessehId
  createdUtc
  name
  publicationKey
  publishUtc
  updatedUtc
  creatorUser {
    djUserId
  }
  revisorUser {
    djUserId
  }
}
    `;
export const PageDtoDataFragmentDoc = `
    fragment PageDTOData on PageDTO {
  type
  metadata {
    ...PageDTOMetadata
  }
  root {
    type
    attributes {
      adPlacementType
      adZone
      isHidden
      pageType
      routeKey
      sectionKey
      sectionLabel
      summaryPriority
    }
    collection {
      type
      attributes {
        layoutId
      }
      collection {
        type
        attributes {
          pageModule {
            uiModuleType
            uiModuleFields {
              ...PageModuleUiModuleFieldsFragment
            }
          }
          moduleId
        }
        collection {
          ... on MobileArticleItem {
            type
            subtype
            content
            attributes {
              base_doc_id
              hosted_url
              id
              link
              originContentType
              originId
              product
              seo_id
              status
              showImage
              showImageBelow
              showFlashline
            }
          }
          ... on ArticleItem {
            type
            content
            attributes {
              base_doc_id
              hosted_url
              id
              link
              originContentType
              originId
              product
              seo_id
              status
            }
          }
          ... on QueryItem {
            type
            attributes {
              query
              isFeed
              feedTitle
              feedUrl
            }
          }
          ... on LinkedItem {
            type
            attributes {
              id
              product
              title
              description
              image {
                id
                alternate_text
                credit
                height
                name
                reuse_type
                media_type
                width
                src {
                  params {
                    size
                  }
                  image_id
                  base_url
                  path
                }
                alt_images
                properties {
                  imphotoid
                  location
                }
                type
              }
              hosted_url
            }
          }
          ... on ExternalCollectionItem {
            type
            metadata {
              id
              name
              createdUtc
            }
            contentItems {
              ... on ArticleItem {
                type
                content
                attributes {
                  base_doc_id
                  hosted_url
                  id
                  link
                  originContentType
                  originId
                  product
                  seo_id
                  status
                }
              }
              ... on QueryItem {
                type
                attributes {
                  query
                }
              }
            }
            attributes {
              id
              repo
            }
          }
        }
      }
    }
  }
}
    `;
export const TwoColumnModuleFragmentFragmentDoc = `
    fragment TwoColumnModuleFragment on UiTwoColumnModule {
  treatmentType
  leftModules {
    ...PageModuleFragmentRecursive
  }
  rightModules {
    ...PageModuleFragmentRecursive
  }
}
    `;
export const PageModuleFragmentFragmentDoc = `
    fragment PageModuleFragment on PageModule {
  ...PageModuleSubFieldsFragment
  uiModuleFields {
    ...PageModuleUiModuleFieldsFragment
    twoColumnModule {
      ...TwoColumnModuleFragment
    }
  }
}
    `;
export const PageEditPageFragmentDoc = `
    fragment PageEditPage on Page {
  name
  notes
  revisionGroupKey
  createdUtc
  creatorUser {
    djUserId
  }
  isMobileAppScreen
  layoutId
  revisorUser {
    djUserId
  }
  routeKey
  config {
    summaryPriority
  }
  pageType
  publishUtc
  pageModules {
    ...PageModuleFragment
  }
}
    `;
export const BannerDtoUpdateDocument = `
    mutation BannerDTOUpdate($bannerDTOUpdateInput: BannerDTOUpdateInput!) {
  updateBanner(bannerDTOUpdateInput: $bannerDTOUpdateInput) {
    ...BannerDTOArtifact
  }
}
    ${BannerDtoArtifactFragmentDoc}`;
export const useBannerDtoUpdateMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<BannerDtoUpdateMutation, TError, BannerDtoUpdateMutationVariables, TContext>
) =>
  useMutation<BannerDtoUpdateMutation, TError, BannerDtoUpdateMutationVariables, TContext>(
    ['BannerDTOUpdate'],
    useFetchData<BannerDtoUpdateMutation, BannerDtoUpdateMutationVariables>(BannerDtoUpdateDocument),
    options
  );
export const BannerDtoPreviewDocument = `
    mutation BannerDTOPreview($bannerDTOPreviewLinkInput: BannerDTOPreviewLinkInput!) {
  getBannerPreviewLink(bannerPreviewLinkInput: $bannerDTOPreviewLinkInput)
}
    `;
export const useBannerDtoPreviewMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<BannerDtoPreviewMutation, TError, BannerDtoPreviewMutationVariables, TContext>
) =>
  useMutation<BannerDtoPreviewMutation, TError, BannerDtoPreviewMutationVariables, TContext>(
    ['BannerDTOPreview'],
    useFetchData<BannerDtoPreviewMutation, BannerDtoPreviewMutationVariables>(BannerDtoPreviewDocument),
    options
  );
export const GetAllBannersDocument = `
    query GetAllBanners($bannersDTOInput: GetBannersDTOInput!, $paginationParams: PaginationParams!) {
  getBanners(
    bannersDTOInput: $bannersDTOInput
    paginationParams: $paginationParams
  ) {
    edges {
      node {
        ...BannerDTOArtifact
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${BannerDtoArtifactFragmentDoc}`;
export const useGetAllBannersQuery = <TData = GetAllBannersQuery, TError = unknown>(
  variables: GetAllBannersQueryVariables,
  options?: UseQueryOptions<GetAllBannersQuery, TError, TData>
) =>
  useQuery<GetAllBannersQuery, TError, TData>(
    ['GetAllBanners', variables],
    useFetchData<GetAllBannersQuery, GetAllBannersQueryVariables>(GetAllBannersDocument).bind(null, variables),
    options
  );
export const useInfiniteGetAllBannersQuery = <TData = GetAllBannersQuery, TError = unknown>(
  variables: GetAllBannersQueryVariables,
  options?: UseInfiniteQueryOptions<GetAllBannersQuery, TError, TData>
) => {
  const query = useFetchData<GetAllBannersQuery, GetAllBannersQueryVariables>(GetAllBannersDocument);
  return useInfiniteQuery<GetAllBannersQuery, TError, TData>(
    ['GetAllBanners.infinite', variables],
    (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
    options
  );
};

export const BannerByIdDocument = `
    query BannerById($id: String!, $publicationKey: String!) {
  getBannerById(id: $id, publicationKey: $publicationKey) {
    ...BannerDTOArtifact
  }
}
    ${BannerDtoArtifactFragmentDoc}`;
export const useBannerByIdQuery = <TData = BannerByIdQuery, TError = unknown>(
  variables: BannerByIdQueryVariables,
  options?: UseQueryOptions<BannerByIdQuery, TError, TData>
) =>
  useQuery<BannerByIdQuery, TError, TData>(
    ['BannerById', variables],
    useFetchData<BannerByIdQuery, BannerByIdQueryVariables>(BannerByIdDocument).bind(null, variables),
    options
  );
export const useInfiniteBannerByIdQuery = <TData = BannerByIdQuery, TError = unknown>(
  variables: BannerByIdQueryVariables,
  options?: UseInfiniteQueryOptions<BannerByIdQuery, TError, TData>
) => {
  const query = useFetchData<BannerByIdQuery, BannerByIdQueryVariables>(BannerByIdDocument);
  return useInfiniteQuery<BannerByIdQuery, TError, TData>(
    ['BannerById.infinite', variables],
    (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
    options
  );
};

export const CollectionUpdateDocument = `
    mutation CollectionUpdate($collectionUpdateInput: CollectionUpdateInput!) {
  collectionUpdate(collectionUpdateInput: $collectionUpdateInput) {
    ...CollectionEditCollection
  }
}
    ${CollectionEditCollectionFragmentDoc}`;
export const useCollectionUpdateMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<CollectionUpdateMutation, TError, CollectionUpdateMutationVariables, TContext>
) =>
  useMutation<CollectionUpdateMutation, TError, CollectionUpdateMutationVariables, TContext>(
    ['CollectionUpdate'],
    useFetchData<CollectionUpdateMutation, CollectionUpdateMutationVariables>(CollectionUpdateDocument),
    options
  );
export const CollectionScheduleDocument = `
    mutation CollectionSchedule($collectionScheduleInput: CollectionScheduleInput!, $previousPublishUtc: Float) {
  collectionSchedule(
    collectionScheduleInput: $collectionScheduleInput
    previousPublishUtc: $previousPublishUtc
  ) {
    ...CollectionScheduleCollection
  }
}
    ${CollectionScheduleCollectionFragmentDoc}
${CollectionEditCollectionFragmentDoc}`;
export const useCollectionScheduleMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<CollectionScheduleMutation, TError, CollectionScheduleMutationVariables, TContext>
) =>
  useMutation<CollectionScheduleMutation, TError, CollectionScheduleMutationVariables, TContext>(
    ['CollectionSchedule'],
    useFetchData<CollectionScheduleMutation, CollectionScheduleMutationVariables>(CollectionScheduleDocument),
    options
  );
export const CollectionDeleteScheduledDocument = `
    mutation CollectionDeleteScheduled($collectionDeleteScheduledInput: CollectionDeleteScheduledInput!) {
  collectionDeleteScheduled(
    collectionDeleteScheduledInput: $collectionDeleteScheduledInput
  ) {
    ...CollectionEditCollection
  }
}
    ${CollectionEditCollectionFragmentDoc}`;
export const useCollectionDeleteScheduledMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CollectionDeleteScheduledMutation,
    TError,
    CollectionDeleteScheduledMutationVariables,
    TContext
  >
) =>
  useMutation<CollectionDeleteScheduledMutation, TError, CollectionDeleteScheduledMutationVariables, TContext>(
    ['CollectionDeleteScheduled'],
    useFetchData<CollectionDeleteScheduledMutation, CollectionDeleteScheduledMutationVariables>(
      CollectionDeleteScheduledDocument
    ),
    options
  );
export const CollectionCreateDocument = `
    mutation CollectionCreate($collectionCreateInput: CollectionCreateInput!) {
  collectionCreate(collectionCreateInput: $collectionCreateInput) {
    idCreatedUtc
  }
}
    `;
export const useCollectionCreateMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<CollectionCreateMutation, TError, CollectionCreateMutationVariables, TContext>
) =>
  useMutation<CollectionCreateMutation, TError, CollectionCreateMutationVariables, TContext>(
    ['CollectionCreate'],
    useFetchData<CollectionCreateMutation, CollectionCreateMutationVariables>(CollectionCreateDocument),
    options
  );
export const CollectionCopyDocument = `
    mutation CollectionCopy($collectionCopyInput: CollectionCopyInput!) {
  collectionCopy(collectionCopyInput: $collectionCopyInput) {
    idCreatedUtc
  }
}
    `;
export const useCollectionCopyMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<CollectionCopyMutation, TError, CollectionCopyMutationVariables, TContext>
) =>
  useMutation<CollectionCopyMutation, TError, CollectionCopyMutationVariables, TContext>(
    ['CollectionCopy'],
    useFetchData<CollectionCopyMutation, CollectionCopyMutationVariables>(CollectionCopyDocument),
    options
  );
export const CollectionArchiveDocument = `
    mutation CollectionArchive($collectionArchiveInput: CollectionArchiveInput!) {
  collectionArchive(collectionArchiveInput: $collectionArchiveInput) {
    idCreatedUtc
  }
}
    `;
export const useCollectionArchiveMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<CollectionArchiveMutation, TError, CollectionArchiveMutationVariables, TContext>
) =>
  useMutation<CollectionArchiveMutation, TError, CollectionArchiveMutationVariables, TContext>(
    ['CollectionArchive'],
    useFetchData<CollectionArchiveMutation, CollectionArchiveMutationVariables>(CollectionArchiveDocument),
    options
  );
export const CollectionOffPlatformConvertDocument = `
    mutation CollectionOffPlatformConvert($collectionOffPlatformInput: CollectionOffPlatformInput!) {
  collectionOffPlatformConvert(
    collectionOffPlatformInput: $collectionOffPlatformInput
  ) {
    ...CollectionEditCollection
  }
}
    ${CollectionEditCollectionFragmentDoc}`;
export const useCollectionOffPlatformConvertMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CollectionOffPlatformConvertMutation,
    TError,
    CollectionOffPlatformConvertMutationVariables,
    TContext
  >
) =>
  useMutation<CollectionOffPlatformConvertMutation, TError, CollectionOffPlatformConvertMutationVariables, TContext>(
    ['CollectionOffPlatformConvert'],
    useFetchData<CollectionOffPlatformConvertMutation, CollectionOffPlatformConvertMutationVariables>(
      CollectionOffPlatformConvertDocument
    ),
    options
  );
export const CollectionAllessehDeleteDocument = `
    mutation CollectionAllessehDelete($deleteAllessehCollectionInput: DeleteAllessehCollectionInput!) {
  deleteAllessehCollection(
    deleteAllessehCollectionInput: $deleteAllessehCollectionInput
  ) {
    message
    statusCode
    error
  }
}
    `;
export const useCollectionAllessehDeleteMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CollectionAllessehDeleteMutation,
    TError,
    CollectionAllessehDeleteMutationVariables,
    TContext
  >
) =>
  useMutation<CollectionAllessehDeleteMutation, TError, CollectionAllessehDeleteMutationVariables, TContext>(
    ['CollectionAllessehDelete'],
    useFetchData<CollectionAllessehDeleteMutation, CollectionAllessehDeleteMutationVariables>(
      CollectionAllessehDeleteDocument
    ),
    options
  );
export const CollectionsDocument = `
    query Collections($collectionsInput: CollectionsInput!, $paginationParams: PaginationParams!) {
  collections(
    collectionsInput: $collectionsInput
    paginationParams: $paginationParams
  ) {
    edges {
      node {
        ...CollectionPageCollection
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${CollectionPageCollectionFragmentDoc}`;
export const useCollectionsQuery = <TData = CollectionsQuery, TError = unknown>(
  variables: CollectionsQueryVariables,
  options?: UseQueryOptions<CollectionsQuery, TError, TData>
) =>
  useQuery<CollectionsQuery, TError, TData>(
    ['Collections', variables],
    useFetchData<CollectionsQuery, CollectionsQueryVariables>(CollectionsDocument).bind(null, variables),
    options
  );
export const useInfiniteCollectionsQuery = <TData = CollectionsQuery, TError = unknown>(
  variables: CollectionsQueryVariables,
  options?: UseInfiniteQueryOptions<CollectionsQuery, TError, TData>
) => {
  const query = useFetchData<CollectionsQuery, CollectionsQueryVariables>(CollectionsDocument);
  return useInfiniteQuery<CollectionsQuery, TError, TData>(
    ['Collections.infinite', variables],
    (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
    options
  );
};

export const ScheduledCollectionsDocument = `
    query ScheduledCollections($allessehCollectionId: String!, $paginationParams: PaginationParams!, $publicationKey: String!) {
  scheduledCollections(
    allessehCollectionId: $allessehCollectionId
    paginationParams: $paginationParams
    publicationKey: $publicationKey
  ) {
    edges {
      node {
        ...CollectionEditCollection
        publishUtc
        publicationKey
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${CollectionEditCollectionFragmentDoc}`;
export const useScheduledCollectionsQuery = <TData = ScheduledCollectionsQuery, TError = unknown>(
  variables: ScheduledCollectionsQueryVariables,
  options?: UseQueryOptions<ScheduledCollectionsQuery, TError, TData>
) =>
  useQuery<ScheduledCollectionsQuery, TError, TData>(
    ['ScheduledCollections', variables],
    useFetchData<ScheduledCollectionsQuery, ScheduledCollectionsQueryVariables>(ScheduledCollectionsDocument).bind(
      null,
      variables
    ),
    options
  );
export const useInfiniteScheduledCollectionsQuery = <TData = ScheduledCollectionsQuery, TError = unknown>(
  variables: ScheduledCollectionsQueryVariables,
  options?: UseInfiniteQueryOptions<ScheduledCollectionsQuery, TError, TData>
) => {
  const query = useFetchData<ScheduledCollectionsQuery, ScheduledCollectionsQueryVariables>(
    ScheduledCollectionsDocument
  );
  return useInfiniteQuery<ScheduledCollectionsQuery, TError, TData>(
    ['ScheduledCollections.infinite', variables],
    (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
    options
  );
};

export const CollectionsPublishedOnDateDocument = `
    query CollectionsPublishedOnDate($allessehCollectionId: String!, $publishUtc: Float!, $paginationParams: PaginationParams!, $publicationKey: String!) {
  collectionsPublishedOnDate(
    allessehCollectionId: $allessehCollectionId
    publishUtc: $publishUtc
    paginationParams: $paginationParams
    publicationKey: $publicationKey
  ) {
    edges {
      node {
        ...CollectionEditCollection
        publishUtc
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${CollectionEditCollectionFragmentDoc}`;
export const useCollectionsPublishedOnDateQuery = <TData = CollectionsPublishedOnDateQuery, TError = unknown>(
  variables: CollectionsPublishedOnDateQueryVariables,
  options?: UseQueryOptions<CollectionsPublishedOnDateQuery, TError, TData>
) =>
  useQuery<CollectionsPublishedOnDateQuery, TError, TData>(
    ['CollectionsPublishedOnDate', variables],
    useFetchData<CollectionsPublishedOnDateQuery, CollectionsPublishedOnDateQueryVariables>(
      CollectionsPublishedOnDateDocument
    ).bind(null, variables),
    options
  );
export const useInfiniteCollectionsPublishedOnDateQuery = <TData = CollectionsPublishedOnDateQuery, TError = unknown>(
  variables: CollectionsPublishedOnDateQueryVariables,
  options?: UseInfiniteQueryOptions<CollectionsPublishedOnDateQuery, TError, TData>
) => {
  const query = useFetchData<CollectionsPublishedOnDateQuery, CollectionsPublishedOnDateQueryVariables>(
    CollectionsPublishedOnDateDocument
  );
  return useInfiniteQuery<CollectionsPublishedOnDateQuery, TError, TData>(
    ['CollectionsPublishedOnDate.infinite', variables],
    (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
    options
  );
};

export const CollectionDtoCreateDocument = `
    mutation CollectionDTOCreate($collectionDTOCreateInput: CollectionDTOCreateInput!) {
  collectionDTOCreate(collectionDTOCreateInput: $collectionDTOCreateInput) {
    ...CollectionDTO
  }
}
    ${CollectionDtoFragmentDoc}`;
export const useCollectionDtoCreateMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<CollectionDtoCreateMutation, TError, CollectionDtoCreateMutationVariables, TContext>
) =>
  useMutation<CollectionDtoCreateMutation, TError, CollectionDtoCreateMutationVariables, TContext>(
    ['CollectionDTOCreate'],
    useFetchData<CollectionDtoCreateMutation, CollectionDtoCreateMutationVariables>(CollectionDtoCreateDocument),
    options
  );
export const CollectionDtoUpdateDocument = `
    mutation CollectionDTOUpdate($collectionDTOUpdateInput: CollectionDTOMutationInput!) {
  collectionDTOUpdate(collectionDTOUpdateInput: $collectionDTOUpdateInput) {
    ...CollectionDTO
  }
}
    ${CollectionDtoFragmentDoc}`;
export const useCollectionDtoUpdateMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<CollectionDtoUpdateMutation, TError, CollectionDtoUpdateMutationVariables, TContext>
) =>
  useMutation<CollectionDtoUpdateMutation, TError, CollectionDtoUpdateMutationVariables, TContext>(
    ['CollectionDTOUpdate'],
    useFetchData<CollectionDtoUpdateMutation, CollectionDtoUpdateMutationVariables>(CollectionDtoUpdateDocument),
    options
  );
export const CollectionDtoCopyDocument = `
    mutation CollectionDTOCopy($collectionDTOCopyInput: CollectionDTOMutationInput!) {
  collectionDTOCopy(collectionDTOCopyInput: $collectionDTOCopyInput) {
    ...CollectionDTO
  }
}
    ${CollectionDtoFragmentDoc}`;
export const useCollectionDtoCopyMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<CollectionDtoCopyMutation, TError, CollectionDtoCopyMutationVariables, TContext>
) =>
  useMutation<CollectionDtoCopyMutation, TError, CollectionDtoCopyMutationVariables, TContext>(
    ['CollectionDTOCopy'],
    useFetchData<CollectionDtoCopyMutation, CollectionDtoCopyMutationVariables>(CollectionDtoCopyDocument),
    options
  );
export const CollectionDtoArchiveDocument = `
    mutation CollectionDTOArchive($collectionDTOArchiveInput: CollectionDTOArchiveInput!) {
  collectionDTOArchive(collectionDTOArchiveInput: $collectionDTOArchiveInput) {
    ...CollectionDTO
  }
}
    ${CollectionDtoFragmentDoc}`;
export const useCollectionDtoArchiveMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<CollectionDtoArchiveMutation, TError, CollectionDtoArchiveMutationVariables, TContext>
) =>
  useMutation<CollectionDtoArchiveMutation, TError, CollectionDtoArchiveMutationVariables, TContext>(
    ['CollectionDTOArchive'],
    useFetchData<CollectionDtoArchiveMutation, CollectionDtoArchiveMutationVariables>(CollectionDtoArchiveDocument),
    options
  );
export const CollectionsDtoDocument = `
    query CollectionsDTO($collectionsDTOInput: CollectionsDTOInput!, $paginationParams: PaginationParams!) {
  collectionsDTO(
    collectionsDTOInput: $collectionsDTOInput
    paginationParams: $paginationParams
  ) {
    edges {
      node {
        ...CollectionDTOList
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${CollectionDtoListFragmentDoc}`;
export const useCollectionsDtoQuery = <TData = CollectionsDtoQuery, TError = unknown>(
  variables: CollectionsDtoQueryVariables,
  options?: UseQueryOptions<CollectionsDtoQuery, TError, TData>
) =>
  useQuery<CollectionsDtoQuery, TError, TData>(
    ['CollectionsDTO', variables],
    useFetchData<CollectionsDtoQuery, CollectionsDtoQueryVariables>(CollectionsDtoDocument).bind(null, variables),
    options
  );
export const useInfiniteCollectionsDtoQuery = <TData = CollectionsDtoQuery, TError = unknown>(
  variables: CollectionsDtoQueryVariables,
  options?: UseInfiniteQueryOptions<CollectionsDtoQuery, TError, TData>
) => {
  const query = useFetchData<CollectionsDtoQuery, CollectionsDtoQueryVariables>(CollectionsDtoDocument);
  return useInfiniteQuery<CollectionsDtoQuery, TError, TData>(
    ['CollectionsDTO.infinite', variables],
    (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
    options
  );
};

export const CollectionDtoByIdDocument = `
    query CollectionDTOById($id: String!, $publicationKey: String!) {
  collectionDTOById(id: $id, publicationKey: $publicationKey) {
    ...CollectionDTO
  }
}
    ${CollectionDtoFragmentDoc}`;
export const useCollectionDtoByIdQuery = <TData = CollectionDtoByIdQuery, TError = unknown>(
  variables: CollectionDtoByIdQueryVariables,
  options?: UseQueryOptions<CollectionDtoByIdQuery, TError, TData>
) =>
  useQuery<CollectionDtoByIdQuery, TError, TData>(
    ['CollectionDTOById', variables],
    useFetchData<CollectionDtoByIdQuery, CollectionDtoByIdQueryVariables>(CollectionDtoByIdDocument).bind(
      null,
      variables
    ),
    options
  );
export const useInfiniteCollectionDtoByIdQuery = <TData = CollectionDtoByIdQuery, TError = unknown>(
  variables: CollectionDtoByIdQueryVariables,
  options?: UseInfiniteQueryOptions<CollectionDtoByIdQuery, TError, TData>
) => {
  const query = useFetchData<CollectionDtoByIdQuery, CollectionDtoByIdQueryVariables>(CollectionDtoByIdDocument);
  return useInfiniteQuery<CollectionDtoByIdQuery, TError, TData>(
    ['CollectionDTOById.infinite', variables],
    (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
    options
  );
};

export const CreateItpDocument = `
    mutation createITP($itpCreateInput: ITPCreateInput!, $publicationKey: String!) {
  createITP(itpCreateInput: $itpCreateInput, publicationKey: $publicationKey) {
    ...Issue
  }
}
    ${IssueFragmentDoc}`;
export const useCreateItpMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<CreateItpMutation, TError, CreateItpMutationVariables, TContext>
) =>
  useMutation<CreateItpMutation, TError, CreateItpMutationVariables, TContext>(
    ['createITP'],
    useFetchData<CreateItpMutation, CreateItpMutationVariables>(CreateItpDocument),
    options
  );
export const DeleteItpDocument = `
    mutation deleteITP($issueId: String!, $publicationKey: String!) {
  deleteITP(issueId: $issueId, publicationKey: $publicationKey) {
    ...Issue
  }
}
    ${IssueFragmentDoc}`;
export const useDeleteItpMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<DeleteItpMutation, TError, DeleteItpMutationVariables, TContext>
) =>
  useMutation<DeleteItpMutation, TError, DeleteItpMutationVariables, TContext>(
    ['deleteITP'],
    useFetchData<DeleteItpMutation, DeleteItpMutationVariables>(DeleteItpDocument),
    options
  );
export const SaveItpDocument = `
    mutation saveITP($itpSaveInput: ITPSaveInput!, $publicationKey: String!) {
  saveITP(itpSaveInput: $itpSaveInput, publicationKey: $publicationKey) {
    createdUtc
    creatorUser {
      djUserId
    }
    issueDate
    issueId
    label
    pages {
      adType
      adZones
      allessehCollectionId
      isHidden
      issueId
      label
      pageType
    }
    publishUtc
    refreshedUtc
    revisorUser {
      djUserId
    }
    status
    updatedUtc
  }
}
    `;
export const useSaveItpMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<SaveItpMutation, TError, SaveItpMutationVariables, TContext>
) =>
  useMutation<SaveItpMutation, TError, SaveItpMutationVariables, TContext>(
    ['saveITP'],
    useFetchData<SaveItpMutation, SaveItpMutationVariables>(SaveItpDocument),
    options
  );
export const PublishItpDocument = `
    mutation publishITP($itpSaveInput: ITPSaveInput!, $publicationKey: String!) {
  publishITP(itpSaveInput: $itpSaveInput, publicationKey: $publicationKey) {
    createdUtc
    creatorUser {
      djUserId
    }
    issueDate
    issueId
    label
    pages {
      adType
      adZones
      allessehCollectionId
      isHidden
      issueId
      label
      pageType
    }
    publishUtc
    refreshedUtc
    revisorUser {
      djUserId
    }
    status
    updatedUtc
  }
}
    `;
export const usePublishItpMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<PublishItpMutation, TError, PublishItpMutationVariables, TContext>
) =>
  useMutation<PublishItpMutation, TError, PublishItpMutationVariables, TContext>(
    ['publishITP'],
    useFetchData<PublishItpMutation, PublishItpMutationVariables>(PublishItpDocument),
    options
  );
export const PreviewItpLinkDocument = `
    mutation previewItpLink($itpSaveInput: ITPSaveInput!, $publicationKey: String!) {
  previewItpLink(itpPreviewInput: $itpSaveInput, publicationKey: $publicationKey)
}
    `;
export const usePreviewItpLinkMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<PreviewItpLinkMutation, TError, PreviewItpLinkMutationVariables, TContext>
) =>
  useMutation<PreviewItpLinkMutation, TError, PreviewItpLinkMutationVariables, TContext>(
    ['previewItpLink'],
    useFetchData<PreviewItpLinkMutation, PreviewItpLinkMutationVariables>(PreviewItpLinkDocument),
    options
  );
export const LastSevenItpIssuesDocument = `
    query LastSevenITPIssues($publicationKey: String!) {
  lastSevenITPIssues(publicationKey: $publicationKey) {
    ...Issue
  }
}
    ${IssueFragmentDoc}`;
export const useLastSevenItpIssuesQuery = <TData = LastSevenItpIssuesQuery, TError = unknown>(
  variables: LastSevenItpIssuesQueryVariables,
  options?: UseQueryOptions<LastSevenItpIssuesQuery, TError, TData>
) =>
  useQuery<LastSevenItpIssuesQuery, TError, TData>(
    ['LastSevenITPIssues', variables],
    useFetchData<LastSevenItpIssuesQuery, LastSevenItpIssuesQueryVariables>(LastSevenItpIssuesDocument).bind(
      null,
      variables
    ),
    options
  );
export const useInfiniteLastSevenItpIssuesQuery = <TData = LastSevenItpIssuesQuery, TError = unknown>(
  variables: LastSevenItpIssuesQueryVariables,
  options?: UseInfiniteQueryOptions<LastSevenItpIssuesQuery, TError, TData>
) => {
  const query = useFetchData<LastSevenItpIssuesQuery, LastSevenItpIssuesQueryVariables>(LastSevenItpIssuesDocument);
  return useInfiniteQuery<LastSevenItpIssuesQuery, TError, TData>(
    ['LastSevenITPIssues.infinite', variables],
    (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
    options
  );
};

export const ItpByDateDocument = `
    query ITPByDate($publicationKey: String!, $issueDate: String!) {
  itpByDate(publicationKey: $publicationKey, issueDate: $issueDate) {
    ...IssueWithPages
    revisorUser {
      djUserId
    }
  }
}
    ${IssueWithPagesFragmentDoc}
${ItpPageModuleFragmentFragmentDoc}`;
export const useItpByDateQuery = <TData = ItpByDateQuery, TError = unknown>(
  variables: ItpByDateQueryVariables,
  options?: UseQueryOptions<ItpByDateQuery, TError, TData>
) =>
  useQuery<ItpByDateQuery, TError, TData>(
    ['ITPByDate', variables],
    useFetchData<ItpByDateQuery, ItpByDateQueryVariables>(ItpByDateDocument).bind(null, variables),
    options
  );
export const useInfiniteItpByDateQuery = <TData = ItpByDateQuery, TError = unknown>(
  variables: ItpByDateQueryVariables,
  options?: UseInfiniteQueryOptions<ItpByDateQuery, TError, TData>
) => {
  const query = useFetchData<ItpByDateQuery, ItpByDateQueryVariables>(ItpByDateDocument);
  return useInfiniteQuery<ItpByDateQuery, TError, TData>(
    ['ITPByDate.infinite', variables],
    (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
    options
  );
};

export const ImportItpContentDocument = `
    query ImportITPContent($publicationKey: String!, $itpImportContentInput: ITPImportContentInput!) {
  importITPContent(
    publicationKey: $publicationKey
    itpImportContentInput: $itpImportContentInput
  ) {
    uiModuleType
    uiModuleFields {
      basicModule {
        contentTypes
        treatmentType
        allowedTreatmentTypes
      }
    }
    moduleItems {
      itemType
      itemFields {
        contentItem {
          originId
          originContentType
          content
        }
      }
    }
    error
  }
}
    `;
export const useImportItpContentQuery = <TData = ImportItpContentQuery, TError = unknown>(
  variables: ImportItpContentQueryVariables,
  options?: UseQueryOptions<ImportItpContentQuery, TError, TData>
) =>
  useQuery<ImportItpContentQuery, TError, TData>(
    ['ImportITPContent', variables],
    useFetchData<ImportItpContentQuery, ImportItpContentQueryVariables>(ImportItpContentDocument).bind(null, variables),
    options
  );
export const useInfiniteImportItpContentQuery = <TData = ImportItpContentQuery, TError = unknown>(
  variables: ImportItpContentQueryVariables,
  options?: UseInfiniteQueryOptions<ImportItpContentQuery, TError, TData>
) => {
  const query = useFetchData<ImportItpContentQuery, ImportItpContentQueryVariables>(ImportItpContentDocument);
  return useInfiniteQuery<ImportItpContentQuery, TError, TData>(
    ['ImportITPContent.infinite', variables],
    (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
    options
  );
};

export const GetDefaultItpPagesDocument = `
    query GetDefaultITPPages($publicationKey: String!, $issueDate: String!) {
  getDefaultITPPages(publicationKey: $publicationKey, issueDate: $issueDate) {
    ...ITPPageFragment
  }
}
    ${ItpPageFragmentFragmentDoc}
${ItpPageModuleFragmentFragmentDoc}`;
export const useGetDefaultItpPagesQuery = <TData = GetDefaultItpPagesQuery, TError = unknown>(
  variables: GetDefaultItpPagesQueryVariables,
  options?: UseQueryOptions<GetDefaultItpPagesQuery, TError, TData>
) =>
  useQuery<GetDefaultItpPagesQuery, TError, TData>(
    ['GetDefaultITPPages', variables],
    useFetchData<GetDefaultItpPagesQuery, GetDefaultItpPagesQueryVariables>(GetDefaultItpPagesDocument).bind(
      null,
      variables
    ),
    options
  );
export const useInfiniteGetDefaultItpPagesQuery = <TData = GetDefaultItpPagesQuery, TError = unknown>(
  variables: GetDefaultItpPagesQueryVariables,
  options?: UseInfiniteQueryOptions<GetDefaultItpPagesQuery, TError, TData>
) => {
  const query = useFetchData<GetDefaultItpPagesQuery, GetDefaultItpPagesQueryVariables>(GetDefaultItpPagesDocument);
  return useInfiniteQuery<GetDefaultItpPagesQuery, TError, TData>(
    ['GetDefaultITPPages.infinite', variables],
    (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
    options
  );
};

export const CreateItpDtoDocument = `
    mutation createItpDTO($itpDTOCreateInput: ItpDTOCreateInput!, $publicationKey: String!) {
  createItpDTO(
    itpDTOCreateInput: $itpDTOCreateInput
    publicationKey: $publicationKey
  ) {
    ...ItpDTOFragment
  }
}
    ${ItpDtoFragmentFragmentDoc}
${IssueContainerFragmentFragmentDoc}
${IssueSectionContainerFragmentFragmentDoc}
${PageContainerFragmentFragmentDoc}
${ModuleContainerFragmentFragmentDoc}
${ItpPageModuleFragmentFragmentDoc}
${ArticleFragmentFragmentDoc}
${QueryFragmentFragmentDoc}
${ExternalCollectionFragmentFragmentDoc}`;
export const useCreateItpDtoMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<CreateItpDtoMutation, TError, CreateItpDtoMutationVariables, TContext>
) =>
  useMutation<CreateItpDtoMutation, TError, CreateItpDtoMutationVariables, TContext>(
    ['createItpDTO'],
    useFetchData<CreateItpDtoMutation, CreateItpDtoMutationVariables>(CreateItpDtoDocument),
    options
  );
export const DeleteItpDtoDocument = `
    mutation deleteItpDTO($allessehId: String!, $publicationKey: String!) {
  deleteItpDTO(allessehId: $allessehId, publicationKey: $publicationKey)
}
    `;
export const useDeleteItpDtoMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<DeleteItpDtoMutation, TError, DeleteItpDtoMutationVariables, TContext>
) =>
  useMutation<DeleteItpDtoMutation, TError, DeleteItpDtoMutationVariables, TContext>(
    ['deleteItpDTO'],
    useFetchData<DeleteItpDtoMutation, DeleteItpDtoMutationVariables>(DeleteItpDtoDocument),
    options
  );
export const SaveItpDtoDocument = `
    mutation saveItpDTO($itpDTOSaveInput: ItpDTOSaveInput!, $publicationKey: String!) {
  saveItpDTO(itpDTOSaveInput: $itpDTOSaveInput, publicationKey: $publicationKey) {
    ...ItpDTOFragment
  }
}
    ${ItpDtoFragmentFragmentDoc}
${IssueContainerFragmentFragmentDoc}
${IssueSectionContainerFragmentFragmentDoc}
${PageContainerFragmentFragmentDoc}
${ModuleContainerFragmentFragmentDoc}
${ItpPageModuleFragmentFragmentDoc}
${ArticleFragmentFragmentDoc}
${QueryFragmentFragmentDoc}
${ExternalCollectionFragmentFragmentDoc}`;
export const useSaveItpDtoMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<SaveItpDtoMutation, TError, SaveItpDtoMutationVariables, TContext>
) =>
  useMutation<SaveItpDtoMutation, TError, SaveItpDtoMutationVariables, TContext>(
    ['saveItpDTO'],
    useFetchData<SaveItpDtoMutation, SaveItpDtoMutationVariables>(SaveItpDtoDocument),
    options
  );
export const PublishItpDtoDocument = `
    mutation publishItpDTO($itpDTOSaveInput: ItpDTOSaveInput!, $publicationKey: String!) {
  publishItpDTO(
    itpDTOSaveInput: $itpDTOSaveInput
    publicationKey: $publicationKey
  ) {
    ...ItpDTOFragment
  }
}
    ${ItpDtoFragmentFragmentDoc}
${IssueContainerFragmentFragmentDoc}
${IssueSectionContainerFragmentFragmentDoc}
${PageContainerFragmentFragmentDoc}
${ModuleContainerFragmentFragmentDoc}
${ItpPageModuleFragmentFragmentDoc}
${ArticleFragmentFragmentDoc}
${QueryFragmentFragmentDoc}
${ExternalCollectionFragmentFragmentDoc}`;
export const usePublishItpDtoMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<PublishItpDtoMutation, TError, PublishItpDtoMutationVariables, TContext>
) =>
  useMutation<PublishItpDtoMutation, TError, PublishItpDtoMutationVariables, TContext>(
    ['publishItpDTO'],
    useFetchData<PublishItpDtoMutation, PublishItpDtoMutationVariables>(PublishItpDtoDocument),
    options
  );
export const PreviewItpDtoLinkDocument = `
    mutation previewItpDTOLink($itpDTOSaveInput: ItpDTOSaveInput!, $publicationKey: String!) {
  previewItpDTOLink(
    itpDTOPreviewInput: $itpDTOSaveInput
    publicationKey: $publicationKey
  )
}
    `;
export const usePreviewItpDtoLinkMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<PreviewItpDtoLinkMutation, TError, PreviewItpDtoLinkMutationVariables, TContext>
) =>
  useMutation<PreviewItpDtoLinkMutation, TError, PreviewItpDtoLinkMutationVariables, TContext>(
    ['previewItpDTOLink'],
    useFetchData<PreviewItpDtoLinkMutation, PreviewItpDtoLinkMutationVariables>(PreviewItpDtoLinkDocument),
    options
  );
export const DefaultItpIssueStateDocument = `
    query DefaultITPIssueState($publicationKey: String!, $issueDate: String!) {
  getDefaultITPIssueState(publicationKey: $publicationKey, issueDate: $issueDate) {
    ...ItpDTOFragment
  }
}
    ${ItpDtoFragmentFragmentDoc}
${IssueContainerFragmentFragmentDoc}
${IssueSectionContainerFragmentFragmentDoc}
${PageContainerFragmentFragmentDoc}
${ModuleContainerFragmentFragmentDoc}
${ItpPageModuleFragmentFragmentDoc}
${ArticleFragmentFragmentDoc}
${QueryFragmentFragmentDoc}
${ExternalCollectionFragmentFragmentDoc}`;
export const useDefaultItpIssueStateQuery = <TData = DefaultItpIssueStateQuery, TError = unknown>(
  variables: DefaultItpIssueStateQueryVariables,
  options?: UseQueryOptions<DefaultItpIssueStateQuery, TError, TData>
) =>
  useQuery<DefaultItpIssueStateQuery, TError, TData>(
    ['DefaultITPIssueState', variables],
    useFetchData<DefaultItpIssueStateQuery, DefaultItpIssueStateQueryVariables>(DefaultItpIssueStateDocument).bind(
      null,
      variables
    ),
    options
  );
export const useInfiniteDefaultItpIssueStateQuery = <TData = DefaultItpIssueStateQuery, TError = unknown>(
  variables: DefaultItpIssueStateQueryVariables,
  options?: UseInfiniteQueryOptions<DefaultItpIssueStateQuery, TError, TData>
) => {
  const query = useFetchData<DefaultItpIssueStateQuery, DefaultItpIssueStateQueryVariables>(
    DefaultItpIssueStateDocument
  );
  return useInfiniteQuery<DefaultItpIssueStateQuery, TError, TData>(
    ['DefaultITPIssueState.infinite', variables],
    (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
    options
  );
};

export const LastSevenItpDtOsDocument = `
    query LastSevenItpDTOs($publicationKey: String!) {
  lastSevenItpDTOs(publicationKey: $publicationKey) {
    ...ItpDTOFragment
  }
}
    ${ItpDtoFragmentFragmentDoc}
${IssueContainerFragmentFragmentDoc}
${IssueSectionContainerFragmentFragmentDoc}
${PageContainerFragmentFragmentDoc}
${ModuleContainerFragmentFragmentDoc}
${ItpPageModuleFragmentFragmentDoc}
${ArticleFragmentFragmentDoc}
${QueryFragmentFragmentDoc}
${ExternalCollectionFragmentFragmentDoc}`;
export const useLastSevenItpDtOsQuery = <TData = LastSevenItpDtOsQuery, TError = unknown>(
  variables: LastSevenItpDtOsQueryVariables,
  options?: UseQueryOptions<LastSevenItpDtOsQuery, TError, TData>
) =>
  useQuery<LastSevenItpDtOsQuery, TError, TData>(
    ['LastSevenItpDTOs', variables],
    useFetchData<LastSevenItpDtOsQuery, LastSevenItpDtOsQueryVariables>(LastSevenItpDtOsDocument).bind(null, variables),
    options
  );
export const useInfiniteLastSevenItpDtOsQuery = <TData = LastSevenItpDtOsQuery, TError = unknown>(
  variables: LastSevenItpDtOsQueryVariables,
  options?: UseInfiniteQueryOptions<LastSevenItpDtOsQuery, TError, TData>
) => {
  const query = useFetchData<LastSevenItpDtOsQuery, LastSevenItpDtOsQueryVariables>(LastSevenItpDtOsDocument);
  return useInfiniteQuery<LastSevenItpDtOsQuery, TError, TData>(
    ['LastSevenItpDTOs.infinite', variables],
    (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
    options
  );
};

export const ItpDtoByDateDocument = `
    query ItpDtoByDate($publicationKey: String!, $issueDate: String!) {
  itpDTOByDate(publicationKey: $publicationKey, issueDate: $issueDate) {
    ...ItpDTOFragment
  }
}
    ${ItpDtoFragmentFragmentDoc}
${IssueContainerFragmentFragmentDoc}
${IssueSectionContainerFragmentFragmentDoc}
${PageContainerFragmentFragmentDoc}
${ModuleContainerFragmentFragmentDoc}
${ItpPageModuleFragmentFragmentDoc}
${ArticleFragmentFragmentDoc}
${QueryFragmentFragmentDoc}
${ExternalCollectionFragmentFragmentDoc}`;
export const useItpDtoByDateQuery = <TData = ItpDtoByDateQuery, TError = unknown>(
  variables: ItpDtoByDateQueryVariables,
  options?: UseQueryOptions<ItpDtoByDateQuery, TError, TData>
) =>
  useQuery<ItpDtoByDateQuery, TError, TData>(
    ['ItpDtoByDate', variables],
    useFetchData<ItpDtoByDateQuery, ItpDtoByDateQueryVariables>(ItpDtoByDateDocument).bind(null, variables),
    options
  );
export const useInfiniteItpDtoByDateQuery = <TData = ItpDtoByDateQuery, TError = unknown>(
  variables: ItpDtoByDateQueryVariables,
  options?: UseInfiniteQueryOptions<ItpDtoByDateQuery, TError, TData>
) => {
  const query = useFetchData<ItpDtoByDateQuery, ItpDtoByDateQueryVariables>(ItpDtoByDateDocument);
  return useInfiniteQuery<ItpDtoByDateQuery, TError, TData>(
    ['ItpDtoByDate.infinite', variables],
    (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
    options
  );
};

export const ImportItpDtoContentDocument = `
    query ImportItpDtoContent($publicationKey: String!, $itpDTOImportContentInput: ItpDTOImportContentInput!) {
  importItpDTOContent(
    publicationKey: $publicationKey
    itpDTOImportContentInput: $itpDTOImportContentInput
  ) {
    issue {
      ...ItpDTOFragment
    }
    newIds
    staleIds
  }
}
    ${ItpDtoFragmentFragmentDoc}
${IssueContainerFragmentFragmentDoc}
${IssueSectionContainerFragmentFragmentDoc}
${PageContainerFragmentFragmentDoc}
${ModuleContainerFragmentFragmentDoc}
${ItpPageModuleFragmentFragmentDoc}
${ArticleFragmentFragmentDoc}
${QueryFragmentFragmentDoc}
${ExternalCollectionFragmentFragmentDoc}`;
export const useImportItpDtoContentQuery = <TData = ImportItpDtoContentQuery, TError = unknown>(
  variables: ImportItpDtoContentQueryVariables,
  options?: UseQueryOptions<ImportItpDtoContentQuery, TError, TData>
) =>
  useQuery<ImportItpDtoContentQuery, TError, TData>(
    ['ImportItpDtoContent', variables],
    useFetchData<ImportItpDtoContentQuery, ImportItpDtoContentQueryVariables>(ImportItpDtoContentDocument).bind(
      null,
      variables
    ),
    options
  );
export const useInfiniteImportItpDtoContentQuery = <TData = ImportItpDtoContentQuery, TError = unknown>(
  variables: ImportItpDtoContentQueryVariables,
  options?: UseInfiniteQueryOptions<ImportItpDtoContentQuery, TError, TData>
) => {
  const query = useFetchData<ImportItpDtoContentQuery, ImportItpDtoContentQueryVariables>(ImportItpDtoContentDocument);
  return useInfiniteQuery<ImportItpDtoContentQuery, TError, TData>(
    ['ImportItpDtoContent.infinite', variables],
    (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
    options
  );
};

export const NewsletterListItemsDocument = `
    query NewsletterListItems($publicationKey: String!) {
  getNewsletterList(publicationKey: $publicationKey) {
    ...NewsletterListItemNewsletterListItem
  }
}
    ${NewsletterListItemNewsletterListItemFragmentDoc}`;
export const useNewsletterListItemsQuery = <TData = NewsletterListItemsQuery, TError = unknown>(
  variables: NewsletterListItemsQueryVariables,
  options?: UseQueryOptions<NewsletterListItemsQuery, TError, TData>
) =>
  useQuery<NewsletterListItemsQuery, TError, TData>(
    ['NewsletterListItems', variables],
    useFetchData<NewsletterListItemsQuery, NewsletterListItemsQueryVariables>(NewsletterListItemsDocument).bind(
      null,
      variables
    ),
    options
  );
export const useInfiniteNewsletterListItemsQuery = <TData = NewsletterListItemsQuery, TError = unknown>(
  variables: NewsletterListItemsQueryVariables,
  options?: UseInfiniteQueryOptions<NewsletterListItemsQuery, TError, TData>
) => {
  const query = useFetchData<NewsletterListItemsQuery, NewsletterListItemsQueryVariables>(NewsletterListItemsDocument);
  return useInfiniteQuery<NewsletterListItemsQuery, TError, TData>(
    ['NewsletterListItems.infinite', variables],
    (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
    options
  );
};

export const CreateNewsletterDocument = `
    mutation CreateNewsletter($newsletterInput: NewsletterInput!) {
  createNewsletter(newsletterInput: $newsletterInput) {
    ...NewsletterDTO
  }
}
    ${NewsletterDtoFragmentDoc}
${PageModuleFragmentRecursiveFragmentDoc}
${PageModuleSubFieldsFragmentFragmentDoc}
${CollectionPageCollectionFragmentDoc}
${PageModuleUiModuleFieldsFragmentFragmentDoc}
${BasicModuleFragmentFragmentDoc}
${TitleModuleFragmentFragmentDoc}
${RankedModuleFragmentFragmentDoc}
${TextModuleFragmentFragmentDoc}
${BasicOptionalModuleFragmentFragmentDoc}
${FeedsModuleFragmentFragmentDoc}`;
export const useCreateNewsletterMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<CreateNewsletterMutation, TError, CreateNewsletterMutationVariables, TContext>
) =>
  useMutation<CreateNewsletterMutation, TError, CreateNewsletterMutationVariables, TContext>(
    ['CreateNewsletter'],
    useFetchData<CreateNewsletterMutation, CreateNewsletterMutationVariables>(CreateNewsletterDocument),
    options
  );
export const CreatePreviewNewsletterDocument = `
    mutation CreatePreviewNewsletter($newsletterInput: NewsletterInput!) {
  createPreviewNewsletter(newsletterInput: $newsletterInput) {
    ...NewsletterDTO
  }
}
    ${NewsletterDtoFragmentDoc}
${PageModuleFragmentRecursiveFragmentDoc}
${PageModuleSubFieldsFragmentFragmentDoc}
${CollectionPageCollectionFragmentDoc}
${PageModuleUiModuleFieldsFragmentFragmentDoc}
${BasicModuleFragmentFragmentDoc}
${TitleModuleFragmentFragmentDoc}
${RankedModuleFragmentFragmentDoc}
${TextModuleFragmentFragmentDoc}
${BasicOptionalModuleFragmentFragmentDoc}
${FeedsModuleFragmentFragmentDoc}`;
export const useCreatePreviewNewsletterMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CreatePreviewNewsletterMutation,
    TError,
    CreatePreviewNewsletterMutationVariables,
    TContext
  >
) =>
  useMutation<CreatePreviewNewsletterMutation, TError, CreatePreviewNewsletterMutationVariables, TContext>(
    ['CreatePreviewNewsletter'],
    useFetchData<CreatePreviewNewsletterMutation, CreatePreviewNewsletterMutationVariables>(
      CreatePreviewNewsletterDocument
    ),
    options
  );
export const GetNewslettersDocument = `
    query GetNewsletters($newslettersSearchInput: NewslettersSearchInput!, $paginationParams: PaginationParams!) {
  getNewsletters(
    newslettersSearchInput: $newslettersSearchInput
    paginationParams: $paginationParams
  ) {
    edges {
      node {
        ...NewsletterDTO
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${NewsletterDtoFragmentDoc}
${PageModuleFragmentRecursiveFragmentDoc}
${PageModuleSubFieldsFragmentFragmentDoc}
${CollectionPageCollectionFragmentDoc}
${PageModuleUiModuleFieldsFragmentFragmentDoc}
${BasicModuleFragmentFragmentDoc}
${TitleModuleFragmentFragmentDoc}
${RankedModuleFragmentFragmentDoc}
${TextModuleFragmentFragmentDoc}
${BasicOptionalModuleFragmentFragmentDoc}
${FeedsModuleFragmentFragmentDoc}`;
export const useGetNewslettersQuery = <TData = GetNewslettersQuery, TError = unknown>(
  variables: GetNewslettersQueryVariables,
  options?: UseQueryOptions<GetNewslettersQuery, TError, TData>
) =>
  useQuery<GetNewslettersQuery, TError, TData>(
    ['GetNewsletters', variables],
    useFetchData<GetNewslettersQuery, GetNewslettersQueryVariables>(GetNewslettersDocument).bind(null, variables),
    options
  );
export const useInfiniteGetNewslettersQuery = <TData = GetNewslettersQuery, TError = unknown>(
  variables: GetNewslettersQueryVariables,
  options?: UseInfiniteQueryOptions<GetNewslettersQuery, TError, TData>
) => {
  const query = useFetchData<GetNewslettersQuery, GetNewslettersQueryVariables>(GetNewslettersDocument);
  return useInfiniteQuery<GetNewslettersQuery, TError, TData>(
    ['GetNewsletters.infinite', variables],
    (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
    options
  );
};

export const NewsletterByIdDocument = `
    query NewsletterById($id: String!, $publicationKey: String!) {
  newsletterById(id: $id, publicationKey: $publicationKey) {
    ...NewsletterDTO
  }
}
    ${NewsletterDtoFragmentDoc}
${PageModuleFragmentRecursiveFragmentDoc}
${PageModuleSubFieldsFragmentFragmentDoc}
${CollectionPageCollectionFragmentDoc}
${PageModuleUiModuleFieldsFragmentFragmentDoc}
${BasicModuleFragmentFragmentDoc}
${TitleModuleFragmentFragmentDoc}
${RankedModuleFragmentFragmentDoc}
${TextModuleFragmentFragmentDoc}
${BasicOptionalModuleFragmentFragmentDoc}
${FeedsModuleFragmentFragmentDoc}`;
export const useNewsletterByIdQuery = <TData = NewsletterByIdQuery, TError = unknown>(
  variables: NewsletterByIdQueryVariables,
  options?: UseQueryOptions<NewsletterByIdQuery, TError, TData>
) =>
  useQuery<NewsletterByIdQuery, TError, TData>(
    ['NewsletterById', variables],
    useFetchData<NewsletterByIdQuery, NewsletterByIdQueryVariables>(NewsletterByIdDocument).bind(null, variables),
    options
  );
export const useInfiniteNewsletterByIdQuery = <TData = NewsletterByIdQuery, TError = unknown>(
  variables: NewsletterByIdQueryVariables,
  options?: UseInfiniteQueryOptions<NewsletterByIdQuery, TError, TData>
) => {
  const query = useFetchData<NewsletterByIdQuery, NewsletterByIdQueryVariables>(NewsletterByIdDocument);
  return useInfiniteQuery<NewsletterByIdQuery, TError, TData>(
    ['NewsletterById.infinite', variables],
    (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
    options
  );
};

export const UpdateOffPlatformDocument = `
    mutation UpdateOffPlatform($offPlatformUpdateInput: OffPlatformUpdateInput!) {
  updateOffPlatform(offPlatformUpdateInput: $offPlatformUpdateInput) {
    ...OffPlatformDTO
  }
}
    ${OffPlatformDtoFragmentDoc}`;
export const useUpdateOffPlatformMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<UpdateOffPlatformMutation, TError, UpdateOffPlatformMutationVariables, TContext>
) =>
  useMutation<UpdateOffPlatformMutation, TError, UpdateOffPlatformMutationVariables, TContext>(
    ['UpdateOffPlatform'],
    useFetchData<UpdateOffPlatformMutation, UpdateOffPlatformMutationVariables>(UpdateOffPlatformDocument),
    options
  );
export const ConvertToOffPlatformDocument = `
    mutation ConvertToOffPlatform($convertToOffPlatformInput: ConvertToOffPlatformInput!) {
  convertToOffPlatform(convertToOffPlatformInput: $convertToOffPlatformInput) {
    ...OffPlatformDTO
  }
}
    ${OffPlatformDtoFragmentDoc}`;
export const useConvertToOffPlatformMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<ConvertToOffPlatformMutation, TError, ConvertToOffPlatformMutationVariables, TContext>
) =>
  useMutation<ConvertToOffPlatformMutation, TError, ConvertToOffPlatformMutationVariables, TContext>(
    ['ConvertToOffPlatform'],
    useFetchData<ConvertToOffPlatformMutation, ConvertToOffPlatformMutationVariables>(ConvertToOffPlatformDocument),
    options
  );
export const GetAllOffPlatformDocument = `
    query GetAllOffPlatform($offPlatformInput: OffPlatformInput!, $paginationParams: PaginationParams!) {
  getAllOffPlatform(
    offPlatformInput: $offPlatformInput
    paginationParams: $paginationParams
  ) {
    edges {
      node {
        ...OffPlatformDTOList
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
  }
}
    ${OffPlatformDtoListFragmentDoc}`;
export const useGetAllOffPlatformQuery = <TData = GetAllOffPlatformQuery, TError = unknown>(
  variables: GetAllOffPlatformQueryVariables,
  options?: UseQueryOptions<GetAllOffPlatformQuery, TError, TData>
) =>
  useQuery<GetAllOffPlatformQuery, TError, TData>(
    ['GetAllOffPlatform', variables],
    useFetchData<GetAllOffPlatformQuery, GetAllOffPlatformQueryVariables>(GetAllOffPlatformDocument).bind(
      null,
      variables
    ),
    options
  );
export const useInfiniteGetAllOffPlatformQuery = <TData = GetAllOffPlatformQuery, TError = unknown>(
  variables: GetAllOffPlatformQueryVariables,
  options?: UseInfiniteQueryOptions<GetAllOffPlatformQuery, TError, TData>
) => {
  const query = useFetchData<GetAllOffPlatformQuery, GetAllOffPlatformQueryVariables>(GetAllOffPlatformDocument);
  return useInfiniteQuery<GetAllOffPlatformQuery, TError, TData>(
    ['GetAllOffPlatform.infinite', variables],
    (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
    options
  );
};

export const OffPlatformByIdDocument = `
    query OffPlatformById($id: String!, $publicationKey: String!) {
  offPlatformById(id: $id, publicationKey: $publicationKey) {
    ...OffPlatformDTO
  }
}
    ${OffPlatformDtoFragmentDoc}`;
export const useOffPlatformByIdQuery = <TData = OffPlatformByIdQuery, TError = unknown>(
  variables: OffPlatformByIdQueryVariables,
  options?: UseQueryOptions<OffPlatformByIdQuery, TError, TData>
) =>
  useQuery<OffPlatformByIdQuery, TError, TData>(
    ['OffPlatformById', variables],
    useFetchData<OffPlatformByIdQuery, OffPlatformByIdQueryVariables>(OffPlatformByIdDocument).bind(null, variables),
    options
  );
export const useInfiniteOffPlatformByIdQuery = <TData = OffPlatformByIdQuery, TError = unknown>(
  variables: OffPlatformByIdQueryVariables,
  options?: UseInfiniteQueryOptions<OffPlatformByIdQuery, TError, TData>
) => {
  const query = useFetchData<OffPlatformByIdQuery, OffPlatformByIdQueryVariables>(OffPlatformByIdDocument);
  return useInfiniteQuery<OffPlatformByIdQuery, TError, TData>(
    ['OffPlatformById.infinite', variables],
    (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
    options
  );
};

export const PageDtoPreviewLinkDocument = `
    mutation PageDTOPreviewLink($pagePreviewLinkInput: PageDTOPreviewLinkInput!) {
  pageDTOPreviewLink(pagePreviewLinkInput: $pagePreviewLinkInput)
}
    `;
export const usePageDtoPreviewLinkMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<PageDtoPreviewLinkMutation, TError, PageDtoPreviewLinkMutationVariables, TContext>
) =>
  useMutation<PageDtoPreviewLinkMutation, TError, PageDtoPreviewLinkMutationVariables, TContext>(
    ['PageDTOPreviewLink'],
    useFetchData<PageDtoPreviewLinkMutation, PageDtoPreviewLinkMutationVariables>(PageDtoPreviewLinkDocument),
    options
  );
export const PageDtoUpdateDocument = `
    mutation PageDTOUpdate($pageUpdateInput: PageDTOUpdateInput!) {
  pageDTOUpdate(pageUpdateInput: $pageUpdateInput) {
    ...PageDTOData
  }
}
    ${PageDtoDataFragmentDoc}
${PageDtoMetadataFragmentDoc}
${PageModuleUiModuleFieldsFragmentFragmentDoc}
${BasicModuleFragmentFragmentDoc}
${TitleModuleFragmentFragmentDoc}
${RankedModuleFragmentFragmentDoc}
${TextModuleFragmentFragmentDoc}
${BasicOptionalModuleFragmentFragmentDoc}
${FeedsModuleFragmentFragmentDoc}`;
export const usePageDtoUpdateMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<PageDtoUpdateMutation, TError, PageDtoUpdateMutationVariables, TContext>
) =>
  useMutation<PageDtoUpdateMutation, TError, PageDtoUpdateMutationVariables, TContext>(
    ['PageDTOUpdate'],
    useFetchData<PageDtoUpdateMutation, PageDtoUpdateMutationVariables>(PageDtoUpdateDocument),
    options
  );
export const CreateWsjSectionFrontPageDocument = `
    mutation CreateWSJSectionFrontPage($wsjSectionFrontInput: WsjSectionFrontCreateInput!) {
  createWSJSectionFrontPage(wsjSectionFrontCreateInput: $wsjSectionFrontInput) {
    ...PageDTOData
  }
}
    ${PageDtoDataFragmentDoc}
${PageDtoMetadataFragmentDoc}
${PageModuleUiModuleFieldsFragmentFragmentDoc}
${BasicModuleFragmentFragmentDoc}
${TitleModuleFragmentFragmentDoc}
${RankedModuleFragmentFragmentDoc}
${TextModuleFragmentFragmentDoc}
${BasicOptionalModuleFragmentFragmentDoc}
${FeedsModuleFragmentFragmentDoc}`;
export const useCreateWsjSectionFrontPageMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CreateWsjSectionFrontPageMutation,
    TError,
    CreateWsjSectionFrontPageMutationVariables,
    TContext
  >
) =>
  useMutation<CreateWsjSectionFrontPageMutation, TError, CreateWsjSectionFrontPageMutationVariables, TContext>(
    ['CreateWSJSectionFrontPage'],
    useFetchData<CreateWsjSectionFrontPageMutation, CreateWsjSectionFrontPageMutationVariables>(
      CreateWsjSectionFrontPageDocument
    ),
    options
  );
export const PagesDtoDocument = `
    query PagesDTO($pagesInput: PagesDTOInput!, $paginationParams: PaginationParams!) {
  pagesDTO(pagesInput: $pagesInput, paginationParams: $paginationParams) {
    edges {
      node {
        type
        metadata {
          ...PageDTOMetadata
        }
        root {
          attributes {
            adPlacementType
            adZone
            isHidden
            pageType
            routeKey
            summaryPriority
          }
          collection {
            attributes {
              layoutId
            }
          }
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${PageDtoMetadataFragmentDoc}`;
export const usePagesDtoQuery = <TData = PagesDtoQuery, TError = unknown>(
  variables: PagesDtoQueryVariables,
  options?: UseQueryOptions<PagesDtoQuery, TError, TData>
) =>
  useQuery<PagesDtoQuery, TError, TData>(
    ['PagesDTO', variables],
    useFetchData<PagesDtoQuery, PagesDtoQueryVariables>(PagesDtoDocument).bind(null, variables),
    options
  );
export const useInfinitePagesDtoQuery = <TData = PagesDtoQuery, TError = unknown>(
  variables: PagesDtoQueryVariables,
  options?: UseInfiniteQueryOptions<PagesDtoQuery, TError, TData>
) => {
  const query = useFetchData<PagesDtoQuery, PagesDtoQueryVariables>(PagesDtoDocument);
  return useInfiniteQuery<PagesDtoQuery, TError, TData>(
    ['PagesDTO.infinite', variables],
    (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
    options
  );
};

export const PageDtoByAllessehIdDocument = `
    query PageDTOByAllessehId($allessehId: String!, $publicationKey: String!) {
  pageDTOByAllessehId(allessehId: $allessehId, publicationKey: $publicationKey) {
    ...PageDTOData
  }
}
    ${PageDtoDataFragmentDoc}
${PageDtoMetadataFragmentDoc}
${PageModuleUiModuleFieldsFragmentFragmentDoc}
${BasicModuleFragmentFragmentDoc}
${TitleModuleFragmentFragmentDoc}
${RankedModuleFragmentFragmentDoc}
${TextModuleFragmentFragmentDoc}
${BasicOptionalModuleFragmentFragmentDoc}
${FeedsModuleFragmentFragmentDoc}`;
export const usePageDtoByAllessehIdQuery = <TData = PageDtoByAllessehIdQuery, TError = unknown>(
  variables: PageDtoByAllessehIdQueryVariables,
  options?: UseQueryOptions<PageDtoByAllessehIdQuery, TError, TData>
) =>
  useQuery<PageDtoByAllessehIdQuery, TError, TData>(
    ['PageDTOByAllessehId', variables],
    useFetchData<PageDtoByAllessehIdQuery, PageDtoByAllessehIdQueryVariables>(PageDtoByAllessehIdDocument).bind(
      null,
      variables
    ),
    options
  );
export const useInfinitePageDtoByAllessehIdQuery = <TData = PageDtoByAllessehIdQuery, TError = unknown>(
  variables: PageDtoByAllessehIdQueryVariables,
  options?: UseInfiniteQueryOptions<PageDtoByAllessehIdQuery, TError, TData>
) => {
  const query = useFetchData<PageDtoByAllessehIdQuery, PageDtoByAllessehIdQueryVariables>(PageDtoByAllessehIdDocument);
  return useInfiniteQuery<PageDtoByAllessehIdQuery, TError, TData>(
    ['PageDTOByAllessehId.infinite', variables],
    (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
    options
  );
};

export const PagesDtoForCollectionIdDocument = `
    query PagesDTOForCollectionId($publicationKey: String!, $collectionId: String!) {
  pagesDTOForCollectionId(
    publicationKey: $publicationKey
    collectionId: $collectionId
  ) {
    numRevisions
    latestPage {
      metadata {
        allessehId
        name
        publishUtc
      }
    }
  }
}
    `;
export const usePagesDtoForCollectionIdQuery = <TData = PagesDtoForCollectionIdQuery, TError = unknown>(
  variables: PagesDtoForCollectionIdQueryVariables,
  options?: UseQueryOptions<PagesDtoForCollectionIdQuery, TError, TData>
) =>
  useQuery<PagesDtoForCollectionIdQuery, TError, TData>(
    ['PagesDTOForCollectionId', variables],
    useFetchData<PagesDtoForCollectionIdQuery, PagesDtoForCollectionIdQueryVariables>(
      PagesDtoForCollectionIdDocument
    ).bind(null, variables),
    options
  );
export const useInfinitePagesDtoForCollectionIdQuery = <TData = PagesDtoForCollectionIdQuery, TError = unknown>(
  variables: PagesDtoForCollectionIdQueryVariables,
  options?: UseInfiniteQueryOptions<PagesDtoForCollectionIdQuery, TError, TData>
) => {
  const query = useFetchData<PagesDtoForCollectionIdQuery, PagesDtoForCollectionIdQueryVariables>(
    PagesDtoForCollectionIdDocument
  );
  return useInfiniteQuery<PagesDtoForCollectionIdQuery, TError, TData>(
    ['PagesDTOForCollectionId.infinite', variables],
    (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
    options
  );
};

export const IsPreviewDraftPageDocument = `
    query IsPreviewDraftPage($allessehId: String!) {
  isPreviewDraftPage(allessehId: $allessehId)
}
    `;
export const useIsPreviewDraftPageQuery = <TData = IsPreviewDraftPageQuery, TError = unknown>(
  variables: IsPreviewDraftPageQueryVariables,
  options?: UseQueryOptions<IsPreviewDraftPageQuery, TError, TData>
) =>
  useQuery<IsPreviewDraftPageQuery, TError, TData>(
    ['IsPreviewDraftPage', variables],
    useFetchData<IsPreviewDraftPageQuery, IsPreviewDraftPageQueryVariables>(IsPreviewDraftPageDocument).bind(
      null,
      variables
    ),
    options
  );
export const useInfiniteIsPreviewDraftPageQuery = <TData = IsPreviewDraftPageQuery, TError = unknown>(
  variables: IsPreviewDraftPageQueryVariables,
  options?: UseInfiniteQueryOptions<IsPreviewDraftPageQuery, TError, TData>
) => {
  const query = useFetchData<IsPreviewDraftPageQuery, IsPreviewDraftPageQueryVariables>(IsPreviewDraftPageDocument);
  return useInfiniteQuery<IsPreviewDraftPageQuery, TError, TData>(
    ['IsPreviewDraftPage.infinite', variables],
    (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
    options
  );
};

export const PageTypeSettingByPublicationKeyPageTypeDocument = `
    query PageTypeSettingByPublicationKeyPageType($publicationKey: String!, $pageType: PageType!) {
  pageTypeSettingByPublicationKeyPageType(
    publicationKey: $publicationKey
    pageType: $pageType
  ) {
    layouts {
      id
      name
      deprecated
      requiredLayoutModules {
        uiModuleType
        uiModuleFields {
          ...PageModuleUiModuleFieldsFragment
          twoColumnModule {
            ...TwoColumnModuleFragment
          }
        }
        ...PageModuleSubFieldsFragment
      }
      availableRequiredLayoutModules {
        uiModuleType
        defaultModule {
          uiModuleType
          uiModuleFields {
            ...PageModuleUiModuleFieldsFragment
            twoColumnModule {
              ...TwoColumnModuleFragment
            }
          }
          ...PageModuleSubFieldsFragment
        }
        minimumAllowed
        maximumAllowed
      }
      availableLayoutModules {
        uiModuleType
        defaultModule {
          uiModuleType
          uiModuleFields {
            ...PageModuleUiModuleFieldsFragment
            twoColumnModule {
              ...TwoColumnModuleFragment
            }
          }
          ...PageModuleSubFieldsFragment
        }
        minimumAllowed
        maximumAllowed
        allowedTreatmentTypes
      }
      availableTreatmentTypes
    }
    treatmentTypeSettings {
      treatmentType
      treatmentTypeKey
      minRequiredContentItems
      maxRequiredContentItems
      label
      contentTypes
      module {
        uiModuleType
        uiModuleFields {
          ...PageModuleUiModuleFieldsFragment
          twoColumnModule {
            ...TwoColumnModuleFragment
          }
        }
        ...PageModuleSubFieldsFragment
      }
    }
    contentTypes
  }
}
    ${PageModuleUiModuleFieldsFragmentFragmentDoc}
${BasicModuleFragmentFragmentDoc}
${TitleModuleFragmentFragmentDoc}
${RankedModuleFragmentFragmentDoc}
${TextModuleFragmentFragmentDoc}
${BasicOptionalModuleFragmentFragmentDoc}
${FeedsModuleFragmentFragmentDoc}
${TwoColumnModuleFragmentFragmentDoc}
${PageModuleFragmentRecursiveFragmentDoc}
${PageModuleSubFieldsFragmentFragmentDoc}
${CollectionPageCollectionFragmentDoc}`;
export const usePageTypeSettingByPublicationKeyPageTypeQuery = <
  TData = PageTypeSettingByPublicationKeyPageTypeQuery,
  TError = unknown
>(
  variables: PageTypeSettingByPublicationKeyPageTypeQueryVariables,
  options?: UseQueryOptions<PageTypeSettingByPublicationKeyPageTypeQuery, TError, TData>
) =>
  useQuery<PageTypeSettingByPublicationKeyPageTypeQuery, TError, TData>(
    ['PageTypeSettingByPublicationKeyPageType', variables],
    useFetchData<PageTypeSettingByPublicationKeyPageTypeQuery, PageTypeSettingByPublicationKeyPageTypeQueryVariables>(
      PageTypeSettingByPublicationKeyPageTypeDocument
    ).bind(null, variables),
    options
  );
export const useInfinitePageTypeSettingByPublicationKeyPageTypeQuery = <
  TData = PageTypeSettingByPublicationKeyPageTypeQuery,
  TError = unknown
>(
  variables: PageTypeSettingByPublicationKeyPageTypeQueryVariables,
  options?: UseInfiniteQueryOptions<PageTypeSettingByPublicationKeyPageTypeQuery, TError, TData>
) => {
  const query = useFetchData<
    PageTypeSettingByPublicationKeyPageTypeQuery,
    PageTypeSettingByPublicationKeyPageTypeQueryVariables
  >(PageTypeSettingByPublicationKeyPageTypeDocument);
  return useInfiniteQuery<PageTypeSettingByPublicationKeyPageTypeQuery, TError, TData>(
    ['PageTypeSettingByPublicationKeyPageType.infinite', variables],
    (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
    options
  );
};

export const PageUpdateDocument = `
    mutation PageUpdate($pageUpdateInput: PageUpdateInput!) {
  pageUpdate(pageUpdateInput: $pageUpdateInput) {
    ...PageEditPage
  }
}
    ${PageEditPageFragmentDoc}
${PageModuleFragmentFragmentDoc}
${PageModuleSubFieldsFragmentFragmentDoc}
${CollectionPageCollectionFragmentDoc}
${PageModuleUiModuleFieldsFragmentFragmentDoc}
${BasicModuleFragmentFragmentDoc}
${TitleModuleFragmentFragmentDoc}
${RankedModuleFragmentFragmentDoc}
${TextModuleFragmentFragmentDoc}
${BasicOptionalModuleFragmentFragmentDoc}
${FeedsModuleFragmentFragmentDoc}
${TwoColumnModuleFragmentFragmentDoc}
${PageModuleFragmentRecursiveFragmentDoc}`;
export const usePageUpdateMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<PageUpdateMutation, TError, PageUpdateMutationVariables, TContext>
) =>
  useMutation<PageUpdateMutation, TError, PageUpdateMutationVariables, TContext>(
    ['PageUpdate'],
    useFetchData<PageUpdateMutation, PageUpdateMutationVariables>(PageUpdateDocument),
    options
  );
export const PagePreviewLinkDocument = `
    mutation PagePreviewLink($pagePreviewLinkInput: PagePreviewLinkInput!) {
  pagePreviewLink(pagePreviewLinkInput: $pagePreviewLinkInput)
}
    `;
export const usePagePreviewLinkMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<PagePreviewLinkMutation, TError, PagePreviewLinkMutationVariables, TContext>
) =>
  useMutation<PagePreviewLinkMutation, TError, PagePreviewLinkMutationVariables, TContext>(
    ['PagePreviewLink'],
    useFetchData<PagePreviewLinkMutation, PagePreviewLinkMutationVariables>(PagePreviewLinkDocument),
    options
  );
export const PageDeleteDocument = `
    mutation PageDelete($pageDeleteInput: PageDeleteInput!) {
  pageDelete(pageDeleteInput: $pageDeleteInput) {
    ...PageEditPage
  }
}
    ${PageEditPageFragmentDoc}
${PageModuleFragmentFragmentDoc}
${PageModuleSubFieldsFragmentFragmentDoc}
${CollectionPageCollectionFragmentDoc}
${PageModuleUiModuleFieldsFragmentFragmentDoc}
${BasicModuleFragmentFragmentDoc}
${TitleModuleFragmentFragmentDoc}
${RankedModuleFragmentFragmentDoc}
${TextModuleFragmentFragmentDoc}
${BasicOptionalModuleFragmentFragmentDoc}
${FeedsModuleFragmentFragmentDoc}
${TwoColumnModuleFragmentFragmentDoc}
${PageModuleFragmentRecursiveFragmentDoc}`;
export const usePageDeleteMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<PageDeleteMutation, TError, PageDeleteMutationVariables, TContext>
) =>
  useMutation<PageDeleteMutation, TError, PageDeleteMutationVariables, TContext>(
    ['PageDelete'],
    useFetchData<PageDeleteMutation, PageDeleteMutationVariables>(PageDeleteDocument),
    options
  );
export const PagesDocument = `
    query Pages($pagesInput: PagesInput!, $paginationParams: PaginationParams!) {
  pages(pagesInput: $pagesInput, paginationParams: $paginationParams) {
    edges {
      node {
        name
        revisionGroupKey
        pageType
        routeKey
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;
export const usePagesQuery = <TData = PagesQuery, TError = unknown>(
  variables: PagesQueryVariables,
  options?: UseQueryOptions<PagesQuery, TError, TData>
) =>
  useQuery<PagesQuery, TError, TData>(
    ['Pages', variables],
    useFetchData<PagesQuery, PagesQueryVariables>(PagesDocument).bind(null, variables),
    options
  );
export const useInfinitePagesQuery = <TData = PagesQuery, TError = unknown>(
  variables: PagesQueryVariables,
  options?: UseInfiniteQueryOptions<PagesQuery, TError, TData>
) => {
  const query = useFetchData<PagesQuery, PagesQueryVariables>(PagesDocument);
  return useInfiniteQuery<PagesQuery, TError, TData>(
    ['Pages.infinite', variables],
    (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
    options
  );
};

export const PageByRevisionGroupKeyDocument = `
    query PageByRevisionGroupKey($revisionGroupKey: String!, $publicationKey: String!) {
  pageByRevisionGroupKey(
    revisionGroupKey: $revisionGroupKey
    publicationKey: $publicationKey
  ) {
    ...PageEditPage
  }
}
    ${PageEditPageFragmentDoc}
${PageModuleFragmentFragmentDoc}
${PageModuleSubFieldsFragmentFragmentDoc}
${CollectionPageCollectionFragmentDoc}
${PageModuleUiModuleFieldsFragmentFragmentDoc}
${BasicModuleFragmentFragmentDoc}
${TitleModuleFragmentFragmentDoc}
${RankedModuleFragmentFragmentDoc}
${TextModuleFragmentFragmentDoc}
${BasicOptionalModuleFragmentFragmentDoc}
${FeedsModuleFragmentFragmentDoc}
${TwoColumnModuleFragmentFragmentDoc}
${PageModuleFragmentRecursiveFragmentDoc}`;
export const usePageByRevisionGroupKeyQuery = <TData = PageByRevisionGroupKeyQuery, TError = unknown>(
  variables: PageByRevisionGroupKeyQueryVariables,
  options?: UseQueryOptions<PageByRevisionGroupKeyQuery, TError, TData>
) =>
  useQuery<PageByRevisionGroupKeyQuery, TError, TData>(
    ['PageByRevisionGroupKey', variables],
    useFetchData<PageByRevisionGroupKeyQuery, PageByRevisionGroupKeyQueryVariables>(
      PageByRevisionGroupKeyDocument
    ).bind(null, variables),
    options
  );
export const useInfinitePageByRevisionGroupKeyQuery = <TData = PageByRevisionGroupKeyQuery, TError = unknown>(
  variables: PageByRevisionGroupKeyQueryVariables,
  options?: UseInfiniteQueryOptions<PageByRevisionGroupKeyQuery, TError, TData>
) => {
  const query = useFetchData<PageByRevisionGroupKeyQuery, PageByRevisionGroupKeyQueryVariables>(
    PageByRevisionGroupKeyDocument
  );
  return useInfiniteQuery<PageByRevisionGroupKeyQuery, TError, TData>(
    ['PageByRevisionGroupKey.infinite', variables],
    (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
    options
  );
};

export const PagesPublishedByRevisionGroupKeyDocument = `
    query PagesPublishedByRevisionGroupKey($revisionGroupKey: String!, $paginationParams: PaginationParams!, $publicationKey: String!) {
  pagesPublishedByRevisionGroupKey(
    revisionGroupKey: $revisionGroupKey
    paginationParams: $paginationParams
    publicationKey: $publicationKey
  ) {
    edges {
      node {
        ...PageEditPage
      }
      cursor
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${PageEditPageFragmentDoc}
${PageModuleFragmentFragmentDoc}
${PageModuleSubFieldsFragmentFragmentDoc}
${CollectionPageCollectionFragmentDoc}
${PageModuleUiModuleFieldsFragmentFragmentDoc}
${BasicModuleFragmentFragmentDoc}
${TitleModuleFragmentFragmentDoc}
${RankedModuleFragmentFragmentDoc}
${TextModuleFragmentFragmentDoc}
${BasicOptionalModuleFragmentFragmentDoc}
${FeedsModuleFragmentFragmentDoc}
${TwoColumnModuleFragmentFragmentDoc}
${PageModuleFragmentRecursiveFragmentDoc}`;
export const usePagesPublishedByRevisionGroupKeyQuery = <
  TData = PagesPublishedByRevisionGroupKeyQuery,
  TError = unknown
>(
  variables: PagesPublishedByRevisionGroupKeyQueryVariables,
  options?: UseQueryOptions<PagesPublishedByRevisionGroupKeyQuery, TError, TData>
) =>
  useQuery<PagesPublishedByRevisionGroupKeyQuery, TError, TData>(
    ['PagesPublishedByRevisionGroupKey', variables],
    useFetchData<PagesPublishedByRevisionGroupKeyQuery, PagesPublishedByRevisionGroupKeyQueryVariables>(
      PagesPublishedByRevisionGroupKeyDocument
    ).bind(null, variables),
    options
  );
export const useInfinitePagesPublishedByRevisionGroupKeyQuery = <
  TData = PagesPublishedByRevisionGroupKeyQuery,
  TError = unknown
>(
  variables: PagesPublishedByRevisionGroupKeyQueryVariables,
  options?: UseInfiniteQueryOptions<PagesPublishedByRevisionGroupKeyQuery, TError, TData>
) => {
  const query = useFetchData<PagesPublishedByRevisionGroupKeyQuery, PagesPublishedByRevisionGroupKeyQueryVariables>(
    PagesPublishedByRevisionGroupKeyDocument
  );
  return useInfiniteQuery<PagesPublishedByRevisionGroupKeyQuery, TError, TData>(
    ['PagesPublishedByRevisionGroupKey.infinite', variables],
    (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
    options
  );
};

export const PagesByPublishUtcTimestampDocument = `
    query PagesByPublishUtcTimestamp($revisionGroupKey: String!, $publishUtc: Float!, $paginationParams: PaginationParams!, $publicationKey: String!) {
  pagesByPublishUtcTimestamp(
    revisionGroupKey: $revisionGroupKey
    publishUtc: $publishUtc
    paginationParams: $paginationParams
    publicationKey: $publicationKey
  ) {
    edges {
      node {
        ...PageEditPage
      }
      cursor
    }
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
  }
}
    ${PageEditPageFragmentDoc}
${PageModuleFragmentFragmentDoc}
${PageModuleSubFieldsFragmentFragmentDoc}
${CollectionPageCollectionFragmentDoc}
${PageModuleUiModuleFieldsFragmentFragmentDoc}
${BasicModuleFragmentFragmentDoc}
${TitleModuleFragmentFragmentDoc}
${RankedModuleFragmentFragmentDoc}
${TextModuleFragmentFragmentDoc}
${BasicOptionalModuleFragmentFragmentDoc}
${FeedsModuleFragmentFragmentDoc}
${TwoColumnModuleFragmentFragmentDoc}
${PageModuleFragmentRecursiveFragmentDoc}`;
export const usePagesByPublishUtcTimestampQuery = <TData = PagesByPublishUtcTimestampQuery, TError = unknown>(
  variables: PagesByPublishUtcTimestampQueryVariables,
  options?: UseQueryOptions<PagesByPublishUtcTimestampQuery, TError, TData>
) =>
  useQuery<PagesByPublishUtcTimestampQuery, TError, TData>(
    ['PagesByPublishUtcTimestamp', variables],
    useFetchData<PagesByPublishUtcTimestampQuery, PagesByPublishUtcTimestampQueryVariables>(
      PagesByPublishUtcTimestampDocument
    ).bind(null, variables),
    options
  );
export const useInfinitePagesByPublishUtcTimestampQuery = <TData = PagesByPublishUtcTimestampQuery, TError = unknown>(
  variables: PagesByPublishUtcTimestampQueryVariables,
  options?: UseInfiniteQueryOptions<PagesByPublishUtcTimestampQuery, TError, TData>
) => {
  const query = useFetchData<PagesByPublishUtcTimestampQuery, PagesByPublishUtcTimestampQueryVariables>(
    PagesByPublishUtcTimestampDocument
  );
  return useInfiniteQuery<PagesByPublishUtcTimestampQuery, TError, TData>(
    ['PagesByPublishUtcTimestamp.infinite', variables],
    (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
    options
  );
};

export const PagesPublishedOnDateDocument = `
    query PagesPublishedOnDate($revisionGroupKey: String!, $publishUtc: Float!, $paginationParams: PaginationParams!, $publicationKey: String!) {
  pagesPublishedOnDate(
    revisionGroupKey: $revisionGroupKey
    publishUtc: $publishUtc
    paginationParams: $paginationParams
    publicationKey: $publicationKey
  ) {
    edges {
      node {
        ...PageEditPage
      }
      cursor
    }
  }
}
    ${PageEditPageFragmentDoc}
${PageModuleFragmentFragmentDoc}
${PageModuleSubFieldsFragmentFragmentDoc}
${CollectionPageCollectionFragmentDoc}
${PageModuleUiModuleFieldsFragmentFragmentDoc}
${BasicModuleFragmentFragmentDoc}
${TitleModuleFragmentFragmentDoc}
${RankedModuleFragmentFragmentDoc}
${TextModuleFragmentFragmentDoc}
${BasicOptionalModuleFragmentFragmentDoc}
${FeedsModuleFragmentFragmentDoc}
${TwoColumnModuleFragmentFragmentDoc}
${PageModuleFragmentRecursiveFragmentDoc}`;
export const usePagesPublishedOnDateQuery = <TData = PagesPublishedOnDateQuery, TError = unknown>(
  variables: PagesPublishedOnDateQueryVariables,
  options?: UseQueryOptions<PagesPublishedOnDateQuery, TError, TData>
) =>
  useQuery<PagesPublishedOnDateQuery, TError, TData>(
    ['PagesPublishedOnDate', variables],
    useFetchData<PagesPublishedOnDateQuery, PagesPublishedOnDateQueryVariables>(PagesPublishedOnDateDocument).bind(
      null,
      variables
    ),
    options
  );
export const useInfinitePagesPublishedOnDateQuery = <TData = PagesPublishedOnDateQuery, TError = unknown>(
  variables: PagesPublishedOnDateQueryVariables,
  options?: UseInfiniteQueryOptions<PagesPublishedOnDateQuery, TError, TData>
) => {
  const query = useFetchData<PagesPublishedOnDateQuery, PagesPublishedOnDateQueryVariables>(
    PagesPublishedOnDateDocument
  );
  return useInfiniteQuery<PagesPublishedOnDateQuery, TError, TData>(
    ['PagesPublishedOnDate.infinite', variables],
    (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
    options
  );
};

export const PagesForCollectionIdCreatedUtcDocument = `
    query PagesForCollectionIdCreatedUtc($collectionIdCreatedUtc: String!, $publicationKey: String!) {
  pagesForCollectionIdCreatedUtc(
    collectionIdCreatedUtc: $collectionIdCreatedUtc
    publicationKey: $publicationKey
  ) {
    numRevisions
    latestPage {
      name
      revisionGroupKey
      publishUtc
    }
  }
}
    `;
export const usePagesForCollectionIdCreatedUtcQuery = <TData = PagesForCollectionIdCreatedUtcQuery, TError = unknown>(
  variables: PagesForCollectionIdCreatedUtcQueryVariables,
  options?: UseQueryOptions<PagesForCollectionIdCreatedUtcQuery, TError, TData>
) =>
  useQuery<PagesForCollectionIdCreatedUtcQuery, TError, TData>(
    ['PagesForCollectionIdCreatedUtc', variables],
    useFetchData<PagesForCollectionIdCreatedUtcQuery, PagesForCollectionIdCreatedUtcQueryVariables>(
      PagesForCollectionIdCreatedUtcDocument
    ).bind(null, variables),
    options
  );
export const useInfinitePagesForCollectionIdCreatedUtcQuery = <
  TData = PagesForCollectionIdCreatedUtcQuery,
  TError = unknown
>(
  variables: PagesForCollectionIdCreatedUtcQueryVariables,
  options?: UseInfiniteQueryOptions<PagesForCollectionIdCreatedUtcQuery, TError, TData>
) => {
  const query = useFetchData<PagesForCollectionIdCreatedUtcQuery, PagesForCollectionIdCreatedUtcQueryVariables>(
    PagesForCollectionIdCreatedUtcDocument
  );
  return useInfiniteQuery<PagesForCollectionIdCreatedUtcQuery, TError, TData>(
    ['PagesForCollectionIdCreatedUtc.infinite', variables],
    (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
    options
  );
};

export const PublicationSettingUpdateDocument = `
    mutation PublicationSettingUpdate($publicationSettingUpdateInput: PublicationSettingUpdateInput!) {
  publicationSettingUpdate(
    publicationSettingUpdateInput: $publicationSettingUpdateInput
  ) {
    publicationKey
    searchableContentTypes
    defaultContentTypes
    baseRoute
    previewBaseRoute
    baseAllessehQuery
    baseProductCardAllessehQuery
    disableAltSummEdit
    editableExternalPublications
    slugMappings
    snippetyIMDomain
    snippetyVideoDomain
    snippetyChartDomain
    defaultAltSumm
    baseLiveCoverageAllessehQuery
    baseTappableAllessehQuery
    disableEmbargo
    preferredTimezone {
      timezone
      timezoneAbbreviation
    }
  }
}
    `;
export const usePublicationSettingUpdateMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    PublicationSettingUpdateMutation,
    TError,
    PublicationSettingUpdateMutationVariables,
    TContext
  >
) =>
  useMutation<PublicationSettingUpdateMutation, TError, PublicationSettingUpdateMutationVariables, TContext>(
    ['PublicationSettingUpdate'],
    useFetchData<PublicationSettingUpdateMutation, PublicationSettingUpdateMutationVariables>(
      PublicationSettingUpdateDocument
    ),
    options
  );
export const PublicationSettingsDocument = `
    query PublicationSettings($publicationKey: String!) {
  publicationSetting(publicationKey: $publicationKey) {
    publicationKey
    searchableContentTypes
    defaultContentTypes
    baseRoute
    previewBaseRoute
    baseAllessehQuery
    baseProductCardAllessehQuery
    disableAltSummEdit
    editableExternalPublications
    slugMappings
    snippetyIMDomain
    snippetyVideoDomain
    snippetyChartDomain
    defaultAltSumm
    baseLiveCoverageAllessehQuery
    baseTappableAllessehQuery
    baseAudioAllessehQuery
    baseVideoAllessehQuery
    baseRecipeAllessehQuery
    basePodcastAllessehQuery
    baseWebStoryAllessehQuery
    baseOpinionAllessehQuery
    baseMarketwatchAllessehQuery
    basePentaAllessehQuery
    baseAfpAllessehQuery
    baseWsjAllessehQuery
    baseMansionGlobalAllessehQuery
    baseBarronsAllessehQuery
    baseDowJonesRiskJournalDJEventsAllessehQuery
    baseDowJonesRiskJournalCCOEventsAllessehQuery
    baseDowJonesRiskJournalContributorAllessehQuery
    baseWorldECRAllessehQuery
    baseExportComplianceManagerAllessehQuery
    enabledArtifacts
    disableEmbargo
    preferredTimezone {
      timezone
      timezoneAbbreviation
    }
    itpRequiredPageTypes
    beforePublishValidation
  }
}
    `;
export const usePublicationSettingsQuery = <TData = PublicationSettingsQuery, TError = unknown>(
  variables: PublicationSettingsQueryVariables,
  options?: UseQueryOptions<PublicationSettingsQuery, TError, TData>
) =>
  useQuery<PublicationSettingsQuery, TError, TData>(
    ['PublicationSettings', variables],
    useFetchData<PublicationSettingsQuery, PublicationSettingsQueryVariables>(PublicationSettingsDocument).bind(
      null,
      variables
    ),
    options
  );
export const useInfinitePublicationSettingsQuery = <TData = PublicationSettingsQuery, TError = unknown>(
  variables: PublicationSettingsQueryVariables,
  options?: UseInfiniteQueryOptions<PublicationSettingsQuery, TError, TData>
) => {
  const query = useFetchData<PublicationSettingsQuery, PublicationSettingsQueryVariables>(PublicationSettingsDocument);
  return useInfiniteQuery<PublicationSettingsQuery, TError, TData>(
    ['PublicationSettings.infinite', variables],
    (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
    options
  );
};

export const ScheduleContentDocument = `
    mutation ScheduleContent($scheduledContentCreateInput: ScheduledContentCreateInput!, $publicationKey: String!) {
  scheduleContent(
    scheduledContentCreateInput: $scheduledContentCreateInput
    publicationKey: $publicationKey
  ) {
    allessehId
    publishUtc
    createdUtc
    status
    creatorUser {
      djUserId
    }
    contentType
  }
}
    `;
export const useScheduleContentMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<ScheduleContentMutation, TError, ScheduleContentMutationVariables, TContext>
) =>
  useMutation<ScheduleContentMutation, TError, ScheduleContentMutationVariables, TContext>(
    ['ScheduleContent'],
    useFetchData<ScheduleContentMutation, ScheduleContentMutationVariables>(ScheduleContentDocument),
    options
  );
export const RescheduleContentDocument = `
    mutation RescheduleContent($scheduledContentRescheduleInput: ScheduledContentRescheduleInput!, $publicationKey: String!) {
  rescheduleContent(
    scheduledContentRescheduleInput: $scheduledContentRescheduleInput
    publicationKey: $publicationKey
  ) {
    allessehId
    publishUtc
    createdUtc
    status
    creatorUser {
      djUserId
    }
    contentType
  }
}
    `;
export const useRescheduleContentMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<RescheduleContentMutation, TError, RescheduleContentMutationVariables, TContext>
) =>
  useMutation<RescheduleContentMutation, TError, RescheduleContentMutationVariables, TContext>(
    ['RescheduleContent'],
    useFetchData<RescheduleContentMutation, RescheduleContentMutationVariables>(RescheduleContentDocument),
    options
  );
export const UpdateScheduledContentDocument = `
    mutation UpdateScheduledContent($scheduledContentUpdateInput: ScheduledContentUpdateInput!, $publicationKey: String!) {
  updateScheduledContent(
    scheduledContentUpdateInput: $scheduledContentUpdateInput
    publicationKey: $publicationKey
  ) {
    allessehId
    publishUtc
    createdUtc
    updatedUtc
    status
    creatorUser {
      djUserId
    }
    revisorUser {
      djUserId
    }
    contentType
  }
}
    `;
export const useUpdateScheduledContentMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    UpdateScheduledContentMutation,
    TError,
    UpdateScheduledContentMutationVariables,
    TContext
  >
) =>
  useMutation<UpdateScheduledContentMutation, TError, UpdateScheduledContentMutationVariables, TContext>(
    ['UpdateScheduledContent'],
    useFetchData<UpdateScheduledContentMutation, UpdateScheduledContentMutationVariables>(
      UpdateScheduledContentDocument
    ),
    options
  );
export const CancelScheduledContentDocument = `
    mutation CancelScheduledContent($scheduledContentCancelInput: ScheduledContentCancelInput!, $publicationKey: String!) {
  cancelScheduledContent(
    scheduledContentCancelInput: $scheduledContentCancelInput
    publicationKey: $publicationKey
  ) {
    allessehId
    publishUtc
    createdUtc
    updatedUtc
    status
    creatorUser {
      djUserId
    }
    revisorUser {
      djUserId
    }
    contentType
  }
}
    `;
export const useCancelScheduledContentMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    CancelScheduledContentMutation,
    TError,
    CancelScheduledContentMutationVariables,
    TContext
  >
) =>
  useMutation<CancelScheduledContentMutation, TError, CancelScheduledContentMutationVariables, TContext>(
    ['CancelScheduledContent'],
    useFetchData<CancelScheduledContentMutation, CancelScheduledContentMutationVariables>(
      CancelScheduledContentDocument
    ),
    options
  );
export const SaveDraftContentDocument = `
    mutation SaveDraftContent($scheduledContentSaveDraftInput: ScheduledContentSaveDraftInput!, $publicationKey: String!) {
  saveDraftContent(
    scheduledContentSaveDraftInput: $scheduledContentSaveDraftInput
    publicationKey: $publicationKey
  ) {
    allessehId
    publishUtc
    createdUtc
    updatedUtc
    status
    creatorUser {
      djUserId
    }
    revisorUser {
      djUserId
    }
    contentType
  }
}
    `;
export const useSaveDraftContentMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<SaveDraftContentMutation, TError, SaveDraftContentMutationVariables, TContext>
) =>
  useMutation<SaveDraftContentMutation, TError, SaveDraftContentMutationVariables, TContext>(
    ['SaveDraftContent'],
    useFetchData<SaveDraftContentMutation, SaveDraftContentMutationVariables>(SaveDraftContentDocument),
    options
  );
export const GetScheduledContentByAllessehIdDocument = `
    query GetScheduledContentByAllessehId($publicationKey: String!, $allessehId: String!, $publishUtc: Float) {
  scheduledContentByAllessehId(
    publicationKey: $publicationKey
    allessehId: $allessehId
    publishUtc: $publishUtc
  ) {
    allessehId
    publishUtc
    createdUtc
    updatedUtc
    status
    creatorUser {
      djUserId
    }
    revisorUser {
      djUserId
    }
    replacedBy {
      allessehId
      publishUtc
    }
    contentType
    body {
      ... on PageDTO {
        ...PageDTOData
      }
      ... on NewsletterDTO {
        ...NewsletterDTO
      }
      ... on Page {
        ...PageEditPage
      }
      ... on Collection {
        ...CollectionEditCollection
      }
      ... on OffPlatformDTO {
        ...OffPlatformDTO
      }
      ... on ITPIssueWithPages {
        ...IssueWithPages
        itpRevisorUser: revisorUser {
          djUserId
        }
      }
      ... on BannerDTO {
        ...BannerDTOArtifact
      }
    }
  }
}
    ${PageDtoDataFragmentDoc}
${PageDtoMetadataFragmentDoc}
${PageModuleUiModuleFieldsFragmentFragmentDoc}
${BasicModuleFragmentFragmentDoc}
${TitleModuleFragmentFragmentDoc}
${RankedModuleFragmentFragmentDoc}
${TextModuleFragmentFragmentDoc}
${BasicOptionalModuleFragmentFragmentDoc}
${FeedsModuleFragmentFragmentDoc}
${NewsletterDtoFragmentDoc}
${PageModuleFragmentRecursiveFragmentDoc}
${PageModuleSubFieldsFragmentFragmentDoc}
${CollectionPageCollectionFragmentDoc}
${PageEditPageFragmentDoc}
${PageModuleFragmentFragmentDoc}
${TwoColumnModuleFragmentFragmentDoc}
${CollectionEditCollectionFragmentDoc}
${OffPlatformDtoFragmentDoc}
${IssueWithPagesFragmentDoc}
${ItpPageModuleFragmentFragmentDoc}
${BannerDtoArtifactFragmentDoc}`;
export const useGetScheduledContentByAllessehIdQuery = <TData = GetScheduledContentByAllessehIdQuery, TError = unknown>(
  variables: GetScheduledContentByAllessehIdQueryVariables,
  options?: UseQueryOptions<GetScheduledContentByAllessehIdQuery, TError, TData>
) =>
  useQuery<GetScheduledContentByAllessehIdQuery, TError, TData>(
    ['GetScheduledContentByAllessehId', variables],
    useFetchData<GetScheduledContentByAllessehIdQuery, GetScheduledContentByAllessehIdQueryVariables>(
      GetScheduledContentByAllessehIdDocument
    ).bind(null, variables),
    options
  );
export const useInfiniteGetScheduledContentByAllessehIdQuery = <
  TData = GetScheduledContentByAllessehIdQuery,
  TError = unknown
>(
  variables: GetScheduledContentByAllessehIdQueryVariables,
  options?: UseInfiniteQueryOptions<GetScheduledContentByAllessehIdQuery, TError, TData>
) => {
  const query = useFetchData<GetScheduledContentByAllessehIdQuery, GetScheduledContentByAllessehIdQueryVariables>(
    GetScheduledContentByAllessehIdDocument
  );
  return useInfiniteQuery<GetScheduledContentByAllessehIdQuery, TError, TData>(
    ['GetScheduledContentByAllessehId.infinite', variables],
    (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
    options
  );
};

export const GetLiveContentByAllessehIdDocument = `
    query GetLiveContentByAllessehId($publicationKey: String!, $allessehId: String!) {
  liveContentByAllessehId(
    publicationKey: $publicationKey
    allessehId: $allessehId
  ) {
    allessehId
    publishUtc
    createdUtc
    updatedUtc
    status
    creatorUser {
      djUserId
    }
    revisorUser {
      djUserId
    }
    replacedBy {
      allessehId
      publishUtc
    }
    contentType
    body {
      ... on PageDTO {
        ...PageDTOData
      }
      ... on NewsletterDTO {
        ...NewsletterDTO
      }
      ... on Page {
        ...PageEditPage
      }
      ... on Collection {
        ...CollectionEditCollection
      }
      ... on ITPIssueWithPages {
        ...IssueWithPages
        itpRevisorUser: revisorUser {
          djUserId
        }
      }
      ... on BannerDTO {
        ...BannerDTOArtifact
      }
    }
  }
}
    ${PageDtoDataFragmentDoc}
${PageDtoMetadataFragmentDoc}
${PageModuleUiModuleFieldsFragmentFragmentDoc}
${BasicModuleFragmentFragmentDoc}
${TitleModuleFragmentFragmentDoc}
${RankedModuleFragmentFragmentDoc}
${TextModuleFragmentFragmentDoc}
${BasicOptionalModuleFragmentFragmentDoc}
${FeedsModuleFragmentFragmentDoc}
${NewsletterDtoFragmentDoc}
${PageModuleFragmentRecursiveFragmentDoc}
${PageModuleSubFieldsFragmentFragmentDoc}
${CollectionPageCollectionFragmentDoc}
${PageEditPageFragmentDoc}
${PageModuleFragmentFragmentDoc}
${TwoColumnModuleFragmentFragmentDoc}
${CollectionEditCollectionFragmentDoc}
${IssueWithPagesFragmentDoc}
${ItpPageModuleFragmentFragmentDoc}
${BannerDtoArtifactFragmentDoc}`;
export const useGetLiveContentByAllessehIdQuery = <TData = GetLiveContentByAllessehIdQuery, TError = unknown>(
  variables: GetLiveContentByAllessehIdQueryVariables,
  options?: UseQueryOptions<GetLiveContentByAllessehIdQuery, TError, TData>
) =>
  useQuery<GetLiveContentByAllessehIdQuery, TError, TData>(
    ['GetLiveContentByAllessehId', variables],
    useFetchData<GetLiveContentByAllessehIdQuery, GetLiveContentByAllessehIdQueryVariables>(
      GetLiveContentByAllessehIdDocument
    ).bind(null, variables),
    options
  );
export const useInfiniteGetLiveContentByAllessehIdQuery = <TData = GetLiveContentByAllessehIdQuery, TError = unknown>(
  variables: GetLiveContentByAllessehIdQueryVariables,
  options?: UseInfiniteQueryOptions<GetLiveContentByAllessehIdQuery, TError, TData>
) => {
  const query = useFetchData<GetLiveContentByAllessehIdQuery, GetLiveContentByAllessehIdQueryVariables>(
    GetLiveContentByAllessehIdDocument
  );
  return useInfiniteQuery<GetLiveContentByAllessehIdQuery, TError, TData>(
    ['GetLiveContentByAllessehId.infinite', variables],
    (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
    options
  );
};

export const GetScheduledContentByTimeWithAllessehIdDocument = `
    query GetScheduledContentByTimeWithAllessehId($allessehId: String!, $maxTimestamp: Float!) {
  scheduledContentByTimeWithAllessehId(
    allessehId: $allessehId
    maxTimestamp: $maxTimestamp
  ) {
    allessehId
    publishUtc
    createdUtc
    updatedUtc
    status
    creatorUser {
      djUserId
    }
    revisorUser {
      djUserId
    }
    replacedBy {
      allessehId
      publishUtc
    }
    contentType
    body {
      ... on PageDTO {
        ...PageDTOData
      }
      ... on NewsletterDTO {
        ...NewsletterDTO
      }
      ... on Page {
        ...PageEditPage
      }
      ... on Collection {
        ...CollectionEditCollection
      }
      ... on ITPIssueWithPages {
        ...IssueWithPages
        itpRevisorUser: revisorUser {
          djUserId
        }
      }
      ... on BannerDTO {
        ...BannerDTOArtifact
      }
    }
  }
}
    ${PageDtoDataFragmentDoc}
${PageDtoMetadataFragmentDoc}
${PageModuleUiModuleFieldsFragmentFragmentDoc}
${BasicModuleFragmentFragmentDoc}
${TitleModuleFragmentFragmentDoc}
${RankedModuleFragmentFragmentDoc}
${TextModuleFragmentFragmentDoc}
${BasicOptionalModuleFragmentFragmentDoc}
${FeedsModuleFragmentFragmentDoc}
${NewsletterDtoFragmentDoc}
${PageModuleFragmentRecursiveFragmentDoc}
${PageModuleSubFieldsFragmentFragmentDoc}
${CollectionPageCollectionFragmentDoc}
${PageEditPageFragmentDoc}
${PageModuleFragmentFragmentDoc}
${TwoColumnModuleFragmentFragmentDoc}
${CollectionEditCollectionFragmentDoc}
${IssueWithPagesFragmentDoc}
${ItpPageModuleFragmentFragmentDoc}
${BannerDtoArtifactFragmentDoc}`;
export const useGetScheduledContentByTimeWithAllessehIdQuery = <
  TData = GetScheduledContentByTimeWithAllessehIdQuery,
  TError = unknown
>(
  variables: GetScheduledContentByTimeWithAllessehIdQueryVariables,
  options?: UseQueryOptions<GetScheduledContentByTimeWithAllessehIdQuery, TError, TData>
) =>
  useQuery<GetScheduledContentByTimeWithAllessehIdQuery, TError, TData>(
    ['GetScheduledContentByTimeWithAllessehId', variables],
    useFetchData<GetScheduledContentByTimeWithAllessehIdQuery, GetScheduledContentByTimeWithAllessehIdQueryVariables>(
      GetScheduledContentByTimeWithAllessehIdDocument
    ).bind(null, variables),
    options
  );
export const useInfiniteGetScheduledContentByTimeWithAllessehIdQuery = <
  TData = GetScheduledContentByTimeWithAllessehIdQuery,
  TError = unknown
>(
  variables: GetScheduledContentByTimeWithAllessehIdQueryVariables,
  options?: UseInfiniteQueryOptions<GetScheduledContentByTimeWithAllessehIdQuery, TError, TData>
) => {
  const query = useFetchData<
    GetScheduledContentByTimeWithAllessehIdQuery,
    GetScheduledContentByTimeWithAllessehIdQueryVariables
  >(GetScheduledContentByTimeWithAllessehIdDocument);
  return useInfiniteQuery<GetScheduledContentByTimeWithAllessehIdQuery, TError, TData>(
    ['GetScheduledContentByTimeWithAllessehId.infinite', variables],
    (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
    options
  );
};

export const GetScheduledContentByPublicationKeyDocument = `
    query GetScheduledContentByPublicationKey($publicationKey: String!, $contentType: AllessehContentType!, $paginationParams: PaginationParams!, $status: ScheduledContentStatus) {
  scheduledContentByPublicationKey(
    publicationKey: $publicationKey
    contentType: $contentType
    paginationParams: $paginationParams
    status: $status
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      cursor
      node {
        allessehId
        publishUtc
        createdUtc
        updatedUtc
        status
        creatorUser {
          djUserId
        }
        revisorUser {
          djUserId
        }
        replacedBy {
          allessehId
          publishUtc
        }
        contentType
        body {
          ... on NewsletterDTO {
            ...NewsletterDTO
          }
          ... on Page {
            ...PageEditPage
          }
          ... on Collection {
            ...CollectionEditCollection
          }
          ... on ITPIssueWithPages {
            ...IssueWithPages
            itpRevisorUser: revisorUser {
              djUserId
            }
          }
          ... on BannerDTO {
            ...BannerDTOArtifact
          }
        }
      }
    }
  }
}
    ${NewsletterDtoFragmentDoc}
${PageModuleFragmentRecursiveFragmentDoc}
${PageModuleSubFieldsFragmentFragmentDoc}
${CollectionPageCollectionFragmentDoc}
${PageModuleUiModuleFieldsFragmentFragmentDoc}
${BasicModuleFragmentFragmentDoc}
${TitleModuleFragmentFragmentDoc}
${RankedModuleFragmentFragmentDoc}
${TextModuleFragmentFragmentDoc}
${BasicOptionalModuleFragmentFragmentDoc}
${FeedsModuleFragmentFragmentDoc}
${PageEditPageFragmentDoc}
${PageModuleFragmentFragmentDoc}
${TwoColumnModuleFragmentFragmentDoc}
${CollectionEditCollectionFragmentDoc}
${IssueWithPagesFragmentDoc}
${ItpPageModuleFragmentFragmentDoc}
${BannerDtoArtifactFragmentDoc}`;
export const useGetScheduledContentByPublicationKeyQuery = <
  TData = GetScheduledContentByPublicationKeyQuery,
  TError = unknown
>(
  variables: GetScheduledContentByPublicationKeyQueryVariables,
  options?: UseQueryOptions<GetScheduledContentByPublicationKeyQuery, TError, TData>
) =>
  useQuery<GetScheduledContentByPublicationKeyQuery, TError, TData>(
    ['GetScheduledContentByPublicationKey', variables],
    useFetchData<GetScheduledContentByPublicationKeyQuery, GetScheduledContentByPublicationKeyQueryVariables>(
      GetScheduledContentByPublicationKeyDocument
    ).bind(null, variables),
    options
  );
export const useInfiniteGetScheduledContentByPublicationKeyQuery = <
  TData = GetScheduledContentByPublicationKeyQuery,
  TError = unknown
>(
  variables: GetScheduledContentByPublicationKeyQueryVariables,
  options?: UseInfiniteQueryOptions<GetScheduledContentByPublicationKeyQuery, TError, TData>
) => {
  const query = useFetchData<
    GetScheduledContentByPublicationKeyQuery,
    GetScheduledContentByPublicationKeyQueryVariables
  >(GetScheduledContentByPublicationKeyDocument);
  return useInfiniteQuery<GetScheduledContentByPublicationKeyQuery, TError, TData>(
    ['GetScheduledContentByPublicationKey.infinite', variables],
    (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
    options
  );
};

export const GetLastNPublishedScheduledContentDocument = `
    query GetLastNPublishedScheduledContent($allessehId: String!, $publishUtc: Float, $status: ScheduledContentStatus!, $n: Float!) {
  lastNPublishedScheduledContent(
    allessehId: $allessehId
    publishUtc: $publishUtc
    status: $status
    n: $n
  ) {
    allessehId
    publishUtc
    createdUtc
    updatedUtc
    status
    creatorUser {
      djUserId
    }
    revisorUser {
      djUserId
    }
    replacedBy {
      allessehId
      publishUtc
    }
    contentType
    body {
      ... on PageDTO {
        ...PageDTOData
      }
      ... on NewsletterDTO {
        ...NewsletterDTO
      }
      ... on Page {
        ...PageEditPage
      }
      ... on Collection {
        ...CollectionEditCollection
      }
      ... on OffPlatformDTO {
        ...OffPlatformDTO
      }
      ... on ITPIssueWithPages {
        ...IssueWithPages
        itpRevisorUser: revisorUser {
          djUserId
        }
      }
      ... on BannerDTO {
        ...BannerDTOArtifact
      }
    }
  }
}
    ${PageDtoDataFragmentDoc}
${PageDtoMetadataFragmentDoc}
${PageModuleUiModuleFieldsFragmentFragmentDoc}
${BasicModuleFragmentFragmentDoc}
${TitleModuleFragmentFragmentDoc}
${RankedModuleFragmentFragmentDoc}
${TextModuleFragmentFragmentDoc}
${BasicOptionalModuleFragmentFragmentDoc}
${FeedsModuleFragmentFragmentDoc}
${NewsletterDtoFragmentDoc}
${PageModuleFragmentRecursiveFragmentDoc}
${PageModuleSubFieldsFragmentFragmentDoc}
${CollectionPageCollectionFragmentDoc}
${PageEditPageFragmentDoc}
${PageModuleFragmentFragmentDoc}
${TwoColumnModuleFragmentFragmentDoc}
${CollectionEditCollectionFragmentDoc}
${OffPlatformDtoFragmentDoc}
${IssueWithPagesFragmentDoc}
${ItpPageModuleFragmentFragmentDoc}
${BannerDtoArtifactFragmentDoc}`;
export const useGetLastNPublishedScheduledContentQuery = <
  TData = GetLastNPublishedScheduledContentQuery,
  TError = unknown
>(
  variables: GetLastNPublishedScheduledContentQueryVariables,
  options?: UseQueryOptions<GetLastNPublishedScheduledContentQuery, TError, TData>
) =>
  useQuery<GetLastNPublishedScheduledContentQuery, TError, TData>(
    ['GetLastNPublishedScheduledContent', variables],
    useFetchData<GetLastNPublishedScheduledContentQuery, GetLastNPublishedScheduledContentQueryVariables>(
      GetLastNPublishedScheduledContentDocument
    ).bind(null, variables),
    options
  );
export const useInfiniteGetLastNPublishedScheduledContentQuery = <
  TData = GetLastNPublishedScheduledContentQuery,
  TError = unknown
>(
  variables: GetLastNPublishedScheduledContentQueryVariables,
  options?: UseInfiniteQueryOptions<GetLastNPublishedScheduledContentQuery, TError, TData>
) => {
  const query = useFetchData<GetLastNPublishedScheduledContentQuery, GetLastNPublishedScheduledContentQueryVariables>(
    GetLastNPublishedScheduledContentDocument
  );
  return useInfiniteQuery<GetLastNPublishedScheduledContentQuery, TError, TData>(
    ['GetLastNPublishedScheduledContent.infinite', variables],
    (metaData) => query({ ...variables, ...(metaData.pageParam ?? {}) }),
    options
  );
};
